/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from 'src/lib/gql-fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountNumber: { input: any; output: any; }
  AverageRating: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Byte: { input: any; output: any; }
  CountryCode: { input: any; output: any; }
  CountryName: { input: any; output: any; }
  CourseDuration: { input: any; output: any; }
  Cuid: { input: any; output: any; }
  Currency: { input: any; output: any; }
  DID: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  DeweyDecimal: { input: any; output: any; }
  Duration: { input: any; output: any; }
  DurationInMinutes: { input: any; output: any; }
  DurationInSeconds: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  GUID: { input: any; output: any; }
  GeoJSON: { input: any; output: any; }
  HSL: { input: any; output: any; }
  HSLA: { input: any; output: any; }
  HexColorCode: { input: any; output: any; }
  Hexadecimal: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  IP: { input: any; output: any; }
  IPCPatent: { input: any; output: any; }
  IPv4: { input: any; output: any; }
  IPv6: { input: any; output: any; }
  ISBN: { input: any; output: any; }
  ISO8601Duration: { input: any; output: any; }
  InstructorPayoutEarningsPeriod: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  JWT: { input: any; output: any; }
  LCCSubclass: { input: any; output: any; }
  Latitude: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
  LocalEndTime: { input: any; output: any; }
  LocalTime: { input: any; output: any; }
  Locale: { input: any; output: any; }
  Long: { input: any; output: any; }
  Longitude: { input: any; output: any; }
  MAC: { input: any; output: any; }
  MaxResultsPerPage: { input: any; output: any; }
  NegativeFloat: { input: any; output: any; }
  NegativeInt: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  NonNegativeFloat: { input: any; output: any; }
  NonNegativeInt: { input: any; output: any; }
  NonPositiveFloat: { input: any; output: any; }
  NonPositiveInt: { input: any; output: any; }
  ObjectID: { input: any; output: any; }
  OffsetInSeconds: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  Port: { input: any; output: any; }
  PositiveFloat: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
  RGB: { input: any; output: any; }
  RGBA: { input: any; output: any; }
  RRuleString: { input: any; output: any; }
  RoutingNumber: { input: any; output: any; }
  SESSN: { input: any; output: any; }
  SafeHtml: { input: any; output: any; }
  SafeInt: { input: any; output: any; }
  SemVer: { input: any; output: any; }
  Time: { input: any; output: any; }
  TimeZone: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  URL: { input: any; output: any; }
  USCurrency: { input: any; output: any; }
  UUID: { input: any; output: any; }
  UnsignedFloat: { input: any; output: any; }
  UnsignedInt: { input: any; output: any; }
  UtcOffset: { input: any; output: any; }
  Void: { input: any; output: any; }
};

/** Represents the actor who performed the event. */
export type Actor = {
  __typename?: 'Actor';
  /** The unique identifier for the actor. */
  actorId: Scalars['ID']['output'];
  /** The type of actor, such as an end user, impersonator, or service. */
  actorType: ActorType;
};

/** Defines the type of actor performing the event. */
export enum ActorType {
  /** Represents an end user who performed the action. */
  EndUser = 'END_USER',
  /** Represents an impersonation of another user performing the action. */
  Impersonation = 'IMPERSONATION',
  /** Represents a service or automated system performing the action. */
  Service = 'SERVICE'
}

/** Gen AI-related organization settings */
export type AiAssistantOrganizationSettings = {
  __typename?: 'AiAssistantOrganizationSettings';
  /** Whether file upload is enabled for the AI Assistant */
  isFileUploadEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The OpenAI API provider for the organization ('OPENAI' or 'MICROSOFT_AZURE_OPENAI') */
  openAiModelProvider?: Maybe<Scalars['String']['output']>;
};

/** Price option for computed price plan. Will be returned for annual plans */
export type AnnualSubscriptionPlanPricingOption = {
  __typename?: 'AnnualSubscriptionPlanPricingOption';
  /** The annual savings amount for the subscription price plan when compared to monthly plans. calculated on pricing backend can be null */
  annualSavings?: Maybe<Money>;
  /** Contains information about the discount context for a given subscription plan price option */
  discount?: Maybe<SubscriptionPlanDiscount>;
  /** Field containing details about the discounted trial subscription offer for a given user. Null indicates no trial is available */
  discountTrial?: Maybe<SubscriptionTrial>;
  /** ID of the price option: */
  id: Scalars['ID']['output'];
  /** Contains information about the license context for a given subscription plan price option */
  licenseContext?: Maybe<SubscriptionPlanLicenseContext>;
  /** The list price of the subscription price plan based on provided requested count from request */
  listPrice: Money;
  /** The monthly list price of the subscription price plan. Applicable for annual plan only. Represents fraction of list price */
  monthlyPrice: Money;
  /** Field showing the prices for the option. */
  price?: Maybe<SubscriptionPlanPrice>;
  /** Interval for renewing the subscription plan ie the length of the subscription plan */
  renewalInterval: DateInterval;
  /** Field containing details about the trial subscription offer for a given user. Null indicates no trial is available */
  trial?: Maybe<SubscriptionTrial>;
};

/** An API client */
export type ApiClient = {
  /** The API Client expiration date */
  expiresOn?: Maybe<Scalars['Date']['output']>;
  /** The grantTypes this API client has */
  grantTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The API Client ID as UUID */
  id: Scalars['ID']['output'];
  /** The API Client name */
  name: Scalars['String']['output'];
  /** The redirect URLs for this authorization_code API clients */
  redirectUrls?: Maybe<Array<Scalars['URL']['output']>>;
  /** The scopes this API client has access to */
  scopes: Array<Scalars['String']['output']>;
};

/** Response from creating an API client containing ApiClient info and client's secret */
export type ApiClientCreateResponse = {
  __typename?: 'ApiClientCreateResponse';
  /** The created API Client */
  apiClient?: Maybe<ApiClient>;
  /** Client Secret for the created API Client */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** The grantTypes this API client has */
  grantTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The redirect URLs for this authorization_code API clients */
  redirectUrls?: Maybe<Array<Scalars['URL']['output']>>;
};

/** Response from deleting an API client containing the deleted API Client ID */
export type ApiClientDeleteResponse = {
  __typename?: 'ApiClientDeleteResponse';
  /** The deleted API Client ID */
  clientId?: Maybe<Scalars['ID']['output']>;
};

/** An API client for an Organization */
export type ApiClientForOrganization = ApiClient & {
  __typename?: 'ApiClientForOrganization';
  /** The API Client expiration date */
  expiresOn?: Maybe<Scalars['Date']['output']>;
  /** The grantTypes this API client has */
  grantTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The API Client ID */
  id: Scalars['ID']['output'];
  /** The API Client name */
  name: Scalars['String']['output'];
  /** The organization this API client is for */
  organization: Organization;
  /** The redirect URLs for this authorization_code API clients */
  redirectUrls?: Maybe<Array<Scalars['URL']['output']>>;
  /** The scopes this API client has access to */
  scopes: Array<Scalars['String']['output']>;
};

/** An API client for a Partner */
export type ApiClientForPartner = ApiClient & {
  __typename?: 'ApiClientForPartner';
  /** The API Client expiration date */
  expiresOn?: Maybe<Scalars['Date']['output']>;
  /** The grantTypes this API client has */
  grantTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The API Client ID */
  id: Scalars['ID']['output'];
  /** The API Client name */
  name: Scalars['String']['output'];
  /** The partner this API client is for */
  partner: Partner;
  /** The redirect URLs for this authorization_code API clients */
  redirectUrls?: Maybe<Array<Scalars['URL']['output']>>;
  /** The scopes this API client has access to */
  scopes: Array<Scalars['String']['output']>;
};

/** Input for creating an API client */
export type ApiClientInput = {
  /** The grantTypes this API client has */
  grantTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The API Client name */
  name: Scalars['String']['input'];
  /** The redirect URLs for this authorization_code API clients */
  redirectUrls?: InputMaybe<Array<Scalars['URL']['input']>>;
  /** The scopes this API client has access to */
  scopes: Array<Scalars['String']['input']>;
};

/** Article lecture */
export type ArticleLecture = CurriculumItem & Lecture & {
  __typename?: 'ArticleLecture';
  /** Lecture's main learning asset */
  asset?: Maybe<Asset>;
  /** The Course this lecture belongs to */
  course?: Maybe<Course>;
  /** Instructor-authored description of the lecture, may contain HTML */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** Total duration of the lecture's content in seconds */
  durationInSeconds: Scalars['DurationInSeconds']['output'];
  /** Id of the lecture */
  id: Scalars['ID']['output'];
  /** Images by their dimensions */
  images: LectureImages;
  /** If user has completed the lecture */
  isCompleted: Scalars['Boolean']['output'];
  /** Whether this lecture is used for promos and course previews. */
  isPreviewable: Scalars['Boolean']['output'];
  /** Lecture's supplementary resources */
  resources?: Maybe<Array<Maybe<Asset>>>;
  /** Associated learning products for supplementary learning */
  supplementaryLearningProducts: Array<LearningProduct>;
  /** The URL of the lecture thumbnail */
  thumbnail?: Maybe<Scalars['URL']['output']>;
  /** Lecture title */
  title: Scalars['String']['output'];
  /** The URL to access the lecture on the auto-enroll page */
  urlAutoEnroll: Scalars['URL']['output'];
  /** Download URL for lecture */
  urlDownload?: Maybe<Scalars['URL']['output']>;
  /** Landing page to view this Lecture */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the lecture */
  versionedIdentifier: VersionedIdentifier;
};


/** Article lecture */
export type ArticleLectureSupplementaryLearningProductsArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * An Assessment represents a collection of Forms (which are variations of items and orderings of items).
 * A user chooses to take an Assessment. They are then give a Form to take from that Assessment.
 */
export type Assessment = LearningPathItem & LearningProduct & {
  __typename?: 'Assessment';
  /** The assessment's assignment information, if the assessment has been assigned to the user */
  assignment?: Maybe<AssessmentAssignment>;
  /** Description of the assessment. */
  description: Scalars['SafeHtml']['output'];
  /** Domains associated with this assessment */
  domains?: Maybe<Array<Maybe<AssessmentDomain>>>;
  /** Duration of an assessment in seconds */
  durationInSeconds?: Maybe<Scalars['DurationInSeconds']['output']>;
  /** ID of the assessment. */
  id: Scalars['ID']['output'];
  /** Is the assessment active or not */
  isActive: Scalars['Boolean']['output'];
  /** Is the assessment beta or not */
  isBeta: Scalars['Boolean']['output'];
  /** Metadata associated with the assessment */
  metadata?: Maybe<AssessmentMetadata>;
  /** Recommended courses based on this assessment */
  recommendedCourses?: Maybe<Array<Maybe<Course>>>;
  /** Related skills framework for this assessment */
  skillsFramework?: Maybe<SkillsFramework>;
  /** Subscription information for this assessment */
  subscriptionInfo?: Maybe<LearningProductSubscriptionInfo>;
  /** The name, for example: 'HTML' or 'AWS Developer Certification'. */
  title: Scalars['String']['output'];
  /** Topic descriptors associated with this assessment */
  topicDescriptors?: Maybe<Array<Maybe<TopicDescriptor>>>;
  /** Topics associated with this assessment */
  topics?: Maybe<Array<Maybe<Topic>>>;
  /** Landing page to view this Assessment */
  urlLanding: Scalars['URL']['output'];
};

/** A unique assignment of an assessment to a user, with optional due date */
export type AssessmentAssignment = {
  __typename?: 'AssessmentAssignment';
  /** An optional due date by which the assignment should be completed */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the assignment */
  id: Scalars['ID']['output'];
};

/** An attempt of an assessment by a learner */
export type AssessmentAttempt = {
  __typename?: 'AssessmentAttempt';
  /** The assessment form used for this attempt */
  assessmentForm?: Maybe<AssessmentForm>;
  /** Completion time of the attempt */
  completionTime?: Maybe<Scalars['DateTime']['output']>;
  /** Current item in the attempt where user is currently at */
  currentItem?: Maybe<AssessmentItem>;
  /** Index of the current item in the attempt */
  currentItemIndex?: Maybe<Scalars['Int']['output']>;
  /** ID of the attempt */
  id: Scalars['ID']['output'];
  /** Responses to the items in the attempt */
  itemAttempts?: Maybe<Array<AssessmentItemAttempt>>;
  /** Last accessed time of the attempt. I.e. the time the user last responded to an item in the attempt */
  lastAccessedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Start time of the attempt */
  startTime: Scalars['DateTime']['output'];
  /** Stats for the attempt */
  stats?: Maybe<AssessmentAttemptScoreStats>;
  /** Total item count in the attempt */
  totalItemCount?: Maybe<Scalars['Int']['output']>;
};

/** Score stats for an attempt of an assessment */
export type AssessmentAttemptScoreStats = {
  __typename?: 'AssessmentAttemptScoreStats';
  /** The percentile associated with this score, compared amongst all users' attempts of this assessment */
  scalePercentile: Scalars['Int']['output'];
  /**
   * The score obtained by the user after completing the attempt
   * Scores can range from 0-200, with 100 representing an average score.
   */
  scaleScore: Scalars['Int']['output'];
};

/** Attempt summary for an assessment with its attempts and remaining attempt count */
export type AssessmentAttemptsSummary = {
  __typename?: 'AssessmentAttemptsSummary';
  /** Assessment information */
  assessment: Assessment;
  /** List of assessment item feedbacks for the assessment */
  assessmentItemFeedbacks?: Maybe<Array<Maybe<AssessmentItemFeedback>>>;
  /** List of attempts for the assessment */
  attempts: Array<AssessmentAttempt>;
  /** Remaining attempt count for the assessment */
  remainingAttemptCount: Scalars['Int']['output'];
};

/** A domain associated with an assessment */
export type AssessmentDomain = {
  __typename?: 'AssessmentDomain';
  /** ID of the domain */
  id: Scalars['ID']['output'];
  /** Title of the domain */
  title: Scalars['String']['output'];
  /** Weight of the domain */
  weight?: Maybe<Scalars['Float']['output']>;
};

/** A form represents a specific variation of an assessment with a particular set and ordering of items */
export type AssessmentForm = {
  __typename?: 'AssessmentForm';
  /** Unique identifier for the assessment form */
  id: Scalars['ID']['output'];
};

/** An AssessmentItem contains data about the item a user can interact with. */
export type AssessmentItem = {
  __typename?: 'AssessmentItem';
  /** Options to be selected for the answer to be correct */
  correctOptions: Array<AssessmentItemOption>;
  /** Domain associated with this item */
  domain?: Maybe<AssessmentDomain>;
  /** Explanation for the question or its answer */
  explanation?: Maybe<Scalars['String']['output']>;
  /** The Id */
  id: Scalars['ID']['output'];
  /** Options to provide as possible answers */
  options: Array<AssessmentItemOption>;
  /** Top 3 most related lectures to this assessment item */
  relatedLectures?: Maybe<Array<Maybe<Lecture>>>;
  /** Question text */
  text: Scalars['String']['output'];
  /** Type of the item/question */
  type?: Maybe<AssessmentItemType>;
};

/** An  AssessmentItemAttempt is an item related to an Assessment that contains how a user performed in an AssessmentItem. */
export type AssessmentItemAttempt = {
  __typename?: 'AssessmentItemAttempt';
  /** The time taken to answer the item in milliseconds */
  durationInMilliseconds: Scalars['Int']['output'];
  /** AssessmentItem related to data */
  item: AssessmentItem;
  /** The response submitted for the item */
  selectedOptions: Array<AssessmentItemOption>;
  /** Returns the attempt status for item */
  status: AssessmentItemAttemptStatus;
};

/** Input for submitting an attempt of an assessment item */
export type AssessmentItemAttemptInput = {
  /** ID of the assessment */
  assessmentId: Scalars['ID']['input'];
  /** ID of the attempt */
  attemptId: Scalars['ID']['input'];
  /** Duration of the attempt in milliseconds */
  durationInMilliseconds: Scalars['Int']['input'];
  /** ID of the item */
  itemId: Scalars['ID']['input'];
  /** IDs of the options selected by the user */
  selectedOptionIds: Array<Scalars['ID']['input']>;
};

/** Contains the valid item attempt status for an item attempt. */
export enum AssessmentItemAttemptStatus {
  /** The user answered the item correctly */
  Correct = 'CORRECT',
  /** The user answered the item incorrectly */
  Incorrect = 'INCORRECT',
  /** The user skipped the item */
  Skipped = 'SKIPPED'
}

/** Item feedback submitted for an assessment item */
export type AssessmentItemFeedback = {
  __typename?: 'AssessmentItemFeedback';
  /** Assessment item related to this feedback */
  assessmentItem?: Maybe<AssessmentItem>;
  /** Text feedback content */
  feedback?: Maybe<Scalars['String']['output']>;
  /** Type of feedback provided */
  feedbackType?: Maybe<AssessmentItemFeedbackType>;
  /** ID of the feedback */
  id: Scalars['ID']['output'];
  /** Whether the user gave thumbs up or down */
  thumbsUp: Scalars['Boolean']['output'];
};

/** Input for submitting feedback for an assessment item */
export type AssessmentItemFeedbackInput = {
  /** Text feedback content */
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Type of feedback provided */
  feedbackType?: InputMaybe<AssessmentItemFeedbackType>;
  /** ID of the item */
  itemId: Scalars['ID']['input'];
  /** Whether the user gave thumbs up or down */
  thumbsUp: Scalars['Boolean']['input'];
};

/** Type of feedback provided for an assessment item */
export enum AssessmentItemFeedbackType {
  /** Feedback for accuracy issues */
  Accuracy = 'ACCURACY',
  /** Feedback for formatting issues */
  Formatting = 'FORMATTING',
  /** Other feedback */
  Other = 'OTHER',
  /** Feedback for irrelevant content */
  Relevance = 'RELEVANCE',
  /** Feedback for wording issues */
  Wording = 'WORDING'
}

/** Option for multiple-choice or multi-select type questions */
export type AssessmentItemOption = {
  __typename?: 'AssessmentItemOption';
  /** Explanation about the option to display after evaluation */
  explanation?: Maybe<Scalars['String']['output']>;
  /** Option id to use as a reference */
  id: Scalars['ID']['output'];
  /** Option text to display during assessment */
  text: Scalars['String']['output'];
};

/** Filters used to fetch user assessment items results that are correct, skipped and attempted. */
export type AssessmentItemResultsFilters = {
  /**
   * Use status to filter itemAttempts return with specific status.
   * Default is to return all status.
   */
  status?: InputMaybe<Array<AssessmentItemAttemptStatus>>;
};

/** Type of the Assessment item */
export enum AssessmentItemType {
  /** Multiple choice item type */
  MultipleChoice = 'MULTIPLE_CHOICE',
  /** Multiple select item type */
  MultiSelect = 'MULTI_SELECT'
}

/** MetaData for an assessment */
export type AssessmentMetadata = {
  __typename?: 'AssessmentMetadata';
  /** Unique analytics ID for this instance of Assessment returned from the server in this request. */
  trackingId?: Maybe<Scalars['String']['output']>;
};

/** A wrapper type to include the recommended Assessment and some additional fields about its recommendation */
export type AssessmentRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'AssessmentRecommendation';
  /** Underlying object of the recommendation to get more information about it */
  assessment?: Maybe<Assessment>;
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/**
 * An AssessmentResults represents a user results for taking an Assessment.
 * items are the attempts of the latest form the User attempted for an Assessment.
 */
export type AssessmentResults = {
  __typename?: 'AssessmentResults';
  /** Assessment related to results */
  assessment: Assessment;
  /** List of items a user either skipped or answered */
  items: Array<AssessmentItemAttempt>;
};

/** List of Assessment and additional data about search response */
export type AssessmentSearchResponse = {
  __typename?: 'AssessmentSearchResponse';
  /** Total number of Assessments matching the search query and filters. */
  count: Scalars['Int']['output'];
  /** Metadata for whole search result used by front end */
  metadata?: Maybe<AssessmentSearchResponseMetadata>;
  /** List of AssessmentSearchResult objects. */
  results: Array<AssessmentSearchResult>;
};

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */
export type AssessmentSearchResponseMetadata = {
  __typename?: 'AssessmentSearchResponseMetadata';
  /** For the request, shows experiment metadata result like bucking info, experiment IDs of assigned feature variants. */
  experimentResults: Array<FeatureVariantAssignment>;
  /** Search analytics tracking id; for uniquely identifying this query and result set; for this request */
  trackingId: Scalars['String']['output'];
};

/** Identifies each result for assessment search. */
export type AssessmentSearchResult = {
  __typename?: 'AssessmentSearchResult';
  /** Attempt summary containing the assessment and its attempt data. */
  attemptsSummary: AssessmentAttemptsSummary;
  /** Unique analytics ID for the found assessment. */
  trackingId: Scalars['String']['output'];
};

/** Detailed metrics for a specific skill/assessment */
export type AssessmentSummary = {
  __typename?: 'AssessmentSummary';
  /** Number of distinct learners who have taken this assessment */
  assessedLearnersCount: Scalars['NonNegativeInt']['output'];
  /** Assessment identifier */
  assessment: Assessment;
  /** Total number of assessments taken (includes re-assessments) */
  assessmentsTakenCount: Scalars['NonNegativeInt']['output'];
  /** Number of learners who improved their proficiency level */
  learnersImprovedCount: Scalars['NonNegativeInt']['output'];
  /** Distribution of proficiency levels for this skill */
  proficiencyLevelDistribution: ProficiencyLevelCounts;
  /** Number of re-assessments taken */
  reassessmentsTakenCount: Scalars['NonNegativeInt']['output'];
};

/** Input for skills breakdown query */
export type AssessmentSummaryInput = {
  /** Filter parameters for the query */
  filters?: InputMaybe<SkillsProficiencyInsightsFilterInput>;
  /** Page number for pagination */
  pageNumber?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Page size for pagination */
  pageSize?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Sort order for results */
  sortOrder?: InputMaybe<AssessmentSummarySortOrder>;
};

/** Paginated list for assessment summary list */
export type AssessmentSummaryResponse = Paginated & {
  __typename?: 'AssessmentSummaryResponse';
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages. Calculated as (total result count / page size) */
  pageCount: Scalars['Int']['output'];
  /** List of skill metrics for the current page */
  results: Array<AssessmentSummary>;
};

/** Sort order options for skills breakdown */
export type AssessmentSummarySortOrder = {
  /** Sort by number of assessed learners */
  assessedLearnersCount?: InputMaybe<SortDirection>;
  /** Sort by number of assessments taken */
  assessmentsTakenCount?: InputMaybe<SortDirection>;
  /** Sort by number of learners who improved */
  learnersImprovedCount?: InputMaybe<SortDirection>;
  /** Sort by number of re-assessments taken */
  reassessmentsTakenCount?: InputMaybe<SortDirection>;
};

/** Assessment activity data point for a specific day */
export type AssessmentTrendDataPoint = {
  __typename?: 'AssessmentTrendDataPoint';
  /** Date of the data point */
  date: Scalars['Date']['output'];
  /** Number of re-assessments taken on this date */
  retakenAssessmentCount: Scalars['NonNegativeInt']['output'];
  /** Number of assessments taken on this date */
  takenAssessmentCount: Scalars['NonNegativeInt']['output'];
};

/**
 * A 'variant' is an instance/representation of an assessment used for having its own dynamic list of questions (deprecated)
 *
 * There may exist multiple variants of the same assessment, which share the same pool of questions, uniquely ordered between variants. Each variant will have a unique id, and will be associated with one assessment from which the questions are drawn.
 */
export type AssessmentVariant = {
  __typename?: 'AssessmentVariant';
  /** The assessment for which the variant is found */
  assessment: Assessment;
  /** The ID */
  id: Scalars['ID']['output'];
};

/** Top level object to track the progress and results of a user taking an assessment variant (deprecated) */
export type AssessmentVariantAttempt = {
  __typename?: 'AssessmentVariantAttempt';
  /** The score and percentile of the variant attempt, available once the attempt is completed */
  evaluation?: Maybe<AssessmentVariantAttemptEvaluation>;
  /** The ID */
  id: Scalars['ID']['output'];
  /** This is set to true once the variant attempt is completed by the user */
  isCompleted: Scalars['Boolean']['output'];
  /** The last time a user interacted with the variant attempt */
  lastInteraction: Scalars['DateTime']['output'];
  /** The variant that the attempt belongs to */
  variant: AssessmentVariant;
};

/** An evaluation of a completed attempt (deprecated) */
export type AssessmentVariantAttemptEvaluation = {
  __typename?: 'AssessmentVariantAttemptEvaluation';
  /** The percentile associated with this score, compared amongst all users' attempts of this assessment */
  percentile: Scalars['Int']['output'];
  /**
   * The score obtained by the user after completing the attempt
   * Scores can range from 0-200, with 100 representing an average score.
   */
  score: Scalars['Float']['output'];
};

/** An asset is a fundamental resource unit (like images, videos, subtitles, texts) for building learning experiences at Udemy. Asset endpoint provides metadata, the storage location, access permission and its type. */
export type Asset = {
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** Unique ID to identify an Asset */
  id: Scalars['ID']['output'];
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Status of the asset */
  status: AssetStatus;
};

/** Represents an article asset, including download information and article content. */
export type AssetArticle = Asset & {
  __typename?: 'AssetArticle';
  /** Article blob, HTML represented as string. */
  article: Scalars['SafeHtml']['output'];
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Article size measured in bytes */
  sizeInBytes: Scalars['Int']['output'];
  /** Status of the article asset */
  status: AssetStatus;
  /** Title of the article asset */
  title: Scalars['String']['output'];
};

/** Represents an audio asset, including download information, captions, and DRM status. */
export type AssetAudio = Asset & {
  __typename?: 'AssetAudio';
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** Duration of the audio in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** Whether the audio is DRM protected */
  isDrmProtected: Scalars['Boolean']['output'];
  /** Media sources for streaming the audio */
  mediaSources: Array<AssetMediaSource>;
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Status of the audio asset */
  status: AssetStatus;
  /** Title of the audio asset */
  title: Scalars['String']['output'];
};

/** Captions are the WebVTT standard files needed for rendering subtitles */
export type AssetCaption = {
  __typename?: 'AssetCaption';
  /** S3 key path */
  fileName: Scalars['String']['output'];
  /** Unique identifier to identify an asset */
  id: Scalars['ID']['output'];
  /** Language identifier, ex: tr_TR is Turkish caption */
  language: Scalars['Locale']['output'];
  /** Auto or manually generated captions */
  source: CaptionSource;
  /** Translation / transcription pipeline status of caption generation */
  status: AssetStatus;
  /** Title of the caption */
  title: Scalars['String']['output'];
  /** URL to the caption file */
  url: Scalars['URL']['output'];
  /** Human readable language definition with source appended, ex: Turkish [Auto] */
  videoLabel: Scalars['String']['output'];
};

/** Download information for a given asset */
export type AssetDownload = {
  __typename?: 'AssetDownload';
  /** For video assets it can be a supported resolution and for others could be a string like 'download' */
  label: Scalars['String']['output'];
  /** URL path for the asset file */
  urlFile: Scalars['URL']['output'];
};

/** Represents an ebook asset */
export type AssetEbook = Asset & {
  __typename?: 'AssetEbook';
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** Number of slides/pages in the ebook */
  numberOfSlides: Scalars['Int']['output'];
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Status of the ebook asset */
  status: AssetStatus;
  /** Current processing step of the ebook */
  step: Scalars['Int']['output'];
  /** Title of the ebook */
  title: Scalars['String']['output'];
};

/** Represents an external link asset, typically used for linking to external resources or websites. */
export type AssetExternalLink = Asset & {
  __typename?: 'AssetExternalLink';
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** External URL */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** Subset of filetypes supported (matching the underlying MIME-type of the Asset file itself) */
  fileType?: Maybe<AssetFileType>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Status of the external link asset */
  status: AssetStatus;
  /** Title of the external link asset */
  title: Scalars['String']['output'];
};

/** Represents a file asset, including download information and file type. */
export type AssetFile = Asset & {
  __typename?: 'AssetFile';
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** Subset of filetypes supported (matching the underlying MIME-type of the Asset file itself) */
  fileType?: Maybe<AssetFileType>;
  /** Unique ID to identify an Asset */
  id: Scalars['ID']['output'];
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Status of the file asset */
  status: AssetStatus;
  /** Title or filename of the file asset */
  title: Scalars['String']['output'];
};

/**
 * Categories for file asset types. These categories roughly map to MIME types.
 * See https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/MIME_types/Common_types for details
 */
export enum AssetFileType {
  /** Roughly equivalent to code-like MIME types (text/html, text/javascript, text/css, etc.); A code file */
  Code = 'CODE',
  /** Roughly equivalent to document-like MIME types (application/pdf, text/markdown, etc.); A document file */
  Document = 'DOCUMENT',
  /** Roughly equivalent to image-like MIME types (e.g. image/jpeg, image/gif, etc.); An image file */
  Image = 'IMAGE',
  /** Equivalent to application/octet-stream; Default for all other non-textual cases. */
  Other = 'OTHER',
  /** Equivalent to text/plain; Default for textual file cases. A textual (.txt) file should be human-readable and must not contain binary data. */
  Text = 'TEXT',
  /** Roughly equivalent to zip-like MIME types (e.g. application/gzip, application/zip, etc.); A compressed archive file */
  Zip = 'ZIP'
}

/** Represents an iframe asset */
export type AssetIFrame = Asset & {
  __typename?: 'AssetIFrame';
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** External URL for the iframe content */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Source URL for the iframe content */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** Status of the iframe asset */
  status: AssetStatus;
  /** Title of the iframe */
  title: Scalars['String']['output'];
};

/** Represents an imported content asset */
export type AssetImportContent = Asset & {
  __typename?: 'AssetImportContent';
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** External URL for the imported content */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Status of the imported content asset */
  status: AssetStatus;
  /** Title of the imported content */
  title: Scalars['String']['output'];
};

/** Media source provides the info to download and stream the media artifacts */
export type AssetMediaSource = {
  __typename?: 'AssetMediaSource';
  /** Is it manual or auto generated media resource */
  label: Scalars['String']['output'];
  /** Media container MIME types */
  mediaType: MediaSourceType;
  /** Source URL */
  src: Scalars['URL']['output'];
};

/** Represents a presentation asset */
export type AssetPresentation = Asset & {
  __typename?: 'AssetPresentation';
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** Number of slides in the presentation */
  numberOfSlides: Scalars['Int']['output'];
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Status of the presentation asset */
  status: AssetStatus;
  /** Current processing step of the presentation */
  step: Scalars['Int']['output'];
  /** Title of the presentation */
  title: Scalars['String']['output'];
};

/** Represents a source code asset */
export type AssetSourceCode = Asset & {
  __typename?: 'AssetSourceCode';
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** Subset of filetypes supported (matching the underlying MIME-type of the Asset file itself) */
  fileType?: Maybe<AssetFileType>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Status of the source code asset */
  status: AssetStatus;
  /** Title of the source code asset */
  title: Scalars['String']['output'];
};

/** Status of asset processing. */
export enum AssetStatus {
  /** The caption processing failed. */
  Failed = 'FAILED',
  /** The caption is currently being processed. */
  Processing = 'PROCESSING',
  /** The caption was processed successfully. */
  Success = 'SUCCESS',
  /** The caption is unprocessed. */
  Unprocessed = 'UNPROCESSED'
}

/** Thumbnail tracks are used for sneak-peek feature. provides a composite image and a metadata file with a timestamp and cartesian plane co-ordinates of a image rectangle. */
export type AssetThumbnailTrack = {
  __typename?: 'AssetThumbnailTrack';
  /** A composite image which is a collage of I frame images. */
  imgUrl: Scalars['URL']['output'];
  /** Captions-like file provides a relative timestamp and the cartesian coordinate. */
  vttUrl: Scalars['URL']['output'];
};

/** Represents a video asset, including download information, captions, and DRM status. */
export type AssetVideo = Asset & {
  __typename?: 'AssetVideo';
  /** Media access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** Captions */
  captions?: Maybe<Array<AssetCaption>>;
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** Length of the asset. Duration in seconds for video assets. */
  duration: Scalars['DurationInSeconds']['output'];
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** Course content is encrypted/DRM */
  isDrmProtected: Scalars['Boolean']['output'];
  /** Media sources */
  mediaSources: Array<AssetMediaSource>;
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Status of the video asset */
  status: AssetStatus;
  /** Thumbnail track */
  thumbnailTrack?: Maybe<AssetThumbnailTrack>;
  /** Title of the video asset */
  title: Scalars['String']['output'];
};

/** Represents a Video Mashup asset, including download information and file type. */
export type AssetVideoMashup = Asset & {
  __typename?: 'AssetVideoMashup';
  /** Media access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** Captions */
  captions?: Maybe<Array<AssetCaption>>;
  /** Download urls for asset. Used in native for download feature. */
  downloads: Array<AssetDownload>;
  /** Length of the asset. Duration in seconds for video assets. */
  duration: Scalars['DurationInSeconds']['output'];
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** Course content is encrypted/DRM */
  isDrmProtected: Scalars['Boolean']['output'];
  /** Media sources */
  mediaSources: Array<AssetMediaSource>;
  /** List of processing errors for failed assets */
  processingErrors?: Maybe<Array<ProcessingError>>;
  /** Slides of the Video Mashup */
  slides?: Maybe<Array<Slide>>;
  /** Status of the video asset */
  status: AssetStatus;
  /** Thumbnail track */
  thumbnailTrack?: Maybe<AssetThumbnailTrack>;
  /** Title of the video mashup asset */
  title: Scalars['String']['output'];
};

/** Lecture in the form of just audio (deprecated) */
export type AudioLecture = CurriculumItem & Lecture & {
  __typename?: 'AudioLecture';
  /** Lecture's main learning asset */
  asset?: Maybe<Asset>;
  /** The Course this lecture belongs to */
  course?: Maybe<Course>;
  /** Instructor-authored description of the lecture, may contain HTML */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** Total duration of the lecture's content in seconds */
  durationInSeconds: Scalars['DurationInSeconds']['output'];
  /** Id of the lecture */
  id: Scalars['ID']['output'];
  /** Images by their dimensions */
  images: LectureImages;
  /** If user has completed the lecture */
  isCompleted: Scalars['Boolean']['output'];
  /** Whether this lecture is used for promos and course previews. */
  isPreviewable: Scalars['Boolean']['output'];
  /** Lecture's supplementary resources */
  resources?: Maybe<Array<Maybe<Asset>>>;
  /** Associated learning products for supplementary learning */
  supplementaryLearningProducts: Array<LearningProduct>;
  /** The URL of the lecture thumbnail */
  thumbnail?: Maybe<Scalars['URL']['output']>;
  /** Lecture title */
  title: Scalars['String']['output'];
  /** The URL to access the lecture on the auto-enroll page */
  urlAutoEnroll: Scalars['URL']['output'];
  /** Download URL for lecture */
  urlDownload?: Maybe<Scalars['URL']['output']>;
  /** Landing page to view this Lecture */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the lecture */
  versionedIdentifier: VersionedIdentifier;
};


/** Lecture in the form of just audio (deprecated) */
export type AudioLectureSupplementaryLearningProductsArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** Defines what chat format configuration should be used for assistant messages */
export type AudioResponseConfigInput = {
  /** The data transfer type */
  dataTransferType: DataTransferType;
  /** The content type of the data */
  fileContentType?: InputMaybe<Scalars['String']['input']>;
  /** The pusher channel config */
  pusherResponseConfig?: InputMaybe<PusherResponseConfigInput>;
};

/** Defines the types of events that occurred. */
export enum AuditEvent {
  /** A user has been assigned by csv. */
  AssignUsersByCsv = 'ASSIGN_USERS_BY_CSV',
  /** A group has been created. */
  GroupCreated = 'GROUP_CREATED',
  /** A group has been deleted. */
  GroupDeleted = 'GROUP_DELETED',
  /** A group has been edited. */
  GroupEdited = 'GROUP_EDITED',
  /** An invitation has been created. */
  InvitationCreated = 'INVITATION_CREATED',
  /** A license has been created. */
  LicenseActivated = 'LICENSE_ACTIVATED',
  /** A license has been deactivated. */
  LicenseDeactivated = 'LICENSE_DEACTIVATED',
  /** A user has been activated. */
  UserActivated = 'USER_ACTIVATED',
  /** A user has been anonymized. */
  UserAnonymized = 'USER_ANONYMIZED',
  /** A user has been created. */
  UserCreated = 'USER_CREATED',
  /** A user has been deactivated. */
  UserDeactivated = 'USER_DEACTIVATED',
  /** A user email has been edited. */
  UserEmailEdited = 'USER_EMAIL_EDITED',
  /** A user list has been exported to csv. */
  UserListExportedToCsv = 'USER_LIST_EXPORTED_TO_CSV',
  /** A user is pending. */
  UserPending = 'USER_PENDING',
  /** A user has been reactivated. */
  UserReactivated = 'USER_REACTIVATED',
  /** A user role has been assigned. */
  UserRoleAssigned = 'USER_ROLE_ASSIGNED',
  /** A user role has been edited. */
  UserRoleEdited = 'USER_ROLE_EDITED',
  /** A user has been updated. */
  UserUpdated = 'USER_UPDATED'
}

/** Input type for filtering logs based on a date time range. */
export type AuditLogDateFilter = {
  /** The end date time of the range for fetching logs. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The start date time of the range for fetching logs. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Authentication credentials for accessing an AWS cloud lab instance */
export type AwsCloudLabInstanceCredentials = {
  __typename?: 'AwsCloudLabInstanceCredentials';
  /** AWS access key ID for programmatic access */
  accessKeyId?: Maybe<Scalars['String']['output']>;
  /** URL for AWS console access */
  consoleUrl?: Maybe<Scalars['URL']['output']>;
  /** AWS secret access key paired with the access key ID */
  secretAccessKey?: Maybe<Scalars['String']['output']>;
  /** Temporary session token for AWS STS-based authentication */
  sessionToken?: Maybe<Scalars['String']['output']>;
};

/** Authentication credentials for accessing an Azure cloud lab instance */
export type AzureCloudLabInstanceCredentials = {
  __typename?: 'AzureCloudLabInstanceCredentials';
  /** URL to the Azure portal login page */
  loginUrl?: Maybe<Scalars['URL']['output']>;
  /** Password for Azure account authentication */
  password?: Maybe<Scalars['String']['output']>;
  /** Azure resource group assigned to the lab instance */
  resourceGroup?: Maybe<Scalars['String']['output']>;
  /** Temporary Access Pass (TAP) for passwordless authentication scenarios */
  temporaryAccessPassword?: Maybe<Scalars['String']['output']>;
  /** Username for Azure account authentication */
  username?: Maybe<Scalars['String']['output']>;
};

/** Issued Badge of a user (Assertion in OpenBadge specification) */
export type BadgeAssertion = {
  __typename?: 'BadgeAssertion';
  /** The BadgeClass object that this Assertion is issued for */
  badgeClass: BadgeClass;
  /** The date this assertion expires */
  expires?: Maybe<Scalars['Date']['output']>;
  /** IRI of the Assertion. IRI of OpenBadge specification */
  externalUrl: Scalars['URL']['output'];
  /** ID of the Assertion. */
  id: Scalars['ID']['output'];
  /** The date this assertion is issued */
  issuedOn: Scalars['Date']['output'];
  /** The url of the uploaded baked image of assertion */
  uploadedImageUrl?: Maybe<Scalars['URL']['output']>;
  /** Owner of the assertion */
  user: User;
};

/** Response for storing assertion (which is given as external url) for current user */
export type BadgeAssertionCreateOrUpdateResponse = {
  __typename?: 'BadgeAssertionCreateOrUpdateResponse';
  /** The BadgeAssertion object that was stored */
  badgeAssertion?: Maybe<BadgeAssertion>;
};

/** Response for deleting assertion of current user */
export type BadgeAssertionDeleteResponse = {
  __typename?: 'BadgeAssertionDeleteResponse';
  /** The ID of the deleted badge assertion */
  badgeAssertionId?: Maybe<Scalars['ID']['output']>;
};

/** Issued badges of a user (Assertion in OpenBadge specification) */
export type BadgeAssertionPaged = Paginated & {
  __typename?: 'BadgeAssertionPaged';
  /** List of BadgeAssertions */
  items: Array<BadgeAssertion>;
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages. Calculated as (total result count / page pageSize) */
  pageCount: Scalars['Int']['output'];
  /** Total number of BadgeAssertions */
  totalCount: Scalars['Int']['output'];
};

/** Search filters for Badge Assertion search */
export type BadgeAssertionsSearchFilters = {
  /** if given, assertions will be filtered by these badgeClasses */
  badgeClassExternalUrls?: InputMaybe<Array<Scalars['URL']['input']>>;
  /** endDate to filter assertions by dateUploaded. If not given, all assertions will be returned */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** startDate to filter assertions by dateUploaded. If not given, all assertions will be returned */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Certification Provider (topic descriptor) for Open Badges */
export type BadgeCertificationProvider = {
  __typename?: 'BadgeCertificationProvider';
  /** ID of certification provider */
  id: Scalars['ID']['output'];
  /** Title of certification provider(Google, Microsoft) */
  name: Scalars['String']['output'];
};

/** Certification Subject Area (topic descriptor) for Open Badges */
export type BadgeCertificationSubjectArea = {
  __typename?: 'BadgeCertificationSubjectArea';
  /** ID of certification subject area */
  id: Scalars['ID']['output'];
  /** Title of certification subject area(Cloud, SQL) */
  name: Scalars['String']['output'];
};

/** The BadgeClass interface. A collection of information about the accomplishment recognized by the Open Badge. It means Certification for the most cases. */
export type BadgeClass = {
  /** An object describing which objectives or educational standards this badge aligns to, if any. */
  alignment?: Maybe<Array<BadgeClassAlignment>>;
  /** User's assertions for the badge class */
  assertions: Array<BadgeAssertion>;
  /** Exam registration details, if an exam is required for earning this Badge */
  certificationExam?: Maybe<CertificationExam>;
  /** Criteria document describing how to earn the BadgeClass (Certification) */
  criteria: BadgeClassCriteria;
  /** A short description of BadgeClass */
  description: Scalars['String']['output'];
  /** User's enrollments for the badge class */
  enrollments: Array<BadgeClassEnrollment>;
  /** Links to exam registration page for this certification (deprecated) */
  examRegistrationUrls: Array<CertificationExamUrl>;
  /** IRI of the BadgeClass. IRI of OpenBadge specification */
  externalUrl: Scalars['URL']['output'];
  /** ID of the BadgeClass. */
  id: Scalars['ID']['output'];
  /** A PNG or SVG image of the BadgeClass */
  image: BadgeClassImage;
  /** Whether the current user is enrolled */
  isEnrolled: Scalars['Boolean']['output'];
  /** Organization that issued the badge. */
  issuer: BadgeClassIssuer;
  /** Name of the BadgeClass */
  name: Scalars['String']['output'];
  /** Certification Provider for this Badge Class */
  providers?: Maybe<Array<BadgeCertificationProvider>>;
  /** Subject Area (recently renamed to Skill Area) for this BadgeClass (i.e. Data Science, CyberSecurity) */
  subjectAreas?: Maybe<Array<BadgeCertificationSubjectArea>>;
  /** A tag that describes the type of achievement. (Skills) */
  tags: Array<Scalars['String']['output']>;
  /** Topic of badge class. Can be null for badge classes uploaded by users */
  topic?: Maybe<Topic>;
  /** Total number of assertions issued for this badge class */
  totalAssertionsCount: Scalars['Int']['output'];
  /** Type of the BadgeClass. In most cases, this will simply be the string BadgeClass */
  type: Array<Scalars['String']['output']>;
  /** Visibility of the badge class on the Udemy platform (only available for applications with admin:application scope) */
  visibilityStatus: BadgeClassVisibilityStatus;
};

/** Alignment object. An intangible item that describes an alignment between a learning resource and a BadgeClass */
export type BadgeClassAlignment = {
  __typename?: 'BadgeClassAlignment';
  /** If applicable, a locally unique string identifier that identifies the alignment target within its framework and/or targetUrl. */
  targetCode?: Maybe<Scalars['String']['output']>;
  /** Short description of the alignment target. */
  targetDescription?: Maybe<Scalars['String']['output']>;
  /** Name of the framework the alignment target. */
  targetFramework?: Maybe<Scalars['String']['output']>;
  /** Name of the alignment. */
  targetName?: Maybe<Scalars['String']['output']>;
  /** URL linking to the official description of the alignment target, for example an individual standard within an educational framework. */
  targetUrl?: Maybe<Scalars['URL']['output']>;
};

/** Input for BadgeClassAlignment */
export type BadgeClassAlignmentInput = {
  /** If applicable, a locally unique string identifier that identifies the alignment target within its framework and/or targetUrl. */
  targetCode?: InputMaybe<Scalars['String']['input']>;
  /** Short description of the alignment target. */
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  /** Name of the framework the alignment target. */
  targetFramework?: InputMaybe<Scalars['String']['input']>;
  /** Name of the alignment. */
  targetName: Scalars['String']['input'];
  /** URL linking to the official description of the alignment target, for example an individual standard within an educational framework. */
  targetUrl: Scalars['URL']['input'];
};

/** Descriptive metadata about the achievements necessary to be issued with particular BadgeClass (Certification). */
export type BadgeClassCriteria = {
  __typename?: 'BadgeClassCriteria';
  /** The URI of a webpage that describes in a human-readable format the criteria for the BadgeClass */
  id?: Maybe<Scalars['URL']['output']>;
  /** A narrative of what is needed to earn the badge. */
  narrative?: Maybe<Scalars['String']['output']>;
  /** Type of the Criteria */
  type?: Maybe<Array<Scalars['String']['output']>>;
};

/** Enrolled learning products for a badge class */
export type BadgeClassEnrollment = {
  __typename?: 'BadgeClassEnrollment';
  /** Completion percentage for the learning product */
  completionPercentage: Scalars['NonNegativeFloat']['output'];
  /** Learning Product */
  learningProduct: LearningProduct;
};

/** Image object of BadgeClass or Issuer */
export type BadgeClassImage = {
  __typename?: 'BadgeClassImage';
  /** The author of the image */
  author?: Maybe<Scalars['String']['output']>;
  /** The caption for the image */
  caption?: Maybe<Scalars['String']['output']>;
  /** URI of the image */
  id: Scalars['ID']['output'];
  /** Type of Image */
  type?: Maybe<Array<Scalars['String']['output']>>;
};

/** Issuer of BadgeClass. A collection of information that describes the entity or organization */
export type BadgeClassIssuer = {
  __typename?: 'BadgeClassIssuer';
  /** A short description of the issuer entity or organization. */
  description?: Maybe<Scalars['String']['output']>;
  /** Contact address for the individual or organization. */
  email?: Maybe<Scalars['EmailAddress']['output']>;
  /** Unique IRI for the Issuer/Profile file */
  id: Scalars['ID']['output'];
  /** IRI or document representing an image of the issuer. This must be a PNG or SVG image. */
  image?: Maybe<BadgeClassImage>;
  /** The name of the entity or organization. */
  name: Scalars['String']['output'];
  /** A phone number for the entity. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** Issuer type. In most cases, this will simply be the string Issuer or the more general Profile */
  type: Array<Scalars['String']['output']>;
  /** The homepage or social media profile of the entity, whether individual or institutional */
  url: Scalars['URL']['output'];
};

/** Register a badge issuer for an organization */
export type BadgeClassIssuerRegisterInput = {
  /** Short description of the organization */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Contact E-mail of the organization */
  email: Scalars['EmailAddress']['input'];
  /** URL of the Organization's logo, could be S3 path as well. TBD */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Organization to appear on Badges */
  name: Scalars['String']['input'];
  /** URL of the Organization's home page or Social media profile */
  url: Scalars['URL']['input'];
};

/** Response for registering a badge issuer for an organization */
export type BadgeClassIssuerRegisterResponse = {
  __typename?: 'BadgeClassIssuerRegisterResponse';
  /** Instance of the created issuer */
  issuer?: Maybe<BadgeClassIssuer>;
};

/** Search filters for Organization BadgeClasses search */
export type BadgeClassOrganizationSearchFilters = {
  /** Filter to include draft badge classes in the response */
  includeUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Search filters for BadgeClass search */
export type BadgeClassSearchFilters = {
  /** Filter by certification subject area */
  certificationAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by certification provider. this has precedence over issuerIds */
  certificationProviderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If not given, all badges will be returned */
  visibilityStatus?: InputMaybe<Array<BadgeClassVisibilityStatus>>;
};

/** Paginated list of BadgeClasses for search response */
export type BadgeClassSearchResponse = Paginated & {
  __typename?: 'BadgeClassSearchResponse';
  /** List of BadgeClasses */
  items: Array<BadgeClass>;
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages. Calculated as (total result count / page pageSize) */
  pageCount: Scalars['Int']['output'];
};

/** Wrapped response type for BadgeClass mutations */
export type BadgeClassUpdateResponse = {
  __typename?: 'BadgeClassUpdateResponse';
  /** The BadgeClass object */
  badgeClass?: Maybe<BadgeClass>;
};

/** Input for updating a badge classes by topicId */
export type BadgeClassUpdateTopicInput = {
  /** ID of the BadgeClass. */
  id: Scalars['ID']['input'];
  /** Topic of badge class */
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for updating a badge classes by visibilityStatus */
export type BadgeClassUpdateVisibilityStatusInput = {
  /** ID of the BadgeClass. */
  id: Scalars['ID']['input'];
  /** Visibility of the badge class on the Udemy platform (only available for applications with admin:application scope) */
  visibilityStatus: BadgeClassVisibilityStatus;
};

/** Visibility of the badge class on the Udemy platform */
export enum BadgeClassVisibilityStatus {
  /** Deleted badges */
  Deleted = 'DELETED',
  /** Hidden from users on the platform */
  Hidden = 'HIDDEN',
  /** Visible to users on the platform, but not discoverable in search */
  InstructorIssued = 'INSTRUCTOR_ISSUED',
  /** Visible to users on the platform, but not discoverable in search, and only visible to users in the issuing organization */
  Organization = 'ORGANIZATION',
  /** Hidden from users on the platform, awaiting content or planning updates */
  Pending = 'PENDING',
  /** Visible to all users */
  Visible = 'VISIBLE'
}

/** Badge enrollment */
export type BadgeEnrollment = {
  __typename?: 'BadgeEnrollment';
  /** The badge that the user is enrolled in */
  badge: BadgeClass;
};

/** Response object for badge issuance CSV upload */
export type BadgeIssuanceCsvUploadResponse = {
  __typename?: 'BadgeIssuanceCsvUploadResponse';
  /**
   * The CSV upload will be processed asynchronously.
   * Backend can respond with a message for the user with this field.
   */
  message?: Maybe<Scalars['String']['output']>;
};

/** SubCategory with no additional fields */
export type BadgeSubCategory = SubCategory & {
  __typename?: 'BadgeSubCategory';
  /** ID of the subcategory */
  id: Scalars['ID']['output'];
  /** Name of the subcategory */
  name: Scalars['String']['output'];
};

/** Represents a badge awarded to a beginner top-rated category topic. */
export type BeginnerTopRatedCategoryTopicBadge = LearningProductBadge & {
  __typename?: 'BeginnerTopRatedCategoryTopicBadge';
  /** The category associated with the badge. */
  category?: Maybe<Category>;
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
  /** The rank of the badge, e.g. 1,2,3 */
  rank: Scalars['NonNegativeInt']['output'];
  /** The topic associated with the badge. */
  topic?: Maybe<Topic>;
};

/** Represents a badge awarded to a beginner top-rated subcategory. */
export type BeginnerTopRatedSubcategoryBadge = LearningProductBadge & {
  __typename?: 'BeginnerTopRatedSubcategoryBadge';
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
  /** The rank of the badge. */
  rank: Scalars['NonNegativeInt']['output'];
  /** The subcategory associated with the badge. */
  subcategory?: Maybe<BadgeSubCategory>;
};

/** Represents a badge awarded to a beginner top-rated subcategory topic. */
export type BeginnerTopRatedSubcategoryTopicBadge = LearningProductBadge & {
  __typename?: 'BeginnerTopRatedSubcategoryTopicBadge';
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
  /** The rank of the badge. */
  rank: Scalars['NonNegativeInt']['output'];
  /** The subcategory associated with the badge. */
  subcategory?: Maybe<BadgeSubCategory>;
  /** The topic associated with the badge. */
  topic?: Maybe<Topic>;
};

/** Represents a badge awarded to a best seller category topic. */
export type BestSellerCategoryTopicBadge = LearningProductBadge & {
  __typename?: 'BestSellerCategoryTopicBadge';
  /** The category associated with the badge. */
  category?: Maybe<Category>;
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
  /** The topic associated with the badge. */
  topic?: Maybe<Topic>;
};

/** Represents a badge awarded to a best seller subcategory. */
export type BestSellerSubcategoryBadge = LearningProductBadge & {
  __typename?: 'BestSellerSubcategoryBadge';
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
  /** The subcategory associated with the badge. */
  subcategory?: Maybe<BadgeSubCategory>;
};

/** Represents a badge awarded to a best seller subcategory topic. */
export type BestSellerSubcategoryTopicBadge = LearningProductBadge & {
  __typename?: 'BestSellerSubcategoryTopicBadge';
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
  /** The subcategory associated with the badge. */
  subcategory?: Maybe<BadgeSubCategory>;
  /** The topic associated with the badge. */
  topic?: Maybe<Topic>;
};

/** A collection of products grouped together */
export type Bundle = {
  __typename?: 'Bundle';
  /** Unique identifier of the bundle */
  id: Scalars['ID']['output'];
  /** The ordered list of items included in this bundle */
  items?: Maybe<Array<BundleItem>>;
  /** The locale this bundle is intended for */
  locale?: Maybe<Scalars['Locale']['output']>;
  /** The display name of the bundle */
  name: Scalars['String']['output'];
  /** The topic associated with this bundle */
  topic?: Maybe<Topic>;
};

/** An individual item included in a bundle */
export type BundleItem = {
  __typename?: 'BundleItem';
  /** Identifier of the bundle item, unique only in combination with its product type */
  id: Scalars['ID']['output'];
  /** The product this bundle item references */
  product?: Maybe<BundleItemProduct>;
};

/** Input to identify a specific item within a bundle */
export type BundleItemInput = {
  /** The identifier of the item (e.g. a course ID, practice test ID, or certification voucher exam ID) */
  id: Scalars['ID']['input'];
  /** The type of the item */
  type: BundleItemType;
};

/** A product that can be included in a bundle */
export type BundleItemProduct = CertificationVoucherExam | Course | PracticeTest;

/** The type of product that can be included in a bundle */
export enum BundleItemType {
  /** A certification voucher exam */
  CertificationVoucherExam = 'CERTIFICATION_VOUCHER_EXAM',
  /** A course */
  Course = 'COURSE',
  /** A practice test */
  PracticeTest = 'PRACTICE_TEST'
}

/** Cursor-paginated list of bundles */
export type BundlesPaged = CursorPaginatedResponse & {
  __typename?: 'BundlesPaged';
  /** Opaque cursor for the next page of results */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The list of bundles in this page */
  items?: Maybe<Array<Maybe<Bundle>>>;
};

/** The source of the caption: user-uploaded or automatically generated. */
export enum CaptionSource {
  /** Automatically generated caption. */
  Auto = 'AUTO',
  /** User uploaded caption. */
  Manual = 'MANUAL'
}

/** Types of captions */
export enum CaptionType {
  /** Captions covering speech and descriptions of non-spoken sounds */
  ClosedCaption = 'CLOSED_CAPTION',
  /** Captions covering speech only */
  Subtitle = 'SUBTITLE'
}

/** The Career Accelerator object. */
export type CareerAccelerator = LearningProduct & {
  __typename?: 'CareerAccelerator';
  /** Articles associated with the Career Accelerator. */
  articles: Array<CareerAcceleratorArticle>;
  /** The associated career for the Career Accelerator. */
  career: CareerAcceleratorCareerInfo;
  /** Info about the certificate that a user may receive from the accelerator. Will be null if the path have a certificate that the user may earn. */
  certificateInfo?: Maybe<CareerAcceleratorCertificateInfo>;
  /** Completion percentage for the current user of the accelerator (using the earning criteria for Grow With Google badges) */
  completionPercentage?: Maybe<Scalars['NonNegativeFloat']['output']>;
  /** Content collection specific properties */
  contentCollectionInfo?: Maybe<CareerAcceleratorContentCollectionInfo>;
  /** The curriculum associated with the Career Accelerator. */
  curriculum: CareerAcceleratorCurriculum;
  /** Frequently Asked Questions (FAQs) associated with the Career Accelerator. */
  faqs: Array<CareerAcceleratorFaq>;
  /** The heading of the Career Accelerator. */
  heading: Scalars['String']['output'];
  /** The ID of the Career Accelerator. */
  id: Scalars['ID']['output'];
  /** Whether the current user is enrolled in the Course Accelerator or not */
  isEnrolled?: Maybe<Scalars['Boolean']['output']>;
  /** The Language of the Career Accelerator. */
  language: LanguageCode;
  /** The primary description of the Career Accelerator. */
  primaryDescription: Scalars['String']['output'];
  /** The primary topic of the Career Accelerator. */
  primaryTopic?: Maybe<Topic>;
  /** Promotional Video Asset for an accelerator (asset should be public) */
  promoVideo?: Maybe<Asset>;
  /** Free-form ribbons (aka badges/labels) for accelerators */
  ribbons?: Maybe<Array<Scalars['String']['output']>>;
  /** The secondary description of the Career Accelerator. */
  secondaryDescription?: Maybe<Scalars['String']['output']>;
  /** The secondary topics of the Career Accelerator. */
  secondaryTopics: Array<Topic>;
  /** The SEO description of the Career Accelerator. */
  seoDescription: Scalars['String']['output'];
  /** The slug of the Career Accelerator used to uniquely identify the Career Accelerator in URLs. */
  slug: Scalars['String']['output'];
  /** Stats related to the learning content in this accelerator */
  stats?: Maybe<CareerAcceleratorContentStats>;
  /** The heading for the testimonial block. */
  testimonialHeading?: Maybe<Scalars['String']['output']>;
  /** Testimonials associated with the Career Accelerator. */
  testimonials: Array<CareerAcceleratorTestimonial>;
};

/** An article associated with a Career Accelerator. */
export type CareerAcceleratorArticle = {
  __typename?: 'CareerAcceleratorArticle';
  /** The author of the article. */
  author: CareerAcceleratorArticleAuthor;
  /** The number of minutes it takes to read the article. */
  minutesToRead?: Maybe<Scalars['Int']['output']>;
  /** The title of the article. */
  title: Scalars['String']['output'];
  /** The URL of the article. */
  url: Scalars['String']['output'];
};

/** An author of a Career Accelerator article. */
export type CareerAcceleratorArticleAuthor = {
  __typename?: 'CareerAcceleratorArticleAuthor';
  /** The name of the article author. */
  name: Scalars['String']['output'];
  /** The thumbnail image URL of the article author. */
  thumbnail?: Maybe<Scalars['String']['output']>;
};

/** A Career object representing a specific career path or field. */
export type CareerAcceleratorCareerInfo = {
  __typename?: 'CareerAcceleratorCareerInfo';
  /** Text representation of the average salary for this Career. */
  averageSalary: Scalars['String']['output'];
  /** The description of the Career. */
  description: Scalars['String']['output'];
  /** The hero image associated with the Career. */
  heroImage: CareerAcceleratorCareerInfoHeroImage;
  /** The image associated with the Career. */
  image: CareerAcceleratorCareerInfoImage;
  /** The name of the Career. */
  name: Scalars['String']['output'];
  /** The number of open job positions in this Career. */
  openJobPositionsCount: Scalars['Int']['output'];
};

/** A CareerHeroImage object representing hero images associated with a Career. */
export type CareerAcceleratorCareerInfoHeroImage = {
  __typename?: 'CareerAcceleratorCareerInfoHeroImage';
  /** The URL for the hero image of the Career. */
  hero: Scalars['String']['output'];
  /** The URL for the medium icon image of the Career. */
  mediumIcon: Scalars['String']['output'];
  /** The URL for the xxlarge icon image of the Career. */
  xxlargeIcon: Scalars['String']['output'];
};

/** A CareerImage object representing images associated with a Career. */
export type CareerAcceleratorCareerInfoImage = {
  __typename?: 'CareerAcceleratorCareerInfoImage';
  /** The URL for the square image of the Career. */
  square: Scalars['String']['output'];
  /** The URL for the wide image of the Career. */
  wide: Scalars['String']['output'];
};

/** A Certificate Info object representing information about the certificate an accelerator might give a user (Udemy and/or OpenBadge.) This is NOT the user's actual certificate. */
export type CareerAcceleratorCertificateInfo = {
  __typename?: 'CareerAcceleratorCertificateInfo';
  /** Badge issued for an accelerator (can be null) */
  badge?: Maybe<BadgeClass>;
  /** If the accelerator has an associated certificate, this is the URL to an image used on the certificate */
  certificateImageUrl?: Maybe<Scalars['String']['output']>;
};

/** CareerAccelerator collection specific properties */
export type CareerAcceleratorContentCollectionInfo = {
  __typename?: 'CareerAcceleratorContentCollectionInfo';
  /** Indicates if CareerAccelerator is part of a Google partner content collection */
  isInGooglePartnerCollection: Scalars['Boolean']['output'];
};

/** Stats related to the items in the career accelerator */
export type CareerAcceleratorContentStats = {
  __typename?: 'CareerAcceleratorContentStats';
  /** The weighted average rating of the courses in the career accelerator */
  averageRating?: Maybe<Scalars['AverageRating']['output']>;
  /** The aggregate duration in seconds of the courses in the career accelerator */
  durationInSeconds?: Maybe<Scalars['DurationInSeconds']['output']>;
  /** The aggregate enrollments for the courses in the career accelerator */
  enrollments?: Maybe<CourseEnrollments>;
  /** The number of courses in the career accelerator */
  numberOfCourses?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** The number of quizzes, practice tests, coding exercises, and labs in the career accelerator */
  numberOfPracticeExercises?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** The aggregate number of ratings in the courses in the career accelerator */
  numberOfRatings?: Maybe<Scalars['NonNegativeInt']['output']>;
};

/** A curriculum for a Career Accelerator, containing sections and items. */
export type CareerAcceleratorCurriculum = {
  __typename?: 'CareerAcceleratorCurriculum';
  /** The sections of the Career Accelerator curriculum. */
  sections: Array<CareerAcceleratorCurriculumSection>;
};

/** A curriculum item in the Career Accelerator, representing a learning product. */
export type CareerAcceleratorCurriculumItem = {
  __typename?: 'CareerAcceleratorCurriculumItem';
  /** The ID of this curriculum item. */
  id: Scalars['ID']['output'];
  /** The learning outcome for this curriculum item. */
  learningOutcome?: Maybe<CareerAcceleratorLearningOutcome>;
  /** The Learning Product associated with this curriculum item. */
  learningProduct?: Maybe<LearningProduct>;
  /** Subjects covered in this curriculum item. */
  subjects: Array<CareerAcceleratorSubject>;
};

/** A section in the Career Accelerator curriculum, containing items. */
export type CareerAcceleratorCurriculumSection = {
  __typename?: 'CareerAcceleratorCurriculumSection';
  /** The items in this section of the Career Accelerator curriculum. */
  items: Array<CareerAcceleratorCurriculumItem>;
};

/** Career accelerator enrollment */
export type CareerAcceleratorEnrollment = {
  __typename?: 'CareerAcceleratorEnrollment';
  /** Time at which the enrollment was archived (null if not archived). */
  archiveTime?: Maybe<Scalars['DateTime']['output']>;
  /** The career accelerator that the user is enrolled in */
  careerAccelerator: CareerAccelerator;
  /** Completion percentage for the current user of the accelerator (using the earning criteria for Grow With Google badges) */
  completionPercentage?: Maybe<Scalars['NonNegativeFloat']['output']>;
  /** Time when the career accelerator was most recently completed (null if not) */
  completionTime?: Maybe<Scalars['DateTime']['output']>;
  /** Time of enrollment in the career accelerator */
  enrollmentTime?: Maybe<Scalars['DateTime']['output']>;
};

/** Paged career accelerator enrollments */
export type CareerAcceleratorEnrollmentsPaged = {
  __typename?: 'CareerAcceleratorEnrollmentsPaged';
  /** Cursor to the next page of career accelerator enrollments for cursor based pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** List of career accelerator enrollments. Items may be less than requested size if objects become unavailable */
  enrollments: Array<CareerAcceleratorEnrollment>;
};

/** A Frequently Asked Question (FAQ) for a Career Accelerator. */
export type CareerAcceleratorFaq = {
  __typename?: 'CareerAcceleratorFAQ';
  /** The answer text of the FAQ. */
  answer: Scalars['String']['output'];
  /** The question text of the FAQ. */
  question: Scalars['String']['output'];
};

/** Learning outcome for a Career Accelerator curriculum item. */
export type CareerAcceleratorLearningOutcome = {
  __typename?: 'CareerAcceleratorLearningOutcome';
  /** The description of this learning outcome. */
  description: Scalars['String']['output'];
  /** The title of this learning outcome. */
  title: Scalars['String']['output'];
};

/** A subject within a Career Accelerator curriculum item. */
export type CareerAcceleratorSubject = {
  __typename?: 'CareerAcceleratorSubject';
  /** The key points covered in the subject. */
  keyPoints: Array<Scalars['String']['output']>;
  /** The title of this subject. */
  title: Scalars['String']['output'];
};

/** A user testimonial for a Career Accelerator. */
export type CareerAcceleratorTestimonial = {
  __typename?: 'CareerAcceleratorTestimonial';
  /** The content of the testimonial. */
  content: Scalars['String']['output'];
  /** The link text for the testimonial URL. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The source of the testimonial. */
  source: CareerAcceleratorTestimonialSource;
  /** The type of the testimonial, e.g., COURSE_REVIEW. */
  type: CareerAcceleratorTestimonialType;
  /** The URL of the testimonial */
  url?: Maybe<Scalars['String']['output']>;
};

/** The source of a Career Accelerator testimonial. */
export type CareerAcceleratorTestimonialSource = {
  __typename?: 'CareerAcceleratorTestimonialSource';
  /** The description of the source. */
  description: Scalars['String']['output'];
  /** The image URL of the source. */
  image?: Maybe<Scalars['String']['output']>;
  /** The name of the source. */
  name: Scalars['String']['output'];
};

/** Defines the type of testimonials available for Career Accelerators. */
export enum CareerAcceleratorTestimonialType {
  /** A testimonial type representing a course review */
  CourseReview = 'COURSE_REVIEW',
  /** A testimonial type representing a third party learning testimonial */
  ThirdParty = 'THIRD_PARTY'
}

/** Input type for filtering Career Accelerators. */
export type CareerAcceleratorsFilters = {
  /** Filter accelerators that are in Google partner collection */
  isInGooglePartnerCollectionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by languages. */
  languages?: InputMaybe<Array<LanguageCode>>;
};

/** Cursor paginated Career Accelerators. */
export type CareerAcceleratorsPaged = CursorPaginatedResponse & {
  __typename?: 'CareerAcceleratorsPaged';
  /** A string that can be used to fetch the next page of results */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The list of Career Accelerators in the current page. */
  items: Array<CareerAccelerator>;
};

/** Category the Course belongs to */
export type Category = {
  /** ID of the category */
  id: Scalars['ID']['output'];
  /** Name of the category */
  name: Scalars['String']['output'];
  /** Subcategories belonging to the category */
  subcategories: Array<SubCategory>;
};

/** Category navigation list item. */
export type CategoryNavListItem = NavListItem & {
  __typename?: 'CategoryNavListItem';
  /** The category this item represents. */
  category: CourseCategory;
  /** List of child navigation items. */
  children: Array<Maybe<NavListItem>>;
};

/** A wrapper type to include the recommended Category and some additional fields about its recommendation */
export type CategoryRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'CategoryRecommendation';
  /** Underlying object of the recommendation to get more information about it */
  category?: Maybe<Category>;
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** Certification Exam for earning a Badge */
export type CertificationExam = {
  __typename?: 'CertificationExam';
  /**
   * If the Cert/Badge provider offers discount/incentive to Udemy students.
   * Private version is for display on e.g. Course Taking Page (after the person has purchased)
   * Whether or not incentive is offered may depend on the specific LearningProduct.
   */
  incentiveOfferTextPrivate?: Maybe<Scalars['SafeHtml']['output']>;
  /**
   * If the Cert/Badge provider offers discount/incentive to Udemy students.
   * Public version is for display on e.g. Course Landing Page (when the person has not yet purchased).
   * Whether or not incentive is offered may depend on the specific LearningProduct.
   */
  incentiveOfferTextPublic?: Maybe<Scalars['SafeHtml']['output']>;
  /** URL to the exam registration page for a certification */
  urlRegistration?: Maybe<Scalars['URL']['output']>;
};


/** Certification Exam for earning a Badge */
export type CertificationExamIncentiveOfferTextPrivateArgs = {
  learningProduct?: InputMaybe<LearningProductInput>;
};


/** Certification Exam for earning a Badge */
export type CertificationExamIncentiveOfferTextPublicArgs = {
  learningProduct?: InputMaybe<LearningProductInput>;
};

/** URL to the exam registration page for a certification with its locale (deprecated) */
export type CertificationExamUrl = {
  __typename?: 'CertificationExamURL';
  /** Locale this exam Is administered in */
  locale: Scalars['Locale']['output'];
  /** URL to the exam registration page for a certification */
  url: Scalars['URL']['output'];
};

/** A voucher instance */
export type CertificationVoucher = {
  __typename?: 'CertificationVoucher';
  /** The exam of the voucher */
  exam?: Maybe<CertificationVoucherExam>;
  /** The expiration date of the voucher */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the voucher */
  id: Scalars['ID']['output'];
  /** The state of the voucher */
  state: CertificationVoucherState;
  /** The voucher pool of the voucher */
  voucherPool?: Maybe<CertificationVoucherPool>;
};

/** Primary entity representing a certification exam */
export type CertificationVoucherExam = {
  __typename?: 'CertificationVoucherExam';
  /** Description of the exam */
  description?: Maybe<Scalars['String']['output']>;
  /** External URL to the exam page on the certification provider's platform */
  externalExamUrl?: Maybe<Scalars['URL']['output']>;
  /** The id of the exam */
  id: Scalars['ID']['output'];
  /** Image URL of the exam */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the user can purchase based on region */
  isAvailableForRegion: Scalars['Boolean']['output'];
  /** Whether this exam offers retake insurance as an option */
  offersRetakeInsurance: Scalars['Boolean']['output'];
  /** Details of the company which provides the certification exams */
  providerDetails: CertificationVoucherProviderDetails;
  /** FAQ style data for the exam */
  questionsAndAnswers: Array<CertificationVoucherExamQuestionAndAnswer>;
  /** Image URL of the retake pattern for the exam */
  retakePatternImageUrl?: Maybe<Scalars['URL']['output']>;
  /** SEO description of the exam */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** SEO title of the exam */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /** The slug of the exam (e.g., comptia-security-plus) */
  slug: Scalars['String']['output'];
  /** Title of the exam */
  title: Scalars['String']['output'];
  /** The certification topic associated with this exam */
  topic?: Maybe<Topic>;
  /** Value propositions of the exam */
  valuePropositions: Array<Scalars['String']['output']>;
  /** Associated voucher pools (e.g., default pool + retake insurance pool) */
  voucherPools?: Maybe<Array<Maybe<CertificationVoucherPool>>>;
};

/** FAQ style data for the voucher exam */
export type CertificationVoucherExamQuestionAndAnswer = {
  __typename?: 'CertificationVoucherExamQuestionAndAnswer';
  /** Answer of the question */
  answer: Scalars['String']['output'];
  /** Question/Header */
  question: Scalars['String']['output'];
};

/** Paginated certification voucher exams response */
export type CertificationVoucherExamsPaged = CursorPaginatedResponse & {
  __typename?: 'CertificationVoucherExamsPaged';
  /** Cursor for the next page of results */
  cursor?: Maybe<Scalars['String']['output']>;
  /** List of certification voucher exams */
  items?: Maybe<Array<Maybe<CertificationVoucherExam>>>;
};

/** Metadata and state for a group of vouchers */
export type CertificationVoucherPool = {
  __typename?: 'CertificationVoucherPool';
  /**
   * The description of the voucher pool
   * @deprecated use CertificationVoucherExam.description
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * URL to the exam page
   * @deprecated use CertificationVoucherExam.examUrl
   */
  examUrl?: Maybe<Scalars['URL']['output']>;
  /** The expiration threshold in months of the voucher pool */
  expirationThresholdInMonths?: Maybe<Scalars['Int']['output']>;
  /** Whether there are vouchers available to purchase */
  hasAvailableVouchers: Scalars['Boolean']['output'];
  /** The id of the voucher pool */
  id: Scalars['ID']['output'];
  /**
   * The image url of the voucher pool
   * @deprecated use CertificationVoucherExam.imageUrl
   */
  imageUrl: Scalars['String']['output'];
  /** Product offering type of the voucher pool */
  productType: VoucherPoolProductType;
  /**
   * FAQ style data for the voucher pool
   * @deprecated use CertificationVoucherExam.questionsAndAnswers
   */
  questionsAndAnswers?: Maybe<Array<Maybe<CertificationVoucherPoolQuestionAndAnswer>>>;
  /**
   * SEO description for the voucher pool
   * @deprecated use CertificationVoucherExam.seoDescription
   */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /**
   * SEO title for the voucher pool
   * @deprecated use CertificationVoucherExam.seoTitle
   */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /**
   * The slug of the voucher pool
   * @deprecated use CertificationVoucherExam.slug
   */
  slug: Scalars['String']['output'];
  /**
   * The title of the voucher pool
   * @deprecated use CertificationVoucherExam.title
   */
  title: Scalars['String']['output'];
  /**
   * Additional information about the voucher pool
   * @deprecated use CertificationVoucherExam.valuePropositions
   */
  valuePropositions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** FAQ style data for the voucher pool */
export type CertificationVoucherPoolQuestionAndAnswer = {
  __typename?: 'CertificationVoucherPoolQuestionAndAnswer';
  /** Answer of the question */
  answer?: Maybe<Scalars['String']['output']>;
  /** Question/Header */
  question?: Maybe<Scalars['String']['output']>;
};

/** Paginated certification voucher pools response */
export type CertificationVoucherPoolsPaged = CursorPaginatedResponse & {
  __typename?: 'CertificationVoucherPoolsPaged';
  /** Cursor for the next page of results */
  cursor?: Maybe<Scalars['String']['output']>;
  /** List of certification voucher pools */
  items: Array<Maybe<CertificationVoucherPool>>;
};

/** Details about a certification provider */
export type CertificationVoucherProviderDetails = {
  __typename?: 'CertificationVoucherProviderDetails';
  /** The display name of the certification provider */
  name: Scalars['String']['output'];
  /** The top/featured exam for this provider */
  topExam?: Maybe<CertificationVoucherExam>;
  /** The type of certification provider */
  type: CertificationVoucherProviderType;
};

/** Certification provider for voucher exams */
export enum CertificationVoucherProviderType {
  /** AWS certification provider */
  Aws = 'AWS',
  /** CompTIA certification provider */
  Comptia = 'COMPTIA',
  /** Linux Foundation certification provider */
  LinuxFoundation = 'LINUX_FOUNDATION',
  /** Microsoft certification provider */
  Microsoft = 'MICROSOFT'
}

/** The state of an individual voucher instance */
export enum CertificationVoucherState {
  /** The voucher code has been revealed to the user */
  CodeRevealed = 'CODE_REVEALED',
  /** The voucher has been purchased */
  Purchased = 'PURCHASED',
  /** The voucher is currently reserved */
  Reserved = 'RESERVED'
}

/** Possible chat feedback form selections */
export enum ChatFeedbackFormSelection {
  /** Chat feedback form selection is not correct */
  NotCorrect = 'NOT_CORRECT',
  /** Chat feedback form selection is helpful */
  NotHelpful = 'NOT_HELPFUL',
  /** Chat feedback form selection is not relevant */
  NotRelevant = 'NOT_RELEVANT',
  /** Chat feedback form selection is offensive */
  Offensive = 'OFFENSIVE',
  /** Chat feedback form selection is unspecified */
  Unspecified = 'UNSPECIFIED'
}

/** Possible chat feedback options */
export enum ChatFeedbackOption {
  /** Chat feedback is negative */
  Negative = 'NEGATIVE',
  /** Chat feedback is positive */
  Positive = 'POSITIVE',
  /** Chat feedback is unspecified */
  Unspecified = 'UNSPECIFIED'
}

/** Possible chat feedback target types to distinguish where feedback originates from. */
export enum ChatFeedbackTargetType {
  /** Feedback target is discovery chat */
  DiscoveryChat = 'DISCOVERY_CHAT',
  /** Feedback target is in-course chat */
  InCourseChat = 'IN_COURSE_CHAT',
  /** Feedback target type is unspecified */
  Unspecified = 'UNSPECIFIED'
}

/** The ClosedCaptionLanguageCode scalar type. */
export enum ClosedCaptionLanguageCode {
  /** Afrikaans */
  Af = 'AF',
  /** Akan */
  Ak = 'AK',
  /** Amharic */
  Am = 'AM',
  /** Arabic */
  Ar = 'AR',
  /** Arabic [CC] */
  ArCc = 'AR_CC',
  /** Assamese */
  As = 'AS',
  /** Azerbaijani */
  Az = 'AZ',
  /** Belarusian */
  Be = 'BE',
  /** Bulgarian */
  Bg = 'BG',
  /** Bambara */
  Bm = 'BM',
  /** Bangla */
  Bn = 'BN',
  /** Tibetan */
  Bo = 'BO',
  /** Breton */
  Br = 'BR',
  /** Bosnian */
  Bs = 'BS',
  /** Catalan */
  Ca = 'CA',
  /** Chechen */
  Ce = 'CE',
  /** Czech */
  Cs = 'CS',
  /** Church Slavic */
  Cu = 'CU',
  /** Welsh */
  Cy = 'CY',
  /** Danish */
  Da = 'DA',
  /** German */
  De = 'DE',
  /** German [CC] */
  DeCc = 'DE_CC',
  /** Dzongkha */
  Dz = 'DZ',
  /** Ewe */
  Ee = 'EE',
  /** Greek */
  El = 'EL',
  /** English */
  En = 'EN',
  /** English [CC] */
  EnCc = 'EN_CC',
  /** Esperanto */
  Eo = 'EO',
  /** Spanish */
  Es = 'ES',
  /** Spanish [CC] */
  EsCc = 'ES_CC',
  /** Estonian */
  Et = 'ET',
  /** Estonian [CC] */
  EtCc = 'ET_CC',
  /** Basque */
  Eu = 'EU',
  /** Persian */
  Fa = 'FA',
  /** Fulah */
  Ff = 'FF',
  /** Finnish */
  Fi = 'FI',
  /** Faroese */
  Fo = 'FO',
  /** French */
  Fr = 'FR',
  /** French [CC] */
  FrCc = 'FR_CC',
  /** Western Frisian */
  Fy = 'FY',
  /** Irish */
  Ga = 'GA',
  /** Scottish Gaelic */
  Gd = 'GD',
  /** Galician */
  Gl = 'GL',
  /** Gujarati */
  Gu = 'GU',
  /** Manx */
  Gv = 'GV',
  /** Hausa */
  Ha = 'HA',
  /** Hebrew */
  He = 'HE',
  /** Hindi */
  Hi = 'HI',
  /** Hindi [CC] */
  HiCc = 'HI_CC',
  /** Croatian */
  Hr = 'HR',
  /** Haitian, Haitian Creole */
  Ht = 'HT',
  /** Hungarian */
  Hu = 'HU',
  /** Armenian */
  Hy = 'HY',
  /** Armenian [CC] */
  HyCc = 'HY_CC',
  /** Interlingua */
  Ia = 'IA',
  /** Indonesian */
  Id = 'ID',
  /** Indonesian [CC] */
  IdCc = 'ID_CC',
  /** Igbo */
  Ig = 'IG',
  /** Sichuan Yi */
  Ii = 'II',
  /** Icelandic */
  Is = 'IS',
  /** Italian */
  It = 'IT',
  /** Italian [CC] */
  ItCc = 'IT_CC',
  /** Japanese */
  Ja = 'JA',
  /** Japanese [CC] */
  JaCc = 'JA_CC',
  /** Javanese */
  Jv = 'JV',
  /** Georgian */
  Ka = 'KA',
  /** Kikuyu */
  Ki = 'KI',
  /** Kazakh */
  Kk = 'KK',
  /** Kalaallisut */
  Kl = 'KL',
  /** Khmer */
  Km = 'KM',
  /** Kannada */
  Kn = 'KN',
  /** Korean */
  Ko = 'KO',
  /** Korean [CC] */
  KoCc = 'KO_CC',
  /** Kashmiri */
  Ks = 'KS',
  /** Kurdish */
  Ku = 'KU',
  /** Cornish */
  Kw = 'KW',
  /** Kyrgyz */
  Ky = 'KY',
  /** Luxembourgish */
  Lb = 'LB',
  /** Ganda */
  Lg = 'LG',
  /** Lingala */
  Ln = 'LN',
  /** Lao */
  Lo = 'LO',
  /** Lithuanian */
  Lt = 'LT',
  /** Luba-Katanga */
  Lu = 'LU',
  /** Latvian */
  Lv = 'LV',
  /** Malagasy */
  Mg = 'MG',
  /** Māori */
  Mi = 'MI',
  /** Macedonian */
  Mk = 'MK',
  /** Malayalam */
  Ml = 'ML',
  /** Mongolian */
  Mn = 'MN',
  /** Marathi */
  Mr = 'MR',
  /** Malay */
  Ms = 'MS',
  /** Maltese */
  Mt = 'MT',
  /** Burmese */
  My = 'MY',
  /** Norwegian (Bokmål) */
  Nb = 'NB',
  /** North Ndebele */
  Nd = 'ND',
  /** Nepali */
  Ne = 'NE',
  /** Dutch */
  Nl = 'NL',
  /** Dutch [CC] */
  NlCc = 'NL_CC',
  /** Norwegian Nynorsk */
  Nn = 'NN',
  /** Norwegian */
  No = 'NO',
  /** Oromo */
  Om = 'OM',
  /** Odia */
  Or = 'OR',
  /** Ossetic */
  Os = 'OS',
  /** Punjabi */
  Pa = 'PA',
  /** Polish */
  Pl = 'PL',
  /** Polish [CC] */
  PlCc = 'PL_CC',
  /** Pashto */
  Ps = 'PS',
  /** Portuguese */
  Pt = 'PT',
  /** Portuguese (Brazil) */
  PtBr = 'PT_BR',
  /** Portuguese [CC] */
  PtCc = 'PT_CC',
  /** Portuguese (Portugal) */
  PtPt = 'PT_PT',
  /** Quechua */
  Qu = 'QU',
  /** Romansh */
  Rm = 'RM',
  /** Rundi */
  Rn = 'RN',
  /** Romanian */
  Ro = 'RO',
  /** Russian */
  Ru = 'RU',
  /** Russian [CC] */
  RuCc = 'RU_CC',
  /** Kinyarwanda */
  Rw = 'RW',
  /** Sanskrit */
  Sa = 'SA',
  /** Sindhi */
  Sd = 'SD',
  /** Northern Sami */
  Se = 'SE',
  /** Sango */
  Sg = 'SG',
  /** Sinhala */
  Si = 'SI',
  /** Slovak */
  Sk = 'SK',
  /** Slovenian */
  Sl = 'SL',
  /** Shona */
  Sn = 'SN',
  /** Somali */
  So = 'SO',
  /** Albanian */
  Sq = 'SQ',
  /** Serbian */
  Sr = 'SR',
  /** Sundanese */
  Su = 'SU',
  /** Swedish */
  Sv = 'SV',
  /** Swahili */
  Sw = 'SW',
  /** Tamil */
  Ta = 'TA',
  /** Tamil [CC] */
  TaCc = 'TA_CC',
  /** Telugu */
  Te = 'TE',
  /** Tajik */
  Tg = 'TG',
  /** Thai */
  Th = 'TH',
  /** Thai [CC] */
  ThCc = 'TH_CC',
  /** Tigrinya */
  Ti = 'TI',
  /** Turkmen */
  Tk = 'TK',
  /** Tagalog */
  Tl = 'TL',
  /** Tongan */
  To = 'TO',
  /** Turkish */
  Tr = 'TR',
  /** Turkish [CC] */
  TrCc = 'TR_CC',
  /** Tatar */
  Tt = 'TT',
  /** Uyghur */
  Ug = 'UG',
  /** Ukrainian */
  Uk = 'UK',
  /** Ukrainian [CC] */
  UkCc = 'UK_CC',
  /** Urdu */
  Ur = 'UR',
  /** Uzbek */
  Uz = 'UZ',
  /** Vietnamese */
  Vi = 'VI',
  /** Vietnamese [CC] */
  ViCc = 'VI_CC',
  /** Volapük */
  Vo = 'VO',
  /** Wolof */
  Wo = 'WO',
  /** Xhosa */
  Xh = 'XH',
  /** Yiddish */
  Yi = 'YI',
  /** Yoruba */
  Yo = 'YO',
  /** Chinese */
  Zh = 'ZH',
  /** Chinese [CC] */
  ZhCc = 'ZH_CC',
  /** Chinese (Simplified) */
  ZhCn = 'ZH_CN',
  /** Chinese (Traditional) */
  ZhTw = 'ZH_TW',
  /** Zulu */
  Zu = 'ZU'
}

/** A lab instance running on a cloud provider (AWS, Azure, or GCP). Users are provided temporary credentials to access the cloud environment */
export type CloudLabInstance = LabInstance & {
  __typename?: 'CloudLabInstance';
  /** When the lab instance is ready, authentication credentials can be retrieved to access the cloud provider environment */
  credentials?: Maybe<CloudLabInstanceCredentials>;
  /** Expiration time of the lab instance */
  expirationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The cloud provider hosting this lab instance */
  provider: CloudLabInstanceProvider;
  /** Status of the LabInstance */
  status: LabInstanceStatus;
  /** UUID of the lab instance */
  uuid: Scalars['ID']['output'];
  /**
   * Token for establishing a secure connection to the lab instance's workspace, if available
   * @deprecated Rely on the credentials for each provider instead
   */
  workspaceToken?: Maybe<Scalars['String']['output']>;
  /**
   * URL of the lab instance's workspace, if available
   * @deprecated Rely on the credentials for each provider instead
   */
  workspaceUrl?: Maybe<Scalars['URL']['output']>;
};

/** Polymorphic credentials type that resolves to provider-specific credential fields based on the cloud provider */
export type CloudLabInstanceCredentials = AwsCloudLabInstanceCredentials | AzureCloudLabInstanceCredentials | GcpCloudLabInstanceCredentials;

/** Supported cloud providers for hosting lab instances */
export enum CloudLabInstanceProvider {
  /** Amazon Web Services */
  Aws = 'AWS',
  /** Microsoft Azure */
  Azure = 'AZURE',
  /** Google Cloud Platform */
  Gcp = 'GCP'
}

/** A micro-content representing a code block */
export type CodeBlock = {
  __typename?: 'CodeBlock';
  /** The code value */
  code: Scalars['String']['output'];
  /** The language of the code */
  language: Scalars['String']['output'];
};

/** Type of the files withing coding exercise templates */
export type CodeFile = {
  __typename?: 'CodeFile';
  /** Content of the codefile inside one of the file list of the coding exercise template */
  content: Scalars['String']['output'];
  /** File name of the codefile inside one of file list of the coding exercise template */
  fileName: Scalars['String']['output'];
};

/** Coding exercise for students to practice their programming */
export type CodingExercise = CurriculumItem & {
  __typename?: 'CodingExercise';
  /** Course this coding exercise belongs to */
  course?: Maybe<Course>;
  /** Problem statement */
  description?: Maybe<Scalars['String']['output']>;
  /** The Id of the coding exercise */
  id: Scalars['ID']['output'];
  /** The title of the coding exercise */
  title: Scalars['String']['output'];
  /** Landing page to view this CodingExercise */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the coding exercise */
  versionedIdentifier: VersionedIdentifier;
};

/** Language possibilities for a coding exercise */
export enum CodingExerciseLanguageOption {
  /** C++ 14 */
  Cplusplus = 'CPLUSPLUS',
  /** C++ 20 */
  Cplusplus_20 = 'CPLUSPLUS_20',
  /** CSV processing with Python */
  CsvProcessingWithPython = 'CSV_PROCESSING_WITH_PYTHON',
  /** C# */
  CSharp = 'C_SHARP',
  /** C# 11 */
  CSharp_11 = 'C_SHARP_11',
  /** HTML */
  Html = 'HTML',
  /** JavaScript ES6 */
  JavascriptEs6 = 'JAVASCRIPT_ES6',
  /** Java 9 */
  Java_9 = 'JAVA_9',
  /** Java 11 */
  Java_11 = 'JAVA_11',
  /** Java 17 */
  Java_17 = 'JAVA_17',
  /** Java 21 */
  Java_21 = 'JAVA_21',
  /** Kotlin 1.9 */
  Kotlin_1_9 = 'KOTLIN_1_9',
  /** PHP 5 */
  Php_5 = 'PHP_5',
  /** PHP 7 */
  Php_7 = 'PHP_7',
  /** Python 3.5 */
  Python_3_5 = 'PYTHON_3_5',
  /** Python 3.8 */
  Python_3_8 = 'PYTHON_3_8',
  /** Python 3.10 */
  Python_3_10 = 'PYTHON_3_10',
  /** React 16 */
  React_16 = 'REACT_16',
  /** React 18 */
  React_18 = 'REACT_18',
  /** Ruby */
  Ruby = 'RUBY',
  /** R 3.6 */
  R_3_6 = 'R_3_6',
  /** SciPy 1.4 (Numby, Pandas, SymPy and SkiCit Learn 0.23 */
  Scipy_1_4NumpyPandasSympyAndScikitLearn_0_23 = 'SCIPY_1_4_NUMPY_PANDAS_SYMPY_AND_SCIKIT_LEARN_0_23',
  /** SQL (MySQL) */
  Sql = 'SQL',
  /** SQLITE 3 */
  Sqlite_3 = 'SQLITE_3',
  /** Swift 3 */
  Swift_3 = 'SWIFT_3',
  /** Swift 5 */
  Swift_5 = 'SWIFT_5',
  /** Web Development */
  WebDevelopment = 'WEB_DEVELOPMENT'
}

/** A wrapper type to include the recommended Coding Exercise and some additional fields about its recommendation */
export type CodingExerciseRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'CodingExerciseRecommendation';
  /** Underlying object of the recommendation to get more information about it */
  codingExercise?: Maybe<CodingExercise>;
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** Type of the coding exercise templates */
export type CodingExerciseTemplate = {
  __typename?: 'CodingExerciseTemplate';
  /** Description of the coding exercise template */
  description: Scalars['String']['output'];
  /** Language of the coding exercise template */
  language: CodingExerciseLanguageOption;
  /** Name of the coding exercise template */
  name: Scalars['String']['output'];
  /** Set of setup files of the sql type coding exercise template */
  setupFiles: Array<CodeFile>;
  /** Set of solution files of the  coding exercise template */
  solutionFiles: Array<CodeFile>;
  /** Supported versions of the language for which the template can be applied */
  supportedVersions: Array<CodingExerciseLanguageOption>;
  /** Set of test files of the coding exercise template */
  testFiles: Array<CodeFile>;
};

/** Filtration options for the coding exercise templates */
export type CodingExerciseTemplateFilters = {
  /** Include the language of the coding exercise template in the response */
  includeVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the language to filter the coding exercise templates */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A lab instance running on docker container-based infrastructure */
export type ContainerLabInstance = LabInstance & {
  __typename?: 'ContainerLabInstance';
  /** Expiration time of the lab instance */
  expirationTime?: Maybe<Scalars['DateTime']['output']>;
  /** Status of the LabInstance */
  status: LabInstanceStatus;
  /** UUID of the lab instance */
  uuid: Scalars['ID']['output'];
  /** Common hostname for all communication endpoints to the lab instance workspace environment, if available */
  workspaceHost?: Maybe<Scalars['String']['output']>;
  /** Token for establishing a secure connection to the lab instance's workspace, if available */
  workspaceToken?: Maybe<Scalars['String']['output']>;
  /**
   * URL of the lab instance's workspace, if available
   * @deprecated Use workspaceHost instead
   */
  workspaceUrl?: Maybe<Scalars['URL']['output']>;
};

/** Type representing a group of content for a subscription plan */
export type ContentCollection = {
  __typename?: 'ContentCollection';
  /** ID of the Content Collection */
  id: Scalars['ID']['output'];
  /** The learning products in this content collection */
  items: LearningProductsPaged;
  /** Stats related to the learning content in this collection */
  stats?: Maybe<ContentCollectionStats>;
};


/** Type representing a group of content for a subscription plan */
export type ContentCollectionItemsArgs = {
  filter: ContentCollectionItemsFilter;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['MaxResultsPerPage']['input']>;
};

/** Result of a bulk add or remove operation for a single content collection and learning product */
export type ContentCollectionBulkItemResult = {
  __typename?: 'ContentCollectionBulkItemResult';
  /** ID of the content collection that was modified */
  collectionId: Scalars['ID']['output'];
  /** Error message if the operation failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Learning product that was added or removed */
  learningProduct: LearningProduct;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Response for bulk add or remove operations on content collections */
export type ContentCollectionBulkItemsResponse = {
  __typename?: 'ContentCollectionBulkItemsResponse';
  /** List of results for each collection and learning product combination */
  results: Array<ContentCollectionBulkItemResult>;
};

/** Response for updating Content Collection items */
export type ContentCollectionCreateOrUpdateResponse = {
  __typename?: 'ContentCollectionCreateOrUpdateResponse';
  /** Updated Content Collection */
  contentCollection?: Maybe<ContentCollection>;
};

/** Input for updating items in a content collection */
export type ContentCollectionItemAddOrRemoveInput = {
  /** Learning Product to be added or removed from Content Collection */
  learningProduct: LearningProductInput;
  /** The reason for the update */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for content collection items */
export type ContentCollectionItemsFilter = {
  /** The type of learning product to filter by */
  type: LearningProductType;
};

/** Stats related to the items in a content collection */
export type ContentCollectionStats = {
  __typename?: 'ContentCollectionStats';
  /** The average rating of the courses in the content collection */
  courseAvgRating?: Maybe<Scalars['Float']['output']>;
  /** The number of courses in the content collection */
  numberOfCourses: Scalars['Int']['output'];
  /** The number of instructors in the content collection */
  numberOfInstructors?: Maybe<Scalars['Int']['output']>;
  /** The number of practice exercises in the content collection */
  numberOfPracticeExercises?: Maybe<Scalars['Int']['output']>;
};

/** Source of a lesson component */
export enum ContentSourceType {
  /** The source is the AI */
  Ai = 'AI',
  /** The source is the instructor */
  Instructor = 'INSTRUCTOR',
  /** The source is mixed */
  Mixed = 'MIXED'
}

/** The Course object. */
export type Course = LearningPathItem & LearningProduct & {
  __typename?: 'Course';
  /** Accreditations a course has */
  accreditations?: Maybe<Array<CourseAccreditation>>;
  /** Badges awarded to the course */
  badges: Array<LearningProductBadge>;
  /** Caption and subtitles the course has */
  captions?: Maybe<Array<CourseCaptionDetails>>;
  /** Career Accelerators that the course is included in, if any */
  careerAccelerators?: Maybe<Array<Maybe<CareerAccelerator>>>;
  /** Categories the course is part of */
  categories: Array<CourseCategory>;
  /** Content collection specific properties */
  contentCollectionInfo?: Maybe<CourseContentCollectionInfo>;
  /** Course's curriculum */
  curriculum: Curriculum;
  /** Description of the course */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** Total duration of the course's content */
  duration?: Maybe<Scalars['CourseDuration']['output']>;
  /** Total duration of the course's content in seconds */
  durationInSeconds?: Maybe<Scalars['DurationInSeconds']['output']>;
  /** Total duration of video content only in seconds */
  durationVideoContent?: Maybe<Scalars['DurationInSeconds']['output']>;
  /** Whether a learner can enroll in a course or not */
  enrollable: Scalars['Boolean']['output'];
  /** Learners enrolled in a course */
  enrollments: CourseEnrollments;
  /** Whether the course has a certificate. */
  hasCertificate: Scalars['Boolean']['output'];
  /** Headline to show under the title */
  headline?: Maybe<Scalars['String']['output']>;
  /** ID of the course. */
  id: Scalars['ID']['output'];
  /** Images by their dimensions */
  images: CourseImages;
  /** Instructors of the Course */
  instructors: Array<CourseInstructor>;
  /** Whether the course is enrolled by the current user or not */
  isEnrolled: Scalars['Boolean']['output'];
  /** Whether the course is a free course or not */
  isFree: Scalars['Boolean']['output'];
  /** Indicates if Course is a practice test only, made to prepare for a certification exam */
  isPracticeTestCourse: Scalars['Boolean']['output'];
  /** Whether the course is published or not */
  isPublished: Scalars['Boolean']['output'];
  /** What you will learn in this course */
  learningOutcomes: Array<Scalars['String']['output']>;
  /** Instruction level of the course */
  level?: Maybe<DifficultyLevel>;
  /** Course locale e.g. en-US or en-GB */
  locale: Scalars['Locale']['output'];
  /** The curriculum item that learner is currently on or next in the course */
  nextCurriculumItem?: Maybe<CurriculumItem>;
  /** The UB organization this course belongs to, only visible if you are part of that organization */
  organization?: Maybe<Organization>;
  /** Organization specific course properties, only visible if you are part of that organization */
  organizationInfo?: Maybe<CourseOrganizationInfo>;
  /** The owner of the course */
  owner?: Maybe<CourseInstructor>;
  /** Prerequisites for taking the course */
  prerequisites: Array<Scalars['String']['output']>;
  /** Primary topic course is tagged with */
  primaryTopic?: Maybe<Topic>;
  /** Whether the course is publicly available or not */
  private?: Maybe<Scalars['Boolean']['output']>;
  /** Promotional video for the course. Clients need to renew it if URL expires by querying it again. */
  promoVideo?: Maybe<CoursePromoVideo>;
  /** When the course was published */
  publishedOn?: Maybe<Scalars['Date']['output']>;
  /** How do students rate the course */
  rating?: Maybe<CourseRating>;
  /** Subscription specific course properties */
  subscriptionInfo?: Maybe<CourseSubscriptionInfo>;
  /** Who should attend the course */
  targetAudience: Array<Scalars['String']['output']>;
  /** Title of the course. */
  title: Scalars['String']['output'];
  /** Topics course is tagged with */
  topics?: Maybe<Array<Topic>>;
  /** When the course was last updated */
  updatedOn?: Maybe<Scalars['Date']['output']>;
  /** The URL to access the auto-enroll page */
  urlAutoEnroll?: Maybe<Scalars['URL']['output']>;
  /** The URL to access the course landing page */
  urlCourseLanding?: Maybe<Scalars['URL']['output']>;
  /** The URL to access the course taking page */
  urlCourseTaking?: Maybe<Scalars['URL']['output']>;
  /** Mobile Native deep link of the course */
  urlMobileNativeDeeplink: Scalars['URL']['output'];
  /** Returns the current user's enrollment details for the course, if they are enrolled. */
  userEnrollment?: Maybe<CourseEnrollment>;
  /** Aggregation this course belongs to */
  variationAggregation?: Maybe<CourseVariationAggregation>;
  /** Versioned identifier of the course */
  versionedIdentifier: VersionedIdentifier;
  /** Activity ID of xAPI statement to identify course */
  xapiActivityId: Scalars['ID']['output'];
};

/** Accreditations */
export type CourseAccreditation = {
  __typename?: 'CourseAccreditation';
  /** Start date of accreditation */
  compliantSince?: Maybe<Scalars['Date']['output']>;
  /** The amount of credits this accreditations supplies */
  creditCount: Scalars['NonNegativeFloat']['output'];
  /** The level of the accreditation */
  level?: Maybe<Scalars['String']['output']>;
  /** Technical subject area */
  subject?: Maybe<Scalars['String']['output']>;
  /** The type of accreditation */
  type: CourseAccreditationType;
};

/** Accreditation types */
export enum CourseAccreditationType {
  /** Continuing professional education */
  Cpe = 'CPE'
}

/** AI generated highlights for a course */
export type CourseAiHighlights = {
  __typename?: 'CourseAiHighlights';
  /** Skills or learning outcomes for the course */
  learningOutcomes: Array<Scalars['String']['output']>;
  /** AI generated summary of the course */
  summary: Scalars['String']['output'];
};

/** Course caption details such as locale, type, and source */
export type CourseCaptionDetails = {
  __typename?: 'CourseCaptionDetails';
  /** Whether the caption is automatically generated */
  automaticallyGenerated: Scalars['Boolean']['output'];
  /** The caption's locale */
  locale: Scalars['Locale']['output'];
  /** The caption type, either subtitles or closed captions */
  type: CaptionType;
};

/** A catalog of all courses available to the client */
export type CourseCatalogFullResponsePaged = {
  __typename?: 'CourseCatalogFullResponsePaged';
  /** List of courses in the catalog */
  courses: Array<Course>;
  /** Cursor to get the next page. Null if no more results available */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Sync Token to use for the next delta sync */
  syncToken: Scalars['String']['output'];
};

/** Changes to catalog of all courses available to the client */
export type CourseCatalogUpdatedResponsePaged = {
  __typename?: 'CourseCatalogUpdatedResponsePaged';
  /** Courses added since last sync */
  addedCourses: Array<Course>;
  /** Cursor to get the next page. Null if no more results available */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Course IDs for courses removed since last sync */
  removedCourses: Array<Scalars['ID']['output']>;
  /** Sync Token to use for the next delta sync */
  syncToken: Scalars['String']['output'];
  /** Courses updated since last sync */
  updatedCourses: Array<Course>;
};

/** Category the Course belongs to */
export type CourseCategory = Category & {
  __typename?: 'CourseCategory';
  /** ID of the category */
  id: Scalars['ID']['output'];
  /** Name of the category */
  name: Scalars['String']['output'];
  /** Subcategories belonging to the category */
  subcategories: Array<CourseSubCategory>;
  /** The URL to the category page this course is a part of */
  url: Scalars['URL']['output'];
};

/** Course collection specific properties */
export type CourseContentCollectionInfo = {
  __typename?: 'CourseContentCollectionInfo';
  /** Indicates if Course is part of Google partner content collection */
  isInGooglePartnerCollection: Scalars['Boolean']['output'];
};

/** Request to copy a course with specified task arguments */
export type CourseCopyRequest = {
  __typename?: 'CourseCopyRequest';
  /** Arguments for the course copy request */
  arguments: Scalars['JSON']['output'];
  /** List of tasks associated with this course copy request */
  copyTasks?: Maybe<Array<Maybe<CourseCopyTask>>>;
  /** Date when course copy request was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the course copy request */
  id: Scalars['ID']['output'];
  /** Whether the course copy request is a draft */
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** The course that is being copied */
  originalCourse?: Maybe<Course>;
  /** Date when course copy request was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who requested the course copy */
  user?: Maybe<User>;
};

/** Response type for course copy request creation */
export type CourseCopyRequestCreateOrUpdateResponse = {
  __typename?: 'CourseCopyRequestCreateOrUpdateResponse';
  /** The course copy request that was created */
  courseCopyRequest?: Maybe<CourseCopyRequest>;
};

/** Asynchronous task for copying a course */
export type CourseCopyTask = {
  __typename?: 'CourseCopyTask';
  /** Arguments for the course copy task */
  arguments: Scalars['JSON']['output'];
  /** Resulting course after the copy task is completed */
  copiedCourse?: Maybe<Course>;
  /** Date when course copy request was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the course copy task */
  id: Scalars['ID']['output'];
  /** Course that is being copied */
  originalCourse?: Maybe<Course>;
  /** The status of the course copy task */
  status: CourseCopyTaskStatus;
  /** Date when course copy request was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Status of a course copy task */
export enum CourseCopyTaskStatus {
  /** The course copy request or task has failed */
  Failed = 'FAILED',
  /** The course copy request or task is in progress */
  InProgress = 'IN_PROGRESS',
  /** The course copy request or task is created */
  Pending = 'PENDING',
  /** The course copy request or task has been completed successfully */
  Success = 'SUCCESS'
}

/** Count of the course curriculum content by type */
export type CourseCurriculumContentCounts = {
  __typename?: 'CourseCurriculumContentCounts';
  /** Count of all coding exercises in the course curriculum */
  codingExercisesCount: Scalars['Int']['output'];
  /** Count of all 'additional' resources associated with this curriculum. Currently includes File, Ebook, and Presentation assets associated with lectures. */
  downloadableResourcesCount: Scalars['Int']['output'];
  /** Count of in-course labs in the course curriculum. */
  inCourseLabsCount: Scalars['Int']['output'];
  /** Count of all lectures in the course curriculum */
  lecturesCount: Scalars['Int']['output'];
  /** Count of all practice assignments in the course curriculum */
  practiceAssignmentsCount: Scalars['Int']['output'];
  /** Count of all questions in the PracticeTests in the course curriculum */
  practiceTestQuestionsCount: Scalars['Int']['output'];
  /** Count of all practice tests in the course curriculum */
  practiceTestsCount: Scalars['Int']['output'];
  /** Count of all quizzes in the course curriculum */
  quizzesCount: Scalars['Int']['output'];
  /** Count of all role plays in the course curriculum */
  rolePlaysCount: Scalars['Int']['output'];
};

/** Course enrollment */
export type CourseEnrollment = {
  __typename?: 'CourseEnrollment';
  /** Time at which the enrollment was archived (null if not archived). */
  archiveTime?: Maybe<Scalars['DateTime']['output']>;
  /** Completed items in the course */
  completedItems?: Maybe<Array<Maybe<CurriculumItem>>>;
  /** Completion percentage for the course */
  completionPercentage?: Maybe<Scalars['NonNegativeFloat']['output']>;
  /** Time when the course was most recently completed (null if not completed) */
  completionTime?: Maybe<Scalars['DateTime']['output']>;
  /** The course that the current user is enrolled in */
  course: Course;
  /** Time of enrollment in the course */
  enrollmentTime?: Maybe<Scalars['DateTime']['output']>;
  /** Time when the course was first completed (null if never completed) */
  firstCompletionTime?: Maybe<Scalars['DateTime']['output']>;
  /** Time of most recent access to the course */
  lastAccessedTime?: Maybe<Scalars['DateTime']['output']>;
  /** The source type of the enrollment */
  primarySourceType?: Maybe<EnrollmentSourceType>;
};

/** Enrollments belonging to the course */
export type CourseEnrollments = {
  __typename?: 'CourseEnrollments';
  /** Exact count of how many students are there currently enrolled (course purchase and subscription). */
  count?: Maybe<Scalars['Int']['output']>;
  /**
   * Count of how many students are currently enrolled (course purchase and subscription) rounded to the nearest decimal
   * Exception: if there are fewer than 10 enrollments we show the exact amount (instead of 0)
   */
  roundedCount: Scalars['Int']['output'];
};

/** Filters for course enrollments */
export type CourseEnrollmentsFilters = {
  /** Include only enrollments with first completion time on or before this date */
  completionTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include only enrollments with first completion time on or after this date */
  completionTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include only enrollments created on or before this date */
  enrollmentTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include only enrollments created on or after this date */
  enrollmentTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Maximum course progress percentage */
  maxCourseProgress?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  /** Minimum course progress percentage */
  minCourseProgress?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
};

/** Paged course enrollments */
export type CourseEnrollmentsPaged = {
  __typename?: 'CourseEnrollmentsPaged';
  /** List of course enrollments. Items may be less than requested size if objects become unavailable */
  courseEnrollments: Array<Maybe<CourseEnrollment>>;
  /** Cursor to the next page of course enrollments for cursor based pagination, null if there are no more pages */
  cursor?: Maybe<Scalars['String']['output']>;
};

/** Sort order options for course enrollments */
export type CourseEnrollmentsSortOrder = {
  /** Course title sort order */
  courseTitle?: InputMaybe<SortDirection>;
  /** Enrollment time sort order */
  enrollmentTime?: InputMaybe<SortDirection>;
  /** Last accessed time sort order */
  lastAccessedTime?: InputMaybe<SortDirection>;
};

/** Course images by varying dimensions */
export type CourseImages = {
  __typename?: 'CourseImages';
  /** Course preview image with 125 pixels height */
  height125?: Maybe<Scalars['String']['output']>;
  /** Course preview image with 200 pixels height */
  height200?: Maybe<Scalars['String']['output']>;
  /** Course preview image with 48x27 dimensions in pixels */
  px48x27?: Maybe<Scalars['String']['output']>;
  /** Course preview image with 50x50 dimensions in pixels */
  px50x50?: Maybe<Scalars['String']['output']>;
  /** Course preview image with 75x75 dimensions in pixels */
  px75x75?: Maybe<Scalars['String']['output']>;
  /** Course preview image with 96x54 dimensions in pixels */
  px96x54?: Maybe<Scalars['String']['output']>;
  /** Course preview image with 100x100 dimensions in pixels */
  px100x100?: Maybe<Scalars['String']['output']>;
  /** Course preview image with 240x135 dimensions in pixels */
  px240x135?: Maybe<Scalars['String']['output']>;
  /** Course preview image with 304x171 dimensions in pixels */
  px304x171?: Maybe<Scalars['String']['output']>;
  /** Course preview image with 480x270 dimensions in pixels */
  px480x270?: Maybe<Scalars['String']['output']>;
  /** Course preview image with 750x422 dimensions in pixels */
  px750x422?: Maybe<Scalars['String']['output']>;
};

/** Instructor for a course */
export type CourseInstructor = Instructor & {
  __typename?: 'CourseInstructor';
  /** Average rating across all courses of instructor */
  averageRating?: Maybe<Scalars['AverageRating']['output']>;
  /** Number of published, public, and unbanned courses for which the user is a visible instructor */
  courseCount?: Maybe<Scalars['Int']['output']>;
  /** Top 3 highest revenue topics associated with the courses of instructor */
  courseTopics?: Maybe<Array<Maybe<Topic>>>;
  /** ID of the Instructor */
  id: Scalars['ID']['output'];
  /** Instructor's image by varying pixels */
  images: InstructorImages;
  /** Whether this instructor has opted into the deals program */
  isOptedIntoDeals?: Maybe<Scalars['Boolean']['output']>;
  /** Is the instructor opted out, i.e. not willing to participate on Gen AI features */
  isOptedOutToGenAI?: Maybe<Scalars['Boolean']['output']>;
  /** Total number of learners that have enrolled into the courses of instructor */
  learnerCount?: Maybe<Scalars['Int']['output']>;
  /** Instructor's name */
  name: Scalars['String']['output'];
  /** The URL to access the instructor page */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Input for linking an opportunity to a course */
export type CourseInstructorContentOpportunityLink = {
  /** ID of the course */
  courseId: Scalars['ID']['input'];
  /** ID of the opportunity */
  opportunityId: Scalars['ID']['input'];
};

/** Organization specific course properties */
export type CourseOrganizationInfo = {
  __typename?: 'CourseOrganizationInfo';
  /** True if this course was purchased separately from the marketplace */
  isMarketplaceImported?: Maybe<Scalars['Boolean']['output']>;
  /** True if this course was created specifically for this organization */
  isOrganizationSpecific?: Maybe<Scalars['Boolean']['output']>;
  /** If not null returns the Date this course will retire from organization's content collection */
  retiresOn?: Maybe<Scalars['Date']['output']>;
};

/** Object to store URL and expiration time for course's promo video */
export type CoursePromoVideo = {
  __typename?: 'CoursePromoVideo';
  /** The underlying assetId for the promo video */
  asset: Asset;
  /** Expiration time of the promo video URL. If null URL doesn't expire */
  expiresOn?: Maybe<Scalars['Timestamp']['output']>;
  /** URL for a promo video asset in mp4 format */
  url: Scalars['URL']['output'];
};

/** Ratings of a course */
export type CourseRating = {
  __typename?: 'CourseRating';
  /** Weighted average rating. Ranges from 0 to 5.0. */
  average?: Maybe<Scalars['AverageRating']['output']>;
  /** Number of ratings */
  count: Scalars['Int']['output'];
};

/** A wrapper type to include the recommended Course and some additional fields about its recommendation */
export type CourseRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'CourseRecommendation';
  /** Underlying object of the recommendation to get more information about it */
  course?: Maybe<Course>;
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** Additional search context for specific UX cases */
export type CourseSearchContext = {
  /** Enables debugging mode for search queries. */
  isDebug?: InputMaybe<Scalars['Boolean']['input']>;
  /** The original query written before any manipulation, e.g., 'pyt' when autocompleted to 'python'. */
  originalQuery?: InputMaybe<Scalars['String']['input']>;
  /** Refined query for the search, used for related or narrowing search. */
  refinedQuery?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specifies the language in which the search should be performed.
   * This parameter is explicitly provided by ChatGPT to control the language context of the search,
   * rather than relying on user preferences or automatic language detection.
   */
  searchLanguage?: InputMaybe<LanguageCode>;
  /** Trigger type for the course search. */
  triggerType: CourseSearchTriggerType;
};

/** Search filters to apply on search request */
export type CourseSearchFilters = {
  /** Filter results based on closed caption language */
  closedCaptionLanguage?: InputMaybe<Array<ClosedCaptionLanguageCode>>;
  /** Whether or not course is for certification preparation */
  isCertificationPrep?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter results based on course language */
  language?: InputMaybe<Array<LanguageCode>>;
  /** Filter course based on difficulty level */
  level?: InputMaybe<Array<DifficultyLevel>>;
  /** Minimum average rating for the course. Ranges from 0 to 5.0. */
  minAverageRating?: InputMaybe<Scalars['AverageRating']['input']>;
  /**
   * Determines if the course is available in the user's Consumer Subscription when user has one.
   * If true, only courses included in the user's Consumer Subscription are shown.
   * If false, only purchasable courses outside the user's Consumer Subscription are shown.
   */
  mustBeInConsumerSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not course must have closed captions */
  mustHaveClosedCaption?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not course must have coding exercises */
  mustHaveCodingExercise?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not course must have labs */
  mustHaveLab?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not course must have practice tests */
  mustHavePracticeTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not course must have quizzes */
  mustHaveQuiz?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not course must have roleplays */
  mustHaveRoleplay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not course must have workspaces */
  mustHaveWorkspace?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter courses based on pageId, used in the "All Courses" section on topic, category, and subcategory pages.
   * When pageId is provided, the search query is skipped and courses are filtered directly by pageId.
   * Each topic, category, and subcategory page has a unique pageId (e.g., 7380 for Python topic, 288 for Development
   * category, 8 for Web Development subcategory).
   *
   * In addition, it is also used for Elevate landing pages, where each page has a unique pageId that
   * corresponds to a content collection id.
   */
  pageId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter courses based on price, paid or free */
  price?: InputMaybe<Array<PriceOption>>;
  /** Filter courses that solely consist of practice tests */
  showPracticeTestCoursesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter courses based on subcategories */
  subcategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter courses based on topics */
  topicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter course based on video length */
  videoLength?: InputMaybe<Array<VideoLength>>;
};

/** List of Courses and additional data about search response */
export type CourseSearchResponse = Paginated & {
  __typename?: 'CourseSearchResponse';
  /** Total number of Courses matching the search query and filters. */
  count: Scalars['Int']['output'];
  /**
   * List of Course objects.
   * @deprecated Use results instead
   */
  courses: Array<Course>;
  /** Identifies available search filter facets. */
  filterOptions: Array<SearchAggregation>;
  /** Metadata for whole search result used by front end */
  metadata?: Maybe<CourseSearchResponseMetadata>;
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages in search response */
  pageCount: Scalars['Int']['output'];
  /** List of CourseSearchResult objects containing course and additional search related fields. */
  results: Array<Maybe<CourseSearchResult>>;
};

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */
export type CourseSearchResponseMetadata = {
  __typename?: 'CourseSearchResponseMetadata';
  /** Associated topic for the search response. */
  associatedTopic?: Maybe<Topic>;
  /** Certification topic for the search response. */
  certificationTopic?: Maybe<Topic>;
  /** Debug information for the search response. */
  debug?: Maybe<Scalars['JSON']['output']>;
  /** For the request, show experiment metadata results like bucketing info, experiment IDs of assigned feature variants. */
  experimentResults: Array<FeatureVariantAssignment>;
  /** Whether there are available courses for organizations in the search result or not. */
  hasOrgCourses: Scalars['Boolean']['output'];
  /** Indicates whether the Google ad banner should be displayed in SRP. */
  isGoogleAdBannerEnabled: Scalars['Boolean']['output'];
  /** Original search query, without any manipulation. */
  originalQuery: Scalars['String']['output'];
  /** Search query suggestion containing the suggested query and the suggestion type. */
  querySuggestion?: Maybe<SearchQuerySuggestion>;
  /** Search analytics tracking id; for uniquely identifying this query and result set; for this request. */
  trackingId: Scalars['String']['output'];
};

/** Represents a course search result with additional data about the search response. */
export type CourseSearchResult = {
  __typename?: 'CourseSearchResult';
  /** The course information returned in the search result. */
  course: Course;
  /** Curriculum items that match with the search query. */
  curriculumItemMatches: Array<Maybe<CurriculumItem>>;
  /** Indicates which hands-on learning ribbons should be shown for this course. */
  handsOnRibbons: Array<HandsOnRibbonType>;
  /** Debugging information related to the search process for this course. */
  searchDebugFeatures?: Maybe<Scalars['JSON']['output']>;
  /** Unique analytics ID for this instance of Course returned from the server in this request. */
  trackingId: Scalars['String']['output'];
};

/** Sort order for courses in search response */
export enum CourseSearchSortType {
  /** Highest rated */
  Rating = 'RATING',
  /** Most relevant */
  Relevance = 'RELEVANCE',
  /** Most reviewed */
  Reviews = 'REVIEWS',
  /** Newest */
  Time = 'TIME'
}

/** Trigger types for the course search. */
export enum CourseSearchTriggerType {
  /** Course search triggered by the Amazon Alexa app */
  AlexaApp = 'ALEXA_APP',
  /** Course search triggered by a category page (e.g, https://www.udemy.com/courses/development/) */
  BrowseCategory = 'BROWSE_CATEGORY',
  /**
   * Course search triggered by a browse certification page
   * This includes pages like:
   * - https://www.udemy.com/browse/certification/
   * - https://www.udemy.com/browse/certification/... (e.g., https://www.udemy.com/browse/certification/aws-certifications/)
   */
  BrowseCertification = 'BROWSE_CERTIFICATION',
  /** Course search triggered by an elevate landing page */
  BrowseElevate = 'BROWSE_ELEVATE',
  /** Course search triggered by a roleplay browse page (e.g, https://www.udemy.com/ai-roleplay/) */
  BrowseRoleplay = 'BROWSE_ROLEPLAY',
  /** Course search triggered by a subcategory page (e.g, https://www.udemy.com/courses/development/web-development/) */
  BrowseSubcategory = 'BROWSE_SUBCATEGORY',
  /** Course search triggered by a topic page (e.g, https://www.udemy.com/topic/machine-learning/) */
  BrowseTopic = 'BROWSE_TOPIC',
  /** Course search triggered by the ChatGPT app */
  ChatgptApp = 'CHATGPT_APP',
  /** Course search triggered by the MCP server */
  McpServer = 'MCP_SERVER',
  /** User clicks on a narrowing search suggestion */
  NarrowingSearch = 'NARROWING_SEARCH',
  /** User clicks on recommendation unit */
  Recommendation = 'RECOMMENDATION',
  /** User clicks on related searches suggestion */
  RelatedSearches = 'RELATED_SEARCHES',
  /** Course search triggered by the Retool platform */
  Retool = 'RETOOL',
  /** User selects a search autocomplete */
  SearchAutocomplete = 'SEARCH_AUTOCOMPLETE',
  /** User insists on the original query, exactly as typed */
  SearchOriginalQuery = 'SEARCH_ORIGINAL_QUERY',
  /** User selects a search suggested query */
  SearchQuerySuggestion = 'SEARCH_QUERY_SUGGESTION',
  /** Course search triggered by native mobile apps for initial zero-state suggested search terms */
  SearchTrendingQuery = 'SEARCH_TRENDING_QUERY',
  /** Course search triggered by Android native app for top/trending search queries */
  TopSearches = 'TOP_SEARCHES',
  /** User inputs query in the search bar */
  UserQuery = 'USER_QUERY'
}

/** Section of the course containing all types of curriculum items */
export type CourseSection = CurriculumItem & {
  __typename?: 'CourseSection';
  /** Course this section belongs to */
  course?: Maybe<Course>;
  /** What will students be able to do at the end of this section? */
  description?: Maybe<Scalars['String']['output']>;
  /** Identifier for the course section */
  id: Scalars['ID']['output'];
  /** Content of the section */
  items: Array<CurriculumItem>;
  /** Title of the section */
  title: Scalars['String']['output'];
  /** Versioned identifier of the course section */
  versionedIdentifier: VersionedIdentifier;
};

/** A wrapper type to include the recommended Course Section and some additional fields about its recommendation */
export type CourseSectionRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'CourseSectionRecommendation';
  /** Underlying object of the recommendation to get more information about it */
  courseSection?: Maybe<CourseSection>;
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** Response for create snapshot */
export type CourseSnapshotCreateResponse = {
  __typename?: 'CourseSnapshotCreateResponse';
  /** The versionId for the snapshot */
  versionId: Scalars['String']['output'];
};

/** SubCategory that is part of CourseCategory */
export type CourseSubCategory = SubCategory & {
  __typename?: 'CourseSubCategory';
  /** ID of the subcategory */
  id: Scalars['ID']['output'];
  /** Name of the subcategory */
  name: Scalars['String']['output'];
  /** The URL to the subcategory page this course is a part of */
  url: Scalars['URL']['output'];
};

/** Course subscription availability status */
export enum CourseSubscriptionAvailabilityStatus {
  /** Course is available in current subscription */
  Current = 'CURRENT',
  /** Course is not available in any current or upgradable subscription plan (e.g. only available via marketplace purchase) */
  None = 'NONE',
  /** Course is available in upgradable subscription */
  Upgrade = 'UPGRADE'
}

/** Subscription specific course properties */
export type CourseSubscriptionInfo = {
  __typename?: 'CourseSubscriptionInfo';
  /** Indicates if the course is available in current or upgradable or none */
  availabilityStatus?: Maybe<CourseSubscriptionAvailabilityStatus>;
  /** Indicates which types of subscription this course can be purchased in the product family */
  availableInSubscriptionFamily?: Maybe<Array<SubscriptionPlan>>;
  /**
   * Indicates which types of subscription this course can be purchased in (deprecated)
   * @deprecated Use availableInSubscriptionFamily instead
   */
  availableInSubscriptions?: Maybe<Array<SubscriptionPlan>>;
  /** Indicates which type of user's subscription course is included in */
  inSubscriptions?: Maybe<Array<SubscriptionPlan>>;
};

/** Course taking-related organization settings */
export type CourseTakingOrganizationSettings = {
  __typename?: 'CourseTakingOrganizationSettings';
  /** Whether course notes feature is enabled */
  isCourseNotesEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Course Variant that belongs to a Course Variation */
export type CourseVariant = {
  __typename?: 'CourseVariant';
  /** Course object in this Course Variant */
  course: Course;
  /** Id of related option in a set of options */
  option: CourseVariationOption;
};

/** Course variant that belongs to a Course Variation */
export type CourseVariantInput = {
  /** CourseId for a course variant */
  courseId: Scalars['ID']['input'];
  /** Option this course is tagged with */
  variationOption: CourseVariationOptionInput;
};

/** A variation of courses */
export type CourseVariation = {
  __typename?: 'CourseVariation';
  /** Name of Variation */
  name: Scalars['String']['output'];
  /** Variation options */
  options: Array<CourseVariationOption>;
  /** Type of variation */
  type: CourseVariationType;
  /** Variants */
  variants: Array<CourseVariant>;
};

/** Aggregation of Course Variations */
export type CourseVariationAggregation = {
  __typename?: 'CourseVariationAggregation';
  /** Date when variation was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Variation aggregation ID */
  id: Scalars['ID']['output'];
  /** Whether the Course Variation Aggregation is published */
  isPublished: Scalars['Boolean']['output'];
  /** Name of the variation aggregation */
  name: Scalars['String']['output'];
  /** Owner of the Course Variation Aggregation */
  owner: CourseInstructor;
  /** Primary course in this aggregation */
  primaryCourse?: Maybe<Course>;
  /** The course variations in this aggregation */
  variations: Array<Maybe<CourseVariation>>;
};

/** Response for update/create */
export type CourseVariationAggregationCreateOrUpdateResponse = {
  __typename?: 'CourseVariationAggregationCreateOrUpdateResponse';
  /** Aggregation that was updated/created */
  courseVariationAggregation?: Maybe<CourseVariationAggregation>;
};

/** Reponse for deletion */
export type CourseVariationAggregationDeleteResponse = {
  __typename?: 'CourseVariationAggregationDeleteResponse';
  /** ID that was deleted */
  courseVariationAggregationId?: Maybe<Scalars['ID']['output']>;
};

/** Input for Course Variation Aggregation */
export type CourseVariationAggregationInput = {
  /** Whether the Course Variation Aggregation is published */
  isPublished: Scalars['Boolean']['input'];
  /** Name of the Course Variation Aggregation */
  name: Scalars['String']['input'];
  /** Primary course in this aggregation */
  primaryCourseId?: InputMaybe<Scalars['ID']['input']>;
  /** Variations in this aggregation */
  variations: Array<CourseVariationInput>;
};

/** Input for each Course Variation */
export type CourseVariationInput = {
  /** Name of the variation */
  name: Scalars['String']['input'];
  /** List of options for the variation */
  options: Array<CourseVariationOptionInput>;
  /** Type of how variants are joined into a variation */
  type: CourseVariationType;
  /** Course variants in this variation */
  variants: Array<CourseVariantInput>;
};

/** Option in a Course Variation */
export type CourseVariationOption = {
  __typename?: 'CourseVariationOption';
  /** Id of an option */
  id: Scalars['ID']['output'];
  /** Label to display in the UI */
  label: Scalars['String']['output'];
};

/** Option in a Course Variation */
export type CourseVariationOptionInput = {
  /** Option ID */
  id: Scalars['ID']['input'];
  /** Label to display in the UI */
  label: Scalars['String']['input'];
};

/** Types of variations */
export enum CourseVariationType {
  /** Audience */
  Audience = 'AUDIENCE',
  /** Course Edition */
  CourseEdition = 'COURSE_EDITION',
  /** Language */
  Language = 'LANGUAGE',
  /** Topic */
  Topic = 'TOPIC'
}

/** Currencies available */
export enum CurrencyCode {
  /** Australian dollar */
  Aud = 'AUD',
  /** Brazilian real */
  Brl = 'BRL',
  /** Canadian dollar */
  Cad = 'CAD',
  /** Chilean peso */
  Clp = 'CLP',
  /** Colombian peso */
  Cop = 'COP',
  /** Danish crone */
  Dkk = 'DKK',
  /** Egyptian pound */
  Egp = 'EGP',
  /** Euro */
  Eur = 'EUR',
  /** Sterling */
  Gbp = 'GBP',
  /** Indonesian rupiah */
  Idr = 'IDR',
  /** Israel new shekel */
  Ils = 'ILS',
  /** Indian rupee */
  Inr = 'INR',
  /** Japanese yen */
  Jpy = 'JPY',
  /** South Korean won */
  Krw = 'KRW',
  /** Mexican peso */
  Mxn = 'MXN',
  /** Malaysian ringgit */
  Myr = 'MYR',
  /** Nigerian naira */
  Ngn = 'NGN',
  /** Norwegian krone */
  Nok = 'NOK',
  /** Peruvian sol */
  Pen = 'PEN',
  /** Philippine peso */
  Php = 'PHP',
  /** Polish złoty */
  Pln = 'PLN',
  /** Romanian leu */
  Ron = 'RON',
  /** Russian ruble */
  Rub = 'RUB',
  /** Singapore dollar */
  Sgd = 'SGD',
  /** Thai baht */
  Thb = 'THB',
  /** Turkish lira */
  Try = 'TRY',
  /** New Taiwan dollar */
  Twd = 'TWD',
  /** United States dollar */
  Usd = 'USD',
  /** Vietnamese dong */
  Vnd = 'VND',
  /** South African rand */
  Zar = 'ZAR'
}

/** Curriculum part of a course */
export type Curriculum = {
  __typename?: 'Curriculum';
  /** Count of the course curriculum content by type */
  contentCounts?: Maybe<CourseCurriculumContentCounts>;
  /** Course this curriculum belongs to */
  course?: Maybe<Course>;
  /** Each course section containing the course curriculum content */
  sections: Array<CourseSection>;
  /** Versioned identifier of the curriculum */
  versionedIdentifier: VersionedIdentifier;
};

/** Interface for a curriculum item */
export type CurriculumItem = {
  /** Course this curriculum item belongs to */
  course?: Maybe<Course>;
  /** Id of the curriculum item */
  id: Scalars['ID']['output'];
  /** Title of the curriculum item */
  title: Scalars['String']['output'];
  /** Versioned identifier of the curriculum item */
  versionedIdentifier: VersionedIdentifier;
};

/** Input for cursor-based pagination queries. Used to request a specific page of results. */
export type CursorPaginatedInput = {
  /**
   * Opaque cursor string from a previous query, used to fetch the next set of results.
   * When omitted, returns the first page of results.
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum number of items to return in a single page.
   * Server will use a default limit if not specified.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Interface for implementing cursor-based pagination responses. */
export type CursorPaginatedResponse = {
  /**
   * Opaque cursor string that points to the end of the current result set.
   * Use this value in subsequent queries to fetch the next page.
   */
  cursor?: Maybe<Scalars['String']['output']>;
};

/**
 * If a part of the response needs customizations about how it should be rendered on the UI, this interface should be
 * implemented.
 */
export type CustomizableRecommendationPresentation = {
  /**
   * Frontend application should always be able to determine how to render a recommendations based on basic
   * information such as context, item type, unit type, etc. However, there might be some edge cases where the person
   * who configures the RecommendationContext and RecommendationUnits on Tapen might want to a customize UI behavior
   * slightly for a unit. This person coordinates with the FE teams and they agree on a specific value for this field.
   * When this specific value is received, FE uses an alternative appearance for that recommendation.
   *
   * The field is a string because the responsibility of this API and related backend services is just to convey this
   * field. It is never processed in recommendation backend services, just conveyed.
   */
  viewType?: Maybe<Scalars['String']['output']>;
};

/** Price option for computed price plan. Will be returned for daily plans */
export type DailySubscriptionPlanPricingOption = {
  __typename?: 'DailySubscriptionPlanPricingOption';
  /** Contains information about the discount context for a given subscription plan price option */
  discount?: Maybe<SubscriptionPlanDiscount>;
  /** Field containing details about the discounted trial subscription offer for a given user. Null indicates no trial is available */
  discountTrial?: Maybe<SubscriptionTrial>;
  /** ID of the price option: */
  id: Scalars['ID']['output'];
  /** Contains information about the license context for a given subscription plan price option */
  licenseContext?: Maybe<SubscriptionPlanLicenseContext>;
  /** The list price of the subscription price plan based on provided requested count from request */
  listPrice: Money;
  /** Field showing the prices for the option. */
  price?: Maybe<SubscriptionPlanPrice>;
  /** Interval for renewing the subscription plan ie the length of the subscription plan */
  renewalInterval: DateInterval;
  /** Field containing details about the trial subscription offer for a given user. Null indicates no trial is available */
  trial?: Maybe<SubscriptionTrial>;
};

/** Represents the type of data transfer */
export enum DataTransferType {
  /** Presigned url file transfer */
  PresignedUrl = 'PRESIGNED_URL',
  /** Pusher transfer */
  Pusher = 'PUSHER'
}

/** Filter used to pass start and end date between which learning activity has to be returned. Date range should be less than or equal to 120 days when granularity is DAY level. */
export type DateFilter = {
  /** End date till which the learning activity has to be measured. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Granularity at which learning activity trend response should be returned like DAY, MONTH. */
  granularity?: InputMaybe<DateIntervalType>;
  /** Start date from which the learning activity has to be measured. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Type representing details about an interval of dates */
export type DateInterval = {
  __typename?: 'DateInterval';
  /** The count of type in the interval */
  count: Scalars['Int']['output'];
  /** Type type of interval */
  type: DateIntervalType;
};

/** Supported units of time over which a subscription trial or billing cycle can occur */
export enum DateIntervalType {
  /** Daily interval */
  Day = 'DAY',
  /** Monthly interval */
  Month = 'MONTH',
  /** Weekly interval */
  Week = 'WEEK',
  /** Yearly interval */
  Year = 'YEAR'
}

/** An input that accepts a range of dates to filter the data. If the end date is not provided, it will be considered as now. The dates are inclusive */
export type DateRangeInput = {
  /** Start date of the interval for requested metrics. should be now for last week/month/year */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Start date of the interval for requested metrics */
  startDate: Scalars['DateTime']['input'];
};

/** Day of the week for report scheduling */
export enum DayOfWeek {
  /** Friday */
  Friday = 'FRIDAY',
  /** Monday */
  Monday = 'MONDAY',
  /** Saturday */
  Saturday = 'SATURDAY',
  /** Sunday */
  Sunday = 'SUNDAY',
  /** Thursday */
  Thursday = 'THURSDAY',
  /** Tuesday */
  Tuesday = 'TUESDAY',
  /** Wednesday */
  Wednesday = 'WEDNESDAY'
}

/** Instruction level of the course */
export enum DifficultyLevel {
  /** Item is appropriate for all skill levels */
  AllLevels = 'ALL_LEVELS',
  /** Item is for beginners */
  Beginner = 'BEGINNER',
  /** Item is for students with expert knowledge */
  Expert = 'EXPERT',
  /** Item is for students with intermediates knowledge */
  Intermediate = 'INTERMEDIATE'
}

/** definition of different discount source types */
export enum DiscountSourceType {
  /** General discount coupon code */
  GeneralCoupon = 'GENERAL_COUPON',
  /** Instructor discount coupon code */
  InstructorCoupon = 'INSTRUCTOR_COUPON',
  /** Udemy discount coupon code */
  UdemyCoupon = 'UDEMY_COUPON'
}

/** The content of a component defined in the CMS */
export type DynamicWebContent = {
  __typename?: 'DynamicWebContent';
  /** The URL to the associated content. */
  contentUrl?: Maybe<Scalars['URL']['output']>;
  /** The text for the URL to the piece of content. */
  contentUrlText?: Maybe<Scalars['String']['output']>;
  /** The associated sub content contained within this piece of content. This allows us to create a collection of nested web content. */
  contents?: Maybe<Array<Maybe<DynamicWebContent>>>;
  /** The description text for the dynamic web content */
  description?: Maybe<Scalars['String']['output']>;
  /** The heading text for the dynamic web content */
  heading?: Maybe<Scalars['String']['output']>;
  /** The text for the content label. */
  image?: Maybe<DynamicWebContentImage>;
  /** The image URL of the secondary image asset associated with this content, usually an icon, with optional alt text */
  labelText?: Maybe<Scalars['String']['output']>;
  /** The image URL of the main image asset associated with this content, with optional alt text */
  secondaryImage?: Maybe<DynamicWebContentImage>;
  /** The tracking ID of the piece of content. To be used to uniquely identify the content in event tracking */
  trackingId?: Maybe<Scalars['ID']['output']>;
};

/** The dynamic web content query filter options */
export type DynamicWebContentFilters = {
  /** The ID of the content to fetch (e.g. `promotionItem`, `organizationLogs`, etc) */
  contentId: Scalars['String']['input'];
  /** The overriding parameters that will be parsed from URL */
  contentPreviewOverrides?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The URL query param that will be parsed to enable returning the content that has been saved but not yet published in the CMS. */
  isContentPreviewEnabled?: Scalars['Boolean']['input'];
  /** The specific page type for the dynamic web content that will match values set in the CMS */
  pageType: DynamicWebContentPageType;
};

/** The dynamic web image object. This combines the image URL and the alt text for the image for a11y purposes. */
export type DynamicWebContentImage = {
  __typename?: 'DynamicWebContentImage';
  /** The alt text of the image for a11y purposes. */
  altText?: Maybe<Scalars['String']['output']>;
  /** The URL to the image asset */
  url?: Maybe<Scalars['URL']['output']>;
};

/** The specific page type for the dynamic web content. This is important for narrowing down the content in the CMS to where Marketing wants to render it. */
export enum DynamicWebContentPageType {
  /** Logged out home page of udemy */
  LoggedOutHomePage = 'LOGGED_OUT_HOME_PAGE',
  /** Personal Plan Landing page */
  PersonalPlanLandingPage = 'PERSONAL_PLAN_LANDING_PAGE',
  /** Udemy Business request demo form */
  RequestDemoForm = 'REQUEST_DEMO_FORM'
}

/** Lecture in form of an EBook (deprecated) */
export type EBookLecture = CurriculumItem & Lecture & {
  __typename?: 'EBookLecture';
  /** Lecture's main learning asset */
  asset?: Maybe<Asset>;
  /** The Course this lecture belongs to */
  course?: Maybe<Course>;
  /** Instructor-authored description of the lecture, may contain HTML */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** Total duration of the lecture's content in seconds */
  durationInSeconds: Scalars['DurationInSeconds']['output'];
  /** Id of the lecture */
  id: Scalars['ID']['output'];
  /** Images by their dimensions */
  images: LectureImages;
  /** If user has completed the lecture */
  isCompleted: Scalars['Boolean']['output'];
  /** Whether this lecture is used for promos and course previews. */
  isPreviewable: Scalars['Boolean']['output'];
  /** Lecture's supplementary resources */
  resources?: Maybe<Array<Maybe<Asset>>>;
  /** Associated learning products for supplementary learning */
  supplementaryLearningProducts: Array<LearningProduct>;
  /** The URL of the lecture thumbnail */
  thumbnail?: Maybe<Scalars['URL']['output']>;
  /** Lecture title */
  title: Scalars['String']['output'];
  /** The URL to access the lecture on the auto-enroll page */
  urlAutoEnroll: Scalars['URL']['output'];
  /** Download URL for lecture */
  urlDownload?: Maybe<Scalars['URL']['output']>;
  /** Landing page to view this Lecture */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the lecture */
  versionedIdentifier: VersionedIdentifier;
};


/** Lecture in form of an EBook (deprecated) */
export type EBookLectureSupplementaryLearningProductsArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** A record of user's enrollment to a learning product */
export type Enrollment = {
  __typename?: 'Enrollment';
  /** Time at which the enrollment was archived (null if not archived). */
  archiveTime?: Maybe<Scalars['DateTime']['output']>;
  /** Time of enrollment */
  createdAt: Scalars['DateTime']['output'];
  /** Learning Product to which the enrollment has been created */
  learningProduct: LearningProduct;
};

/** Response object for archiving an enrollment. */
export type EnrollmentArchiveResponse = {
  __typename?: 'EnrollmentArchiveResponse';
  /** The enrollment that was archived */
  enrollment: Enrollment;
};

/** Response object for enrollment creation */
export type EnrollmentCreateResponse = {
  __typename?: 'EnrollmentCreateResponse';
  /** Enrollment */
  enrollment?: Maybe<Enrollment>;
};

/** Source of the enrollment */
export enum EnrollmentSourceType {
  /** The enrollment was created from a purchase */
  Purchase = 'PURCHASE',
  /** The enrollment was created from a subscription context */
  Subscription = 'SUBSCRIPTION'
}

/** Response object for unarchiving an enrollment. */
export type EnrollmentUnarchiveResponse = {
  __typename?: 'EnrollmentUnarchiveResponse';
  /** The enrollment that was unarchived */
  enrollment: Enrollment;
};

/** Input for enrolling to learning product */
export type EnrollmentsLearningProductInput = {
  /** ID of the learning product */
  id: Scalars['ID']['input'];
  /** Type of the learning product */
  type: EnrollmentsLearningProductInputType;
  /** Version ID of the learning product */
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** Learning product type input */
export enum EnrollmentsLearningProductInputType {
  /** Badge Class */
  BadgeClass = 'BADGE_CLASS',
  /** Career Accelerator */
  CareerAccelerator = 'CAREER_ACCELERATOR',
  /** Course */
  Course = 'COURSE'
}

/** Represents the entity who was affected by the event. */
export type Entity = {
  __typename?: 'Entity';
  /** The unique identifier for the entity. */
  entityId: Scalars['ID']['output'];
  /** The type of entity, such as an end user, group, or license. */
  entityType: EntityType;
};

/** Defines the type of entity who was affected by the event. */
export enum EntityType {
  /** Represents an end user who was affected by the action. */
  EndUser = 'END_USER',
  /** Represents a group which was affected by the action. */
  Group = 'GROUP',
  /** Represents a license which was affected by the action. */
  License = 'LICENSE',
  /** Means the entity type is not applicable for this event. */
  Na = 'NA'
}

/** Lecture that refers to an external source (deprecated) */
export type ExternalLecture = CurriculumItem & Lecture & {
  __typename?: 'ExternalLecture';
  /** Lecture's main learning asset */
  asset?: Maybe<Asset>;
  /** The Course this lecture belongs to */
  course?: Maybe<Course>;
  /** Instructor-authored description of the lecture, may contain HTML */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** Id of the lecture */
  id: Scalars['ID']['output'];
  /** Images by their dimensions */
  images: LectureImages;
  /** If user has completed the lecture */
  isCompleted: Scalars['Boolean']['output'];
  /** Whether this lecture is used for promos and course previews. */
  isPreviewable: Scalars['Boolean']['output'];
  /** Lecture's supplementary resources */
  resources?: Maybe<Array<Maybe<Asset>>>;
  /** Associated learning products for supplementary learning */
  supplementaryLearningProducts: Array<LearningProduct>;
  /** The URL of the lecture thumbnail */
  thumbnail?: Maybe<Scalars['URL']['output']>;
  /** Lecture title */
  title: Scalars['String']['output'];
  /** The URL to access the lecture on the auto-enroll page */
  urlAutoEnroll: Scalars['URL']['output'];
  /** Download URL for lecture */
  urlDownload?: Maybe<Scalars['URL']['output']>;
  /** Landing page to view this Lecture */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the lecture */
  versionedIdentifier: VersionedIdentifier;
};


/** Lecture that refers to an external source (deprecated) */
export type ExternalLectureSupplementaryLearningProductsArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** Stores realtime attribute like build_number->20220322_v1 */
export type FeatureRequestAttributeInput = {
  /** Key, ex: build_number */
  key: Scalars['String']['input'];
  /** Value, ex: 20220322_v1 */
  value: Scalars['String']['input'];
};

/** Holds assigned feature variant  */
export type FeatureVariantAssignment = {
  __typename?: 'FeatureVariantAssignment';
  /** Configuration data of assigned feature variant */
  configuration?: Maybe<Scalars['JSON']['output']>;
  /** List of experiment ids bucketed for current feature */
  experimentIds: Array<Scalars['Int']['output']>;
  /** Feature code of assigned feature variant */
  featureCode: Scalars['String']['output'];
  /** Shows whether this feature variant is in experiment */
  isInExperiment?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the presentation on the frontend is the actual response of the Experimentation Platform or not. */
  isLocalDefault: Scalars['Boolean']['output'];
};

/** Holds filters for feature variant assignments */
export type FeatureVariantAssignmentFilters = {
  /** Filter by real time attributes */
  realtimeAttributes?: InputMaybe<Array<FeatureRequestAttributeInput>>;
};

/** Feedback object */
export type Feedback = {
  __typename?: 'Feedback';
  /** ID associated with Feedback */
  id: Scalars['ID']['output'];
  /** Option selected when storing the feedback */
  option: FeedbackOption;
  /** Text feedback to a target */
  text?: Maybe<Scalars['String']['output']>;
};

/** Input to create Feedback */
export type FeedbackCreateInput = {
  /** Option selected when storing a feedback */
  option: FeedbackOption;
  /** Object to give feedback to */
  target: FeedbackInputTarget;
  /** Text feedback to a target */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Response for storing a feedback */
export type FeedbackCreateResponse = {
  __typename?: 'FeedbackCreateResponse';
  /** The feedback created if the mutation was successful */
  feedback?: Maybe<Feedback>;
};

/** Polymorphic object to represent what the feedback is being applied to */
export type FeedbackInputTarget = {
  /** ID of the target */
  id: Scalars['ID']['input'];
  /** Type of the target */
  type: FeedbackTargetType;
};

/** Possible feedback options */
export enum FeedbackOption {
  /** Negative feedback is given to a target */
  Negative = 'NEGATIVE',
  /** Positive feedback is given to a target */
  Positive = 'POSITIVE',
  /** Feedback to a target is unselected, or removed */
  Unselected = 'UNSELECTED'
}

/** Possible object targets to apply the feedback to */
export enum FeedbackTargetType {
  /** Feedback is given to a course section */
  CourseSection = 'COURSE_SECTION',
  /** Feedback is given to a content discovery learning assistant chat message */
  DiscoveryChat = 'DISCOVERY_CHAT',
  /** Feedback is given to an in course learning assistant chat message */
  InCourseChat = 'IN_COURSE_CHAT',
  /** Feedback is given to an in-course lab */
  InCourseLab = 'IN_COURSE_LAB',
  /** Feedback is given to a learning assistant chat message (deprecated) */
  LearningAssistantChatMessage = 'LEARNING_ASSISTANT_CHAT_MESSAGE',
  /** Feedback is given to a lecture */
  Lecture = 'LECTURE',
  /** Feedback is given to a role play */
  RolePlay = 'ROLE_PLAY',
  /** Feedback is given to a role play learner report actionable tips */
  RolePlayLearnerReportActionableTips = 'ROLE_PLAY_LEARNER_REPORT_ACTIONABLE_TIPS',
  /** Feedback is given to a role play learner report areas for improvement */
  RolePlayLearnerReportAreasForImprovement = 'ROLE_PLAY_LEARNER_REPORT_AREAS_FOR_IMPROVEMENT',
  /** Feedback is given to a role play learner report strengths */
  RolePlayLearnerReportStrengths = 'ROLE_PLAY_LEARNER_REPORT_STRENGTHS'
}

/** Lecture in the form of a single file (deprecated) */
export type FileLecture = CurriculumItem & Lecture & {
  __typename?: 'FileLecture';
  /** Lecture's main learning asset */
  asset?: Maybe<Asset>;
  /** The Course this lecture belongs to */
  course?: Maybe<Course>;
  /** Instructor-authored description of the lecture, may contain HTML */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** Id of the lecture */
  id: Scalars['ID']['output'];
  /** Images by their dimensions */
  images: LectureImages;
  /** If user has completed the lecture */
  isCompleted: Scalars['Boolean']['output'];
  /** Whether this lecture is used for promos and course previews. */
  isPreviewable: Scalars['Boolean']['output'];
  /** Lecture's supplementary resources */
  resources?: Maybe<Array<Maybe<Asset>>>;
  /** Associated learning products for supplementary learning */
  supplementaryLearningProducts: Array<LearningProduct>;
  /** The URL of the lecture thumbnail */
  thumbnail?: Maybe<Scalars['URL']['output']>;
  /** Lecture title */
  title: Scalars['String']['output'];
  /** The URL to access the lecture on the auto-enroll page */
  urlAutoEnroll: Scalars['URL']['output'];
  /** Download URL for lecture */
  urlDownload?: Maybe<Scalars['URL']['output']>;
  /** Landing page to view this Lecture */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the lecture */
  versionedIdentifier: VersionedIdentifier;
};


/** Lecture in the form of a single file (deprecated) */
export type FileLectureSupplementaryLearningProductsArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** Fill in the blanks question. No options, question text has placeholders for user to fill in */
export type FillInTheBlanksQuizItem = QuizItem & {
  __typename?: 'FillInTheBlanksQuizItem';
  /** Correct answers in order for the fill in the blank items */
  correctAnswers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Explanation of the item */
  explanation: Scalars['String']['output'];
  /** ID of the item */
  id: Scalars['ID']['output'];
  /** Related lectures */
  relatedLectures: Array<Lecture>;
  /** Question text */
  text: Scalars['String']['output'];
};

/** Authentication credentials for accessing a GCP cloud lab instance */
export type GcpCloudLabInstanceCredentials = {
  __typename?: 'GcpCloudLabInstanceCredentials';
  /** Employee ID associated with the GCP user account */
  employeeId?: Maybe<Scalars['String']['output']>;
  /** URL to the Google Cloud Console login page */
  loginUrl?: Maybe<Scalars['URL']['output']>;
  /** Password for GCP account authentication */
  password?: Maybe<Scalars['String']['output']>;
  /** Username for GCP account authentication */
  username?: Maybe<Scalars['String']['output']>;
};

/** Represents types of hands-on learning experiences available in a course. These ribbons indicate interactive learning features that enhance the course experience. */
export enum HandsOnRibbonType {
  /** Coding exercise challenges */
  CodingExercises = 'CODING_EXERCISES',
  /** General hands-on practice activities */
  HandsOnPractices = 'HANDS_ON_PRACTICES',
  /** Hands-on lab environments */
  Labs = 'LABS',
  /** Practice test assessments */
  PracticeTests = 'PRACTICE_TESTS',
  /** Quiz assessments */
  Quiz = 'QUIZ',
  /** Interactive role-play exercises */
  RolePlay = 'ROLE_PLAY',
  /** Interactive workspace environments */
  Workspace = 'WORKSPACE'
}

/** Represents a badge awarded to a hot and new learning product. */
export type HotAndNewBadge = LearningProductBadge & {
  __typename?: 'HotAndNewBadge';
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
};

/** Instructor for a learning product */
export type Instructor = {
  /** ID of the Instructor */
  id: Scalars['ID']['output'];
  /** Instructor's image by varying pixels */
  images: InstructorImages;
  /** Is the instructor opted out, i.e. not willing to participate on Gen AI features */
  isOptedOutToGenAI?: Maybe<Scalars['Boolean']['output']>;
  /** Instructor's name */
  name: Scalars['String']['output'];
  /** The URL to access the instructor page */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Instructor's account balance */
export type InstructorAccountBalance = {
  __typename?: 'InstructorAccountBalance';
  /** Instructor's current account balance amount */
  amount: Scalars['Float']['output'];
};

/** Instructor's account issues */
export type InstructorAccountIssues = {
  __typename?: 'InstructorAccountIssues';
  /** If instructor is Australian and has no Australian Business Number(ABN) */
  noAbn: Scalars['Boolean']['output'];
  /** If instructor has no payout method */
  noPayoutMethod: Scalars['Boolean']['output'];
  /** If instructor has no tax forms */
  noTaxForms: Scalars['Boolean']['output'];
};

/** Instructor Content Opportunity object  */
export type InstructorContentOpportunity = {
  __typename?: 'InstructorContentOpportunity';
  /** Category of the opportunity */
  category: Category;
  /** The time the content opportunity was created at */
  createdAt: Scalars['DateTime']['output'];
  /** Display rule of the opportunity */
  displayRule: InstructorContentOpportunityDisplayRule;
  /** Domain of the opportunity */
  domain: Scalars['String']['output'];
  /** Estimated demand of the opportunity */
  estimatedDemand: Scalars['String']['output'];
  /** ID of the opportunity */
  id: Scalars['ID']['output'];
  /** Financial incentive eligibility of the opportunity */
  isFinancialIncentiveEligible: Scalars['Boolean']['output'];
  /** Key content of the opportunity */
  keyContent: Scalars['String']['output'];
  /** Language of the opportunity */
  language: LanguageCode;
  /** Level of the opportunity */
  level: InstructorContentOpportunityLevel;
  /** The last time the content opportunity was modified at */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Priority level of the opportunity */
  priority: InstructorContentOpportunityPriority;
  /** Subject of the opportunity */
  subject: Scalars['String']['output'];
  /** Target audience of the opportunity */
  targetAudience: Scalars['String']['output'];
  /** Type of the opportunity */
  type: InstructorContentOpportunityType;
};

/** Display rule of the content opportunity */
export enum InstructorContentOpportunityDisplayRule {
  /** Opportunity is for all instructors */
  AllInstructors = 'ALL_INSTRUCTORS',
  /** Opportunity is excluded */
  Exclude = 'EXCLUDE',
  /** Opportunity is for internal use only */
  InternalOnly = 'INTERNAL_ONLY',
  /** Opportunity is for IP instructors only */
  IpOnly = 'IP_ONLY',
  /** Opportunity is no longer a priority */
  NoLongerAPriority = 'NO_LONGER_A_PRIORITY'
}

/** Filters for ContentOpportunity */
export type InstructorContentOpportunityFilters = {
  /** Category of the content opportunity */
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Display rule of the opportunities */
  displayRule?: InputMaybe<Array<InputMaybe<InstructorContentOpportunityDisplayRule>>>;
  /** Domain list of the opportunities */
  domain?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Estimated demand of the opportunities */
  estimatedDemand?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Financial incentive eligibility of the opportunities */
  isFinancialIncentiveEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Language list of the opportunities */
  language?: InputMaybe<Array<InputMaybe<LanguageCode>>>;
  /** Level list of the opportunities */
  level?: InputMaybe<Array<InputMaybe<InstructorContentOpportunityLevel>>>;
  /** Priority list of the opportunities */
  priority?: InputMaybe<Array<InputMaybe<InstructorContentOpportunityPriority>>>;
  /** Type list of the opportunities */
  type?: InputMaybe<Array<InputMaybe<InstructorContentOpportunityType>>>;
};

/** Level of the content opportunity */
export enum InstructorContentOpportunityLevel {
  /** Opportunity is for all levels */
  AllLevels = 'ALL_LEVELS',
  /** Opportunity is for any level (any of the above levels) */
  AnyLevel = 'ANY_LEVEL',
  /** Opportunity is for beginner level */
  Beginner = 'BEGINNER',
  /** Opportunity is for expert level */
  Expert = 'EXPERT',
  /** Opportunity is for intermediate level */
  Intermediate = 'INTERMEDIATE'
}

/** Response for creating a course opportunity mapping (Linking an opportunity to a course) */
export type InstructorContentOpportunityLinkCourseResponse = {
  __typename?: 'InstructorContentOpportunityLinkCourseResponse';
  /** Linked opportunity */
  opportunity?: Maybe<InstructorContentOpportunity>;
};

/** Priority level of the content opportunity */
export enum InstructorContentOpportunityPriority {
  /** High priority */
  High = 'HIGH',
  /** Low priority */
  Low = 'LOW',
  /** Medium priority */
  Medium = 'MEDIUM'
}

/** Paginated response for content opportunity search */
export type InstructorContentOpportunitySearchResponse = Paginated & {
  __typename?: 'InstructorContentOpportunitySearchResponse';
  /** If search text results are exact match or if it is split to words and searched */
  isExactMatch?: Maybe<Scalars['Boolean']['output']>;
  /** List of opportunities */
  opportunities: Array<InstructorContentOpportunity>;
  /** Current page number */
  page: Scalars['Int']['output'];
  /** Total number of pages */
  pageCount: Scalars['Int']['output'];
};

/** Sort order for ContentOpportunities */
export enum InstructorContentOpportunitySortType {
  /** Most important */
  Priority = 'PRIORITY',
  /** Newest */
  Time = 'TIME'
}

/** Type of the content opportunity */
export enum InstructorContentOpportunityType {
  /** Opportunity is a first mover (there is limited content coverage in UB for the demand) */
  FirstMover = 'FIRST_MOVER',
  /** Opportunity is a organization request */
  OrgRequest = 'ORG_REQUEST',
  /** Opportunity is a specialized one (demand is high for specific roles) */
  Specialized = 'SPECIALIZED',
  /** Opportunity is a trend (there is some content coverage in UB for the demand) */
  Trending = 'TRENDING'
}

/** Response for deleting a course opportunity mapping (Unlinking an opportunity from a course) */
export type InstructorContentOpportunityUnlinkCourseResponse = {
  __typename?: 'InstructorContentOpportunityUnlinkCourseResponse';
  /** Unlinked opportunity */
  opportunity?: Maybe<InstructorContentOpportunity>;
};

/** Instructor images by varying dimensions */
export type InstructorImages = {
  __typename?: 'InstructorImages';
  /** Instructor image with 50x50 dimensions in pixels */
  px50x50?: Maybe<Scalars['String']['output']>;
};

/** Represent learner metrics. Every learner metric has a value and total learner */
export type InstructorInsightMetric = {
  __typename?: 'InstructorInsightMetric';
  /** Ratio of this metric by total related metrics */
  ratio?: Maybe<Scalars['Float']['output']>;
  /** Value of the metrics */
  value: Scalars['Int']['output'];
};

/** A representation of a practice-test for instructor insights */
export type InstructorInsightPracticeTest = {
  __typename?: 'InstructorInsightPracticeTest';
  /** Id of the practice test */
  id: Scalars['ID']['output'];
  /** Instructor relevant metrics for the practice test */
  metrics: InstructorInsightPracticeTestInsight;
  /** Minimum passing score for an attempt to be considered successful */
  passPercent: Scalars['Int']['output'];
  /** Previous versions of the practice test */
  previousVersions: Array<Maybe<InstructorInsightPracticeTestVersion>>;
  /** The question list of the practice test */
  questions: Array<InstructorInsightPracticeTestQuestion>;
  /** The title of the practice test */
  title: Scalars['String']['output'];
  /** The version of the practice test */
  version: Scalars['Int']['output'];
};

/** Metrics of a Practice Test */
export type InstructorInsightPracticeTestInsight = {
  __typename?: 'InstructorInsightPracticeTestInsight';
  /** An attempt is the complete set of data associated with a learner who has started, completed, and received a score for a specific version of a practice test */
  attempts?: Maybe<InstructorInsightMetric>;
  /** The # of unique learners who clicked on both the “Begin test” and “Finish Test” buttons at least once in the PT learner experience. */
  completed: InstructorInsightMetric;
  /** The # of unique learners who have never passed the test. */
  failed: InstructorInsightMetric;
  /** Id of the practice test */
  id: Scalars['ID']['output'];
  /** The # of unique learners who have passed a PT at least once. */
  passed: InstructorInsightMetric;
  /** The # of unique learners who clicked to “Begin test” button in the PT learner experience, if the learner started 5 times, that learner should be counted as 1, approach will be unique learners. */
  started: InstructorInsightMetric;
  /** Learner metrics of time spent metric */
  timeSpent?: Maybe<InstructorInsightMetric>;
  /** The total # of learners */
  total: InstructorInsightMetric;
};

/** A representation of a practice-test question for instructor insights */
export type InstructorInsightPracticeTestQuestion = {
  __typename?: 'InstructorInsightPracticeTestQuestion';
  /** Choices for the question specified by the instructor. There are no pre-specified choices for some question types (fill-in-the-blanks) so this can be null. */
  choices?: Maybe<Array<InstructorInsightPracticeTestQuestionChoice>>;
  /** If the question is deleted this shows the date when */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Id of the question */
  id: Scalars['ID']['output'];
  /** Instructor relevant metrics for the question */
  metrics: InstructorInsightPracticeTestQuestionInsight;
  /** The status of the question */
  status: InstructorInsightPracticeTestQuestionStatus;
  /** The title of the question */
  text: Scalars['String']['output'];
  /** Type of the question */
  type?: Maybe<InstructorInsightPracticeTestQuestionType>;
  /** Link to where the question can be edited, if the question is not deleted */
  urlEdit?: Maybe<Scalars['URL']['output']>;
  /** The version of the question */
  version: Scalars['Int']['output'];
};

/** Choice of a question inside a practice test */
export type InstructorInsightPracticeTestQuestionChoice = {
  __typename?: 'InstructorInsightPracticeTestQuestionChoice';
  /** Id of the choice */
  id: Scalars['String']['output'];
  /** The type of the incorrect choice */
  incorrectType?: Maybe<InstructorInsightPracticeTestQuestionChoiceIncorrectType>;
  /** Whether the choice is correct or not */
  isCorrect: Scalars['Boolean']['output'];
  /** Insight metrics of the choice */
  metrics?: Maybe<InstructorInsightPracticeTestQuestionChoiceInsight>;
  /** The order of the choice inside the question */
  order: Scalars['Int']['output'];
  /** The value of the choice */
  text: Scalars['String']['output'];
};

/** Type of an incorrect answer at the Practice Test. */
export enum InstructorInsightPracticeTestQuestionChoiceIncorrectType {
  /** To mark commonly selected incorrect answer */
  CommonlySelected = 'COMMONLY_SELECTED'
}

/** Insight metrics of an answer */
export type InstructorInsightPracticeTestQuestionChoiceInsight = {
  __typename?: 'InstructorInsightPracticeTestQuestionChoiceInsight';
  /** Id of the answer */
  id: Scalars['String']['output'];
  /** Number of learners seeing this question for the first time and selecting this answer */
  selectionCount: Scalars['Int']['output'];
  /** Ratio of the number of learners seeing this question for the first time and selecting this answer to the total number of learners seeing this question for the first time and answering */
  selectionRate?: Maybe<Scalars['Float']['output']>;
};

/** Insight metrics of a question inside a practice test */
export type InstructorInsightPracticeTestQuestionInsight = {
  __typename?: 'InstructorInsightPracticeTestQuestionInsight';
  /** Average time spent on question by learners. In seconds. */
  avgTimeSpent: Scalars['Float']['output'];
  /** The percentage of learners who gave the correct answer. */
  correctRatio: Scalars['Float']['output'];
  /** Id of the question */
  id: Scalars['ID']['output'];
  /** The percentage of learners who gave the incorrect answer. */
  incorrectRatio: Scalars['Float']['output'];
  /** Number of learners who saw this question for the first time. */
  numberOfLearners: Scalars['Int']['output'];
  /** Number of learners who gave the correct answer. */
  numberOfSuccessfulLearners: Scalars['Int']['output'];
  /** Calculated quality level of the question. */
  qualityLevel?: Maybe<InstructorInsightPracticeTestQuestionQualityLevel>;
  /** The percentage of learners who clicked on skip question button for this question. */
  skippedRatio: Scalars['Float']['output'];
};

/** Type of the quality level of a Practice Test Question. */
export enum InstructorInsightPracticeTestQuestionQualityLevel {
  /** The question is bad quality */
  Bad = 'BAD',
  /** The question is good quality */
  Good = 'GOOD',
  /** The question is medium quality */
  Medium = 'MEDIUM',
  /** There is not enough data to determine the quality of the question */
  NotEnoughData = 'NOT_ENOUGH_DATA'
}

/** Status of a question of a Practice Test at a date */
export enum InstructorInsightPracticeTestQuestionStatus {
  /** ACTIVE means the question was/is active */
  Active = 'ACTIVE',
  /** DELETED means the question was/is deleted */
  Deleted = 'DELETED'
}

/** Type of a question at the Practice Test. It can be multiple choice, multiple selection or fill in the blanks. */
export enum InstructorInsightPracticeTestQuestionType {
  /** Fill in the blanks question */
  FillInTheBlanks = 'FILL_IN_THE_BLANKS',
  /** Multiple choice question */
  MultipleChoice = 'MULTIPLE_CHOICE',
  /** Multiple selection question */
  MultipleSelection = 'MULTIPLE_SELECTION'
}

/** Practice test version data */
export type InstructorInsightPracticeTestVersion = {
  __typename?: 'InstructorInsightPracticeTestVersion';
  /** Change log for the version */
  changeLog: Scalars['String']['output'];
  /** Start date of the interval for requested metrics. should be now for last week/month/year */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Start date of the interval for requested metrics */
  startDate: Scalars['DateTime']['output'];
  /** Version number */
  version: Scalars['Int']['output'];
};

/** Instructor's payout */
export type InstructorPayout = {
  __typename?: 'InstructorPayout';
  /** Payout amount */
  amount: Scalars['NonNegativeFloat']['output'];
  /** Payout created date */
  created: Scalars['DateTime']['output'];
  /** Payout currency */
  currency: CurrencyCode;
  /** All earning periods of the payout */
  earningPeriods: Array<Scalars['InstructorPayoutEarningsPeriod']['output']>;
  /** Payout id */
  id: Scalars['ID']['output'];
  /** Instructor of payout */
  instructor: CourseInstructor;
  /** Display name of the payment method */
  paymentMethodDisplayName?: Maybe<Scalars['String']['output']>;
  /** Payout date */
  payoutDate: Scalars['DateTime']['output'];
  /** Payout method type */
  payoutMethodType?: Maybe<PaymentMethodType>;
  /** Payout status */
  status: PayoutStatusType;
  /** Payout tax amount */
  taxAmount: Scalars['NonNegativeFloat']['output'];
};

/** Instructor's payouts paged */
export type InstructorPayoutsPaged = Paginated & {
  __typename?: 'InstructorPayoutsPaged';
  /** If instructor has payouts older than limit year */
  hasOlderPayouts: Scalars['Boolean']['output'];
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** Number of pages of instructor's payouts */
  pageCount: Scalars['Int']['output'];
  /** List of instructor's payouts */
  payouts?: Maybe<Array<InstructorPayout>>;
};

/** Instructor Preview Curriculum */
export type InstructorPreviewCurriculum = {
  __typename?: 'InstructorPreviewCurriculum';
  /** Count of the instructor preview curriculum content by type */
  contentCounts?: Maybe<CourseCurriculumContentCounts>;
  /** Section containing the instructor preview curriculum content */
  sections: Array<CourseSection>;
};

/** A wrapper type to include the recommended Instructor and some additional fields about its recommendation */
export type InstructorRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'InstructorRecommendation';
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /** Underlying object of the recommendation to get more information about it */
  instructor?: Maybe<CourseInstructor>;
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** Assessable outcome with a normalized score */
export type InteractionWidgetAssessableOutcome = {
  __typename?: 'InteractionWidgetAssessableOutcome';
  /** Whether the interaction is complete */
  isComplete: Scalars['Boolean']['output'];
  /** Whether the response is empty */
  isEmpty: Scalars['Boolean']['output'];
  /** Optional weighted max points */
  maxPoints?: Maybe<Scalars['Float']['output']>;
  /** Normalized score (0-1) */
  score: Scalars['Float']['output'];
};

/** An uploaded asset */
export type InteractionWidgetAsset = {
  __typename?: 'InteractionWidgetAsset';
  /** When this asset was uploaded */
  createdAt: Scalars['DateTime']['output'];
  /** Original filename */
  filename: Scalars['String']['output'];
  /** Content hash of the file */
  hash: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Whether this asset has been soft-deleted */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** MIME type of the asset */
  mimeType: InteractionWidgetAssetMimeType;
  /** File size in bytes */
  size: Scalars['Int']['output'];
  /** When this asset was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Temporary URL for accessing the asset */
  url: Scalars['URL']['output'];
};

/** Supported asset MIME types */
export enum InteractionWidgetAssetMimeType {
  /** Binary data */
  Bin = 'BIN',
  /** Cascading Style Sheets */
  Css = 'CSS',
  /** GIF image */
  Gif = 'GIF',
  /** JPEG image */
  Jpeg = 'JPEG',
  /** JavaScript */
  Js = 'JS',
  /** JSON data */
  Json = 'JSON',
  /** JavaScript XML */
  Jsx = 'JSX',
  /** PNG image */
  Png = 'PNG',
  /** SVG image */
  Svg = 'SVG',
  /** TypeScript */
  Ts = 'TS',
  /** TypeScript XML */
  Tsx = 'TSX',
  /** WEBP image */
  Webp = 'WEBP'
}

/** Input for ending an asset upload */
export type InteractionWidgetAssetUploadEndInput = {
  /** Original filename */
  filename: Scalars['String']['input'];
  /** Content hash of the file */
  hash: Scalars['String']['input'];
};

/** Input for starting an asset upload */
export type InteractionWidgetAssetUploadStartInput = {
  /** Original filename */
  filename: Scalars['String']['input'];
  /** Content hash of the file */
  hash: Scalars['String']['input'];
};

/** Response from starting an asset upload */
export type InteractionWidgetAssetUploadStartResponse = {
  __typename?: 'InteractionWidgetAssetUploadStartResponse';
  /** Presigned URL to upload (PUT request) the file to */
  uploadUrl: Scalars['URL']['output'];
};

/** Context for computing an interaction view */
export type InteractionWidgetContext = {
  /** The view mode for the interaction */
  mode: InteractionWidgetMode;
  /** The role of the user in the interaction */
  role: InteractionWidgetRole;
};

/** A configured instance of an interaction, validated against its release's schema */
export type InteractionWidgetDefinition = {
  __typename?: 'InteractionWidgetDefinition';
  /** When this definition was created */
  createdAt: Scalars['DateTime']['output'];
  /** The interaction configuration data (shape defined by release's definitionSchema) */
  definition: Scalars['JSON']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Whether this definition has been soft-deleted */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this definition is published */
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** Parent release */
  release: InteractionWidgetRelease;
  /**
   * Product scope.
   * Colon-delimited segments format (e.g. "course-creator:course-123").
   */
  scope?: Maybe<Scalars['String']['output']>;
  /** Parent interaction type */
  type: InteractionWidgetType;
  /** When this definition was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for creating a new interaction definition */
export type InteractionWidgetDefinitionCreateInput = {
  /** The definition configuration data */
  definition: Scalars['JSON']['input'];
  /** Human-readable name */
  name: Scalars['String']['input'];
  /**
   * Product scope.
   * Colon-delimited segments format (e.g. "course-creator:course-123").
   */
  scope?: InputMaybe<Scalars['String']['input']>;
};

/** Partial update input for an interaction definition — only provided fields are applied */
export type InteractionWidgetDefinitionUpdateInput = {
  /** Updated definition configuration data */
  definition?: InputMaybe<Scalars['JSON']['input']>;
  /** Whether this definition is published */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated display name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated list of interaction definitions */
export type InteractionWidgetDefinitionsPaged = CursorPaginatedResponse & {
  __typename?: 'InteractionWidgetDefinitionsPaged';
  /** Cursor for the next page of results */
  cursor?: Maybe<Scalars['String']['output']>;
  /** List of interaction definitions */
  items?: Maybe<Array<Maybe<InteractionWidgetDefinition>>>;
};

/** Reference to data by inline value or by existing entity ID (exactly one must be provided) */
export type InteractionWidgetEntityRef = {
  /** Existing entity ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Inline JSON value */
  inline?: InputMaybe<Scalars['JSON']['input']>;
};

/** View mode for an interaction */
export enum InteractionWidgetMode {
  /** Evaluating submitted responses */
  Evaluate = 'EVALUATE',
  /** Collecting user responses */
  Gather = 'GATHER',
  /** Reviewing completed responses */
  Review = 'REVIEW'
}

/** Non-assessable outcome with optional arbitrary data */
export type InteractionWidgetNonAssessableOutcome = {
  __typename?: 'InteractionWidgetNonAssessableOutcome';
  /** Optional arbitrary data */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Whether the interaction is complete */
  isComplete: Scalars['Boolean']['output'];
  /** Whether the response is empty */
  isEmpty: Scalars['Boolean']['output'];
};

/** Discriminated outcome — either assessable (scored) or non-assessable */
export type InteractionWidgetOutcome = InteractionWidgetAssessableOutcome | InteractionWidgetNonAssessableOutcome;

/** A versioned snapshot of an interaction type, containing assets and schemas */
export type InteractionWidgetRelease = {
  __typename?: 'InteractionWidgetRelease';
  /** Assets */
  assets: InteractionWidgetReleaseAssets;
  /** When this release was created */
  createdAt: Scalars['DateTime']['output'];
  /** JSON Schema for validating definitions against this release */
  definitionSchema?: Maybe<Scalars['JSON']['output']>;
  /** Paginated list of definitions under this release */
  definitions: InteractionWidgetDefinitionsPaged;
  /** Description of this release */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Whether the controller asset is included in public responses */
  isControllerPublic?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this release has been soft-deleted */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this release is published (immutable once true) */
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  /** The release this was forked from, if any */
  parent?: Maybe<InteractionWidgetRelease>;
  /** JSON Schema for validating sessions against this release */
  sessionSchema?: Maybe<Scalars['JSON']['output']>;
  /** Paginated list of sessions under this release */
  sessions: InteractionWidgetSessionsPaged;
  /** Parent interaction type */
  type: InteractionWidgetType;
  /** When this release was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Semver version string (e.g., '1.2.0') */
  version: Scalars['String']['output'];
};


/** A versioned snapshot of an interaction type, containing assets and schemas */
export type InteractionWidgetReleaseDefinitionsArgs = {
  pageInfo?: InputMaybe<CursorPaginatedInput>;
  scope?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InteractionWidgetSource>;
};


/** A versioned snapshot of an interaction type, containing assets and schemas */
export type InteractionWidgetReleaseSessionsArgs = {
  pageInfo?: InputMaybe<CursorPaginatedInput>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

/** Assets for an interaction release */
export type InteractionWidgetReleaseAssets = {
  __typename?: 'InteractionWidgetReleaseAssets';
  /** Controller compiled code asset */
  controllerCompiledCode: InteractionWidgetAsset;
  /** Controller source code asset */
  controllerSourceCode: InteractionWidgetAsset;
  /** Other assets */
  other: Array<Maybe<InteractionWidgetAsset>>;
  /** Styles compiled code asset */
  stylesCompiledCode?: Maybe<InteractionWidgetAsset>;
  /** Styles source code asset */
  stylesSourceCode?: Maybe<InteractionWidgetAsset>;
  /** UI compiled code asset */
  uiCompiledCode: InteractionWidgetAsset;
  /** UI source code asset */
  uiSourceCode: InteractionWidgetAsset;
};

/** Asset references for a release */
export type InteractionWidgetReleaseAssetsInput = {
  /** Controller compiled bundle asset ID */
  controllerCompiledCodeId: Scalars['ID']['input'];
  /** Controller source code asset ID */
  controllerSourceCodeId: Scalars['ID']['input'];
  /** Additional asset IDs */
  otherIds: Array<Scalars['ID']['input']>;
  /** Styles compiled bundle asset ID */
  stylesCompiledCodeId?: InputMaybe<Scalars['ID']['input']>;
  /** Styles source code asset ID */
  stylesSourceCodeId?: InputMaybe<Scalars['ID']['input']>;
  /** UI compiled bundle asset ID */
  uiCompiledCodeId: Scalars['ID']['input'];
  /** UI source code asset ID */
  uiSourceCodeId: Scalars['ID']['input'];
};

/** Published release bundle */
export type InteractionWidgetReleaseBundle = {
  __typename?: 'InteractionWidgetReleaseBundle';
  /** Assets */
  assets: InteractionWidgetReleaseBundleAssets;
  /** Release ID */
  id: Scalars['ID']['output'];
};

/** Assets for a published release bundle */
export type InteractionWidgetReleaseBundleAssets = {
  __typename?: 'InteractionWidgetReleaseBundleAssets';
  /** Controller compiled code asset */
  controllerCompiledCode?: Maybe<InteractionWidgetAsset>;
  /** Other assets */
  other: Array<Maybe<InteractionWidgetAsset>>;
  /** Styles compiled code asset */
  stylesCompiledCode?: Maybe<InteractionWidgetAsset>;
  /** UI compiled code asset */
  uiCompiledCode: InteractionWidgetAsset;
};

/** Result of computing the release model */
export type InteractionWidgetReleaseComputeModelResponse = {
  __typename?: 'InteractionWidgetReleaseComputeModelResponse';
  /** The computed outcome */
  outcome: InteractionWidgetOutcome;
  /** The computed view model */
  viewModel: Scalars['JSON']['output'];
};

/** Input for creating a new interaction release */
export type InteractionWidgetReleaseCreateInput = {
  /** Assets */
  assets: InteractionWidgetReleaseAssetsInput;
  /** JSON Schema for validating definitions */
  definitionSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Description of this release */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the controller asset is included in public responses */
  isControllerPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON Schema for validating sessions */
  sessionSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Semver version string */
  version: Scalars['String']['input'];
};

/** Partial update input for an interaction release — only provided fields are applied */
export type InteractionWidgetReleaseUpdateInput = {
  /** Assets */
  assets?: InputMaybe<InteractionWidgetReleaseAssetsInput>;
  /** JSON Schema for validating definitions */
  definitionSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Description of this release */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the controller asset is included in public responses */
  isControllerPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set to true to publish (irreversible) */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON Schema for validating sessions */
  sessionSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Updated semver version string */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated list of interaction releases */
export type InteractionWidgetReleasesPaged = CursorPaginatedResponse & {
  __typename?: 'InteractionWidgetReleasesPaged';
  /** Cursor for the next page of results */
  cursor?: Maybe<Scalars['String']['output']>;
  /** List of interaction releases */
  items?: Maybe<Array<Maybe<InteractionWidgetRelease>>>;
};

/** Role of a user within an interaction */
export enum InteractionWidgetRole {
  /** The author who created the interaction */
  Author = 'AUTHOR',
  /** The user responding to the interaction */
  Respondent = 'RESPONDENT',
  /** A reviewer examining responses */
  Reviewer = 'REVIEWER'
}

/** A user's response session for an interaction */
export type InteractionWidgetSession = {
  __typename?: 'InteractionWidgetSession';
  /** When this session was created */
  createdAt: Scalars['DateTime']['output'];
  /** Parent definition, if associated */
  definition?: Maybe<InteractionWidgetDefinition>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Parent release */
  release: InteractionWidgetRelease;
  /**
   * Product scope.
   * Colon-delimited segments format (e.g. "course-creator:course-123").
   */
  scope?: Maybe<Scalars['String']['output']>;
  /** The user's response data (shape defined by release's sessionSchema) */
  session: Scalars['JSON']['output'];
  /** Parent interaction type */
  type: InteractionWidgetType;
  /** When this session was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for creating a new interaction session */
export type InteractionWidgetSessionCreateInput = {
  /** Parent definition ID, if associated */
  definitionId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Product scope.
   * Colon-delimited segments format (e.g. "course-creator:course-123").
   */
  scope?: InputMaybe<Scalars['String']['input']>;
  /** The session response data */
  session: Scalars['JSON']['input'];
};

/** Partial update input for an interaction session — only provided fields are applied */
export type InteractionWidgetSessionUpdateInput = {
  /** The updated session data */
  session?: InputMaybe<Scalars['JSON']['input']>;
};

/** Paginated list of interaction sessions */
export type InteractionWidgetSessionsPaged = CursorPaginatedResponse & {
  __typename?: 'InteractionWidgetSessionsPaged';
  /** Cursor for the next page of results */
  cursor?: Maybe<Scalars['String']['output']>;
  /** List of interaction sessions */
  items?: Maybe<Array<Maybe<InteractionWidgetSession>>>;
};

/** Source filter for listing interaction entities */
export enum InteractionWidgetSource {
  /** Items owned by the requesting user */
  Owned = 'OWNED',
  /** Items shared with all instructors */
  Shared = 'SHARED'
}

/** An interaction type — a pluggable educational component (e.g., multiple-choice, fill-in-the-blank) */
export type InteractionWidgetType = {
  __typename?: 'InteractionWidgetType';
  /** When this type was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of this interaction type */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Whether this type has been soft-deleted */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this type is shared with all instructors */
  isShared?: Maybe<Scalars['Boolean']['output']>;
  /** The latest published release, if available */
  latestPublishedRelease?: Maybe<InteractionWidgetRelease>;
  /** Human-readable display name */
  name: Scalars['String']['output'];
  /** The type this was forked from, if any */
  parent?: Maybe<InteractionWidgetType>;
  /** Paginated list of releases under this type */
  releases: InteractionWidgetReleasesPaged;
  /** URL-safe slug (e.g., 'multiple-choice') */
  slug: Scalars['String']['output'];
  /** Thumbnail asset */
  thumbnail?: Maybe<InteractionWidgetAsset>;
  /** When this type was last updated */
  updatedAt: Scalars['DateTime']['output'];
};


/** An interaction type — a pluggable educational component (e.g., multiple-choice, fill-in-the-blank) */
export type InteractionWidgetTypeReleasesArgs = {
  pageInfo?: InputMaybe<CursorPaginatedInput>;
};

/** Input for creating a new interaction type */
export type InteractionWidgetTypeCreateInput = {
  /** Description of this interaction type */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable display name */
  name: Scalars['String']['input'];
  /** URL-safe slug (e.g., 'multiple-choice') */
  slug: Scalars['String']['input'];
  /** Thumbnail asset ID */
  thumbnailAssetId?: InputMaybe<Scalars['ID']['input']>;
};

/** Paginated list of interaction types */
export type InteractionWidgetTypePaged = CursorPaginatedResponse & {
  __typename?: 'InteractionWidgetTypePaged';
  /** Cursor for the next page of results */
  cursor?: Maybe<Scalars['String']['output']>;
  /** List of interaction types */
  items?: Maybe<Array<Maybe<InteractionWidgetType>>>;
};

/** Partial update input for an interaction type — only provided fields are applied */
export type InteractionWidgetTypeUpdateInput = {
  /** Updated description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether to share this type with all instructors */
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Thumbnail asset ID */
  thumbnailAssetId?: InputMaybe<Scalars['ID']['input']>;
};

/** The Lab object. */
export type Lab = LearningPathItem & LearningProduct & {
  __typename?: 'Lab';
  /** The current user's active lab instances associated with this lab */
  activeInstances: Array<LabInstance>;
  /** Bulleted list of things a person will accomplish in this Lab. */
  activities: Array<Scalars['String']['output']>;
  /** Top level description of the Lab. */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** Average duration of lab in seconds */
  durationInSeconds?: Maybe<Scalars['DurationInSeconds']['output']>;
  /** ID of the Lab. */
  id: Scalars['ID']['output'];
  /** The Lab's Instructors */
  instructors: Array<LabInstructor>;
  /** Bulleted list of things a person will learn in this Lab. */
  learningOutcomes: Array<Scalars['String']['output']>;
  /** Upper bound of estimated time (in seconds) to complete Lab. */
  maxEstimatedTime: Scalars['DurationInSeconds']['output'];
  /** Metadata associated with the lab */
  metadata?: Maybe<LabMetaData>;
  /** Lower bound of estimated time (in seconds) to complete Lab. */
  minEstimatedTime: Scalars['DurationInSeconds']['output'];
  /** Bulleted list of things a person should already know in order to do this Lab. */
  prerequisites: Array<Scalars['String']['output']>;
  /** Subscription information for this lab */
  subscriptionInfo?: Maybe<LearningProductSubscriptionInfo>;
  /** Active system messages for a lab */
  systemMessages?: Maybe<Array<LabSystemMessage>>;
  /** Tasks associated with this lab */
  tasks: Array<LabTask>;
  /** Title of the Lab. */
  title: Scalars['String']['output'];
  /** The Lab's topics */
  topics?: Maybe<Array<Topic>>;
  /** The Lab's landing URL */
  urlLanding: Scalars['URL']['output'];
  /** Quotas calculated for the user based on previous labs consumption */
  userQuotas?: Maybe<Array<LabQuota>>;
};

/** Represents lab context for chat */
export type LabContextInput = {
  /** ID of the lab */
  labId: Scalars['ID']['input'];
  /** ID of the task */
  taskId: Scalars['ID']['input'];
};

/** An instance of a lab's workspace for the user to interact with */
export type LabInstance = {
  /** Expiration time of the lab instance */
  expirationTime?: Maybe<Scalars['DateTime']['output']>;
  /** The current status of the lab instance */
  status: LabInstanceStatus;
  /** UUID of the lab instance */
  uuid: Scalars['ID']['output'];
  /**
   * Token for establishing a secure connection to the lab instance's workspace, if available
   * @deprecated Use workspaceToken from a concrete lab instance type instead
   */
  workspaceToken?: Maybe<Scalars['String']['output']>;
  /**
   * URL of the lab instance's workspace, if available
   * @deprecated Use workspaceHost from a concrete lab instance type instead
   */
  workspaceUrl?: Maybe<Scalars['URL']['output']>;
};

/** The operational state of a lab instance */
export enum LabInstanceStatus {
  /** Same as killed; action started by an admin(via Tapen, cli script) */
  AdminKilled = 'ADMIN_KILLED',
  /** Same as killing; action started by an admin (via Tapen, cli script) */
  AdminKilling = 'ADMIN_KILLING',
  /** Similar to killed; used as a signal to a stopped Vocareum lab due to lack of resources */
  Deactivated = 'DEACTIVATED',
  /** LabInstance is not working; might be recoverable */
  Error = 'ERROR',
  /** LabInstance is being isolated to support the isolation mode */
  Isolating = 'ISOLATING',
  /** For some reason, e.g. abuse of resources, the instance was killed */
  Killed = 'KILLED',
  /** Someone requested the LabInstance be killed; the instance cannot be started again */
  Killing = 'KILLING',
  /** Default state; the LabInstance was created but no call to provision it has been issued yet */
  Pending = 'PENDING',
  /** A request to provision the LabInstance was queued with the provider */
  Queued = 'QUEUED',
  /** LabInstance is up and running; user can interact with it */
  Running = 'RUNNING',
  /** Provider has acknowledged the provisioning request and it's working on it */
  Starting = 'STARTING',
  /** LabInstance is not reachable/interactable, but it can be started again */
  Stopped = 'STOPPED',
  /** Someone requested the LabInstance be stopped */
  Stopping = 'STOPPING'
}

/** Instructor for a lab */
export type LabInstructor = Instructor & {
  __typename?: 'LabInstructor';
  /** ID of the Instructor */
  id: Scalars['ID']['output'];
  /** Instructor's image by varying pixels */
  images: InstructorImages;
  /** Is the instructor opted out, i.e. not willing to participate on Gen AI features */
  isOptedOutToGenAI?: Maybe<Scalars['Boolean']['output']>;
  /** Instructor's name */
  name: Scalars['String']['output'];
  /** The URL to access the instructor page */
  url?: Maybe<Scalars['URL']['output']>;
};

/** MetaData for a lab */
export type LabMetaData = {
  __typename?: 'LabMetaData';
  /** Unique analytics ID for this instance of Lab returned from the server in this request. */
  trackingId?: Maybe<Scalars['String']['output']>;
};

/** Limits established for learners to constrain lab consumption */
export type LabQuota = {
  __typename?: 'LabQuota';
  /** End timestamp calculated based on first activity of rolling window */
  endTimestamp: Scalars['Timestamp']['output'];
  /** Indicates if the quota limit has been reached to disable lab launches */
  isLimitReached: Scalars['Boolean']['output'];
  /** Timespan type of the user quota, e.g. weekly */
  timespanType: LabQuotaTimespanType;
  /** Quota type, e.g. seconds spent on lab instances */
  type: LabQuotaType;
  /** Quota usage computed for the user */
  usage: LabQuotaNumberUsage;
};

/** Quota usage is determined by discrete integer values */
export type LabQuotaNumberUsage = {
  __typename?: 'LabQuotaNumberUsage';
  /** Current usage from the quota */
  current: Scalars['NonNegativeInt']['output'];
  /** Max usage allowed from the quota */
  max: Scalars['NonNegativeInt']['output'];
};

/** Rolling window of time to include user interactions with labs */
export enum LabQuotaTimespanType {
  /** Quota is determined by weekly interactions */
  Week = 'WEEK'
}

/** Entity used for calculating user quotas */
export enum LabQuotaType {
  /** Quota has a maximum amount of seconds for lab consumption */
  SecondsConsumed = 'SECONDS_CONSUMED'
}

/** Specifies how a quota usage is represented */
export type LabQuotaUsage = LabQuotaNumberUsage;

/** A wrapper type to include the recommended Lab and some additional fields about its recommendation */
export type LabRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'LabRecommendation';
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /** Underlying object of the recommendation to get more information about it */
  lab?: Maybe<Lab>;
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** List of Labs and additional data about search response */
export type LabSearchResponse = {
  __typename?: 'LabSearchResponse';
  /** Total number of Labs matching the search query and filters. */
  count: Scalars['Int']['output'];
  /** Identifies available search filter facets. */
  filterOptions: Array<SearchAggregation>;
  /** List of Lab objects. */
  labs: Array<Lab>;
  /** Search analytics tracking id; for uniquely identifying this query and result set; for this request */
  trackingId: Scalars['String']['output'];
};

/** Messages administered internally at Udemy to be displayed for users inside labs */
export type LabSystemMessage = {
  __typename?: 'LabSystemMessage';
  /** Alert level for the message */
  alertLevel: LabSystemMessageAlertLevel;
  /** Description of the message */
  description: Scalars['String']['output'];
  /** ID of the message */
  id: Scalars['ID']['output'];
  /** Indicates if launches are temporarily disabled for the lab */
  isLaunchDisabled: Scalars['Boolean']['output'];
  /** Permanent messages should always be shown to learners, regardless if they've seen it already */
  isPermanent: Scalars['Boolean']['output'];
  /** Audience segment this message targets. Null means the message is shown to all users. */
  targetAudience?: Maybe<LabSystemMessageTargetAudience>;
  /** Title of the message */
  title: Scalars['String']['output'];
  /** Optional link associated with the message */
  url?: Maybe<Scalars['URL']['output']>;
};

/** The message alert level */
export enum LabSystemMessageAlertLevel {
  /** Represents an error message for the lab, e.g. an ongoing maintenance for the lab */
  Error = 'ERROR',
  /** Represents an informational message, e.g. an upcoming maintenance for the lab */
  Information = 'INFORMATION',
  /** Represents a success message, e.g. a new feature was added for the lab */
  Success = 'SUCCESS',
  /** Represents a warning message, e.g. there could be slowness launching the lab */
  Warning = 'WARNING'
}

/** Audience segment a system message targets */
export enum LabSystemMessageTargetAudience {
  /** Instructor of a lab */
  Instructor = 'INSTRUCTOR',
  /** Paid consumer subscription user */
  PaidSubscription = 'PAID_SUBSCRIPTION',
  /** Trial consumer subscription user */
  TrialSubscription = 'TRIAL_SUBSCRIPTION',
  /** Udemy Business user */
  UdemyBusiness = 'UDEMY_BUSINESS'
}

/** A task to be completed by users within the lab's workspace */
export type LabTask = {
  __typename?: 'LabTask';
  /** Timestamp of the task completion */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Task description; supports HTML */
  descriptionHtml: Scalars['SafeHtml']['output'];
  /** Whether the task supports automated review */
  hasAutomatedReviewTests?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the lab task */
  id: Scalars['ID']['output'];
  /** Resources associated with the lab task */
  resources: Array<LabTaskResource>;
  /** Status of the lab task */
  status: LabTaskStatus;
  /** Title of the lab task */
  title: Scalars['String']['output'];
  /** The offset in seconds within a lecture video that this lab task corresponds to, if associated to a lecture */
  videoTimestamp?: Maybe<Scalars['OffsetInSeconds']['output']>;
};

/** A required or optional resource for completing a lab task */
export type LabTaskResource = {
  __typename?: 'LabTaskResource';
  /** Associated asset for the lab task resource */
  asset?: Maybe<Asset>;
  /**
   * ID of the asset
   * @deprecated Use asset instead
   */
  assetId: Scalars['ID']['output'];
  /**
   * URL of the asset
   * @deprecated Use asset instead
   */
  assetUrl: Scalars['URL']['output'];
  /** ID of the resource */
  id: Scalars['ID']['output'];
  /** Title of the resource */
  title: Scalars['String']['output'];
  /** Type of the resource */
  type: LabTaskResourceType;
};

/** The type of a lab task resource */
export enum LabTaskResourceType {
  /** An asset resource, e.g. a file or an image */
  Asset = 'ASSET',
  /** A miscellaneous documentation resource, e.g. a markdown file */
  Documentation = 'DOCUMENTATION',
  /** A resource documenting how to accomplish a lab task */
  HowTo = 'HOW_TO',
  /** A source code resource, e.g. a reference code archive file */
  SolutionSourceCode = 'SOLUTION_SOURCE_CODE',
  /** Default state; the resource type is not specified */
  Unspecified = 'UNSPECIFIED'
}

/** The publishing status of a lab task */
export enum LabTaskStatus {
  /** Default state; Task is still being edited by the instructor */
  Draft = 'DRAFT',
  /** Task is published and ready for learners to complete */
  Published = 'PUBLISHED'
}

/** The LanguageCode scalar type as defined by ISO 639-1. */
export enum LanguageCode {
  /** Afrikaans */
  Af = 'AF',
  /** Akan */
  Ak = 'AK',
  /** Amharic */
  Am = 'AM',
  /** Arabic */
  Ar = 'AR',
  /** Assamese */
  As = 'AS',
  /** Azerbaijani */
  Az = 'AZ',
  /** Belarusian */
  Be = 'BE',
  /** Bulgarian */
  Bg = 'BG',
  /** Bambara */
  Bm = 'BM',
  /** Bangla */
  Bn = 'BN',
  /** Tibetan */
  Bo = 'BO',
  /** Breton */
  Br = 'BR',
  /** Bosnian */
  Bs = 'BS',
  /** Catalan */
  Ca = 'CA',
  /** Chechen */
  Ce = 'CE',
  /** Czech */
  Cs = 'CS',
  /** Church Slavic */
  Cu = 'CU',
  /** Welsh */
  Cy = 'CY',
  /** Danish */
  Da = 'DA',
  /** German */
  De = 'DE',
  /** Dzongkha */
  Dz = 'DZ',
  /** Ewe */
  Ee = 'EE',
  /** Greek */
  El = 'EL',
  /** English */
  En = 'EN',
  /** Esperanto */
  Eo = 'EO',
  /** Spanish */
  Es = 'ES',
  /** Estonian */
  Et = 'ET',
  /** Basque */
  Eu = 'EU',
  /** Persian */
  Fa = 'FA',
  /** Fulah */
  Ff = 'FF',
  /** Finnish */
  Fi = 'FI',
  /** Faroese */
  Fo = 'FO',
  /** French */
  Fr = 'FR',
  /** Western Frisian */
  Fy = 'FY',
  /** Irish */
  Ga = 'GA',
  /** Scottish Gaelic */
  Gd = 'GD',
  /** Galician */
  Gl = 'GL',
  /** Gujarati */
  Gu = 'GU',
  /** Manx */
  Gv = 'GV',
  /** Hausa */
  Ha = 'HA',
  /** Hebrew */
  He = 'HE',
  /** Hindi */
  Hi = 'HI',
  /** Croatian */
  Hr = 'HR',
  /** Haitian, Haitian Creole */
  Ht = 'HT',
  /** Hungarian */
  Hu = 'HU',
  /** Armenian */
  Hy = 'HY',
  /** Interlingua */
  Ia = 'IA',
  /** Indonesian */
  Id = 'ID',
  /** Igbo */
  Ig = 'IG',
  /** Sichuan Yi */
  Ii = 'II',
  /** Icelandic */
  Is = 'IS',
  /** Italian */
  It = 'IT',
  /** Japanese */
  Ja = 'JA',
  /** Javanese */
  Jv = 'JV',
  /** Georgian */
  Ka = 'KA',
  /** Kikuyu */
  Ki = 'KI',
  /** Kazakh */
  Kk = 'KK',
  /** Kalaallisut */
  Kl = 'KL',
  /** Khmer */
  Km = 'KM',
  /** Kannada */
  Kn = 'KN',
  /** Korean */
  Ko = 'KO',
  /** Kashmiri */
  Ks = 'KS',
  /** Kurdish */
  Ku = 'KU',
  /** Cornish */
  Kw = 'KW',
  /** Kyrgyz */
  Ky = 'KY',
  /** Luxembourgish */
  Lb = 'LB',
  /** Ganda */
  Lg = 'LG',
  /** Lingala */
  Ln = 'LN',
  /** Lao */
  Lo = 'LO',
  /** Lithuanian */
  Lt = 'LT',
  /** Luba-Katanga */
  Lu = 'LU',
  /** Latvian */
  Lv = 'LV',
  /** Malagasy */
  Mg = 'MG',
  /** Māori */
  Mi = 'MI',
  /** Macedonian */
  Mk = 'MK',
  /** Malayalam */
  Ml = 'ML',
  /** Mongolian */
  Mn = 'MN',
  /** Marathi */
  Mr = 'MR',
  /** Malay */
  Ms = 'MS',
  /** Maltese */
  Mt = 'MT',
  /** Burmese */
  My = 'MY',
  /** Norwegian (Bokmål) */
  Nb = 'NB',
  /** North Ndebele */
  Nd = 'ND',
  /** Nepali */
  Ne = 'NE',
  /** Dutch */
  Nl = 'NL',
  /** Norwegian Nynorsk */
  Nn = 'NN',
  /** Norwegian */
  No = 'NO',
  /** Oromo */
  Om = 'OM',
  /** Odia */
  Or = 'OR',
  /** Ossetic */
  Os = 'OS',
  /** Punjabi */
  Pa = 'PA',
  /** Polish */
  Pl = 'PL',
  /** Pashto */
  Ps = 'PS',
  /** Portuguese */
  Pt = 'PT',
  /** Portuguese (Brazil) */
  PtBr = 'PT_BR',
  /** Portuguese (Portugal) */
  PtPt = 'PT_PT',
  /** Quechua */
  Qu = 'QU',
  /** Romansh */
  Rm = 'RM',
  /** Rundi */
  Rn = 'RN',
  /** Romanian */
  Ro = 'RO',
  /** Russian */
  Ru = 'RU',
  /** Kinyarwanda */
  Rw = 'RW',
  /** Sanskrit */
  Sa = 'SA',
  /** Sindhi */
  Sd = 'SD',
  /** Northern Sami */
  Se = 'SE',
  /** Sango */
  Sg = 'SG',
  /** Sinhala */
  Si = 'SI',
  /** Slovak */
  Sk = 'SK',
  /** Slovenian */
  Sl = 'SL',
  /** Shona */
  Sn = 'SN',
  /** Somali */
  So = 'SO',
  /** Albanian */
  Sq = 'SQ',
  /** Serbian */
  Sr = 'SR',
  /** Sundanese */
  Su = 'SU',
  /** Swedish */
  Sv = 'SV',
  /** Swahili */
  Sw = 'SW',
  /** Tamil */
  Ta = 'TA',
  /** Telugu */
  Te = 'TE',
  /** Tajik */
  Tg = 'TG',
  /** Thai */
  Th = 'TH',
  /** Tigrinya */
  Ti = 'TI',
  /** Turkmen */
  Tk = 'TK',
  /** Tagalog */
  Tl = 'TL',
  /** Tongan */
  To = 'TO',
  /** Turkish */
  Tr = 'TR',
  /** Tatar */
  Tt = 'TT',
  /** Uyghur */
  Ug = 'UG',
  /** Ukrainian */
  Uk = 'UK',
  /** Urdu */
  Ur = 'UR',
  /** Uzbek */
  Uz = 'UZ',
  /** Vietnamese */
  Vi = 'VI',
  /** Volapük */
  Vo = 'VO',
  /** Wolof */
  Wo = 'WO',
  /** Xhosa */
  Xh = 'XH',
  /** Yiddish */
  Yi = 'YI',
  /** Yoruba */
  Yo = 'YO',
  /** Chinese */
  Zh = 'ZH',
  /** Chinese (Simplified) */
  ZhCn = 'ZH_CN',
  /** Chinese (Traditional) */
  ZhTw = 'ZH_TW',
  /** Zulu */
  Zu = 'ZU'
}

/** Scope of the data for the insights. It can be for all courses or for ub courses only. If it is for ub courses only, the data will be filtered by the courses that are for the ub only. If it is for all courses, the data will not be filtered */
export enum LearnerChannel {
  /** All courses */
  All = 'ALL',
  /** For ub courses only */
  Ub = 'UB'
}

/**
 * Represents a learner's self-reported proficiency for a specific skill.
 * currentProficiency is a global user attribute, not scoped to any goal.
 */
export type LearnerSkillProficiency = {
  __typename?: 'LearnerSkillProficiency';
  /** The learner's current self-reported proficiency level for this skill */
  currentProficiency: ProficiencyLevel;
  /** The skills framework this proficiency is recorded for. */
  skillsFramework: SkillsFramework;
  /** UTC datetime when the proficiency was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Response wrapper for the learnerSkillProficiencyUpdate mutation. */
export type LearnerSkillProficiencyUpdateResponse = {
  __typename?: 'LearnerSkillProficiencyUpdateResponse';
  /** The updated learner skill proficiency, if the update succeeded. */
  learnerSkillProficiency?: Maybe<LearnerSkillProficiency>;
};

/** Represents the learning activity period like daily or monthly and the corresponding date in value. For monthly, day portion in the value will be 1st of the month. */
export type LearningActivityPeriod = {
  __typename?: 'LearningActivityPeriod';
  /** Day on which learning activity happened. */
  day?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Month on which learning activity happened. */
  month?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Type of the interval. */
  type?: Maybe<DateIntervalType>;
  /** Year on which learning activity happened. */
  year?: Maybe<Scalars['NonNegativeInt']['output']>;
};

/** Contains records of time spent in a learning activity */
export type LearningActivityRecord = {
  __typename?: 'LearningActivityRecord';
  /** Period of the learning activity. */
  period?: Maybe<LearningActivityPeriod>;
  /** Learning mintues spent between startDate and endDate. */
  timeSpentInMinutes: Scalars['NonNegativeFloat']['output'];
};

/** Filters used to fetch summary of learning activity. */
export type LearningActivitySummaryFilters = {
  /** End date till which the learning activity has to be measured. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Start date from which the learning activity has to be measured. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Represents the learning activity in trend view. */
export type LearningActivityTrend = {
  __typename?: 'LearningActivityTrend';
  /** List of learning activity over a period of time. */
  learningActivityRecords?: Maybe<Array<Maybe<LearningActivityRecord>>>;
};

/** Filters used to fetch learning activity. */
export type LearningActivityTrendFilters = {
  /** Filter used to pass start and end date between which learning activity has to be returned. */
  dateFilter?: InputMaybe<DateFilter>;
};

/** Base message item entity - add here any fields shared across all item types */
export type LearningAssistantBaseChatMessageItem = {
  /** Fallback or alternative text that represents this entity's content */
  fallbackText: Scalars['String']['output'];
};

/** Input for sending an audio chat message */
export type LearningAssistantChatAudioMessageInput = {
  /** The audion response configuration */
  audioResponseConfig?: InputMaybe<AudioResponseConfigInput>;
  /** Presigned url of file provided by user */
  inputAudioFileUrl: Scalars['URL']['input'];
  /** The content type of the input file */
  inputFileContentType?: InputMaybe<Scalars['String']['input']>;
  /** The response type of assistant */
  responseType?: InputMaybe<ResponseType>;
};

/** Represents code blocks that can be shared within a chat message */
export type LearningAssistantChatCodeBlock = LearningAssistantBaseChatMessageItem & {
  __typename?: 'LearningAssistantChatCodeBlock';
  /** The content of the code block */
  content: Scalars['String']['output'];
  /** Fallback or alternative text that represents this entity's content */
  fallbackText: Scalars['String']['output'];
  /** The unique identifier of the code block item within a chat message */
  id: Scalars['ID']['output'];
  /** The programming language of the code block */
  language: LearningAssistantChatCodeBlockLanguage;
};

/** The programming languages available in Learning Assistant code blocks */
export enum LearningAssistantChatCodeBlockLanguage {
  /** Assembly */
  Assembly = 'ASSEMBLY',
  /** Batch File */
  BatchFile = 'BATCH_FILE',
  /** C */
  C = 'C',
  /** Clojure */
  Clojure = 'CLOJURE',
  /** CMake */
  Cmake = 'CMAKE',
  /** COBOL */
  Cobol = 'COBOL',
  /** CoffeeScript */
  Coffeescript = 'COFFEESCRIPT',
  /** C++ */
  Cpp = 'CPP',
  /** C# */
  Csharp = 'CSHARP',
  /** CSS */
  Css = 'CSS',
  /** CSV */
  Csv = 'CSV',
  /** Dart */
  Dart = 'DART',
  /** Default */
  Default = 'DEFAULT',
  /** DM */
  Dm = 'DM',
  /** Dockerfile */
  Dockerfile = 'DOCKERFILE',
  /** Elixir */
  Elixir = 'ELIXIR',
  /** Erlang */
  Erlang = 'ERLANG',
  /** Fortran */
  Fortran = 'FORTRAN',
  /** Go */
  Go = 'GO',
  /** Groovy */
  Groovy = 'GROOVY',
  /** Haskell */
  Haskell = 'HASKELL',
  /** HTML */
  Html = 'HTML',
  /** INI */
  Ini = 'INI',
  /** Java */
  Java = 'JAVA',
  /** JavaScript */
  Javascript = 'JAVASCRIPT',
  /** JSON */
  Json = 'JSON',
  /** Julia */
  Julia = 'JULIA',
  /** Kotlin */
  Kotlin = 'KOTLIN',
  /** Lisp */
  Lisp = 'LISP',
  /** Lua */
  Lua = 'LUA',
  /** Makefile */
  Makefile = 'MAKEFILE',
  /** Markdown */
  Markdown = 'MARKDOWN',
  /** MATLAB */
  Matlab = 'MATLAB',
  /** Objective-C */
  ObjectiveC = 'OBJECTIVE_C',
  /** OCaml */
  Ocaml = 'OCAML',
  /** Pascal */
  Pascal = 'PASCAL',
  /** Perl */
  Perl = 'PERL',
  /** PHP */
  Php = 'PHP',
  /** PowerShell */
  Powershell = 'POWERSHELL',
  /** Prolog */
  Prolog = 'PROLOG',
  /** Python */
  Python = 'PYTHON',
  /** R */
  R = 'R',
  /** Ruby */
  Ruby = 'RUBY',
  /** Rust */
  Rust = 'RUST',
  /** Scala */
  Scala = 'SCALA',
  /** Shell */
  Shell = 'SHELL',
  /** SQL */
  Sql = 'SQL',
  /** Swift */
  Swift = 'SWIFT',
  /** TeX */
  Tex = 'TEX',
  /** TOML */
  Toml = 'TOML',
  /** TypeScript */
  Typescript = 'TYPESCRIPT',
  /** Verilog */
  Verilog = 'VERILOG',
  /** Visual Basic */
  VisualBasic = 'VISUAL_BASIC',
  /** XML */
  Xml = 'XML',
  /** YAML */
  Yaml = 'YAML'
}

/** Input for generic chat context */
export type LearningAssistantChatContextForGeneric = {
  /** Override for the chat name */
  chatNameOverride: Scalars['String']['input'];
};

/** Input for role play context */
export type LearningAssistantChatContextForRolePlay = {
  /** The course id */
  courseId: Scalars['ID']['input'];
  /** The role play id */
  rolePlayId: Scalars['ID']['input'];
};

/** Input for chat message history context */
export type LearningAssistantChatContextInput = {
  /** Course context */
  courseContext?: InputMaybe<LearningAssistantChatContextInputForCourse>;
  /** Generic chat context */
  genericContext?: InputMaybe<LearningAssistantChatContextForGeneric>;
  /** Role play context */
  rolePlayContext?: InputMaybe<LearningAssistantChatContextForRolePlay>;
};

/** Input for chat message context */
export type LearningAssistantChatContextInputForCourse = {
  /** The course id */
  courseId?: InputMaybe<Scalars['ID']['input']>;
  /** Context about files used in this chat, such as files uploaded or referenced in the conversation */
  fileContext?: InputMaybe<Array<LearningAssistantFileContextInput>>;
  /** The lab task context */
  labTaskContext?: InputMaybe<LabContextInput>;
  /** The lecture id */
  lectureId?: InputMaybe<Scalars['ID']['input']>;
  /** The practice test context */
  practiceTestContext?: InputMaybe<PracticeTestContextInput>;
  /** The quiz context */
  quizContext?: InputMaybe<QuizContextInput>;
  /** The section id */
  sectionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input to submit a chat feedback form */
export type LearningAssistantChatFeedbackFormSubmitInput = {
  /** Chat ID */
  chatId: Scalars['ID']['input'];
  /** Optional feedback ID from initial feedback submission */
  feedbackId?: InputMaybe<Scalars['ID']['input']>;
  /** Chat message ID */
  messageId: Scalars['ID']['input'];
  /** Feedback selections */
  selections: Array<ChatFeedbackFormSelection>;
  /** Target type of the feedback */
  targetType: ChatFeedbackTargetType;
  /** Optional text providing additional feedback details */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Input to submit a chat feedback */
export type LearningAssistantChatFeedbackSubmitInput = {
  /** Chat ID */
  chatId: Scalars['ID']['input'];
  /** Chat message ID */
  messageId: Scalars['ID']['input'];
  /** Selected chat feedback option */
  option: ChatFeedbackOption;
  /** Target type of the feedback */
  targetType: ChatFeedbackTargetType;
};

/** Submit chat feedback response */
export type LearningAssistantChatFeedbackSubmitResponse = {
  __typename?: 'LearningAssistantChatFeedbackSubmitResponse';
  /** The created chat feedback ID */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Base interface for file objects shared via the chat assistant */
export type LearningAssistantChatFileBase = {
  /** The MIME type of the file */
  mimeType: LearningAssistantFileMimeType;
  /** The ID of the file in the cloud storage system */
  storageFileId: Scalars['ID']['output'];
  /** The presigned URL for accessing the file For uploads, this URL supports PUT operations. For retrieval, it supports GET */
  url: Scalars['URL']['output'];
};

/** Represents a file message shared in the chat, retrievable from learning assistant cloud storage */
export type LearningAssistantChatFileItem = LearningAssistantChatFileBase & {
  __typename?: 'LearningAssistantChatFileItem';
  /** The MIME type of the file */
  mimeType: LearningAssistantFileMimeType;
  /** The ID of the file in the cloud storage system */
  storageFileId: Scalars['ID']['output'];
  /** The presigned URL to fetch this file (GET) */
  url: Scalars['URL']['output'];
};

/** Represents a list of files that can be shared within a chat message */
export type LearningAssistantChatFiles = LearningAssistantBaseChatMessageItem & {
  __typename?: 'LearningAssistantChatFiles';
  /** Fallback or alternative text that represents this entity's content */
  fallbackText: Scalars['String']['output'];
  /** List of files */
  files: Array<LearningAssistantChatFileItem>;
};

/** Response for initiating a chat session */
export type LearningAssistantChatInitiateResponse = LearningAssistantChatResponse & {
  __typename?: 'LearningAssistantChatInitiateResponse';
  /** Server returns an ID for the chat */
  chatId: Scalars['ID']['output'];
  /** Error message if the chat session is not initiated */
  error?: Maybe<LearningAssistantChatResponseError>;
  /** Server returns user quotas for interactions with the Assistant */
  userQuotas: LearningAssistantUserQuotas;
};

/** Represents Udemy instructors given by the assistant  */
export type LearningAssistantChatInstructors = LearningAssistantBaseChatMessageItem & {
  __typename?: 'LearningAssistantChatInstructors';
  /** Fallback or alternative text that represents this entity's content */
  fallbackText: Scalars['String']['output'];
  /** A list of Udemy instructors */
  instructors: Array<LearningAssistantSupportedInstructor>;
};

/** Input for feeding chat context */
export type LearningAssistantChatInteractionInput = {
  /** Distinguishes types of the interaction */
  interactionType: LearningAssistantChatInteractionType;
  /** Lab Task Presented interaction for input */
  labTaskPresented?: InputMaybe<LearningAssistantLabTaskPresentedInteraction>;
  /** Practice Test Answer Checked interaction for input */
  practiceTestAnswerChecked?: InputMaybe<LearningAssistantPracticeTestAnswerCheckedInteraction>;
  /** Practice Test Question Presented interaction for input */
  practiceTestQuestionPresented?: InputMaybe<LearningAssistantPracticeTestQuestionPresentedInteraction>;
  /** Quiz Answer Checked interaction for input */
  quizAnswerChecked?: InputMaybe<LearningAssistantQuizAnswerCheckedInteraction>;
  /** Quiz Question Presented interaction for input */
  quizQuestionPresented?: InputMaybe<LearningAssistantQuizQuestionPresentedInteraction>;
  /** Generic Text interaction for input */
  text?: InputMaybe<LearningAssistantTextInteraction>;
};

/** Response for the mutation to send chat interactions */
export type LearningAssistantChatInteractionResponse = {
  __typename?: 'LearningAssistantChatInteractionResponse';
  /** Boolean to indicate success for the mutation so clients can understand if interactions were properly processed by the BE */
  hasReceivedInteractions: Scalars['Boolean']['output'];
};

/** Interaction type for the client interaction with the Learning Assistant */
export enum LearningAssistantChatInteractionType {
  /** Generic Text interaction type */
  Generic = 'GENERIC',
  /** Lab Task Presented interaction type */
  LabTaskPresented = 'LAB_TASK_PRESENTED',
  /** Practice Test Answer Checked interaction type */
  PracticeTestAnswerChecked = 'PRACTICE_TEST_ANSWER_CHECKED',
  /** Practice Test Question Presented interaction type */
  PracticeTestQuestionPresented = 'PRACTICE_TEST_QUESTION_PRESENTED',
  /** Quiz Answer Checked interaction type */
  QuizAnswerChecked = 'QUIZ_ANSWER_CHECKED',
  /** Quiz Question Presented interaction type */
  QuizQuestionPresented = 'QUIZ_QUESTION_PRESENTED'
}

/** Represent learning products that can be shared within a chat message (deprecated) */
export type LearningAssistantChatLearningProduct = LearningAssistantBaseChatMessageItem & {
  __typename?: 'LearningAssistantChatLearningProduct';
  /** Fallback or alternative text that represents this entity's content */
  fallbackText: Scalars['String']['output'];
  /** List of learning products */
  learningProducts: Array<LearningAssistantLearningProduct>;
};

/** Represent learning products or curriculum items that can be shared within a chat message */
export type LearningAssistantChatLearningProductOrCurriculumItem = LearningAssistantBaseChatMessageItem & {
  __typename?: 'LearningAssistantChatLearningProductOrCurriculumItem';
  /** Fallback or alternative text that represents this entity's content */
  fallbackText: Scalars['String']['output'];
  /** List of learning products or curriculum items */
  learningProducts: Array<LearningAssistantLearningProductOrCurriculumItem>;
};

/** Represent a chat message */
export type LearningAssistantChatMessage = {
  __typename?: 'LearningAssistantChatMessage';
  /** ID of the chat that the message belongs to */
  chatId: Scalars['ID']['output'];
  /** Timestamp indicating when the message was created */
  created: Scalars['Timestamp']['output'];
  /** ID of the chat message */
  id: Scalars['ID']['output'];
  /** Items of the chat message */
  items: Array<LearningAssistantChatMessageItem>;
  /** Role of the chat message */
  role: LearningAssistantChatMessageRole;
};

/** Union of possible chat message items */
export type LearningAssistantChatMessageItem = LearningAssistantChatCodeBlock | LearningAssistantChatFiles | LearningAssistantChatInstructors | LearningAssistantChatLearningProduct | LearningAssistantChatLearningProductOrCurriculumItem | LearningAssistantChatTextMessage | LearningAssistantUnknownMessageItem;

/** Represents the roles of chat messages */
export enum LearningAssistantChatMessageRole {
  /** Represents messages generated by the learning assistant */
  Assistant = 'ASSISTANT',
  /** Represents messages sent by users */
  User = 'USER'
}

/** Response for sending a chat message */
export type LearningAssistantChatMessageSendResponse = LearningAssistantChatResponse & {
  __typename?: 'LearningAssistantChatMessageSendResponse';
  /** Error message if the chat message is not sent */
  error?: Maybe<LearningAssistantChatResponseError>;
  /** Chat message returned by the server */
  message: LearningAssistantChatMessage;
  /** Server returns user quotas for interactions with the Assistant */
  userQuotas: LearningAssistantUserQuotas;
};

/** Paginated chat messages */
export type LearningAssistantChatMessagesPaged = Paginated & {
  __typename?: 'LearningAssistantChatMessagesPaged';
  /** Chat messages */
  items: Array<Maybe<LearningAssistantChatMessage>>;
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages. Calculated as (total result count/page size) */
  pageCount: Scalars['Int']['output'];
};

/** Represents different types of chat sessions */
export enum LearningAssistantChatName {
  /** Discovery Chat */
  DiscoveryChat = 'DISCOVERY_CHAT',
  /** Generic Chat */
  GenericChat = 'GENERIC_CHAT',
  /** In Course Chat */
  InCourseChat = 'IN_COURSE_CHAT',
  /** Interactive Question Generation Chat */
  IqgChat = 'IQG_CHAT',
  /** Learner Profile Chat */
  LearnerProfileChat = 'LEARNER_PROFILE_CHAT',
  /** Role Play Chat */
  RolePlayChat = 'ROLE_PLAY_CHAT',
  /** Skills Chat */
  SkillsChat = 'SKILLS_CHAT'
}

/** Common fields returned by chat-related responses */
export type LearningAssistantChatResponse = {
  /** Error message if the chat session is not initiated */
  error?: Maybe<LearningAssistantChatResponseError>;
};

/** Common error structure for Learning Assistant chat responses */
export type LearningAssistantChatResponseError = {
  __typename?: 'LearningAssistantChatResponseError';
  /** Error code */
  code: LearningAssistantErrorCode;
  /** Error message */
  message: Scalars['String']['output'];
};

/** Response for terminating the chat session */
export type LearningAssistantChatTerminateResponse = {
  __typename?: 'LearningAssistantChatTerminateResponse';
  /** The ID of the chat that was terminated */
  chatId?: Maybe<Scalars['ID']['output']>;
};

/** Represent a text message that can be shared within a chat message */
export type LearningAssistantChatTextMessage = LearningAssistantBaseChatMessageItem & {
  __typename?: 'LearningAssistantChatTextMessage';
  /** Fallback or alternative text that represents this entity's content */
  fallbackText: Scalars['String']['output'];
  /** The text content */
  text: Scalars['String']['output'];
};

/** Input for sending a text chat message */
export type LearningAssistantChatTextMessageInput = {
  /** The text content */
  text: Scalars['String']['input'];
};

/** Input for requesting a new upload URL */
export type LearningAssistantCreatePresignedUrlInput = {
  /** The MIME type of the file to upload */
  mimeType: LearningAssistantFileMimeType;
};

/** Represent a curriculum item that extends an actual curriculum item */
export type LearningAssistantCurriculumItem = {
  __typename?: 'LearningAssistantCurriculumItem';
  /** The description of the curriculum item */
  learningAssistantGeneratedDescription?: Maybe<Scalars['String']['output']>;
  /** The curriculum item */
  learningProduct: CurriculumItem;
};

/** Error codes for Learning Assistant chat operations */
export enum LearningAssistantErrorCode {
  /** If chat context is not found */
  ErrorCodeChatContextNotFound = 'ERROR_CODE_CHAT_CONTEXT_NOT_FOUND',
  /** If chat id is not available */
  ErrorCodeChatIdRequired = 'ERROR_CODE_CHAT_ID_REQUIRED',
  /** If chat message is not available */
  ErrorCodeChatMessageRequired = 'ERROR_CODE_CHAT_MESSAGE_REQUIRED',
  /** If chat session is expired */
  ErrorCodeChatSessionExpired = 'ERROR_CODE_CHAT_SESSION_EXPIRED',
  /** If course id is not available */
  ErrorCodeCourseIdRequired = 'ERROR_CODE_COURSE_ID_REQUIRED',
  /** Empty audio file content */
  ErrorCodeEmptyAudioFileContent = 'ERROR_CODE_EMPTY_AUDIO_FILE_CONTENT',
  /** If file content type is not supported */
  ErrorCodeFileUnsupportedContentType = 'ERROR_CODE_FILE_UNSUPPORTED_CONTENT_TYPE',
  /** Unexpected caught error. */
  ErrorCodeInternalError = 'ERROR_CODE_INTERNAL_ERROR',
  /** If the course id is not valid */
  ErrorCodeInvalidCourseId = 'ERROR_CODE_INVALID_COURSE_ID',
  /** If user message length is more than the max. Right not max is 2500 char. */
  ErrorCodeMaxUserMessageLength = 'ERROR_CODE_MAX_USER_MESSAGE_LENGTH',
  /** Content Flagged */
  ErrorCodeModerationFlagged = 'ERROR_CODE_MODERATION_FLAGGED',
  /** If user does not have a permission to initialize chat. This is own by exp platform flag to avoid unwanted access */
  ErrorCodeNotAuthorized = 'ERROR_CODE_NOT_AUTHORIZED',
  /** If input contains PII (Not active right now) */
  ErrorCodePiiDetected = 'ERROR_CODE_PII_DETECTED',
  /** If chat message is failure to process */
  ErrorCodeProcessingIsFailed = 'ERROR_CODE_PROCESSING_IS_FAILED',
  /** If one of quota limit is exceeded */
  ErrorCodeQuotaLimitExceeded = 'ERROR_CODE_QUOTA_LIMIT_EXCEEDED',
  /** If code session limit is exceeded */
  ErrorCodeSessionMessageLimitExceeded = 'ERROR_CODE_SESSION_MESSAGE_LIMIT_EXCEEDED',
  /** If code session is not found */
  ErrorCodeSessionNotFound = 'ERROR_CODE_SESSION_NOT_FOUND',
  /** If since request parameter is not available */
  ErrorCodeSinceIsRequired = 'ERROR_CODE_SINCE_IS_REQUIRED',
  /** If user send a new message before former message is still processing. */
  ErrorCodeTooManyRequest = 'ERROR_CODE_TOO_MANY_REQUEST',
  /** Unspecified error */
  ErrorCodeUnspecified = 'ERROR_CODE_UNSPECIFIED',
  /** If input contains own user id */
  ErrorCodeUserIdDetectedInMessage = 'ERROR_CODE_USER_ID_DETECTED_IN_MESSAGE',
  /** If user id is not found */
  ErrorCodeUserIdNotFound = 'ERROR_CODE_USER_ID_NOT_FOUND'
}

/** Input representing a file context passed into the chat, including file metadata and its temporary access URL. */
export type LearningAssistantFileContextInput = {
  /** The MIME type of the file */
  mimeType: LearningAssistantFileMimeType;
  /** The ID of the file in the cloud storage system */
  storageFileId: Scalars['ID']['input'];
};

/** Supported file MIME types */
export enum LearningAssistantFileMimeType {
  /** GIF image */
  Gif = 'GIF',
  /** JPEG image */
  Jpeg = 'JPEG',
  /** PDF image */
  Pdf = 'PDF',
  /** PNG image */
  Png = 'PNG',
  /** WEBP image */
  Webp = 'WEBP'
}

/** Response containing a presigned URL for either uploading or downloading a file, depending on the context of the request. For upload: the URL is used with PUT. For download: the URL is used with GET */
export type LearningAssistantFileUploadUrl = LearningAssistantChatFileBase & {
  __typename?: 'LearningAssistantFileUploadUrl';
  /** The MIME type of the file */
  mimeType: LearningAssistantFileMimeType;
  /** The ID of the file in the cloud storage system */
  storageFileId: Scalars['ID']['output'];
  /** The presigned URL.For uploading a file, use this URL with PUT. For fetching a previously uploaded file, use it with GET */
  url: Scalars['URL']['output'];
};

/** List of presigned URLs */
export type LearningAssistantFileUploadUrlResponse = {
  __typename?: 'LearningAssistantFileUploadUrlResponse';
  /** List that contains presigned URLs for each file */
  files: Array<LearningAssistantFileUploadUrl>;
};

/** Send when user selects a lab task */
export type LearningAssistantLabTaskPresentedInteraction = {
  /** ID of the lab */
  labId: Scalars['ID']['input'];
  /** ID of the task */
  taskId: Scalars['ID']['input'];
};

/** Represent a learning assistant-specific learning product that extends an actual learning product */
export type LearningAssistantLearningProduct = {
  __typename?: 'LearningAssistantLearningProduct';
  /** The description of the learning product */
  learningAssistantGeneratedDescription?: Maybe<Scalars['String']['output']>;
  /** The learning product */
  learningProduct: LearningProduct;
};

/** Union of possible chat message item types that can be shared within a chat message item */
export type LearningAssistantLearningProductOrCurriculumItem = LearningAssistantCurriculumItem | LearningAssistantLearningProduct;

/** User checks (submits) a practice test answer */
export type LearningAssistantPracticeTestAnswerCheckedInteraction = {
  /** Answer text selected by user */
  answer: Scalars['String']['input'];
  /** Explanation for the selected answer */
  answerExplanation: Scalars['String']['input'];
  /** Defines if the user has selected the correct answer */
  isCorrectAnswer: Scalars['Boolean']['input'];
  /** ID of the practice test's question */
  practiceTestId: Scalars['String']['input'];
};

/** User sees a practice test question */
export type LearningAssistantPracticeTestQuestionPresentedInteraction = {
  /** Correct answer text from the practice test question */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Correct answer text array for the practice test question(for multiple answer question types) */
  answers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Nullable question choice explanations */
  choiceExplanations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Choice text contents for the practice test question */
  choices?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Overall Explanation for practice test question */
  overallExplanation?: InputMaybe<Scalars['String']['input']>;
  /** ID of the practice test's question */
  practiceTestId: Scalars['String']['input'];
  /** Question text that was presented */
  question: Scalars['String']['input'];
  /** question type enum for practice test question */
  questionType: QuestionType;
};

/** User checks (submits) a quiz answer (text fields are exactly as seen on the UI) */
export type LearningAssistantQuizAnswerCheckedInteraction = {
  /** Answer text selected by user */
  answer: Scalars['String']['input'];
  /** Explanation for the selected answer */
  answerExplanation: Scalars['String']['input'];
  /** Defines if the user has selected the correct answer */
  isCorrectAnswer: Scalars['Boolean']['input'];
  /** ID of the quiz's question */
  quizId: Scalars['String']['input'];
};

/** User sees a quiz question (text fields are exactly as seen on the UI) */
export type LearningAssistantQuizQuestionPresentedInteraction = {
  /** Correct answer text from the quiz question */
  answer: Scalars['String']['input'];
  /** Nullable question choices explanations */
  choiceExplanations: Array<InputMaybe<Scalars['String']['input']>>;
  /** Question choices texts for the quiz question */
  choices: Array<Scalars['String']['input']>;
  /** Question text that was presented */
  question: Scalars['String']['input'];
  /** ID of the quiz's question */
  quizId: Scalars['String']['input'];
};

/** Enhanced suggested prompt with categorization for future UI differentiation */
export type LearningAssistantSuggestedPrompt = {
  __typename?: 'LearningAssistantSuggestedPrompt';
  /** Prompt suggested category (enum) unspecified, content based, AIA capability. */
  category?: Maybe<LearningAssistantSuggestedPromptCategory>;
  /** ID of the suggested prompt */
  id: Scalars['ID']['output'];
  /** Prompt suggested subcategory (enum) unspecified, FAQ, Quiz, Lecture*, etc. */
  subcategory?: Maybe<LearningAssistantSuggestedPromptSubcategory>;
  /** Prompt string that serves as a template */
  template: Scalars['String']['output'];
};

/** Represents the category of a suggested prompt matches backend enum */
export enum LearningAssistantSuggestedPromptCategory {
  /** Prompt suggested category (enum) AIA capability */
  AiaCapability = 'AIA_CAPABILITY',
  /** Prompt suggested category (enum) content based */
  ContentBasedPrompts = 'CONTENT_BASED_PROMPTS',
  /** Prompt suggested category (enum) unspecified */
  Unspecified = 'UNSPECIFIED'
}

/** Represents all pages that support displaying suggested prompts */
export enum LearningAssistantSuggestedPromptPageSource {
  /** AI Assistant Page */
  AiAssistantPage = 'AI_ASSISTANT_PAGE',
  /** Course Landing Page */
  CourseLandingPage = 'COURSE_LANDING_PAGE',
  /** Course Taking Page */
  CourseTakingPage = 'COURSE_TAKING_PAGE',
  /** Logged In Home Page */
  LoggedInHomePage = 'LOGGED_IN_HOME_PAGE',
  /** Search Results Page */
  SearchResultsPage = 'SEARCH_RESULTS_PAGE'
}

/** Represents the subcategory of a suggested prompt matches backend enum */
export enum LearningAssistantSuggestedPromptSubcategory {
  /** Prompt suggested subcategory (enum) Code debugging */
  CodeDebugging = 'CODE_DEBUGGING',
  /** Prompt suggested subcategory (enum) FAQ */
  Faq = 'FAQ',
  /** Prompt suggested subcategory (enum) Lecture based */
  LectureBased = 'LECTURE_BASED',
  /** Prompt suggested subcategory (enum) Lecture search */
  LectureSearch = 'LECTURE_SEARCH',
  /** Prompt suggested subcategory (enum) Lecture summarization */
  LectureSummarization = 'LECTURE_SUMMARIZATION',
  /** Prompt suggested subcategory (enum) Others */
  Others = 'OTHERS',
  /** Prompt suggested subcategory (enum) Quiz */
  Quiz = 'QUIZ',
  /** Prompt suggested subcategory (enum) Skills focused */
  SkillsFocused = 'SKILLS_FOCUSED',
  /** Prompt suggested subcategory (enum) unspecified */
  Unspecified = 'UNSPECIFIED'
}

/** Paginated suggested prompts */
export type LearningAssistantSuggestedPromptsPaged = Paginated & {
  __typename?: 'LearningAssistantSuggestedPromptsPaged';
  /** Suggested prompts */
  items: Array<LearningAssistantSuggestedPrompt>;
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages. Calculated as (total result count/page size) */
  pageCount: Scalars['Int']['output'];
};

/** Types of Udemy Instructors that the Assistant might respond with */
export type LearningAssistantSupportedInstructor = CourseInstructor;

/** Generic interaction that enables faster implementation of new interaction types */
export type LearningAssistantTextInteraction = {
  /** Formatted text from clients to be passed to the Assistant */
  content: Scalars['String']['input'];
};

/** Represents BE entities that are not yet mapped to a GQL type */
export type LearningAssistantUnknownMessageItem = LearningAssistantBaseChatMessageItem & {
  __typename?: 'LearningAssistantUnknownMessageItem';
  /** Fallback or alternative text that represents this entity's content */
  fallbackText: Scalars['String']['output'];
};

/** Input for retrieving presigned URLs for previously uploaded files */
export type LearningAssistantUploadedPresignedUrlInput = {
  /** The MIME type of the file */
  mimeType: LearningAssistantFileMimeType;
  /** The ID of the uploaded file in cloud storage */
  storageFileId: Scalars['ID']['input'];
};

/** Quota (limit) that a user can have when interacting with the Learning Assistant */
export type LearningAssistantUserQuota = {
  __typename?: 'LearningAssistantUserQuota';
  /** End time of the user quota in UTC */
  endTime: Scalars['Timestamp']['output'];
  /** Start time of the user quota in UTC */
  startTime: Scalars['Timestamp']['output'];
  /** Timespan type of the user quota, e.g. daily */
  timespanType: LearningAssistantUserQuotaTimespanType;
  /** Quota type, e.g. message count */
  type: LearningAssistantUserQuotaType;
  /** Quota usage computed for the user */
  usage: LearningAssistantUserQuotaUsage;
};

/** Quota usage is determined by discrete integer values */
export type LearningAssistantUserQuotaNumberUsage = {
  __typename?: 'LearningAssistantUserQuotaNumberUsage';
  /** Current usage from the user */
  current: Scalars['Int']['output'];
  /** Max usage allowed from the quota */
  max: Scalars['Int']['output'];
};

/** Response for fetching user quota */
export type LearningAssistantUserQuotaResponse = {
  __typename?: 'LearningAssistantUserQuotaResponse';
  /** Quotas associated with the user by the server */
  userQuotas: LearningAssistantUserQuotas;
};

/** Window of time to include user interactions with the Learning Assistant. Also, it represents the frequency by which the user quota is reset */
export enum LearningAssistantUserQuotaTimespanType {
  /** User quota is determined by daily interactions */
  Day = 'DAY',
  /** User quota is determined by monthly interactions */
  Month = 'MONTH',
  /** User quota is determined by weekly interactions */
  Week = 'WEEK'
}

/** Entity used for calculating user quotas */
export enum LearningAssistantUserQuotaType {
  /** Users have a quota based on their number of messages submitted */
  MessageCount = 'MESSAGE_COUNT'
}

/** Specifies how a quota usage is represented */
export type LearningAssistantUserQuotaUsage = LearningAssistantUserQuotaNumberUsage;

/** All active user quotas segregated by whether they have exceeded or not */
export type LearningAssistantUserQuotas = {
  __typename?: 'LearningAssistantUserQuotas';
  /** List of active user quotas that have exceeded, i.e. reached the max limit */
  exceededQuotas: Array<LearningAssistantUserQuota>;
  /** List of active user quotas that have not exceeded, i.e. the usage is below the max limit */
  nonExceededQuotas: Array<LearningAssistantUserQuota>;
};

/** A learning objective is a brief statements that describe what students will be expected to learn. */
export type LearningObjective = {
  __typename?: 'LearningObjective';
  /** Activities in the Learning Objective */
  activities: Array<Maybe<LearningObjectiveActivity>>;
  /** The status of the content mapping task */
  alternativeActivities: Array<Maybe<LearningObjectiveActivity>>;
  /** Unique id to identify for learning objective */
  id: Scalars['ID']['output'];
  /** More granular learning objectives associated with this learning objective */
  learningObjectives: Array<Maybe<LearningObjective>>;
  /** Name of learning objective */
  name: Scalars['String']['output'];
};

/** Represents the types of activities we can map to a Learning Objective. */
export type LearningObjectiveActivity = ArticleLecture | AssessmentItem | AudioLecture | Course | EBookLecture | ExternalLecture | FileLecture | Lab | PresentationLecture | ProLearningPath | VideoLecture | VideoMashupLecture;

/** Allows the user to set the activity id's and the activity types they want to query for. */
export type LearningObjectiveActivityInput = {
  /** Activity ID */
  activityId: Scalars['ID']['input'];
  /** Activity Type */
  activityType: LearningObjectiveActivityTypeInput;
};

/** Represent the types of activities we can map to a Learning Objective. */
export enum LearningObjectiveActivityTypeInput {
  /** This activity is an Adaptive assessment question */
  AssessmentQuestion = 'ASSESSMENT_QUESTION',
  /** This activity is a course */
  Course = 'COURSE',
  /** This activity is a lab */
  Lab = 'LAB',
  /** This activity is a lab task */
  LabTask = 'LAB_TASK',
  /** This activity is a lecture */
  Lecture = 'LECTURE'
}

/** This holds data to create a learning objective */
export type LearningObjectiveInput = {
  /** Id to identify for learning objective */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Child Learning objectives associated with this learning objective. */
  learningObjectives: Array<LearningObjectiveInput>;
  /** Name of learning objective */
  name: Scalars['String']['input'];
};

/** Response for updating a Learning Objective */
export type LearningObjectiveUpdateResponse = {
  __typename?: 'LearningObjectiveUpdateResponse';
  /** Learning Objective that was updated */
  learningObjective?: Maybe<LearningObjective>;
};

/** The learning path object. */
export type LearningPath = {
  /** Badges of the learning path. */
  badges?: Maybe<Array<BadgeClass>>;
  /** Date when learning path was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the learning path. */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** The duration of the learning path */
  durationInSeconds?: Maybe<Scalars['DurationInSeconds']['output']>;
  /** ID of the learning path. */
  id: Scalars['ID']['output'];
  /** Is the user enrolled in this learning path or not */
  isEnrolled: Scalars['Boolean']['output'];
  /** Number of items in the learning path. */
  itemCount: Scalars['Int']['output'];
  /** Date when learning path was last modified */
  modifiedAt: Scalars['DateTime']['output'];
  /** Owner user for the learning path */
  owner: LearningPathInstructor;
  /** Number of sections in the learning path */
  sectionCount: Scalars['Int']['output'];
  /** Sections of the learning path */
  sections?: Maybe<Array<LearningPathSection>>;
  /** Subscription information for this learning path. */
  subscriptionInfo?: Maybe<LearningProductSubscriptionInfo>;
  /** Title of the learning path. */
  title: Scalars['String']['output'];
  /** Topics associated with the learning path. */
  topics?: Maybe<Array<Topic>>;
  /** Unique analytics ID for this instance of LearningPath returned from the server in this request. */
  trackingId?: Maybe<Scalars['String']['output']>;
  /** Landing page to view this LearningPath */
  urlLanding: Scalars['URL']['output'];
};

/** Catalog of all learning paths available to the client */
export type LearningPathCatalogFullResponsePaged = {
  __typename?: 'LearningPathCatalogFullResponsePaged';
  /** Cursor to get the next page. Null if no more results available */
  cursor?: Maybe<Scalars['String']['output']>;
  /** List of courses in the catalog */
  learningPaths: Array<Maybe<LearningPath>>;
  /** Sync Token to use for the next delta sync */
  syncToken: Scalars['String']['output'];
};

/** Changes to catalog of all learning paths available to the client since last sync */
export type LearningPathCatalogUpdatedResponsePaged = {
  __typename?: 'LearningPathCatalogUpdatedResponsePaged';
  /** Learning Paths added since last sync */
  addedLearningPaths: Array<Maybe<LearningPath>>;
  /** Cursor to get the next page. Null if no more results available */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Learning Path IDs for courses removed since last sync */
  removedLearningPaths: Array<Scalars['ID']['output']>;
  /** Sync Token to use for the next delta sync */
  syncToken: Scalars['String']['output'];
  /** Learning Paths updated since last sync */
  updatedLearningPaths: Array<Maybe<LearningPath>>;
};

/** Collection of curriculum items presented in a learning path as a one item */
export type LearningPathCoursePortion = LearningPathItem & {
  __typename?: 'LearningPathCoursePortion';
  /** Description of the course portion */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** The duration of the course portion */
  durationInSeconds?: Maybe<Scalars['DurationInSeconds']['output']>;
  /** ID of the course portion */
  id: Scalars['ID']['output'];
  /** Items in the course portion */
  items?: Maybe<Array<Maybe<CurriculumItem>>>;
  /** Title of the course portion */
  title: Scalars['String']['output'];
};

/** Response for creating/updating a learning path from skills */
export type LearningPathCreateResponse = {
  __typename?: 'LearningPathCreateResponse';
  /** Learning path created/updated */
  learningPath?: Maybe<ProLearningPath>;
};

/** Learning path enrollment */
export type LearningPathEnrollment = {
  __typename?: 'LearningPathEnrollment';
  /** The learning path that the user is enrolled in */
  learningPath: LearningPath;
};

/** Instructor for a Learning Path */
export type LearningPathInstructor = Instructor & {
  __typename?: 'LearningPathInstructor';
  /** ID of the Instructor */
  id: Scalars['ID']['output'];
  /** Instructor's image by varying pixels */
  images: InstructorImages;
  /** Is the instructor opted out, i.e. not willing to participate on Gen AI features */
  isOptedOutToGenAI?: Maybe<Scalars['Boolean']['output']>;
  /** Instructor's name */
  name: Scalars['String']['output'];
  /** The URL to access the instructor page */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Learning Path Item can be Course, Lab, Assessment, Learning Path Resource, and Course Portion */
export type LearningPathItem = {
  /** Description of the item */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** The duration of the item */
  durationInSeconds?: Maybe<Scalars['DurationInSeconds']['output']>;
  /** ID of the item */
  id: Scalars['ID']['output'];
  /** Title of the item */
  title: Scalars['String']['output'];
};

/** A wrapper type to include the recommended Learning Path and some additional fields about its recommendation */
export type LearningPathRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'LearningPathRecommendation';
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /** Underlying object of the recommendation to get more information about it */
  learningPath?: Maybe<LearningPath>;
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** Learning Path Resource represents a link to another resource */
export type LearningPathResource = LearningPathItem & {
  __typename?: 'LearningPathResource';
  /** Description of the learning path resource */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** The duration of the learning path resource */
  durationInSeconds?: Maybe<Scalars['DurationInSeconds']['output']>;
  /** ID of the learning path resource */
  id: Scalars['ID']['output'];
  /** Title of the learning path resource */
  title: Scalars['String']['output'];
  /** Landing URL for the learning path resource */
  urlLanding: Scalars['URL']['output'];
};

/** Search filters to apply on path search request */
export type LearningPathSearchFilters = {
  /** Filters udemy pro paths if set to true, shows all paths if set to false or not provided */
  isProPath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether path must have a certificate or not */
  mustHaveCertificate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** List of LearningPath and additional data about search response */
export type LearningPathSearchResponse = {
  __typename?: 'LearningPathSearchResponse';
  /** Total number of Paths matching the search query and filters. */
  count: Scalars['Int']['output'];
  /** Metadata for whole search result used by front end */
  metadata?: Maybe<PathSearchResponseMetadata>;
  /**
   * Found learning for search request.
   * @deprecated Use results field instead which supports both ProLearningPath and OrganizationLearningPath
   */
  paths: Array<ProLearningPath>;
  /** List of LearningPathSearchResult objects. */
  results: Array<LearningPathSearchResult>;
};

/** Identifies each result for learning path search. */
export type LearningPathSearchResult = {
  __typename?: 'LearningPathSearchResult';
  /** The learning path found in search. */
  learningPath: LearningPath;
  /** Unique analytics ID for the found learning path. */
  trackingId: Scalars['String']['output'];
};

/** Learning Path Section represents a collection of items in a learning path */
export type LearningPathSection = {
  __typename?: 'LearningPathSection';
  /** Description of the section */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** The duration of the section */
  durationInSeconds?: Maybe<Scalars['DurationInSeconds']['output']>;
  /** ID of the section */
  id: Scalars['ID']['output'];
  /** Number of items in the section */
  itemCount: Scalars['Int']['output'];
  /** Items in the section */
  items?: Maybe<Array<Maybe<LearningPathItem>>>;
  /** Title of the section */
  title: Scalars['String']['output'];
};

/** All partner's content collection items that are available, currently just course */
export type LearningProduct = {
  /** ID of the learning product */
  id: Scalars['ID']['output'];
};

/** Represents a request to access a specific learning product */
export type LearningProductAccessRequest = {
  __typename?: 'LearningProductAccessRequest';
  /** The user who approved the access request */
  approver?: Maybe<User>;
  /** The time the access request was created at */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the access request */
  id: Scalars['ID']['output'];
  /** The learning product being requested */
  learningProduct: LearningProduct;
  /** The last time the access request was modified at */
  modifiedAt: Scalars['DateTime']['output'];
  /** The organization associated with the access request */
  organization: Organization;
  /** The user who made the access request */
  requester: User;
  /** The status of the access request */
  status: LearningProductAccessRequestStatus;
};

/** Response for approval operation on learning product access requests */
export type LearningProductAccessRequestApproveResponse = {
  __typename?: 'LearningProductAccessRequestApproveResponse';
  /** List of processed access requests with their outcomes */
  results: Array<LearningProductAccessRequestProcessItem>;
};

/** Represents the response for creating a learning product access request */
export type LearningProductAccessRequestCreateResponse = {
  __typename?: 'LearningProductAccessRequestCreateResponse';
  /** The created learning product access request */
  accessRequest?: Maybe<LearningProductAccessRequest>;
};

/** Status codes representing the result of processing access requests */
export enum LearningProductAccessRequestProcessCode {
  /** Request could not be processed due to no available seats */
  NoSeatsAvailable = 'NO_SEATS_AVAILABLE',
  /** Request could not be processed because it was not found */
  RequestNotFound = 'REQUEST_NOT_FOUND',
  /** Request was processed successfully */
  Success = 'SUCCESS',
  /** Request could not be processed due to an internal error */
  UnknownError = 'UNKNOWN_ERROR'
}

/** Represents the result of processing an individual access request */
export type LearningProductAccessRequestProcessItem = {
  __typename?: 'LearningProductAccessRequestProcessItem';
  /** Result code indicating the outcome of processing this request */
  code: LearningProductAccessRequestProcessCode;
  /** The processed access request */
  id: Scalars['ID']['output'];
};

/** Response for rejection operation on learning product access requests */
export type LearningProductAccessRequestRejectResponse = {
  __typename?: 'LearningProductAccessRequestRejectResponse';
  /** List of processed access requests with their outcomes */
  results: Array<LearningProductAccessRequestProcessItem>;
};

/** Status of a learning product access request */
export enum LearningProductAccessRequestStatus {
  /** Request has been approved */
  Approved = 'APPROVED',
  /** Request was auto-approved */
  AutoApproved = 'AUTO_APPROVED',
  /** Request is pending approval */
  Pending = 'PENDING',
  /** Request has been rejected */
  Rejected = 'REJECTED'
}

/** Paginated response for learning product access requests */
export type LearningProductAccessRequestsPaged = Paginated & {
  __typename?: 'LearningProductAccessRequestsPaged';
  /** List of learning product access requests */
  items: Array<Maybe<LearningProductAccessRequest>>;
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages. Calculated as (total result count / page size) */
  pageCount: Scalars['Int']['output'];
  /** Total number of learning product access requests */
  totalCount: Scalars['Int']['output'];
};

/** Represents a badge awarded to a learning product. */
export type LearningProductBadge = {
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
};

/** Input for getting badge classes by learning products */
export type LearningProductInput = {
  /** ID of the learning product */
  id: Scalars['ID']['input'];
  /** Type of the learning product */
  type: LearningProductType;
  /** Version ID of the learning product */
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Subscription inclusion for a learning product (Lab, Assessment, or Learning Path).
 * Indicates which active subscriptions include this product. Empty list means the product is not in any active subscription.
 * No user-license filtering: this is the list of active subscriptions that include the product.
 */
export type LearningProductSubscriptionInfo = {
  __typename?: 'LearningProductSubscriptionInfo';
  /**
   * Active subscriptions that include this product.
   * We do not filter by user license; this is purely "which active subscriptions include this product?"
   */
  inSubscriptions?: Maybe<Array<SubscriptionPlan>>;
};

/** Type of learning product. */
export enum LearningProductType {
  /** Assessment */
  Assessment = 'ASSESSMENT',
  /** Badge Class (OpenBadgeClass & OrganizationBadgeClass) */
  BadgeClass = 'BADGE_CLASS',
  /** Career Accelerator */
  CareerAccelerator = 'CAREER_ACCELERATOR',
  /** Course */
  Course = 'COURSE',
  /** Lab */
  Lab = 'LAB',
  /** Learning path */
  LearningPath = 'LEARNING_PATH',
  /** Practice test */
  PracticeTest = 'PRACTICE_TEST'
}

/** Filter options for learning products */
export type LearningProductsItemsFilter = {
  /** The type of learning product to filter by */
  type?: InputMaybe<LearningProductType>;
};

/** A collection of learning products for a partner */
export type LearningProductsPaged = Paginated & {
  __typename?: 'LearningProductsPaged';
  /** The contents of the collection, currently just courses. Items may be less than requested size if objects become unavailable */
  items: Array<LearningProduct>;
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages. Calculated as (total result count / page size) */
  pageCount: Scalars['Int']['output'];
};

/** The LearningReminder object. */
export type LearningReminder = {
  __typename?: 'LearningReminder';
  /** Calendar Type for the learning reminder */
  calendarType?: Maybe<LearningReminderCalendarType>;
  /** Duration of the learning event. */
  durationInMinutes?: Maybe<Scalars['DurationInMinutes']['output']>;
  /** End date of the recurring learning reminders. */
  endDate: Scalars['DateTime']['output'];
  /** ID of the learning reminder. */
  id: Scalars['ID']['output'];
  /** Learning product of the learning reminder. */
  learningProduct?: Maybe<LearningProduct>;
  /** The recurrence rule for the reminder */
  recurrencePattern?: Maybe<Scalars['RRuleString']['output']>;
  /** Delivery method for the learning reminder */
  reminderMethod: LearningReminderNotificationMethod;
  /** When to show the reminder, expressed as minutes before the learning reminder start time */
  reminderMinutesBefore: Scalars['Int']['output'];
  /** Start date of the first recurring learning reminder. */
  startDate: Scalars['DateTime']['output'];
  /** Title of the learning reminder. */
  title: Scalars['String']['output'];
};

/** Calendar type of the learning reminder */
export enum LearningReminderCalendarType {
  /** Apple Calendar Type */
  Apple = 'APPLE',
  /** Google Calendar Type */
  Google = 'GOOGLE',
  /** Other Calendars */
  Other = 'OTHER',
  /** Outlook Calendar Type */
  Outlook = 'OUTLOOK'
}

/** Response for creating or updating a learning reminder */
export type LearningReminderCreateOrUpdateResponse = {
  __typename?: 'LearningReminderCreateOrUpdateResponse';
  /** The learning reminder that was created */
  learningReminder?: Maybe<LearningReminder>;
};

/** Response for deleting a learning reminder */
export type LearningReminderDeleteResponse = {
  __typename?: 'LearningReminderDeleteResponse';
  /** The ID of the learning reminder that was deleted */
  learningReminderId?: Maybe<Scalars['ID']['output']>;
};

/** Input for creating and updating a learning reminder */
export type LearningReminderInput = {
  /** Calendar Type for the learning reminder */
  calendarType?: InputMaybe<LearningReminderCalendarType>;
  /** Duration of the learning event. */
  durationInMinutes?: InputMaybe<Scalars['DurationInMinutes']['input']>;
  /** End date of the recurring learning reminders. */
  endDate: Scalars['DateTime']['input'];
  /** Learning product of the learning reminder. */
  learningProduct?: InputMaybe<LearningReminderLearningProductInput>;
  /** The recurrence rule for the reminder */
  recurrencePattern?: InputMaybe<Scalars['RRuleString']['input']>;
  /** Delivery method for the learning reminder */
  reminderMethod: LearningReminderNotificationMethod;
  /** When to show the reminder, expressed as minutes before the learning reminder start time */
  reminderMinutesBefore: Scalars['Int']['input'];
  /** Start date of the first recurring learning reminder. */
  startDate: Scalars['DateTime']['input'];
  /** Title of the learning reminder. */
  title: Scalars['String']['input'];
};

/** Input for learning product of the learning reminder */
export type LearningReminderLearningProductInput = {
  /** ID of the learning product. */
  id: Scalars['ID']['input'];
  /** ID of the learning product. */
  type: Scalars['String']['input'];
};

/** Notification method of the learning reminder */
export enum LearningReminderNotificationMethod {
  /** Email Reminder Method */
  Email = 'EMAIL',
  /** Push Reminder Method */
  Push = 'PUSH'
}

/** Paginated learning reminders of the user */
export type LearningRemindersPaged = Paginated & {
  __typename?: 'LearningRemindersPaged';
  /** Learning reminders of the user */
  items: Array<LearningReminder>;
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages. Calculated as (total result count / page size) */
  pageCount: Scalars['Int']['output'];
};

/** The testimonial given relevant to a learning item or event */
export type LearningTestimonial = {
  __typename?: 'LearningTestimonial';
  /** The localized content of the Learning Testimonial */
  content: Scalars['String']['output'];
  /** The ID of the Learning Testimonial */
  id: Scalars['ID']['output'];
  /** The URL related to the Learning Testimonial */
  relatedUrl: Scalars['URL']['output'];
  /** The localized text for the URL related to the Learning Testimonial */
  relatedUrlText: Scalars['String']['output'];
  /** The source of the Learning Testimonial */
  source: LearningTestimonialSource;
  /** The type of Learning Testimonial */
  type: LearningTestimonialType;
};

/** The Learning Testimonials query filter options */
export type LearningTestimonialFilters = {
  /** The URL query param that will be parsed to enable returning the content that has been saved but not yet published in the CMS. */
  isContentPreviewEnabled?: Scalars['Boolean']['input'];
  /** The specific page type for Learning Testimonials that will match values set in the CMS */
  pageType: LearningTestimonialPageType;
};

/** The specific page type for the Learning Testimonial. This is important for narrowing down the testimonial content in the CMS to where Marketing wants to render it. (Other pages will be added in the future, e.g., Personal Plan, etc) */
export enum LearningTestimonialPageType {
  /** Logged out home page of udemy */
  LoggedOutHomePage = 'LOGGED_OUT_HOME_PAGE'
}

/** The source of the learning testimonial */
export type LearningTestimonialSource = {
  __typename?: 'LearningTestimonialSource';
  /** Description text of the source for the Learning Testimonial (e.g., job title for Course Review types, etc) */
  description?: Maybe<Scalars['String']['output']>;
  /** The URL to the image asset of the source for the Learning Testimonial */
  image: Scalars['URL']['output'];
  /** Name of the source for the Learning Testimonial */
  name: Scalars['String']['output'];
};

/** Type of Learning Testimonial */
export enum LearningTestimonialType {
  /** Case study Learning Testimonial */
  CaseStudy = 'CASE_STUDY',
  /** Course review Learning Testimonial */
  CourseReview = 'COURSE_REVIEW',
  /** Third party Learning Testimonial */
  ThirdParty = 'THIRD_PARTY'
}

/** Represents a lecture type  */
export type Lecture = {
  /** Lecture's main learning asset */
  asset?: Maybe<Asset>;
  /** The Course this lecture belongs to */
  course?: Maybe<Course>;
  /** Instructor-authored description of the lecture, may contain HTML */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** Id of the lecture */
  id: Scalars['ID']['output'];
  /** Images by their dimensions */
  images: LectureImages;
  /** If user has completed the lecture */
  isCompleted: Scalars['Boolean']['output'];
  /** Whether this lecture is used for promos and course previews. */
  isPreviewable: Scalars['Boolean']['output'];
  /** Lecture's supplementary resources */
  resources?: Maybe<Array<Maybe<Asset>>>;
  /** Associated learning products for supplementary learning */
  supplementaryLearningProducts: Array<LearningProduct>;
  /** The URL of the lecture thumbnail */
  thumbnail?: Maybe<Scalars['URL']['output']>;
  /** Lecture title */
  title: Scalars['String']['output'];
  /** The URL to access the lecture on the auto-enroll page */
  urlAutoEnroll: Scalars['URL']['output'];
  /** Download URL for lecture */
  urlDownload?: Maybe<Scalars['URL']['output']>;
  /** Landing page to view this Lecture */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the lecture */
  versionedIdentifier: VersionedIdentifier;
};


/** Represents a lecture type  */
export type LectureSupplementaryLearningProductsArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** Lecture images by varying dimensions */
export type LectureImages = {
  __typename?: 'LectureImages';
  /** Lecture preview image with 50 pixels height */
  height50?: Maybe<Scalars['String']['output']>;
  /** Lecture preview image with 75 pixels height */
  height75?: Maybe<Scalars['String']['output']>;
  /** Lecture preview image with 100 pixels height */
  height100?: Maybe<Scalars['String']['output']>;
  /** Lecture preview image with 320 pixels height */
  height320?: Maybe<Scalars['String']['output']>;
  /** Lecture preview image with 480 pixels height */
  height480?: Maybe<Scalars['String']['output']>;
};

/** A wrapper type to include the recommended Lecture and some additional fields about its recommendation */
export type LectureRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'LectureRecommendation';
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /** Underlying object of the recommendation to get more information about it */
  lecture?: Maybe<Lecture>;
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** List of LectureResults and additional data about search response */
export type LectureSearchResponse = {
  __typename?: 'LectureSearchResponse';
  /** For the request, shows experiment metadata result like bucking info, experiment IDs of assigned feature variants. */
  experimentResults: Array<FeatureVariantAssignment>;
  /** Metadata for whole search result used by front end */
  metadata?: Maybe<LectureSearchResponseMetadata>;
  /** List of LectureResult objects. The main search result is found in this list. This result is made nullable as a catch point for any errors that may occur downstream. */
  results: Array<Maybe<LectureSearchResult>>;
};

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */
export type LectureSearchResponseMetadata = {
  __typename?: 'LectureSearchResponseMetadata';
  /** Order of the lab unit at the search result page. The value is calculated according to query intent evaluation */
  labUnitOrder: Scalars['Int']['output'];
  /** Experiment variant for the lecture unit  */
  lectureExperimentVariant: Scalars['String']['output'];
  /** Order of the lecture unit at the search result page. The value is calculated according to query intent evaluation */
  lectureUnitOrder: Scalars['Int']['output'];
  /** Search analytics tracking id; for uniquely identifying this query and result set; for this request */
  trackingId: Scalars['String']['output'];
};

/** Identifies each result for lecture search. */
export type LectureSearchResult = {
  __typename?: 'LectureSearchResult';
  /** Containing course of the found lecture. */
  course: Course;
  /** Found lecture for lecture search request. */
  lecture: Lecture;
  /** Unique analytics ID for the found lecture. */
  trackingId?: Maybe<Scalars['String']['output']>;
};

/** An AI-generated summary for a lecture */
export type LectureSummary = {
  __typename?: 'LectureSummary';
  /** The lecture this summary belongs to */
  lecture: Lecture;
  /** The AI-generated summary text */
  summaryText: Scalars['String']['output'];
};

/** A lesson associated with a learning product */
export type Lesson = {
  __typename?: 'Lesson';
  /** The lesson article whose fragments are mapped within the playable media */
  article?: Maybe<LessonArticle>;
  /** The creation timestamp */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** The entity tag for optimistic locking, to be provided, as read, when updating */
  entityTag: Scalars['Int']['output'];
  /** The id of the lesson */
  id: LessonId;
  /** The lesson's original locale */
  locale: Scalars['Locale']['output'];
  /** The last update timestamp */
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** The version of the lesson */
  version: Scalars['String']['output'];
};

/** A rich article whose fragments can map to timestamps within the playable media */
export type LessonArticle = {
  __typename?: 'LessonArticle';
  /** A description for the article */
  description: Scalars['String']['output'];
  /** The article's fragments */
  fragments: Array<LessonArticleFragment>;
  /** The article's locale. Supports translation. */
  locale: Scalars['Locale']['output'];
  /** The source of the article */
  source: ContentSourceType;
  /** The key takeaways of an article in markdown format */
  takeaways?: Maybe<Markdown>;
  /** The title of the article */
  title: Scalars['String']['output'];
  /** A uuid uniquely identifying an article */
  uuid: Scalars['UUID']['output'];
};

/** A fragment of an article with possible mapping to the lesson's playable media */
export type LessonArticleFragment = {
  __typename?: 'LessonArticleFragment';
  /** The polymorphic content of the fragment */
  content: LessonArticleFragmentContent;
  /** The offset in seconds within the playable media this fragment corresponds to */
  timestamp?: Maybe<Scalars['OffsetInSeconds']['output']>;
};

/** Polymorphic Article Fragment Content */
export type LessonArticleFragmentContent = CodeBlock | Markdown;

/** A flexible identification for a lesson */
export type LessonId = {
  __typename?: 'LessonId';
  /** The type of the id */
  idType: LessonIdType;
  /** The id value */
  idValue: Scalars['ID']['output'];
};

/** Input type for providing a lesson id */
export type LessonIdInput = {
  /** The type of the id */
  idType: LessonIdType;
  /** The id value */
  idValue: Scalars['ID']['input'];
};

/** The types of a LessonId */
export enum LessonIdType {
  /** A lesson attached to an asset ID */
  AssetId = 'ASSET_ID',
  /** A standalone lesson with a UUID */
  Uuid = 'UUID'
}

/** License-related organization settings */
export type LicenseOrganizationSettings = {
  __typename?: 'LicenseOrganizationSettings';
  /** Whether license allocation requests made in product should be automatically approved */
  isLicenseAutomaticAllocationEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** License pool */
export type LicensePool = {
  __typename?: 'LicensePool';
  /** The License pool unique identifier */
  id: Scalars['ID']['output'];
  /** Users with invite permissions to this license pool */
  inviters?: Maybe<Array<User>>;
  /** True if it is a default pool */
  isDefault: Scalars['Boolean']['output'];
  /** Set of license counts assigned to this license pool */
  licenseCounts: Array<LicensePoolProductTypeCount>;
  /** Pool name */
  name: Scalars['String']['output'];
  /** The organization this pool is assigned to */
  organization: Organization;
};

/** Count of Active Users per Product Type per License Pool */
export type LicensePoolActiveUserCountPerPool = {
  __typename?: 'LicensePoolActiveUserCountPerPool';
  /** License Pools active user count per SubscriptionPlanProductType of the pool */
  activeUsersPerProductType: Array<Maybe<LicensePoolUsersPerType>>;
  /** License pool */
  licensePool: LicensePool;
};

/** Response for a license pool create or update mutation */
export type LicensePoolCreateOrUpdateResponse = {
  __typename?: 'LicensePoolCreateOrUpdateResponse';
  /** License pool */
  licensePool?: Maybe<LicensePool>;
};

/** Response for a license pool delete mutation */
export type LicensePoolDeleteResponse = {
  __typename?: 'LicensePoolDeleteResponse';
  /** Id of the deleted license pool */
  licensePoolId?: Maybe<Scalars['ID']['output']>;
};

/** The input used for creating and updating a license pool */
export type LicensePoolInput = {
  /** User Ids to who can invite to this license pool */
  inviterUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Set of license counts assigned to this license pool */
  licenseCounts?: InputMaybe<Array<LicensePoolProductTypeCountInput>>;
  /** License pool name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** User Ids to add to this license pool */
  userIdsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Product type license count */
export type LicensePoolProductTypeCount = {
  __typename?: 'LicensePoolProductTypeCount';
  /** The current max license count */
  maxLicenseCount: Scalars['Int']['output'];
  /** The product type this license count is assigned to */
  productType: SubscriptionPlanProductType;
  /** The current used license count for this license count */
  usedLicenseCount: Scalars['Int']['output'];
};

/** The input used for describing a product type license count */
export type LicensePoolProductTypeCountInput = {
  /** The current max license count */
  maxLicenseCount: Scalars['Int']['input'];
  /** The product type this license count is assigned to */
  productType: SubscriptionPlanProductType;
};

/** Response for a license pool update preview mutation */
export type LicensePoolUpdatePreviewResponse = {
  __typename?: 'LicensePoolUpdatePreviewResponse';
  /** License pools */
  licensePools: Array<LicensePool>;
};

/** Response for License Pool users move mutation */
export type LicensePoolUsersMoveResponse = {
  __typename?: 'LicensePoolUsersMoveResponse';
  /** License Pools users moved per SubscriptionPlanProductType of the pool */
  usersMovedPerType?: Maybe<Array<LicensePoolUsersPerType>>;
};

/** License Pools users per SubscriptionPlanProductType of the pool */
export type LicensePoolUsersPerType = {
  __typename?: 'LicensePoolUsersPerType';
  /** The SubscriptionPlanProductType these moved users are assigned to */
  productType: SubscriptionPlanProductType;
  /** Number of users */
  userCount: Scalars['NonNegativeInt']['output'];
};

/** Filters for the License Pools queries */
export type LicensePoolsActiveUserFilters = {
  /** Filter by license pool id */
  licensePoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by user Id */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Enum for locale config options */
export enum LocaleConfig {
  /** Use the lesson's locale */
  LessonLocale = 'LESSON_LOCALE',
  /** Use the user's locale */
  UserLocale = 'USER_LOCALE'
}

/** Input type for providing a locale configuration */
export type LocaleInput = {
  /** a locale config to use */
  localeConfig: LocaleConfig;
};

/** A micro-content representing markdown */
export type Markdown = {
  __typename?: 'Markdown';
  /** The markdown value */
  content: Scalars['String']['output'];
};

/** Single bullet item with optional icon. */
export type MarketingBulletV1 = {
  __typename?: 'MarketingBulletV1';
  /**
   * Icon identifier (design-system token), not a URL.
   * E.g., "icon-person".
   */
  icon?: Maybe<Scalars['String']['output']>;
  /** Short text for the bullet in rich text format. */
  label: Scalars['String']['output'];
};

/** Call-to-action button with destination link. */
export type MarketingCallToActionV1 = {
  __typename?: 'MarketingCallToActionV1';
  /** Button label shown to users. */
  label: Scalars['String']['output'];
  /** Destination URL for the button. */
  url: Scalars['URL']['output'];
};

/**
 * Shared interface for all marketing card types in V1.
 * Ensures consistent core fields across different card implementations.
 */
export type MarketingCardV1 = {
  /** Main image for the card. */
  image: MarketingImageV1;
  /** Optional pill displayed on the card (e.g., "3 MM+ Learners" with people icon). */
  pill?: Maybe<MarketingPillV1>;
  /** Primary title of the card (e.g., "CompTIA", "AWS", "React Course"). */
  title: Scalars['String']['output'];
  /** Destination URL when the card is clicked. */
  url: Scalars['URL']['output'];
};

/** Standard header copy used across marketing components. */
export type MarketingHeaderV1 = {
  __typename?: 'MarketingHeaderV1';
  /** Main headline text for the section. */
  headline: Scalars['SafeHtml']['output'];
  /** Brief supporting description shown below the headline. */
  supportingText?: Maybe<Scalars['String']['output']>;
};

/** Marketing card with full background image and text content overlaid on top. */
export type MarketingImageBackgroundCardV1 = MarketingCardV1 & {
  __typename?: 'MarketingImageBackgroundCardV1';
  /** Main image for the card. */
  image: MarketingImageV1;
  /** Optional pill displayed above or near the title (text + optional icon). */
  pill?: Maybe<MarketingPillV1>;
  /** Primary title of the card (e.g., "Generative AI"). */
  title: Scalars['String']['output'];
  /** Destination URL when the card is clicked. */
  url: Scalars['URL']['output'];
};

/**
 * Marketing card with image positioned at the top and text content below.
 * Implements the shared MarketingCardV1 interface.
 */
export type MarketingImageTopCardV1 = MarketingCardV1 & {
  __typename?: 'MarketingImageTopCardV1';
  /** Main image for the card. */
  image: MarketingImageV1;
  /** Optional pill displayed on the card (e.g., "3 MM+ Learners" with people icon). */
  pill?: Maybe<MarketingPillV1>;
  /** Subtitle or description below the title. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Primary title of the card (e.g., "CompTIA", "AWS", "React Course"). */
  title: Scalars['String']['output'];
  /** Destination URL when the card is clicked. */
  url: Scalars['URL']['output'];
};

/** Image asset used in marketing components. */
export type MarketingImageV1 = {
  __typename?: 'MarketingImageV1';
  /** Accessible alternative text. */
  altText?: Maybe<Scalars['String']['output']>;
  /** Canonical image URL. */
  url: Scalars['URL']['output'];
};

/** Two-column marketing section with intro copy on the left and a fixed row of cards on the right. */
export type MarketingIntroCardsRowV1 = {
  __typename?: 'MarketingIntroCardsRowV1';
  /** Primary call-to-action button (label + link). */
  callToAction: MarketingCallToActionV1;
  /**
   * Fixed set of cards displayed as a horizontal row.
   * Uses the shared MarketingCardV1 interface for flexibility.
   */
  cards: Array<Maybe<MarketingCardV1>>;
  /** Header for this component. */
  header: MarketingHeaderV1;
};

/** Small pill UI element used in other components (icon + label). */
export type MarketingPillV1 = {
  __typename?: 'MarketingPillV1';
  /**
   * Icon identifier (design-system token), not a URL.
   * E.g., "icon-people".
   */
  icon?: Maybe<Scalars['String']['output']>;
  /** Short text for the pill. */
  label: Scalars['String']['output'];
};

/** Two-column marketing section with copy with bullets on the left and an image on the right. */
export type MarketingSplitBulletedMediaV1 = {
  __typename?: 'MarketingSplitBulletedMediaV1';
  /** Key points displayed as a bulleted list. */
  bullets: Array<Maybe<MarketingBulletV1>>;
  /** Primary call-to-action button (label + link). */
  callToAction: MarketingCallToActionV1;
  /** Header for this component. */
  header: MarketingHeaderV1;
  /** Prominent image displayed on the right side of the section. */
  image: MarketingImageV1;
};

/** Two-column hero with marketing copy on the left and a cards carousel on the right. */
export type MarketingSplitCardsCarouselV1 = {
  __typename?: 'MarketingSplitCardsCarouselV1';
  /** All cards in the carousel. */
  cards: Array<Maybe<MarketingCardV1>>;
  /** Header for this component. */
  header: MarketingHeaderV1;
};

/** Two-column marketing section with featured popular topic on the left and categorized topics on the right. */
export type MarketingSplitPopularTopicsDirectoryV1 = {
  __typename?: 'MarketingSplitPopularTopicsDirectoryV1';
  /** Header content with headline and supporting text. */
  header: MarketingHeaderV1;
  /** The most popular topic being highlighted (e.g., "ChatGPT"). */
  mostPopularTopic?: Maybe<Topic>;
  /** Primary call-to-action button (e.g., "Show all popular skills") */
  primaryCallToAction: MarketingCallToActionV1;
  /** Categorized topics displayed in category columns (e.g., Development, Design, Business). */
  topicCategories: Array<Maybe<MarketingTopicCategoryV1>>;
};

/** Tabbed interface with header content where topic tabs control course card display. */
export type MarketingTabsTopicsCardsV1 = {
  __typename?: 'MarketingTabsTopicsCardsV1';
  /** Header content with headline and supporting text. */
  header: MarketingHeaderV1;
  /** Topics that act as tabs for filtering course recommendations, in display order. */
  topics: Array<Maybe<Topic>>;
};

/** A category of topic with a header and list of topics. */
export type MarketingTopicCategoryV1 = {
  __typename?: 'MarketingTopicCategoryV1';
  /** Category name displayed as column header (e.g., "Development", "Design", "Business"). */
  name: Scalars['String']['output'];
  /** List of topics in this category. */
  topics: Array<Maybe<Topic>>;
};

/** Current User */
export type Me = {
  __typename?: 'Me';
  /**
   * The current user's active organization licenses.
   * This field is present only if the user is a member of an organization or team.
   */
  activeLicenses?: Maybe<Array<Maybe<OrganizationUserLicense>>>;
  /** The current user's certification vouchers */
  certificationVouchers?: Maybe<Array<Maybe<CertificationVoucher>>>;
  /** The current user's enrollments */
  enrollments?: Maybe<MeEnrollments>;
  /** The current user is instructing a course or has intent to become an instructor */
  hasInstructorOptions?: Maybe<Scalars['Boolean']['output']>;
  /** The current user's id */
  id: Scalars['ID']['output'];
  /** The current user's geo ip country as defined by ISO 3166-1 alpha-2 */
  ipCountry?: Maybe<Scalars['CountryCode']['output']>;
  /** The organization the current user belongs to, if any */
  organization?: Maybe<Organization>;
  /** The current user's profile */
  userProfile?: Maybe<UserProfile>;
  /** The current user's settings */
  userSettings?: Maybe<Array<Maybe<UserSetting>>>;
};


/** Current User */
export type MeUserSettingsArgs = {
  filter?: InputMaybe<UserSettingFilter>;
};

/** Enrollments of the current user */
export type MeEnrollments = {
  __typename?: 'MeEnrollments';
  /** List of badge enrollments */
  badgeEnrollments: Array<Maybe<BadgeEnrollment>>;
  /** List of career accelerator enrollments */
  careerAcceleratorEnrollments: CareerAcceleratorEnrollmentsPaged;
  /** Count of course enrollments matching the given filters */
  courseEnrollmentCount: Scalars['Int']['output'];
  /**
   * List of course enrollments sorted by lastAccessedTime
   * @deprecated Use courseEnrollmentsPaged instead
   */
  courseEnrollments: Array<Maybe<CourseEnrollment>>;
  /** List of current user's course enrollments fetching for the given course ids */
  courseEnrollmentsForCourseIds: Array<Maybe<CourseEnrollment>>;
  /** List of paged course enrollments sorted by lastAccessedTime */
  courseEnrollmentsPaged: CourseEnrollmentsPaged;
  /** List of learning path enrollments */
  learningPathEnrollments: Array<Maybe<LearningPathEnrollment>>;
};


/** Enrollments of the current user */
export type MeEnrollmentsCareerAcceleratorEnrollmentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: Scalars['MaxResultsPerPage']['input'];
};


/** Enrollments of the current user */
export type MeEnrollmentsCourseEnrollmentCountArgs = {
  filters?: InputMaybe<CourseEnrollmentsFilters>;
};


/** Enrollments of the current user */
export type MeEnrollmentsCourseEnrollmentsArgs = {
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['MaxResultsPerPage']['input'];
};


/** Enrollments of the current user */
export type MeEnrollmentsCourseEnrollmentsForCourseIdsArgs = {
  courseIds: Array<Scalars['ID']['input']>;
};


/** Enrollments of the current user */
export type MeEnrollmentsCourseEnrollmentsPagedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CourseEnrollmentsFilters>;
  order?: Array<CourseEnrollmentsSortOrder>;
  pageSize?: Scalars['MaxResultsPerPage']['input'];
};

/** The available media source MIME types for video/audio streaming and playback. */
export enum MediaSourceType {
  /** MPEG-DASH streaming manifest (.mpd) */
  ApplicationDashXml = 'APPLICATION_DASH_XML',
  /** HLS streaming playlist (.m3u8) */
  ApplicationXMpegurl = 'APPLICATION_X_MPEGURL',
  /** MP3 audio file */
  AudioMp3 = 'AUDIO_MP3',
  /** MP4 video file (progressive download) */
  VideoMp4 = 'VIDEO_MP4'
}

/** Represents a key-value pair in metadata. */
export type MetadataEntry = {
  __typename?: 'MetadataEntry';
  /** The key for the metadata entry, describing the type of information (e.g., 'ROLE'). */
  key: Scalars['String']['output'];
  /** The value for the metadata entry, containing the actual data associated with the key. */
  value: Scalars['String']['output'];
};

/** Money */
export type Money = {
  __typename?: 'Money';
  /** Amount */
  amount?: Maybe<Scalars['Decimal']['output']>;
  /** Currency */
  currency?: Maybe<CurrencyCode>;
};

/** Money input */
export type MoneyInput = {
  /** Amount */
  amount: Scalars['Decimal']['input'];
  /** Currency */
  currency: CurrencyCode;
};

/** Price option for computed price plan. Will be returned for monthly plans */
export type MonthlySubscriptionPlanPricingOption = {
  __typename?: 'MonthlySubscriptionPlanPricingOption';
  /** Contains information about the discount context for a given subscription plan price option */
  discount?: Maybe<SubscriptionPlanDiscount>;
  /** Field containing details about the discounted trial subscription offer for a given user. Null indicates no trial is available */
  discountTrial?: Maybe<SubscriptionTrial>;
  /** ID of the price option: */
  id: Scalars['ID']['output'];
  /** Contains information about the license context for a given subscription plan price option */
  licenseContext?: Maybe<SubscriptionPlanLicenseContext>;
  /** The list price of the subscription price plan based on provided requested count from request */
  listPrice: Money;
  /** Field showing the prices for the option. */
  price?: Maybe<SubscriptionPlanPrice>;
  /** Interval for renewing the subscription plan ie the length of the subscription plan */
  renewalInterval: DateInterval;
  /** Field containing details about the trial subscription offer for a given user. Null indicates no trial is available */
  trial?: Maybe<SubscriptionTrial>;
};

/** Input for querying more RecommendationContextSections from a RecommendationContext */
export type MoreRecommendationContextSectionsInput = {
  /** The 'sectionsCursor' field in the RecommendationContext */
  cursor: Scalars['String']['input'];
  /** Requested number of sections to fetch. The result might have less sections */
  requestedSectionCount?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/** Response returned when more RecommendationContextSections are queried for a RecommendationContext */
export type MoreRecommendationContextSectionsResponse = {
  __typename?: 'MoreRecommendationContextSectionsResponse';
  /**
   * A slice of RecommendationContextSections available in a RecommendationContext. Slice boundaries are determined by the
   * cursor and count parameters in the query.
   */
  sections: Array<RecommendationContextSection>;
  /** Cursor to get more RecommendationContextSections from the RecommendationContext. Null, if there is no more. */
  sectionsCursor?: Maybe<Scalars['String']['output']>;
};

/** Input for querying more RecommendationItems from a RecommendationUnit */
export type MoreRecommendationItemsInput = {
  /** The 'itemsCursor' field in the RecommendationUnit */
  cursor: Scalars['String']['input'];
  /** Requested number of items to fetch. The result might have less items. */
  requestedItemCount?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/** Response returned when more RecommendationItems are queried for a RecommendationUnit */
export type MoreRecommendationItemsResponse = {
  __typename?: 'MoreRecommendationItemsResponse';
  /**
   * A slice of RecommendationItems available in a RecommendationUnit. Slice boundaries are determined by the
   * cursor and count parameters in the query.
   */
  items: Array<RecommendationItem>;
  /** Cursor to get more RecommendationItems from this RecommendationUnit. Null, if there is no more. */
  itemsCursor?: Maybe<Scalars['String']['output']>;
};

/** Multi-select question. Several available options, with one or more correct answer options. */
export type MultiSelectQuizItem = QuizItem & {
  __typename?: 'MultiSelectQuizItem';
  /** Correct options for the multi-select item */
  correctOptions: Array<QuizItemOption>;
  /** Explanation of the item */
  explanation: Scalars['String']['output'];
  /** ID of the item */
  id: Scalars['ID']['output'];
  /** Options for the item */
  options: Array<QuizItemOption>;
  /** Related lectures */
  relatedLectures: Array<Lecture>;
  /** Question text */
  text: Scalars['String']['output'];
};

/** Represents multiple choice quiz context */
export type MultipleChoiceQuizContextInput = {
  /** The choice selected by user */
  choice?: InputMaybe<Scalars['String']['input']>;
  /** Whether the selected choice is correct */
  isChoiceCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  /** The quiz id */
  quizId: Scalars['ID']['input'];
};

/** Multiple-choice question. Several available options, with one and only one correct answer. */
export type MultipleChoiceQuizItem = QuizItem & {
  __typename?: 'MultipleChoiceQuizItem';
  /** Correct option for the multiple choice item */
  correctOption: QuizItemOption;
  /** Explanation of the item */
  explanation: Scalars['String']['output'];
  /** ID of the item */
  id: Scalars['ID']['output'];
  /** Options for the item */
  options: Array<QuizItemOption>;
  /** Related lectures */
  relatedLectures: Array<Lecture>;
  /** Question text */
  text: Scalars['String']['output'];
};

/** Root mutation from which every mutation schema extends */
export type Mutation = {
  __typename?: 'Mutation';
  /** Create an API client for an organization or partner */
  apiClientCreate?: Maybe<ApiClientCreateResponse>;
  /** Delete an API client for an organization or partner, returns the deleted API Client ID */
  apiClientDelete?: Maybe<ApiClientDeleteResponse>;
  /** Start an assessment */
  assessmentAttemptCreate?: Maybe<AssessmentAttempt>;
  /** Submit an attempt of an assessment item */
  assessmentItemAttemptSubmit?: Maybe<AssessmentAttempt>;
  /** Revoke a previously submitted assessment item feedback */
  assessmentItemFeedbackRevoke?: Maybe<Scalars['Boolean']['output']>;
  /** Send item feedback for an assessment item */
  assessmentItemFeedbackSubmit?: Maybe<AssessmentItemFeedback>;
  /** Delete assertion of current user with given id */
  badgeAssertionDelete?: Maybe<BadgeAssertionDeleteResponse>;
  /** Storing the badge assertion URL and corresponding image path, retrieved from the Udemy uploader, for the current user. */
  badgeAssertionStoreByUrl?: Maybe<BadgeAssertionCreateOrUpdateResponse>;
  /** Register a badge issuer for user's organization (Requires UB Admin privileges) */
  badgeClassIssuerRegister?: Maybe<BadgeClassIssuerRegisterResponse>;
  /**
   * Update an existing badge class issuer for user's organization (Requires UB Admin privileges).
   * This is an overwrite endpoint that will perform a full update.
   */
  badgeClassIssuerUpdate?: Maybe<BadgeClassIssuerRegisterResponse>;
  /** Update a badge class topic (only available for applications with admin:application scope) */
  badgeClassUpdateTopic?: Maybe<BadgeClassUpdateResponse>;
  /** Update a badge class visibilityStatus (only available for applications with admin:application scope) */
  badgeClassUpdateVisibilityStatus?: Maybe<BadgeClassUpdateResponse>;
  /** Reveal a voucher code */
  certificationVoucherCodeReveal: Scalars['String']['output'];
  /** Add items in a content collection */
  contentCollectionAddItems?: Maybe<ContentCollectionCreateOrUpdateResponse>;
  /** Add learning products to multiple content collections in bulk. */
  contentCollectionBulkAddItems?: Maybe<ContentCollectionBulkItemsResponse>;
  /** Remove learning products from multiple content collections in bulk. */
  contentCollectionBulkRemoveItems?: Maybe<ContentCollectionBulkItemsResponse>;
  /** Remove items from a content collection */
  contentCollectionRemoveItems?: Maybe<ContentCollectionCreateOrUpdateResponse>;
  /** Create a course copy request to copy a course with specified arguments */
  courseCopyRequestCreate?: Maybe<CourseCopyRequestCreateOrUpdateResponse>;
  /** Submit course copy request and start copy tasks, request must be a draft before submitting */
  courseCopyRequestSubmit?: Maybe<CourseCopyRequestCreateOrUpdateResponse>;
  /** Update course copy request arguments for copy tasks, request must be a draft */
  courseCopyRequestUpdateArguments?: Maybe<CourseCopyRequestCreateOrUpdateResponse>;
  /** Creates a snapshot of a course's head version with an optional comment */
  courseSnapshotCreate?: Maybe<CourseSnapshotCreateResponse>;
  /** Create a new Course Variation Aggregation */
  courseVariationAggregationCreate?: Maybe<CourseVariationAggregationCreateOrUpdateResponse>;
  /** Delete a Course Variation Aggregation */
  courseVariationAggregationDelete?: Maybe<CourseVariationAggregationDeleteResponse>;
  /** Update an existing Course Variation Aggregation */
  courseVariationAggregationUpdate?: Maybe<CourseVariationAggregationCreateOrUpdateResponse>;
  /** Archives current user's enrollment to learning product */
  enrollmentArchive?: Maybe<EnrollmentArchiveResponse>;
  /** Enrolls current user to learning product */
  enrollmentCreate?: Maybe<EnrollmentCreateResponse>;
  /** Unenrolls current user from learning product */
  enrollmentDelete?: Maybe<Scalars['Boolean']['output']>;
  /** Unarchives current user's enrollment to learning product */
  enrollmentUnarchive?: Maybe<EnrollmentUnarchiveResponse>;
  /** Create a feedback */
  feedbackCreate?: Maybe<FeedbackCreateResponse>;
  /** Link an opportunity to a course */
  instructorContentOpportunityLinkCourse?: Maybe<InstructorContentOpportunityLinkCourseResponse>;
  /** Unlink an opportunity from a course */
  instructorContentOpportunityUnlinkCourse?: Maybe<InstructorContentOpportunityUnlinkCourseResponse>;
  /** Finalize an asset upload after the file has been uploaded to the presigned URL */
  interactionWidgetAssetUploadEnd?: Maybe<InteractionWidgetAsset>;
  /** Start an asset upload and receive a presigned upload URL */
  interactionWidgetAssetUploadStart?: Maybe<InteractionWidgetAssetUploadStartResponse>;
  /** Create a new definition for a release */
  interactionWidgetDefinitionCreate?: Maybe<InteractionWidgetDefinition>;
  /** Soft-delete a definition */
  interactionWidgetDefinitionDelete?: Maybe<InteractionWidgetDefinition>;
  /** Partially update a definition — only provided fields are modified */
  interactionWidgetDefinitionUpdate?: Maybe<InteractionWidgetDefinition>;
  /** Create a new release for an interaction type */
  interactionWidgetReleaseCreate?: Maybe<InteractionWidgetRelease>;
  /** Soft-delete a release */
  interactionWidgetReleaseDelete?: Maybe<InteractionWidgetRelease>;
  /** Fork a release (creates a copy owned by the caller) */
  interactionWidgetReleaseFork?: Maybe<InteractionWidgetRelease>;
  /** Partially update a release — only provided fields are modified */
  interactionWidgetReleaseUpdate?: Maybe<InteractionWidgetRelease>;
  /** Validate a definition against the release's constraints */
  interactionWidgetReleaseValidate?: Maybe<Scalars['Boolean']['output']>;
  /** Create a new session */
  interactionWidgetSessionCreate?: Maybe<InteractionWidgetSession>;
  /** Partially update a session — only provided fields are modified */
  interactionWidgetSessionUpdate?: Maybe<InteractionWidgetSession>;
  /** Create a new interaction type */
  interactionWidgetTypeCreate?: Maybe<InteractionWidgetType>;
  /** Soft-delete an interaction type */
  interactionWidgetTypeDelete?: Maybe<InteractionWidgetType>;
  /** Fork an interaction type (creates a copy owned by the caller) */
  interactionWidgetTypeFork?: Maybe<InteractionWidgetType>;
  /** Partially update an interaction type — only provided fields are modified */
  interactionWidgetTypeUpdate?: Maybe<InteractionWidgetType>;
  /** Issue badges by uploading a CSV with badge and recipient details */
  issueBadgesByCsvUpload: BadgeIssuanceCsvUploadResponse;
  /**
   * Allows the learner to self-report their currentProficiency for a specific skill.
   * This is a global profile update (not scoped to any goal), but will affect the
   * calculated skills gap (desiredProficiency - currentProficiency) for any goals
   * containing this skill.
   * Routed to: Learner Profile Service.
   */
  learnerSkillProficiencyUpdate: LearnerSkillProficiencyUpdateResponse;
  /** Submit a chat feedback form */
  learningAssistantChatFeedbackFormSubmit?: Maybe<LearningAssistantChatFeedbackSubmitResponse>;
  /** Submit a chat feedback */
  learningAssistantChatFeedbackSubmit?: Maybe<LearningAssistantChatFeedbackSubmitResponse>;
  /** Initiate a chat session */
  learningAssistantChatInitiate?: Maybe<LearningAssistantChatInitiateResponse>;
  /** Initiate a generic chat session with dynamic configuration */
  learningAssistantChatInitiateGeneric?: Maybe<LearningAssistantChatInitiateResponse>;
  /** Initiate a chat session with course id */
  learningAssistantChatInitiateWithCourse?: Maybe<LearningAssistantChatInitiateResponse>;
  /** Initiate a chat session with course id and role play id */
  learningAssistantChatInitiateWithCourseAndRolePlay?: Maybe<LearningAssistantChatInitiateResponse>;
  /** Send chat interaction from a client to an existing chat session from the Learning Assistant */
  learningAssistantChatInteraction?: Maybe<LearningAssistantChatInteractionResponse>;
  /** Send an audio chat message */
  learningAssistantChatMessageAudioSend?: Maybe<LearningAssistantChatMessageSendResponse>;
  /** Send an in course chat message */
  learningAssistantChatMessageSendForCourse?: Maybe<LearningAssistantChatMessageSendResponse>;
  /** Send a chat message */
  learningAssistantChatMessageTextSend?: Maybe<LearningAssistantChatMessageSendResponse>;
  /** Terminate the chat session */
  learningAssistantChatTerminate?: Maybe<LearningAssistantChatTerminateResponse>;
  /** Presigned URL for uploading a new file to cloud storage via PUT */
  learningAssistantCreatePresignedUrls: LearningAssistantFileUploadUrlResponse;
  /** Update mapped content status for list of mapped content in a Skills Framework */
  learningObjectiveUpdateActivities?: Maybe<LearningObjectiveUpdateResponse>;
  /** Create a learning path from skills framework */
  learningPathCreateFromSkillsFramework?: Maybe<LearningPathCreateResponse>;
  /** Approves existing learning product access requests */
  learningProductAccessRequestApprove: LearningProductAccessRequestApproveResponse;
  /** Creates a new learning product access request */
  learningProductAccessRequestCreate?: Maybe<LearningProductAccessRequestCreateResponse>;
  /** Rejects existing learning product access requests */
  learningProductAccessRequestReject: LearningProductAccessRequestRejectResponse;
  /** Create a learning reminder */
  learningReminderCreate?: Maybe<LearningReminderCreateOrUpdateResponse>;
  /** Delete the learning reminder */
  learningReminderDelete?: Maybe<LearningReminderDeleteResponse>;
  /** Update the learning reminder */
  learningReminderUpdate?: Maybe<LearningReminderCreateOrUpdateResponse>;
  /** Adds inviter to the given license pool */
  licensePoolAddInviter?: Maybe<LicensePoolCreateOrUpdateResponse>;
  /** Create a license pool entity */
  licensePoolCreate?: Maybe<LicensePoolCreateOrUpdateResponse>;
  /** Delete a license pool entity */
  licensePoolDelete?: Maybe<LicensePoolDeleteResponse>;
  /** Remove inviter from the given license pool */
  licensePoolRemoveInviter?: Maybe<LicensePoolCreateOrUpdateResponse>;
  /** Update a license pool entity */
  licensePoolUpdate?: Maybe<LicensePoolCreateOrUpdateResponse>;
  /** Preview of the impact to license pools if targe License Pool was to be updated */
  licensePoolUpdatePreview?: Maybe<LicensePoolUpdatePreviewResponse>;
  /** Moves users from their respective license pools to a target license pool */
  licensePoolUsersMove?: Maybe<LicensePoolUsersMoveResponse>;
  /** Assign existing occupation to the user */
  occupationAssign?: Maybe<UserOccupationInfoUpdateResponse>;
  /** Assign existing occupation group to the user */
  occupationGroupAssign?: Maybe<UserOccupationInfoUpdateResponse>;
  /** Assign new occupation string to the user */
  occupationRawAssign?: Maybe<UserOccupationInfoUpdateResponse>;
  /** Assign management status to the user. */
  occupationUpdateIsManager?: Maybe<UserOccupationInfoUpdateResponse>;
  /** Create a new organization badge class */
  organizationBadgeClassCreate?: Maybe<OrganizationBadgeClassCreateResponse>;
  /** Delete an organization badge class if it is in draft status */
  organizationBadgeClassDelete?: Maybe<OrganizationBadgeClassDeleteResponse>;
  /** Update an existing organization badge class */
  organizationBadgeClassUpdate?: Maybe<OrganizationBadgeClassUpdateResponse>;
  /** Update the status of an existing organization badge class */
  organizationBadgeClassUpdateStatus?: Maybe<OrganizationBadgeClassUpdateResponse>;
  /** Create an Organization */
  organizationCreate?: Maybe<OrganizationCreateResponse>;
  /** Create a new organization learning goal. */
  organizationLearningGoalCreate?: Maybe<OrganizationLearningGoalCreateResponse>;
  /** Deactivates an existing active organization learning goal. */
  organizationLearningGoalDeactivate?: Maybe<OrganizationLearningGoalDeactivateResponse>;
  /** Updates given notification preferences of organization */
  organizationNotificationPreferencesUpdate?: Maybe<OrganizationNotificationPreferencesUpdateResponse>;
  /** Override settings for an organization */
  organizationSettingSetOverride?: Maybe<OrganizationSettingSetOverrideResponse>;
  /** Adding the new subscription to Organization */
  organizationSubscriptionCreate?: Maybe<OrganizationSubscriptionCreateResponse>;
  /** Complete a quiz attempt */
  quizAttemptComplete?: Maybe<QuizAttempt>;
  /** Start a quiz attempt */
  quizAttemptStart?: Maybe<QuizAttempt>;
  /** Submit an answer for a quiz item */
  quizItemResponseSubmit?: Maybe<QuizItemResponse>;
  /** Manually mark a quiz as complete */
  quizMarkComplete?: Maybe<Scalars['Boolean']['output']>;
  /** Manually mark a quiz as incomplete */
  quizMarkUncomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Create a new scheduled report */
  scheduledReportJobCreate?: Maybe<ScheduledReportJobResponse>;
  /** Activate a skills framework */
  skillsFrameworkActivateById?: Maybe<SkillsFrameworkUpdateResponse>;
  /** Map content to skills framework */
  skillsFrameworkMapContent?: Maybe<SkillsFrameworkMapContentResponse>;
  /** Publish skills framework to make it immutable */
  skillsFrameworkPublishById?: Maybe<SkillsFrameworkUpdateResponse>;
  /** Save a skills framework */
  skillsFrameworkUpdate?: Maybe<SkillsFrameworkUpdateResponse>;
  /** End a Skills Preparation */
  skillsPrepEnd?: Maybe<SkillsPrep>;
  /** Restart a Skills Preparation */
  skillsPrepRestart?: Maybe<SkillsPrep>;
  /** Start a Skills Preparation */
  skillsPrepStart?: Maybe<SkillsPrep>;
  /** Update a Skills Preparation to use the latest version of the skills framework */
  skillsPrepUpgrade?: Maybe<SkillsPrep>;
  /**
   * This mutation is used when a user wants to cancel a subscription.
   *
   * Preconditions:
   * - The status of the subscription enrollment is either ACTIVE or TRIAL.
   * - The product type of the subscription enrollment is either 'Consumer Subscription' or 'Team Plan'.
   * - The user must be authorized on that subscription. Being authorized means either:
   * - Product type is 'Consumer Subscription' and the user is the subscriber of the subscription enrollment.
   * - Product type is 'Team Plan' and the user is an admin for the subscriber organization.
   *
   * If the criteria above are met, the subscription will be canceled and the new SubscriptionEnrollment data will be
   * returned. As a result of the cancellation:
   * - There won't be any future charges. There will not be any refund for earlier charges.
   * - The user will see the subscription status as CANCELED immediately. However, the content will remain accessible
   * until the end of the existing billing period.
   * - The user may revert this cancellation until the end of the current billing period. (See the mutation named
   * 'subscriptionEnrollmentReactivate')
   * - At the end of the current billing period, the status will become EXPIRED and the content will become inaccessible.
   */
  subscriptionEnrollmentCancel?: Maybe<SubscriptionEnrollmentUpdateResponse>;
  /**
   * This mutation is used when a user wants to revert a previous cancellation operation done by the mutation named
   * 'subscriptionEnrollmentCancel'.
   *
   * Preconditions:
   * - The status of the subscription enrollment is CANCELED.
   * - The product type of the subscription enrollment is either 'Consumer Subscription' or 'Team Plan'.
   * - The user must be authorized on that subscription. Being authorized means either:
   * - Product type is 'Consumer Subscription' and the user is the subscriber of the subscription enrollment.
   * - Product type is 'Team Plan' and the user is an admin for the subscriber organization.
   *
   * If the criteria above are met, the previous cancellation will be reverted and the new SubscriptionEnrollment data
   * will be returned. As a result of the reactivation:
   * - Future charges will be scheduled again according to the initial plan.
   * - The user will be able to see the new subscription status immediately. The new status will be:
   * - TRIAL, unless the trial period has ended
   * - ACTIVE, if the trial period has ended
   */
  subscriptionEnrollmentReactivate?: Maybe<SubscriptionEnrollmentUpdateResponse>;
  /** Override subscription feature values for the given organization or user (only available for applications with admin:application scope) */
  subscriptionFeaturesSetOverrides?: Maybe<SubscriptionFeaturesSetOverrideResponse>;
  /** Assign a user's topic interest */
  topicInterestAssign?: Maybe<TopicInterestUpdateResponse>;
  /** Un-assign a user's topic interest */
  topicInterestUnassign?: Maybe<TopicInterestUpdateResponse>;
  /**
   * Mark a task as complete. The backend validates whether this task
   * is manually completable — if not, it returns an error. Idempotent.
   */
  userChecklistTaskComplete?: Maybe<UserChecklistTaskMutationResponse>;
  /**
   * Save which page the user last viewed in a multi-page task.
   * The backend validates whether this task supports pages.
   */
  userChecklistTaskUpdateLastViewedPage?: Maybe<UserChecklistTaskMutationResponse>;
  /** Updates users notification preferences */
  userNotificationPreferencesUpdate?: Maybe<UserNotificationPreferencesUpdateResponse>;
};


/** Root mutation from which every mutation schema extends */
export type MutationApiClientCreateArgs = {
  apiClient: ApiClientInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationApiClientDeleteArgs = {
  clientId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationAssessmentAttemptCreateArgs = {
  assessmentId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationAssessmentItemAttemptSubmitArgs = {
  assessmentItemAttemptInput: AssessmentItemAttemptInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationAssessmentItemFeedbackRevokeArgs = {
  feedbackId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationAssessmentItemFeedbackSubmitArgs = {
  input: AssessmentItemFeedbackInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationBadgeAssertionDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationBadgeAssertionStoreByUrlArgs = {
  badgeAssertionImagePath?: InputMaybe<Scalars['String']['input']>;
  externalUrl: Scalars['URL']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationBadgeClassIssuerRegisterArgs = {
  badgeClassIssuerRegisterInput?: InputMaybe<BadgeClassIssuerRegisterInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationBadgeClassIssuerUpdateArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<BadgeClassIssuerRegisterInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationBadgeClassUpdateTopicArgs = {
  input: BadgeClassUpdateTopicInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationBadgeClassUpdateVisibilityStatusArgs = {
  input: BadgeClassUpdateVisibilityStatusInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationCertificationVoucherCodeRevealArgs = {
  id: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationContentCollectionAddItemsArgs = {
  collectionId: Scalars['ID']['input'];
  itemsToAdd: Array<ContentCollectionItemAddOrRemoveInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationContentCollectionBulkAddItemsArgs = {
  collectionIds: Array<Scalars['ID']['input']>;
  items: Array<ContentCollectionItemAddOrRemoveInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationContentCollectionBulkRemoveItemsArgs = {
  collectionIds: Array<Scalars['ID']['input']>;
  items: Array<ContentCollectionItemAddOrRemoveInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationContentCollectionRemoveItemsArgs = {
  collectionId: Scalars['ID']['input'];
  itemsToRemove: Array<ContentCollectionItemAddOrRemoveInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationCourseCopyRequestCreateArgs = {
  arguments?: InputMaybe<Scalars['JSON']['input']>;
  originalCourseId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationCourseCopyRequestSubmitArgs = {
  id: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationCourseCopyRequestUpdateArgumentsArgs = {
  arguments?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationCourseSnapshotCreateArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  courseId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationCourseVariationAggregationCreateArgs = {
  aggregation: CourseVariationAggregationInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationCourseVariationAggregationDeleteArgs = {
  aggregationId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationCourseVariationAggregationUpdateArgs = {
  aggregation?: InputMaybe<CourseVariationAggregationInput>;
  aggregationId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationEnrollmentArchiveArgs = {
  learningProduct: EnrollmentsLearningProductInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationEnrollmentCreateArgs = {
  learningProduct: EnrollmentsLearningProductInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationEnrollmentDeleteArgs = {
  learningProduct: EnrollmentsLearningProductInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationEnrollmentUnarchiveArgs = {
  learningProduct: EnrollmentsLearningProductInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationFeedbackCreateArgs = {
  feedbackCreateInput: FeedbackCreateInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationInstructorContentOpportunityLinkCourseArgs = {
  link: CourseInstructorContentOpportunityLink;
};


/** Root mutation from which every mutation schema extends */
export type MutationInstructorContentOpportunityUnlinkCourseArgs = {
  link: CourseInstructorContentOpportunityLink;
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetAssetUploadEndArgs = {
  input: InteractionWidgetAssetUploadEndInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetAssetUploadStartArgs = {
  input: InteractionWidgetAssetUploadStartInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetDefinitionCreateArgs = {
  input: InteractionWidgetDefinitionCreateInput;
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetDefinitionDeleteArgs = {
  definitionId: Scalars['ID']['input'];
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetDefinitionUpdateArgs = {
  definitionId: Scalars['ID']['input'];
  input: InteractionWidgetDefinitionUpdateInput;
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetReleaseCreateArgs = {
  input: InteractionWidgetReleaseCreateInput;
  typeId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetReleaseDeleteArgs = {
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetReleaseForkArgs = {
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetReleaseUpdateArgs = {
  input: InteractionWidgetReleaseUpdateInput;
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetReleaseValidateArgs = {
  definition?: InputMaybe<Scalars['JSON']['input']>;
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
  useLatestCompatibleAssets?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetSessionCreateArgs = {
  input: InteractionWidgetSessionCreateInput;
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetSessionUpdateArgs = {
  input: InteractionWidgetSessionUpdateInput;
  releaseId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetTypeCreateArgs = {
  input: InteractionWidgetTypeCreateInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetTypeForkArgs = {
  id: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationInteractionWidgetTypeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: InteractionWidgetTypeUpdateInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationIssueBadgesByCsvUploadArgs = {
  csvPath: Scalars['String']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLearnerSkillProficiencyUpdateArgs = {
  newProficiency: ProficiencyLevel;
  skillsFrameworkId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantChatFeedbackFormSubmitArgs = {
  chatFeedbackFormSubmitInput: LearningAssistantChatFeedbackFormSubmitInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantChatFeedbackSubmitArgs = {
  chatFeedbackSubmitInput: LearningAssistantChatFeedbackSubmitInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantChatInitiateArgs = {
  name: LearningAssistantChatName;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantChatInitiateGenericArgs = {
  name: Scalars['String']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantChatInitiateWithCourseArgs = {
  courseId: Scalars['ID']['input'];
  name: LearningAssistantChatName;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantChatInitiateWithCourseAndRolePlayArgs = {
  courseId: Scalars['ID']['input'];
  name: LearningAssistantChatName;
  rolePlayId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantChatInteractionArgs = {
  chatId: Scalars['ID']['input'];
  chatInteractions: Array<LearningAssistantChatInteractionInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantChatMessageAudioSendArgs = {
  chatId: Scalars['ID']['input'];
  message: LearningAssistantChatAudioMessageInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantChatMessageSendForCourseArgs = {
  chatId: Scalars['ID']['input'];
  context: LearningAssistantChatContextInputForCourse;
  message: LearningAssistantChatTextMessageInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantChatMessageTextSendArgs = {
  chatId: Scalars['ID']['input'];
  message: LearningAssistantChatTextMessageInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantChatTerminateArgs = {
  chatId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningAssistantCreatePresignedUrlsArgs = {
  chatId: Scalars['ID']['input'];
  files: Array<LearningAssistantCreatePresignedUrlInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningObjectiveUpdateActivitiesArgs = {
  activities: Array<LearningObjectiveActivityInput>;
  alternativeActivities: Array<LearningObjectiveActivityInput>;
  learningObjectiveId: Scalars['ID']['input'];
  skillsFrameworkIdInput: SkillsFrameworkIdInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningPathCreateFromSkillsFrameworkArgs = {
  skillsFrameworkIdInput: SkillsFrameworkIdInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningProductAccessRequestApproveArgs = {
  requestIds: Array<Scalars['ID']['input']>;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningProductAccessRequestCreateArgs = {
  learningProduct: LearningProductInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningProductAccessRequestRejectArgs = {
  requestIds: Array<Scalars['ID']['input']>;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningReminderCreateArgs = {
  learningReminder: LearningReminderInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningReminderDeleteArgs = {
  learningReminderId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLearningReminderUpdateArgs = {
  learningReminder: LearningReminderInput;
  learningReminderId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLicensePoolAddInviterArgs = {
  licensePoolId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLicensePoolCreateArgs = {
  licensePool: LicensePoolInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationLicensePoolDeleteArgs = {
  licensePoolId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLicensePoolRemoveInviterArgs = {
  licensePoolId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLicensePoolUpdateArgs = {
  licensePool: LicensePoolInput;
  licensePoolId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLicensePoolUpdatePreviewArgs = {
  licensePool: LicensePoolInput;
  licensePoolId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationLicensePoolUsersMoveArgs = {
  targetLicensePoolId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


/** Root mutation from which every mutation schema extends */
export type MutationOccupationAssignArgs = {
  occupationAssignment?: InputMaybe<OccupationAssignmentInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationOccupationGroupAssignArgs = {
  occupationGroupAssignment?: InputMaybe<OccupationGroupAssignmentInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationOccupationRawAssignArgs = {
  occupationAssignment?: InputMaybe<OccupationRawAssignmentInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationOccupationUpdateIsManagerArgs = {
  isManager: Scalars['Boolean']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationOrganizationBadgeClassCreateArgs = {
  input: OrganizationBadgeClassInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationOrganizationBadgeClassDeleteArgs = {
  id: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationOrganizationBadgeClassUpdateArgs = {
  id: Scalars['ID']['input'];
  input: OrganizationBadgeClassInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationOrganizationBadgeClassUpdateStatusArgs = {
  id: Scalars['ID']['input'];
  status: OrganizationBadgeStatus;
};


/** Root mutation from which every mutation schema extends */
export type MutationOrganizationCreateArgs = {
  input: OrganizationCreateInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationOrganizationLearningGoalCreateArgs = {
  input: OrganizationLearningGoalCreateInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationOrganizationLearningGoalDeactivateArgs = {
  id: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationOrganizationNotificationPreferencesUpdateArgs = {
  organizationPreferences: OrganizationNotificationPreferenceSetInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationOrganizationSettingSetOverrideArgs = {
  input: OrganizationSettingSetOverrideInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationOrganizationSubscriptionCreateArgs = {
  organizationSubscriptionDetails: OrganizationSubscriptionCreateInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationQuizAttemptCompleteArgs = {
  quizAttemptId: Scalars['ID']['input'];
  quizId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationQuizAttemptStartArgs = {
  quizId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationQuizItemResponseSubmitArgs = {
  itemResponse?: InputMaybe<QuizItemResponseSubmitInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationQuizMarkCompleteArgs = {
  quizId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationQuizMarkUncompleteArgs = {
  quizId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationScheduledReportJobCreateArgs = {
  input: ScheduledReportJobInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationSkillsFrameworkActivateByIdArgs = {
  skillsFrameworkIdInput: SkillsFrameworkIdInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationSkillsFrameworkMapContentArgs = {
  skillsFrameworkIdInput: SkillsFrameworkIdInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationSkillsFrameworkPublishByIdArgs = {
  skillsFrameworkIdInput: SkillsFrameworkIdInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationSkillsFrameworkUpdateArgs = {
  entityTag: Scalars['Int']['input'];
  skillsFramework: SkillsFrameworkInput;
  skillsFrameworkIdInput: SkillsFrameworkIdInput;
};


/** Root mutation from which every mutation schema extends */
export type MutationSkillsPrepEndArgs = {
  goalId: Scalars['ID']['input'];
  goalType: SkillsFrameworkGoalType;
  status: SkillsPrepStatus;
  userId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationSkillsPrepRestartArgs = {
  goalId: Scalars['ID']['input'];
  goalType: SkillsFrameworkGoalType;
  userId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationSkillsPrepStartArgs = {
  goalId: Scalars['ID']['input'];
  goalType: SkillsFrameworkGoalType;
  userId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationSkillsPrepUpgradeArgs = {
  goalId: Scalars['ID']['input'];
  goalType: SkillsFrameworkGoalType;
  userId: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationSubscriptionEnrollmentCancelArgs = {
  id: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationSubscriptionEnrollmentReactivateArgs = {
  id: Scalars['ID']['input'];
};


/** Root mutation from which every mutation schema extends */
export type MutationSubscriptionFeaturesSetOverridesArgs = {
  overrides: Array<SubscriptionFeatureOverrideInput>;
};


/** Root mutation from which every mutation schema extends */
export type MutationTopicInterestAssignArgs = {
  topicIds: Array<Scalars['ID']['input']>;
};


/** Root mutation from which every mutation schema extends */
export type MutationTopicInterestUnassignArgs = {
  topicIds: Array<Scalars['ID']['input']>;
};


/** Root mutation from which every mutation schema extends */
export type MutationUserChecklistTaskCompleteArgs = {
  checklistName: UserChecklistName;
  taskName: UserChecklistTaskName;
};


/** Root mutation from which every mutation schema extends */
export type MutationUserChecklistTaskUpdateLastViewedPageArgs = {
  checklistName: UserChecklistName;
  lastViewedPageNumber: Scalars['NonNegativeInt']['input'];
  taskName: UserChecklistTaskName;
};


/** Root mutation from which every mutation schema extends */
export type MutationUserNotificationPreferencesUpdateArgs = {
  userNotificationPreferencesInput: UserNotificationPreferenceSetInput;
};

/** Item in navigation list. */
export type NavListItem = {
  /** List of child navigation items. */
  children: Array<Maybe<NavListItem>>;
};

/** Identifies the name of the navigation list. */
export enum NavListName {
  /** The navigation tabs seen on category and subcategory landing pages. */
  LinkBar = 'LINK_BAR',
  /** The main navigation list seen in explore menu */
  Main = 'MAIN'
}

/** Represents a badge awarded to a new learning product. */
export type NewBadge = LearningProductBadge & {
  __typename?: 'NewBadge';
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
};

/** Details of Occupation */
export type Occupation = {
  __typename?: 'Occupation';
  /** ID of the occupation instance */
  id: Scalars['ID']['output'];
  /** Name of the occupation */
  name: Scalars['String']['output'];
  /** Representative Topic */
  representativeTopic?: Maybe<Topic>;
  /** URL of the landing page, can be null if no landing page such as OLP exists */
  urlLandingPage?: Maybe<Scalars['URL']['output']>;
};

/** User is assigning occupation to themself */
export type OccupationAssignmentInput = {
  /** ID of the occupation */
  occupationId: Scalars['ID']['input'];
};

/** Occupation group type */
export type OccupationGroup = {
  __typename?: 'OccupationGroup';
  /** ID of the occupation group */
  id: Scalars['ID']['output'];
  /** Name of the occupation group */
  name: Scalars['String']['output'];
};

/** Current user assigning existing occupation group. */
export type OccupationGroupAssignmentInput = {
  /** ID of the occupation group */
  occupationGroupId: Scalars['ID']['input'];
};

/** Shows page search results of occupation */
export type OccupationPaged = Paginated & {
  __typename?: 'OccupationPaged';
  /** Occupation groups. Items may be less than requested size if objects become unavailable */
  items: Array<Occupation>;
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages. Calculated as (total result count / page size) */
  pageCount: Scalars['Int']['output'];
};

/** Current user assigning user provided occupation. */
export type OccupationRawAssignmentInput = {
  /** Raw user provided string to represent the current user's occupation. */
  userProvidedOccupation: Scalars['String']['input'];
};

/** A wrapper type to include the recommended Occupation and some additional fields about its recommendation */
export type OccupationRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'OccupationRecommendation';
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /** Underlying object of the recommendation to get more information about it */
  occupation?: Maybe<Occupation>;
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** Filters for occupation search */
export type OccupationSearchFilters = {
  /** Include occupations with the following group ids */
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The OpenBadgeClass object. This implements the BadgeClass. */
export type OpenBadgeClass = BadgeClass & LearningProduct & {
  __typename?: 'OpenBadgeClass';
  /** An object describing which objectives or educational standards this badge aligns to, if any. */
  alignment?: Maybe<Array<BadgeClassAlignment>>;
  /** User's assertions for the badge class */
  assertions: Array<BadgeAssertion>;
  /** Exam registration details, if an exam is required for earning this Badge */
  certificationExam?: Maybe<CertificationExam>;
  /** Criteria document describing how to earn the BadgeClass (Certification) */
  criteria: BadgeClassCriteria;
  /** A short description of BadgeClass */
  description: Scalars['String']['output'];
  /** User's enrollments for the badge class */
  enrollments: Array<BadgeClassEnrollment>;
  /** Links to exam registration page for this certification (deprecated) */
  examRegistrationUrls: Array<CertificationExamUrl>;
  /** IRI of the BadgeClass. IRI of OpenBadge specification */
  externalUrl: Scalars['URL']['output'];
  /** ID of the BadgeClass. */
  id: Scalars['ID']['output'];
  /** A PNG or SVG image of the BadgeClass */
  image: BadgeClassImage;
  /** Whether the current user is enrolled */
  isEnrolled: Scalars['Boolean']['output'];
  /** Organization that issued the badge. */
  issuer: BadgeClassIssuer;
  /** Name of the BadgeClass */
  name: Scalars['String']['output'];
  /** Certification Provider for this Badge Class */
  providers?: Maybe<Array<BadgeCertificationProvider>>;
  /** Subject Area (recently renamed to Skill Area) for this BadgeClass (i.e. Data Science, CyberSecurity) */
  subjectAreas?: Maybe<Array<BadgeCertificationSubjectArea>>;
  /** A tag that describes the type of achievement. (Skills) */
  tags: Array<Scalars['String']['output']>;
  /** Topic of badge class. Can be null for badge classes uploaded by users */
  topic?: Maybe<Topic>;
  /** Total number of assertions issued for this badge class */
  totalAssertionsCount: Scalars['Int']['output'];
  /** Type of the BadgeClass. In most cases, this will simply be the string BadgeClass */
  type: Array<Scalars['String']['output']>;
  /** Visibility of the badge class on the Udemy platform (only available for applications with admin:application scope) */
  visibilityStatus: BadgeClassVisibilityStatus;
};

/** A UB organization */
export type Organization = {
  __typename?: 'Organization';
  /** The UB organization's unique identifier */
  id: Scalars['ID']['output'];
  /** Images for an organization */
  images: OrganizationImages;
  /** Organization type */
  type: OrganizationType;
};

/** Represents an audit log entry for an organization. */
export type OrganizationAuditLog = {
  __typename?: 'OrganizationAuditLog';
  /** The actor who performed the action logged in this entry. */
  actor: Actor;
  /** The entity who was affected by the action logged in this entry. This is optional as some events may not have a directly associated entity. */
  entity?: Maybe<Entity>;
  /** The event that occurred (e.g., 'USER_CREATED'). */
  event: AuditEvent;
  /** Additional metadata associated with the event, as a list of key-value pairs. */
  metadata: Array<MetadataEntry>;
  /** The unique identifier for the organization associated with the audit log. */
  orgId: Scalars['ID']['output'];
  /** The timestamp for when the event occurred. */
  timestamp: Scalars['DateTime']['output'];
};

/** Input type for filtering organization logs. */
export type OrganizationAuditLogFilter = {
  /** The filter for the date time range. */
  dateRange?: InputMaybe<AuditLogDateFilter>;
};

/** Background images for an organization */
export type OrganizationBackgroundImages = {
  __typename?: 'OrganizationBackgroundImages';
  /** Background image size 960x540 */
  px960x540?: Maybe<Scalars['URL']['output']>;
  /** Background image size 1920x1080 */
  px1920x1080?: Maybe<Scalars['URL']['output']>;
};

/** The OrganizationBadgeClass object. This implements the BadgeClass. This has a few more issuer organization related fields. */
export type OrganizationBadgeClass = BadgeClass & LearningProduct & {
  __typename?: 'OrganizationBadgeClass';
  /** An object describing which objectives or educational standards this badge aligns to, if any. */
  alignment?: Maybe<Array<BadgeClassAlignment>>;
  /** User's assertions for the badge class */
  assertions: Array<BadgeAssertion>;
  /** Additional details of the organization badge */
  badgeDetails?: Maybe<OrganizationBadgeClassDetails>;
  /** Exam registration details, if an exam is required for earning this Badge */
  certificationExam?: Maybe<CertificationExam>;
  /** Criteria document describing how to earn the BadgeClass (Certification) */
  criteria: BadgeClassCriteria;
  /** A short description of BadgeClass */
  description: Scalars['String']['output'];
  /** List of earning criteria for the badge */
  earningCriteria: Array<OrganizationBadgeEarningCriteria>;
  /** User's enrollments for the badge class */
  enrollments: Array<BadgeClassEnrollment>;
  /** Links to exam registration page for this certification (deprecated) */
  examRegistrationUrls: Array<CertificationExamUrl>;
  /** IRI of the BadgeClass. IRI of OpenBadge specification */
  externalUrl: Scalars['URL']['output'];
  /** ID of the BadgeClass. */
  id: Scalars['ID']['output'];
  /** A PNG or SVG image of the BadgeClass */
  image: BadgeClassImage;
  /** Whether the current user is enrolled */
  isEnrolled: Scalars['Boolean']['output'];
  /** Organization that issued the badge. */
  issuer: BadgeClassIssuer;
  /** Last modified timestamp */
  lastModified: Scalars['Date']['output'];
  /** Name of the BadgeClass */
  name: Scalars['String']['output'];
  /** Certification Provider for this Badge Class */
  providers?: Maybe<Array<BadgeCertificationProvider>>;
  /** Status of the organization badge class */
  status: OrganizationBadgeStatus;
  /** Subject Area (recently renamed to Skill Area) for this BadgeClass (i.e. Data Science, CyberSecurity) */
  subjectAreas?: Maybe<Array<BadgeCertificationSubjectArea>>;
  /** A tag that describes the type of achievement. (Skills) */
  tags: Array<Scalars['String']['output']>;
  /** Topic of badge class. Can be null for badge classes uploaded by users */
  topic?: Maybe<Topic>;
  /** Total number of assertions issued for this badge class */
  totalAssertionsCount: Scalars['Int']['output'];
  /** Type of the BadgeClass. In most cases, this will simply be the string BadgeClass */
  type: Array<Scalars['String']['output']>;
  /** Visibility of the badge class on the Udemy platform (only available for applications with admin:application scope) */
  visibilityStatus: BadgeClassVisibilityStatus;
};

/** Response for creating a new organization badge class */
export type OrganizationBadgeClassCreateResponse = {
  __typename?: 'OrganizationBadgeClassCreateResponse';
  /** The OrganizationBadgeClass object created */
  badgeClass?: Maybe<OrganizationBadgeClass>;
};

/** Response for deleting an organization badge class */
export type OrganizationBadgeClassDeleteResponse = {
  __typename?: 'OrganizationBadgeClassDeleteResponse';
  /** The ID of the deleted badge class */
  id: Scalars['ID']['output'];
};

/** Additional details of the organization badge */
export type OrganizationBadgeClassDetails = {
  __typename?: 'OrganizationBadgeClassDetails';
  /** Whether the badge is for learning, validation or experience */
  badgeType?: Maybe<Scalars['String']['output']>;
  /** Foundational, Intermediate or Expert */
  level?: Maybe<Scalars['String']['output']>;
  /** Rough estimation of the time to earn the badge */
  timeToEarn?: Maybe<Scalars['String']['output']>;
};

/** Input for creating a new organization badge class */
export type OrganizationBadgeClassInput = {
  /** Alignment information for the badge */
  alignment?: InputMaybe<Array<BadgeClassAlignmentInput>>;
  /** Type of the badge */
  badgeType?: InputMaybe<Scalars['String']['input']>;
  /** Description of the badge */
  description: Scalars['String']['input'];
  /** List of criteria for earning the badge */
  earningCriteria: Array<OrganizationBadgeEarningCriteriaInput>;
  /** Image URL for the badge */
  imageUrl: Scalars['URL']['input'];
  /** Level of the badge */
  level?: InputMaybe<Scalars['String']['input']>;
  /** Name of the badge */
  name: Scalars['String']['input'];
  /** List of tags for the badge */
  tags: Array<Scalars['String']['input']>;
  /** Expected time to earn the badge */
  timeToEarn?: InputMaybe<Scalars['String']['input']>;
};

/** Response for updating an existing organization badge class */
export type OrganizationBadgeClassUpdateResponse = {
  __typename?: 'OrganizationBadgeClassUpdateResponse';
  /** The OrganizationBadgeClass object updated */
  badgeClass?: Maybe<OrganizationBadgeClass>;
};

/** Criteria for earning an organization badge by custom input */
export type OrganizationBadgeCustomEarningCriteria = OrganizationBadgeEarningCriteria & {
  __typename?: 'OrganizationBadgeCustomEarningCriteria';
  /** Description of the criteria */
  criteriaDescription?: Maybe<Scalars['String']['output']>;
  /** ID of the criteria */
  id: Scalars['ID']['output'];
  /** URL of the criteria */
  link?: Maybe<Scalars['URL']['output']>;
  /** Title of the criteria */
  linkTitle?: Maybe<Scalars['String']['output']>;
  /** If the criteria is optional */
  optional: Scalars['Boolean']['output'];
  /** Type of the criteria */
  type: OrganizationBadgeEarningCriteriaType;
};

/** Custom earning criteria input */
export type OrganizationBadgeCustomEarningCriteriaInput = {
  /** Helpful link related to criteria */
  link: Scalars['URL']['input'];
  /** Title to be displayed for the link */
  linkTitle?: InputMaybe<Scalars['String']['input']>;
};

/** Interface for criteria for earning an organization badge */
export type OrganizationBadgeEarningCriteria = {
  /** Description of the criteria */
  criteriaDescription?: Maybe<Scalars['String']['output']>;
  /** ID of the criteria */
  id: Scalars['ID']['output'];
  /** If the criteria is optional */
  optional: Scalars['Boolean']['output'];
  /** Type of the criteria */
  type: OrganizationBadgeEarningCriteriaType;
};

/** Earning criteria input combined */
export type OrganizationBadgeEarningCriteriaInput = {
  /** Description of the criteria */
  criteriaDescription?: InputMaybe<Scalars['String']['input']>;
  /** Custom criteria */
  customCriteria?: InputMaybe<OrganizationBadgeCustomEarningCriteriaInput>;
  /** ID of the criteria */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Learning product criteria */
  learningProductCriteria?: InputMaybe<OrganizationBadgeLearningProductEarningCriteriaInput>;
  /** If the criteria is optional */
  optional: Scalars['Boolean']['input'];
  /** Type of earning criteria (custom or learning product) */
  type: OrganizationBadgeEarningCriteriaType;
};

/** Criteria type for earning an organization badge */
export enum OrganizationBadgeEarningCriteriaType {
  /** Criteria for earning an organization badge by custom input */
  Custom = 'CUSTOM',
  /** Criteria for earning an organization badge by learning product */
  LearningProduct = 'LEARNING_PRODUCT'
}

/** Criteria that is empty for earning an organization badge */
export type OrganizationBadgeEmptyEarningCriteria = OrganizationBadgeEarningCriteria & {
  __typename?: 'OrganizationBadgeEmptyEarningCriteria';
  /** Description of the criteria */
  criteriaDescription?: Maybe<Scalars['String']['output']>;
  /** ID of the criteria */
  id: Scalars['ID']['output'];
  /** If the criteria is optional */
  optional: Scalars['Boolean']['output'];
  /** Type of the criteria */
  type: OrganizationBadgeEarningCriteriaType;
};

/** Criteria for earning an organization badge by learning product */
export type OrganizationBadgeLearningProductEarningCriteria = OrganizationBadgeEarningCriteria & {
  __typename?: 'OrganizationBadgeLearningProductEarningCriteria';
  /** Description of the criteria */
  criteriaDescription?: Maybe<Scalars['String']['output']>;
  /** ID of the criteria */
  id: Scalars['ID']['output'];
  /** Learning product for earning the badge */
  learningProduct: LearningProduct;
  /** If the criteria is optional */
  optional: Scalars['Boolean']['output'];
  /** Type of the criteria */
  type: OrganizationBadgeEarningCriteriaType;
};

/** Learning Product earning criteria input */
export type OrganizationBadgeLearningProductEarningCriteriaInput = {
  /** Learning product to be completed for earning the badge */
  learningProduct?: InputMaybe<LearningProductInput>;
};

/** Status of an OrganizationBadgeClass */
export enum OrganizationBadgeStatus {
  /** Draft, can still be edited */
  Draft = 'DRAFT',
  /** Expired */
  Expired = 'EXPIRED',
  /** Published */
  Published = 'PUBLISHED'
}

/** Input for creation of organizations */
export type OrganizationCreateInput = {
  /** This is a Udemy-internal test account */
  isInternalTest: Scalars['Boolean']['input'];
  /** This is a test account. Used to exclude the organization from instructor payouts. */
  isTest: Scalars['Boolean']['input'];
  /** Set owner by inviting user. This user will automatically take a license for the account, but needs to accept the invite to access. */
  ownerInvitationEmail: Scalars['EmailAddress']['input'];
  /** Invite locale, for example en_US */
  ownerInvitationLocale: Scalars['Locale']['input'];
  /** Salesforce Account ID for auditability purposes */
  salesforceAccountId: Scalars['String']['input'];
  /** Subdomain. The account will be available at subdomain.udemy.com */
  subdomain: Scalars['String']['input'];
  /** Account Name. This name will be used in the account header when no logo is configured. It's also used in the in-product messaging when referring to this account. Admins can change this value in Manage -> Settings. */
  title: Scalars['String']['input'];
};

/** Response for Organization creation operation */
export type OrganizationCreateResponse = {
  __typename?: 'OrganizationCreateResponse';
  /** The created Organization */
  organization?: Maybe<Organization>;
};

/** Favicon images for an organization */
export type OrganizationFaviconImages = {
  __typename?: 'OrganizationFaviconImages';
  /** Favicon image size 16x16 */
  px16x16?: Maybe<Scalars['URL']['output']>;
  /** Favicon image size 32x32 */
  px32x32?: Maybe<Scalars['URL']['output']>;
};

/** Images for an organization */
export type OrganizationImages = {
  __typename?: 'OrganizationImages';
  /** Background images for an organization */
  background?: Maybe<OrganizationBackgroundImages>;
  /** Favicon images for an organization */
  favicon?: Maybe<OrganizationFaviconImages>;
  /** Logo images for an organization */
  logo?: Maybe<OrganizationLogoImages>;
};

/** Response object for Organization Insight progress buckets */
export type OrganizationInsightProgressBucket = {
  __typename?: 'OrganizationInsightProgressBucket';
  /** Number of learners in this bucket */
  learnerCount: Scalars['NonNegativeInt']['output'];
  /** Start and end minutes range */
  minutesRange?: Maybe<OrganizationInsightProgressMinutesRange>;
};

/** Response object for Organization Insight minutes range */
export type OrganizationInsightProgressMinutesRange = {
  __typename?: 'OrganizationInsightProgressMinutesRange';
  /** Maximum minutes (exclusive) in the bucket */
  endMinutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Minimum minutes (inclusive) in the bucket */
  startMinutes: Scalars['NonNegativeInt']['output'];
};

/** An input that accepts a start and end minutes */
export type OrganizationInsightProgressMinutesRangeInput = {
  /** Maximum minutes (exclusive) in the bucket */
  endMinutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  /** Minimum minutes (inclusive) in the bucket */
  startMinutes: Scalars['NonNegativeInt']['input'];
};

/** Response object for Organization Insight learner count */
export type OrganizationInsights = {
  __typename?: 'OrganizationInsights';
  /** Result for each bucket */
  buckets: Array<OrganizationInsightProgressBucket>;
};

/** An input that accepts a range of dates to filter the data and buckets with start and end minutes */
export type OrganizationInsightsFilterInput = {
  /** Input for each bucket */
  buckets: Array<OrganizationInsightProgressMinutesRangeInput>;
  /** date range for the metrics */
  dateRange?: InputMaybe<DateRangeInput>;
};

/** Represents the organization learning goal */
export type OrganizationLearningGoal = {
  __typename?: 'OrganizationLearningGoal';
  /** The time at which the learning goal was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the learning goal */
  createdBy: User;
  /** The date by which to achieve the learning goal. */
  endDate: Scalars['DateTime']['output'];
  /** ID of the OrganizationLearningGoal. */
  id: Scalars['ID']['output'];
  /** The number of learning minutes to be completed as part of the goal. */
  minutesToLearn: Scalars['Int']['output'];
  /** The time at which the learning goal was updated. */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who updated the learning goal */
  modifiedBy?: Maybe<User>;
  /** The date when the learning goal starts. */
  startDate: Scalars['DateTime']['output'];
  /** Statistics about the learning goal */
  stats?: Maybe<OrganizationLearningGoalStats>;
  /** Status of the goal */
  status: OrganizationLearningGoalStatus;
  /** Title of the learning goal */
  title: Scalars['String']['output'];
};

/** Represents the input to create learning goal of an organization */
export type OrganizationLearningGoalCreateInput = {
  /** The date by which to achieve the learning goal. */
  endDate: Scalars['DateTime']['input'];
  /** The number of learning minutes to be completed as part of the goal. */
  minutesToLearn: Scalars['Int']['input'];
  /** The date when the learning goal starts. */
  startDate: Scalars['DateTime']['input'];
  /** Title of the learning goal */
  title: Scalars['String']['input'];
};

/** Represents the organization learning goal create response */
export type OrganizationLearningGoalCreateResponse = {
  __typename?: 'OrganizationLearningGoalCreateResponse';
  /** Represents the newly created organization learning goal */
  organizationLearningGoal?: Maybe<OrganizationLearningGoal>;
};

/** Represents the organization learning goal deactivate response */
export type OrganizationLearningGoalDeactivateResponse = {
  __typename?: 'OrganizationLearningGoalDeactivateResponse';
  /** Represents the deactivated organization learning goal */
  organizationLearningGoal?: Maybe<OrganizationLearningGoal>;
};

/** Progress made by learners in organization towards the goal */
export type OrganizationLearningGoalProgress = {
  __typename?: 'OrganizationLearningGoalProgress';
  /** Count of learners who have consumed the target learning minutes set in the goal by organization */
  completedUserCount: Scalars['NonNegativeInt']['output'];
  /** Count of learners who have consumed less than half of the target learning minutes set in the goal by organization */
  justStartedUserCount: Scalars['NonNegativeInt']['output'];
  /** Count of learners who have consumed more than half of the target learning minutes set in the goal by organization */
  majorityCompletedUserCount: Scalars['NonNegativeInt']['output'];
  /** Count of learners who yet to start progress towards consuming the target learning minutes set in the goal by organization */
  notStartedUserCount: Scalars['NonNegativeInt']['output'];
};

/** Represents the stats of learning goal of an organization */
export type OrganizationLearningGoalStats = {
  __typename?: 'OrganizationLearningGoalStats';
  /** Progress made by learners in organization towards the goal */
  progress?: Maybe<OrganizationLearningGoalProgress>;
};

/** Status of an organization learning goal */
export enum OrganizationLearningGoalStatus {
  /** Learning goal is active */
  Active = 'ACTIVE',
  /** Learning goal is inactive */
  Inactive = 'INACTIVE'
}

/** Learning Path object that belongs to an organization */
export type OrganizationLearningPath = LearningPath & LearningProduct & {
  __typename?: 'OrganizationLearningPath';
  /** Badges of the learning path. */
  badges?: Maybe<Array<BadgeClass>>;
  /** Date when learning path was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the learning path. */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** The duration of the learning path */
  durationInSeconds: Scalars['DurationInSeconds']['output'];
  /** ID of the learning path. */
  id: Scalars['ID']['output'];
  /** Is the user enrolled in this learning path or not */
  isEnrolled: Scalars['Boolean']['output'];
  /** Number of items in the learning path. */
  itemCount: Scalars['Int']['output'];
  /** Date when learning path was last modified */
  modifiedAt: Scalars['DateTime']['output'];
  /** Total No of enrollments for the learning path. */
  numberOfEnrollments: Scalars['Int']['output'];
  /** Organization that owns the learning path */
  organization: Organization;
  /** Owner user for the learning path */
  owner: LearningPathInstructor;
  /** Number of sections in the learning path */
  sectionCount: Scalars['Int']['output'];
  /** Sections of the learning path */
  sections?: Maybe<Array<LearningPathSection>>;
  /** Subscription information for this learning path. */
  subscriptionInfo?: Maybe<LearningProductSubscriptionInfo>;
  /** Title of the learning path. */
  title: Scalars['String']['output'];
  /** Topics associated with the learning path. */
  topics?: Maybe<Array<Topic>>;
  /** Unique analytics ID for this instance of LearningPath returned from the server in this request. */
  trackingId?: Maybe<Scalars['String']['output']>;
  /** The URL to enroll in the learning path */
  urlAutoEnroll?: Maybe<Scalars['URL']['output']>;
  /** Landing page to view this LearningPath */
  urlLanding: Scalars['URL']['output'];
};

/** Logo images for an organization */
export type OrganizationLogoImages = {
  __typename?: 'OrganizationLogoImages';
  /** Logo image W_35 */
  width35?: Maybe<Scalars['URL']['output']>;
  /** Logo image W_70 */
  width70?: Maybe<Scalars['URL']['output']>;
};

/** Represents the each organization notification preference */
export type OrganizationNotificationPreferenceInput = {
  /** True if notification type is enabled */
  isEnabled: Scalars['Boolean']['input'];
  /** The role-based setting of notification */
  notificationRoleType: OrganizationNotificationRoleType;
};

/** Represents the notification preferences of an organization */
export type OrganizationNotificationPreferenceSetInput = {
  /** List of role-based notification preferences belongs to organization */
  roleBasedPreferences: Array<OrganizationNotificationPreferenceInput>;
  /** Source of the action to store audit information */
  source: Scalars['String']['input'];
};

/** Represents the organization notification save response */
export type OrganizationNotificationPreferencesUpdateResponse = {
  __typename?: 'OrganizationNotificationPreferencesUpdateResponse';
  /** The updated notification preferences if mutation is successful */
  roleBasedPreferences?: Maybe<Array<OrganizationRoleBasedNotificationPreference>>;
};

/** Role-based organization notifications to group organization notifications by role */
export enum OrganizationNotificationRoleType {
  /** Represents every member of a particular organization */
  Everyone = 'EVERYONE',
  /** Represents group admins of a particular organization */
  GroupAdmins = 'GROUP_ADMINS',
  /** Represents learners of a particular organization */
  Learners = 'LEARNERS'
}

/** A notification preference belongs to organization */
export type OrganizationRoleBasedNotificationPreference = {
  __typename?: 'OrganizationRoleBasedNotificationPreference';
  /** True if notification type is enabled */
  isEnabled: Scalars['Boolean']['output'];
  /** The role-based setting of notification */
  notificationRoleType: OrganizationNotificationRoleType;
};

/** A setting for an organization */
export type OrganizationSetting = {
  __typename?: 'OrganizationSetting';
  /** The name of the setting */
  name: OrganizationSettingName;
  /** The organization this setting is assigned to */
  organization: Organization;
  /** The value of the setting */
  value: Scalars['Boolean']['output'];
};

/** The setting names available for an organization */
export enum OrganizationSettingName {
  /** The setting to denote whether an organization is opted in to the AI Assistant GenAI feature */
  GenaiAiAssistantEnabled = 'GENAI_AI_ASSISTANT_ENABLED',
  /** The setting to denote whether an organization is opted in to GenAI features */
  GenaiOptIn = 'GENAI_OPT_IN',
  /** "The setting to denote whether an organization is opted in to the Role Play GenAI feature" */
  GenaiRolePlayEnabled = 'GENAI_ROLE_PLAY_ENABLED',
  /** The setting to denote whether an organization is opted in to the Skills Mapping GenAI feature */
  GenaiSkillsMappingEnabled = 'GENAI_SKILLS_MAPPING_ENABLED',
  /** The setting to denote whether sharing to Microsoft Teams is enabled */
  MsTeamsShare = 'MS_TEAMS_SHARE',
  /** The setting denoting if recurring billing is enabled for the org */
  RecurringBilling = 'RECURRING_BILLING',
  /** The setting to denote whether data should be sent to marketo */
  SendDataToMarketo = 'SEND_DATA_TO_MARKETO',
  /** The setting to denote whether the sentiment survey is enabled */
  SentimentSurvey = 'SENTIMENT_SURVEY',
  /** The setting to denote whether sharing to Slack is enabled */
  SlackShare = 'SLACK_SHARE',
  /** The setting to denote whether the org is Team Plan V2 enabled */
  TpV2Enabled = 'TP_V2_ENABLED',
  /** The setting to denote whether workplace sharing is enabled */
  WorkplaceShare = 'WORKPLACE_SHARE'
}

/** Input for setting overrides on organization settings. Only a specific set of settings (reflected in the params) can be overridden; in particular not all settings are meant to be self-serve, and some of them can only be set from Udemy. */
export type OrganizationSettingSetOverrideInput = {
  /** License-related settings that can be overridden */
  license?: InputMaybe<OverrideableOrganizationLicenseSettings>;
};

/** Response of setting overrides on organization settings. It returns all settings for the organization. */
export type OrganizationSettingSetOverrideResponse = {
  __typename?: 'OrganizationSettingSetOverrideResponse';
  /** All organization settings after the override has been applied */
  settings?: Maybe<OrganizationSettings>;
};

/** Organization settings */
export type OrganizationSettings = {
  __typename?: 'OrganizationSettings';
  /** AI Assistant-related settings */
  aiAssistant?: Maybe<AiAssistantOrganizationSettings>;
  /** Course taking-related settings */
  courseTaking?: Maybe<CourseTakingOrganizationSettings>;
  /** License-related settings */
  license?: Maybe<LicenseOrganizationSettings>;
  /** Player-related settings */
  player?: Maybe<PlayerOrganizationSettings>;
  /** Security-related settings */
  security?: Maybe<SecurityOrganizationSettings>;
  /** SSO-related settings */
  sso?: Maybe<SsoOrganizationSettings>;
};

/** Organization Subscription */
export type OrganizationSubscription = {
  __typename?: 'OrganizationSubscription';
  /** Base Subscription (if an addon subscription) */
  baseSubscription?: Maybe<OrganizationSubscription>;
  /** A list of Content Collections included in the subscription */
  contentCollections?: Maybe<Array<Maybe<ContentCollection>>>;
  /** End date in UTC */
  endDate: Scalars['Date']['output'];
  /** Id */
  id: Scalars['ID']['output'];
  /** Organization */
  organization: Organization;
  /** Product Type */
  productType: SubscriptionPlanProductType;
  /** Salesforce Contract Start Date in UTC */
  salesforceContractStartDate: Scalars['Date']['output'];
  /** Salesforce Opportunity Id */
  salesforceOpportunityId: Scalars['String']['output'];
  /** Max users count */
  seatCount: Scalars['PositiveInt']['output'];
  /** Start on a date (in UTC) */
  startDate: Scalars['Date']['output'];
  /** Title */
  title: Scalars['String']['output'];
  /** Total Price (Per Year) */
  totalPrice: Money;
  /** Trial Option. If not set, than it's a paid subscription */
  trialType?: Maybe<OrganizationSubscriptionTrialType>;
};

/** Input for the Organization Subscription Creation */
export type OrganizationSubscriptionCreateInput = {
  /** Base Subscription id (if creating an addon) */
  baseSubscriptionId?: InputMaybe<Scalars['ID']['input']>;
  /** A list of Content Collection ids */
  contentCollectionIds: Array<Scalars['ID']['input']>;
  /** Contract end date in UTC */
  endDate: Scalars['Date']['input'];
  /** Organization id */
  organizationId: Scalars['ID']['input'];
  /** Product Type */
  productType: SubscriptionPlanProductType;
  /** Salesforce Contract Start Date in UTC */
  salesforceContractStartDate: Scalars['Date']['input'];
  /** Salesforce Opportunity Id */
  salesforceOpportunityId: Scalars['String']['input'];
  /** Max users count */
  seatCount: Scalars['PositiveInt']['input'];
  /** Start on a date (in UTC) */
  startDate: Scalars['Date']['input'];
  /** Title */
  title: Scalars['String']['input'];
  /** Total Price (Per Year) */
  totalPrice: MoneyInput;
  /** Trial Option. If not set, than it's a paid subscription */
  trialType?: InputMaybe<OrganizationSubscriptionTrialType>;
};

/** Response for Adding Subscriptions to Organization */
export type OrganizationSubscriptionCreateResponse = {
  __typename?: 'OrganizationSubscriptionCreateResponse';
  /** The created organization subscription */
  organizationSubscription?: Maybe<OrganizationSubscription>;
};

/** Type of Trial Subscription for Organizations */
export enum OrganizationSubscriptionTrialType {
  /** Free trial subscription */
  IsFreeTrial = 'IS_FREE_TRIAL'
}

/** Type of an organization */
export enum OrganizationType {
  /** Udemy Business */
  UdemyBusiness = 'UDEMY_BUSINESS',
  /** Udemy Business China */
  UdemyBusinessChina = 'UDEMY_BUSINESS_CHINA',
  /** Udemy Government */
  UdemyGovernment = 'UDEMY_GOVERNMENT'
}

/** Group identifiers within an organization to allow filtering the report data */
export type OrganizationUserGroup = {
  __typename?: 'OrganizationUserGroup';
  /** ID of the organization user group */
  id: Scalars['ID']['output'];
};

/** Object that describes the type and status of license assigned to a user in an organization */
export type OrganizationUserLicense = {
  __typename?: 'OrganizationUserLicense';
  /** The organization this license is assigned to */
  organization: Organization;
  /**
   * The product type of the license assigned to the user.
   * This replaces the deprecated 'type' field and provides more granular information about the subscription plan.
   */
  productType: SubscriptionPlanProductType;
  /** The status of license assigned to the user */
  status: OrganizationUserLicenseStatus;
  /**
   * The type of license assigned to the user
   * @deprecated Use productType instead
   */
  type: OrganizationUserLicenseType;
  /** The User this license is assigned to */
  user: User;
};

/** Object that describes the status of license assigned to a user in an organization */
export enum OrganizationUserLicenseStatus {
  /** license is usable and assigned to the specified user */
  Active = 'ACTIVE',
  /** license is not usable */
  Inactive = 'INACTIVE'
}

/** Object that describes the type of license assigned to a user in an organization */
export enum OrganizationUserLicenseType {
  /** Default Enterprise and Team Plan license Type */
  Basic = 'BASIC',
  /** UB Pro license Type */
  Pro = 'PRO'
}

/** Filters for the organizationUserLicenses query */
export type OrganizationUserLicensesFilters = {
  /** Filter by product type */
  productType?: InputMaybe<SubscriptionPlanProductType>;
  /** Filter by license status */
  status?: InputMaybe<OrganizationUserLicenseStatus>;
};

/** Overrideable settings related to Licenses */
export type OverrideableOrganizationLicenseSettings = {
  /** Whether license automatic allocation is enabled */
  isLicenseAutomaticAllocationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Interface for implementing paginated results */
export type Paginated = {
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages. Calculated as (total result count / page size) */
  pageCount: Scalars['Int']['output'];
};

/** A Partner */
export type Partner = {
  __typename?: 'Partner';
  /** The partner's unique identifier */
  id: Scalars['ID']['output'];
};

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */
export type PathSearchResponseMetadata = {
  __typename?: 'PathSearchResponseMetadata';
  /** For the request, shows experiment metadata result like bucking info, experiment IDs of assigned feature variants. */
  experimentResults: Array<FeatureVariantAssignment>;
  /** Search analytics tracking id; for uniquely identifying this query and result set; for this request */
  trackingId: Scalars['String']['output'];
};

/** Enum for different payment method types */
export enum PaymentMethodType {
  /** Payment method CHEQUE */
  Cheque = 'CHEQUE',
  /** Payment method JPMORGAN */
  Jpmorgan = 'JPMORGAN',
  /** Payment method PAYONEER */
  Payoneer = 'PAYONEER',
  /** Payment method PAYPAL */
  Paypal = 'PAYPAL',
  /** Payment method TIPALTI */
  Tipalti = 'TIPALTI',
  /** Payment method WIRE */
  Wire = 'WIRE'
}

/** Input for payout exists search filter */
export type PayoutExistsSearchFilterInput = {
  /** list of payout methods to search */
  payoutMethods?: InputMaybe<Array<PaymentMethodType>>;
  /** list of status to search */
  statuses?: InputMaybe<Array<PayoutStatusType>>;
};

/** Enum for different payout statuses */
export enum PayoutStatusType {
  /** Payout status BLOCKED */
  Blocked = 'BLOCKED',
  /** Payout status CANCELLED */
  Cancelled = 'CANCELLED',
  /** Payout status DERECOGNIZED */
  Derecognized = 'DERECOGNIZED',
  /** Payout status FAILED */
  Failed = 'FAILED',
  /** Payout status INITIAL */
  Initial = 'INITIAL',
  /** Payout status PARTIALLY_SUCCESS */
  PartiallySuccess = 'PARTIALLY_SUCCESS',
  /** Payout status PENDING */
  Pending = 'PENDING',
  /** Payout status PROCESSING */
  Processing = 'PROCESSING',
  /** Payout status QUEUING */
  Queuing = 'QUEUING',
  /** Payout status READY_TO_PAY */
  ReadyToPay = 'READY_TO_PAY',
  /** Payout status SUCCESS */
  Success = 'SUCCESS',
  /** Payout status UNCLAIMED */
  Unclaimed = 'UNCLAIMED',
  /** Payout status UNPAID */
  Unpaid = 'UNPAID'
}

/** Player-related organization settings */
export type PlayerOrganizationSettings = {
  __typename?: 'PlayerOrganizationSettings';
  /** Whether playback speed control is disabled */
  isPlaybackSpeedControlDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether skipping within lectures is disabled */
  isSkippingWithinLectureDisabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Popular topic */
export type PopularTopic = {
  __typename?: 'PopularTopic';
  /** The type of popularity associated with this topic */
  popularityType?: Maybe<TopicPopularityTypes>;
  /** Associated Subcategory */
  subcategory?: Maybe<PopularTopicSubCategory>;
  /** A topic */
  topic: Topic;
};

/** Topic SubCategory */
export type PopularTopicSubCategory = SubCategory & {
  __typename?: 'PopularTopicSubCategory';
  /** ID of the subcategory */
  id: Scalars['ID']['output'];
  /** Name of the subcategory */
  name: Scalars['String']['output'];
};

/** Assigment test with multiple-choice and free-from questions reviewed by instructors */
export type PracticeAssignment = CurriculumItem & {
  __typename?: 'PracticeAssignment';
  /** Course this practice assignment belongs to */
  course?: Maybe<Course>;
  /** Description of the assignment */
  description: Scalars['String']['output'];
  /** The Id of the assignment */
  id: Scalars['ID']['output'];
  /** The title of the assignment */
  title: Scalars['String']['output'];
  /** Landing page to view this PracticeAssignment */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the practice assignment */
  versionedIdentifier: VersionedIdentifier;
};

/** Practice test that is more detailed than a Quiz */
export type PracticeTest = CurriculumItem & LearningProduct & {
  __typename?: 'PracticeTest';
  /** Course this practice test belongs to */
  course?: Maybe<Course>;
  /** The Id of the practice test */
  id: Scalars['ID']['output'];
  /** Percentage required to pass (0 - 100) */
  minimumPassingScore: Scalars['Int']['output'];
  /** Whether the question and answer order is randomized */
  randomized: Scalars['Boolean']['output'];
  /** The title of the practice test */
  title: Scalars['String']['output'];
  /** Landing page to view this PracticeTest */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the practice test */
  versionedIdentifier: VersionedIdentifier;
};

/** Represents the selected choices of practice test context */
export type PracticeTestChoiceContextInput = {
  /** The string content of choice selected by user */
  choice: Scalars['String']['input'];
  /** Explanation for selected choice (optional) */
  choiceExplanation?: InputMaybe<Scalars['String']['input']>;
  /** Whether each selected choice is correct  */
  isChoiceCorrect: Scalars['Boolean']['input'];
};

/** Represents practice test context for in-course chat */
export type PracticeTestContextInput = {
  /** Represents the context of choices selected by the user */
  choices?: InputMaybe<Array<PracticeTestChoiceContextInput>>;
  /** Represents overall correctness of answer */
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Represents the overall explanation for the practice test question */
  overallExplanation?: InputMaybe<Scalars['String']['input']>;
  /** The practice test id */
  practiceTestId: Scalars['ID']['input'];
  /** Represents question type for practice test question */
  questionType?: InputMaybe<QuestionType>;
};

/** Filters for practice test insights */
export type PracticeTestInsightFilters = {
  /** date range for the metrics */
  dateRange?: InputMaybe<DateRangeInput>;
};

/** Presentation Lecture for Udemy Business */
export type PresentationLecture = CurriculumItem & Lecture & {
  __typename?: 'PresentationLecture';
  /** Lecture's main learning asset */
  asset?: Maybe<Asset>;
  /** The Course this lecture belongs to */
  course?: Maybe<Course>;
  /** Instructor-authored description of the lecture, may contain HTML */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** Total duration of the lecture's content in seconds */
  durationInSeconds: Scalars['DurationInSeconds']['output'];
  /** Id of the lecture */
  id: Scalars['ID']['output'];
  /** Images by their dimensions */
  images: LectureImages;
  /** If user has completed the lecture */
  isCompleted: Scalars['Boolean']['output'];
  /** Whether this lecture is used for promos and course previews. */
  isPreviewable: Scalars['Boolean']['output'];
  /** Lecture's supplementary resources */
  resources?: Maybe<Array<Maybe<Asset>>>;
  /** Associated learning products for supplementary learning */
  supplementaryLearningProducts: Array<LearningProduct>;
  /** The URL of the lecture thumbnail */
  thumbnail?: Maybe<Scalars['URL']['output']>;
  /** Lecture title */
  title: Scalars['String']['output'];
  /** The URL to access the lecture on the auto-enroll page */
  urlAutoEnroll: Scalars['URL']['output'];
  /** Download URL for lecture */
  urlDownload?: Maybe<Scalars['URL']['output']>;
  /** Landing page to view this Lecture */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the lecture */
  versionedIdentifier: VersionedIdentifier;
};


/** Presentation Lecture for Udemy Business */
export type PresentationLectureSupplementaryLearningProductsArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** Price of the course, free or paid */
export enum PriceOption {
  /** Free */
  Free = 'FREE',
  /** Paid */
  Paid = 'PAID'
}

/** The LearningPath only available for PRO subscriptions */
export type ProLearningPath = LearningPath & LearningProduct & {
  __typename?: 'ProLearningPath';
  /** Badges of the learning path. */
  badges?: Maybe<Array<BadgeClass>>;
  /** Date when learning path was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the learning path. */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** The duration of the learning path */
  durationInSeconds: Scalars['DurationInSeconds']['output'];
  /** ID of the learning path. */
  id: Scalars['ID']['output'];
  /** Is the user enrolled in this learning path or not */
  isEnrolled: Scalars['Boolean']['output'];
  /** Number of items in the learning path. */
  itemCount: Scalars['Int']['output'];
  /** Date when learning path was last modified */
  modifiedAt: Scalars['DateTime']['output'];
  /** Total No of enrollments for the learning path. */
  numberOfEnrollments: Scalars['Int']['output'];
  /** Owner user for the learning path */
  owner: LearningPathInstructor;
  /** Number of sections in the learning path */
  sectionCount: Scalars['Int']['output'];
  /** Sections of the learning path */
  sections?: Maybe<Array<LearningPathSection>>;
  /** Subscription information for this learning path. */
  subscriptionInfo?: Maybe<LearningProductSubscriptionInfo>;
  /** Title of the learning path. */
  title: Scalars['String']['output'];
  /** Topics associated with the learning path. */
  topics?: Maybe<Array<Topic>>;
  /** Unique analytics ID for this instance of LearningPath returned from the server in this request. */
  trackingId?: Maybe<Scalars['String']['output']>;
  /** The URL to enroll in the learning path */
  urlAutoEnroll?: Maybe<Scalars['URL']['output']>;
  /** Landing page to view this LearningPath */
  urlLanding: Scalars['URL']['output'];
};

/** Instructor-friendly error message for failed assets */
export type ProcessingError = {
  __typename?: 'ProcessingError';
  /** Friendly error message for failed assets */
  errorMessage: Scalars['String']['output'];
  /** Udemy Support help link */
  helpLink: Scalars['String']['output'];
};

/**
 * Proficiency levels for skills — shared across Goal Service (targetProficiency)
 * and Learner Profile Service (currentProficiency).
 */
export enum ProficiencyLevel {
  /** Developing level proficiency (intermediate). */
  Developing = 'DEVELOPING',
  /** Established level proficiency (proficient). */
  Established = 'ESTABLISHED',
  /** Limited level proficiency (beginner). */
  Limited = 'LIMITED',
  /** Superior level proficiency (advanced). */
  Superior = 'SUPERIOR'
}

/** The numbers of users which have attained each level */
export type ProficiencyLevelCounts = {
  __typename?: 'ProficiencyLevelCounts';
  /** Number of learners at "Developing" proficiency level */
  developing: Scalars['NonNegativeInt']['output'];
  /** Number of learners at "Established" proficiency level */
  established: Scalars['NonNegativeInt']['output'];
  /** Number of learners at "Limited" proficiency level */
  limited: Scalars['NonNegativeInt']['output'];
  /** Number of learners at "Superior" proficiency level */
  superior: Scalars['NonNegativeInt']['output'];
};

/** Change in proficiency level counts over time */
export type ProficiencyLevelCountsChange = {
  __typename?: 'ProficiencyLevelCountsChange';
  /** Current counts of proficiency levels (based on the most recent attempts of assessments) */
  currentLevels: ProficiencyLevelCounts;
  /** Starting proficiency levels (first attempts at assessments) */
  startingLevels: ProficiencyLevelCounts;
};

/** Represents the pusher config */
export type PusherResponseConfigInput = {
  /** The pusher channel id */
  channelId: Scalars['String']['input'];
  /** The pusher event name */
  eventName: Scalars['String']['input'];
};

/** Root query from which every query schema extends */
export type Query = {
  __typename?: 'Query';
  /** Fetch all active subscription enrollments for the user or organization if the user is a member of an organization. currentSubscriptionEnrollment retrieves only the current active base subscription, activeSubscriptionEnrollments will include both base and add-on subscription types */
  activeSubscriptionEnrollments?: Maybe<Array<Maybe<SubscriptionEnrollment>>>;
  /** Get API client by ID */
  apiClient: ApiClient;
  /** Get all API clients the requesting organization user or partner has access to */
  apiClients: Array<ApiClient>;
  /** Retrieve an assessment by its ID */
  assessment?: Maybe<Assessment>;
  /**
   * Returns the assessment attempt summaries (assessment, attempts, remaining
   * attempt count, item feedbacks) for assessments the calling user has access
   * to, determined by the user's learningProducts entitlements. Requires the
   * ASSESSMENTS subscription feature to be enabled for the user.
   *
   * Note: inactive assessments remain in the result if the user has previously attempted them.
   */
  assessmentAttemptsSummaries?: Maybe<Array<Maybe<AssessmentAttemptsSummary>>>;
  /** Get latest attempts by assessment IDs */
  assessmentAttemptsSummariesByAssessmentIds?: Maybe<Array<Maybe<AssessmentAttemptsSummary>>>;
  /** Get attempt summaries for the assessments bundled in a collection */
  assessmentAttemptsSummariesByCollection?: Maybe<Array<Maybe<AssessmentAttemptsSummary>>>;
  /** Get assessment attempt summary by assessment ID */
  assessmentAttemptsSummary?: Maybe<AssessmentAttemptsSummary>;
  /** Get assessment attempt summary for the assessment related to the primary topic of a course */
  assessmentAttemptsSummaryByCoursePrimaryTopic?: Maybe<AssessmentAttemptsSummary>;
  /** Get assessment attempt summary by assessment slug */
  assessmentAttemptsSummaryBySlug?: Maybe<AssessmentAttemptsSummary>;
  /** Get assessment attempt summary for the assessment related to the marketplace course */
  assessmentAttemptsSummaryForMarketplaceCourse?: Maybe<AssessmentAttemptsSummary>;
  /**
   * Retrieves list of assessment results associated with course id that contain items a user attempted.
   * Can filter by correct, incorrect or skipped Items with default returning all 3.
   */
  assessmentResultsByCourse?: Maybe<Array<Maybe<AssessmentResults>>>;
  /** Searches assessments by given query */
  assessmentSearch?: Maybe<AssessmentSearchResponse>;
  /** Retrieve detailed breakdown by assessment */
  assessmentSummary?: Maybe<AssessmentSummaryResponse>;
  /**
   * Get the latest attempts for all assessments in a collection
   * @deprecated Variants are no longer exposed
   */
  assessmentVariantAttemptsLatestByCollection: Array<AssessmentVariantAttempt>;
  /**
   * Returns the assessments the calling user has access to, determined by the
   * user's learningProducts entitlements. Requires the ASSESSMENTS subscription
   * feature to be enabled for the user.
   */
  assessments?: Maybe<Array<Maybe<Assessment>>>;
  /** Get assessments by collection id */
  assessmentsByCollection?: Maybe<Array<Maybe<Assessment>>>;
  /** Get recommended assessments for the primary topic of a course */
  assessmentsByCoursePrimaryTopic: Array<Assessment>;
  /** Get recommended assessments for a course */
  assessmentsRecommendedByCourse: Array<Assessment>;
  /** Fetches an asset by its ID */
  asset?: Maybe<Asset>;
  /** Get an Open Badge Assertion by id */
  badgeAssertion?: Maybe<BadgeAssertion>;
  /** Get list of Open Badge Assertions by their ids */
  badgeAssertions: Array<Maybe<BadgeAssertion>>;
  /** Get list of Open Badge Assertions of given user. Must be a UB admin for the given User */
  badgeAssertionsByUser?: Maybe<BadgeAssertionPaged>;
  /** Get list of Open Badge Assertions for organization. User must be an admin for the given organization */
  badgeAssertionsForCurrentOrganization?: Maybe<BadgeAssertionPaged>;
  /** Get user's issued badges that are uploaded by the user */
  badgeAssertionsImported?: Maybe<BadgeAssertionPaged>;
  /** List of Certification Providers filtered for having content */
  badgeCertificationProvidersWithContent: Array<BadgeCertificationProvider>;
  /** Get certification subject areas for badges */
  badgeCertificationSubjectAreas: Array<BadgeCertificationSubjectArea>;
  /** Get BadgeClass by id */
  badgeClass?: Maybe<BadgeClass>;
  /** Search for BadgeClasses with Admin filters (only available for applications with admin:application scope) */
  badgeClassAdminSearch?: Maybe<BadgeClassSearchResponse>;
  /** Get user's enrollments for a badge class */
  badgeClassEnrollmentsByBadgeClassId: Array<BadgeClassEnrollment>;
  /** Issuer list of all BadgeClasses */
  badgeClassIssuers: Array<BadgeClassIssuer>;
  /** Query issuers for user's organization (Requires Admin privileges) */
  badgeClassIssuersForCurrentOrganization: Array<BadgeClassIssuer>;
  /** Search for organization BadgeClasses */
  badgeClassOrganizationSearch?: Maybe<BadgeClassSearchResponse>;
  /** Search for BadgeClasses */
  badgeClassSearch?: Maybe<BadgeClassSearchResponse>;
  /** Get list of BadgeClass for a list of ids */
  badgeClasses: Array<Maybe<BadgeClass>>;
  /** Get user's active certification preparation */
  badgeClassesActive: Array<BadgeClass>;
  /** Get mapped badge classes for learning products */
  badgeClassesByLearningProducts?: Maybe<Array<BadgeClass>>;
  /** Get list of BadgeClasses under a topic */
  badgeClassesByTopic: Array<BadgeClass>;
  /** Get list of BadgeClasses under list of topics */
  badgeClassesByTopics: Array<BadgeClass>;
  /** Retrieve a bundle by its unique identifier */
  bundle?: Maybe<Bundle>;
  /** List bundles that contain a specific item */
  bundlesByBundleItem: BundlesPaged;
  /** List bundles associated with a given topic */
  bundlesByTopicId: BundlesPaged;
  /** Retrieve a Career Accelerator by ID. */
  careerAccelerator?: Maybe<CareerAccelerator>;
  /** Retrieve a Career Accelerator by slug. */
  careerAcceleratorBySlug?: Maybe<CareerAccelerator>;
  /** Retrieve a paginated list of Career Accelerators with optional filters and pagination. */
  careerAccelerators: CareerAcceleratorsPaged;
  /** Retrieve Career Accelerators associated with specific Course IDs. */
  careerAcceleratorsByCourseIds?: Maybe<Array<Maybe<Array<Maybe<CareerAccelerator>>>>>;
  /** Retrieve multiple Career Accelerators by their IDs. */
  careerAcceleratorsByIds: Array<CareerAccelerator>;
  /** Retrieve all categories */
  categories: Array<Category>;
  /** Get a certification voucher exam by slug */
  certificationVoucherExamBySlug?: Maybe<CertificationVoucherExam>;
  /** Get a certification voucher exam by certification topic ID */
  certificationVoucherExamByTopicId?: Maybe<CertificationVoucherExam>;
  /** Get a list of certification voucher exams with optional certification provider filter */
  certificationVoucherExams: CertificationVoucherExamsPaged;
  /** Get multiple certification voucher exams by IDs */
  certificationVoucherExamsByIds: Array<Maybe<CertificationVoucherExam>>;
  /** Get the current user's recommended voucher exams */
  certificationVoucherExamsRecommended?: Maybe<Array<Maybe<CertificationVoucherExam>>>;
  /** Get a voucher pool by certification topic id */
  certificationVoucherPoolByTopicId?: Maybe<CertificationVoucherPool>;
  /** Get a paginated list of all certification voucher pools */
  certificationVoucherPools: CertificationVoucherPoolsPaged;
  /** Get a list of voucher pools by id */
  certificationVoucherPoolsById?: Maybe<Array<Maybe<CertificationVoucherPool>>>;
  /** Get a list of voucher pools by slug */
  certificationVoucherPoolsBySlug?: Maybe<Array<Maybe<CertificationVoucherPool>>>;
  /** Fetches a coding exercise by its ID */
  codingExercise?: Maybe<CodingExercise>;
  /** Retrieve a set of coding exercise templates by their language */
  codingExerciseTemplatesByLanguage: Array<CodingExerciseTemplate>;
  /** Returns a content collection by its ID */
  contentCollection?: Maybe<ContentCollection>;
  /** Retrieve a course by its ID */
  course?: Maybe<Course>;
  /** Get AI highlights for a course */
  courseAiHighlightsByCourseId?: Maybe<CourseAiHighlights>;
  /**
   * Retrieves list of Assessments associated with course id that contain items a user attempted. Can filter by correct,
   * skipped or incorrect Items with default returning all 3. A course may have multiple Assessments associated with it.
   */
  courseAssessmentItemResults: Array<AssessmentResults>;
  /**
   * Retrieve a course by its landing URL with optional access credentials.
   *
   * If the course is publicly accessible, credentials are ignored and the course is returned.
   *
   * If the course is private and the correct credential is supplied, the course is returned.
   *
   * If the course is not found, returns null.
   *
   * If the course exists but is inaccessible, returns null with a GraphQL error extension
   * describing why access was denied so the frontend can render the appropriate UI.
   *
   * Error extension shape (untyped JSON, not part of the schema):
   *   code: "ACCESS_RESTRICTED"
   *   courseAccessRestriction: "PASSWORD_PROTECTED" | "INVITE_ONLY" | "UNAVAILABLE_IN_YOUR_ORGANIZATION" | "UNAVAILABLE"
   *     All values come from CRS CourseAccessContext. For UNAVAILABLE_IN_YOUR_ORGANIZATION,
   *     CRS calls ContentAccessControlService internally after standard access checks pass.
   *   passwordError: String        (populated when a wrong password was supplied)
   */
  courseByLandingURL?: Maybe<Course>;
  /** Retrieve a course by its versioned identifier */
  courseByVersionedIdentifier?: Maybe<Course>;
  /** Retrieve course catalog for the client */
  courseCatalogFull?: Maybe<CourseCatalogFullResponsePaged>;
  /** Retrieve changes to course catalog since last sync */
  courseCatalogUpdated?: Maybe<CourseCatalogUpdatedResponsePaged>;
  /** Retrieve a category by id */
  courseCategory?: Maybe<CourseCategory>;
  /** Get course copy request by ID */
  courseCopyRequest?: Maybe<CourseCopyRequest>;
  /** Get all course copy requests for the current user */
  courseCopyRequests: Array<CourseCopyRequest>;
  /** Get course copy requests by original course ID */
  courseCopyRequestsByOriginalCourseId: Array<CourseCopyRequest>;
  /** Search for courses */
  courseSearch?: Maybe<CourseSearchResponse>;
  /** Get Course Variation Aggregation for a given aggregation ID */
  courseVariationAggregation: CourseVariationAggregation;
  /** Get Course Variation Aggregation for a given course ID */
  courseVariationAggregationByCourseId: CourseVariationAggregation;
  /** Get all Course Variations Aggregations owned by the current user */
  courseVariationAggregations: Array<CourseVariationAggregation>;
  /** Retrieve a set of courses by their IDs */
  courses: Array<Maybe<Course>>;
  /** Retrieve a set of courses by their landing URLs */
  coursesByLandingURLs: Array<Maybe<Course>>;
  /** Retrieve a set of courses by their versioned identifiers */
  coursesByVersionedIdentifiers: Array<Maybe<Course>>;
  /** Get curated courses for a category */
  coursesCuratedByCategorySlug?: Maybe<Array<Maybe<Course>>>;
  /** Get curated courses for a subcategory */
  coursesCuratedBySubcategorySlug?: Maybe<Array<Maybe<Course>>>;
  /** Get recommended courses for an assessment */
  coursesRecommendedByAssessment: Array<Course>;
  /** Fetch the current subscription of user or subscription of user's organization if user is a member of an organization. Current subscription could be cancelled or expired. */
  currentSubscriptionEnrollment?: Maybe<SubscriptionEnrollment>;
  /** The query to get the dynamic web content for the component represented by the `contentId` filter */
  dynamicWebContent: DynamicWebContent;
  /** Returns assigned feature variants by configuration context code */
  featureVariantAssignmentsByConfigurationContextCode: Array<FeatureVariantAssignment>;
  /** Returns assigned feature variants */
  featureVariantAssignmentsByFeatureCodes: Array<FeatureVariantAssignment>;
  /** Return featured reviews for a given set of topics */
  featuredReviewsByTopics: Array<Review>;
  /** A query to return the account balance amount. */
  instructorAccountBalance?: Maybe<InstructorAccountBalance>;
  /** A query to return instructor's account issues. */
  instructorAccountIssues?: Maybe<InstructorAccountIssues>;
  /** Get the linked opportunity of a course */
  instructorContentOpportunityByCourse?: Maybe<InstructorContentOpportunity>;
  /** Get content opportunities by filters, pagination and query text */
  instructorContentOpportunitySearch?: Maybe<InstructorContentOpportunitySearchResponse>;
  /** A query to return a list of instructor's payouts. Page size is fixed to 15 */
  instructorPayoutsByPage?: Maybe<InstructorPayoutsPaged>;
  /**
   * Fetches the curriculum for a course including unpublished curriculum items and draft Practice Tests, for use in instructor preview.
   * Unlike the standard `Course.curriculum` field, this returns all curriculum items regardless of publish status.
   * Nested fields within sections (e.g. `CourseSection.course`) behave the same as the standard `course` query.
   */
  instructorPreviewCurriculumByCourseId?: Maybe<InstructorPreviewCurriculum>;
  /** Fetch an asset by ID */
  interactionWidgetAsset?: Maybe<InteractionWidgetAsset>;
  /** Compute the correct session for a release */
  interactionWidgetCorrectSession?: Maybe<InteractionWidgetSession>;
  /** Get a default definition for a release */
  interactionWidgetDefaultDefinition?: Maybe<InteractionWidgetDefinition>;
  /** Get a default session for a release */
  interactionWidgetDefaultSession?: Maybe<InteractionWidgetSession>;
  /** Fetch a definition by type, release, and definition ID */
  interactionWidgetDefinition?: Maybe<InteractionWidgetDefinition>;
  /** Definitions for a release */
  interactionWidgetDefinitions: InteractionWidgetDefinitionsPaged;
  /** Fetch a release by type ID and release ID */
  interactionWidgetRelease?: Maybe<InteractionWidgetRelease>;
  /** Compute release model */
  interactionWidgetReleaseComputeModel?: Maybe<InteractionWidgetReleaseComputeModelResponse>;
  /** Fetch a published release bundle */
  interactionWidgetReleasePublishedBundle?: Maybe<InteractionWidgetReleaseBundle>;
  /** Releases for an interaction type */
  interactionWidgetReleases: InteractionWidgetReleasesPaged;
  /** Fetch a session by type, release, and session ID */
  interactionWidgetSession?: Maybe<InteractionWidgetSession>;
  /** Sessions for a release */
  interactionWidgetSessions: InteractionWidgetSessionsPaged;
  /** Fetch an interaction type by ID */
  interactionWidgetType?: Maybe<InteractionWidgetType>;
  /** Interaction types with pagination and source filtering */
  interactionWidgetTypes: InteractionWidgetTypePaged;
  /** Retrieve a Lab by its ID */
  lab?: Maybe<Lab>;
  /** Search for labs */
  labSearch?: Maybe<LabSearchResponse>;
  /** Retrieve a set of Labs by their IDs */
  labs: Array<Maybe<Lab>>;
  /**
   * Query to get summary of learning activity of a user like total learning minutes consumed based on the filter.
   * Note that this query only works for UB users.
   */
  learningActivitySummary?: Maybe<LearningActivityRecord>;
  /**
   * Query to get learning activity of a user based on the filter.
   * Note that this query only works for UB users.
   */
  learningActivityTrend?: Maybe<LearningActivityTrend>;
  /** List chat message history for chat sessions by context with pagination support */
  learningAssistantChatHistoryMessages: LearningAssistantChatMessagesPaged;
  /** List chat messages for a chat session since the given timestamp */
  learningAssistantChatMessages: LearningAssistantChatMessagesPaged;
  /** Retrieve a set of suggested prompts that users can ask the assistant */
  learningAssistantSuggestedPrompts: LearningAssistantSuggestedPromptsPaged;
  /** Fetch new presigned URLs for previously uploaded files, allowing clients to re-access the files via GET */
  learningAssistantUploadedPresignedUrls: LearningAssistantFileUploadUrlResponse;
  /** Returns any user quota that has exceeded. If no user quota has exceeded, it returns the first quota */
  learningAssistantUserQuota: LearningAssistantUserQuotaResponse;
  /** Get learning objectives by skills framework id and learning objective ids */
  learningObjectivesByIdsAndSkills: Array<Maybe<LearningObjective>>;
  /** Get learning objectives by skills framework id and activities */
  learningObjectivesBySkillsAndActivities: Array<Maybe<LearningObjective>>;
  /** Retrieve a learning path by its ID */
  learningPath?: Maybe<LearningPath>;
  /** Retrieve learning path catalog for the client */
  learningPathCatalogFull?: Maybe<LearningPathCatalogFullResponsePaged>;
  /** Retrieve updates to the learning path catalog for the client */
  learningPathCatalogUpdated?: Maybe<LearningPathCatalogUpdatedResponsePaged>;
  /** Searches paths by given query */
  learningPathSearch?: Maybe<LearningPathSearchResponse>;
  /** Retrieve a paginated list of learning product access requests for the current organization */
  learningProductAccessRequests: LearningProductAccessRequestsPaged;
  /**
   * Returns available learning products for the client.
   * When the caller's JWT contains a partner_id, only courses are returned regardless of the filter (legacy partner behaviour).
   * When no partner_id is present, filter.type is applied and all supported learning product types are returned.
   */
  learningProducts: LearningProductsPaged;
  /** Retrieve a Learning Reminder by its ID */
  learningReminder?: Maybe<LearningReminder>;
  /** List Learning Reminders for a user inferred from an authentication context */
  learningReminders: LearningRemindersPaged;
  /** Returns a list of Learning Testimonials based on the page type */
  learningTestimonials: Array<Maybe<LearningTestimonial>>;
  /** Fetches a lecture by its ID */
  lecture?: Maybe<Lecture>;
  /** Searches lectures semantically for given query. To get a result, query must be in english and at least three words. The search team has been focused on leveraging semantic search to be able to recommend the right lectures for users. Instead of relying on just titles and descriptions, the team leverage caption data to understand content better and provide better results */
  lectureSearch?: Maybe<LectureSearchResponse>;
  /**
   * Fetches all AI-generated lecture summaries for a course
   * @deprecated Use aiSummary field on VideoLecture instead
   */
  lectureSummariesForCourse?: Maybe<Array<Maybe<LectureSummary>>>;
  /** Fetches multiple lectures by their IDs */
  lectures: Array<Maybe<Lecture>>;
  /** Fetches the latest released version of a Lesson */
  lesson?: Maybe<Lesson>;
  /** Fetches the public version of a lesson if available */
  lessonPublic?: Maybe<Lesson>;
  /** Get license pools */
  licensePools: Array<LicensePool>;
  /** Returns a list of pools with active user counts per product type */
  licensePoolsActiveUserCounts: Array<Maybe<LicensePoolActiveUserCountPerPool>>;
  /** Returns a list of pools that the given user can invite others to */
  licensePoolsByInviter: Array<LicensePool>;
  /** Preview of the license pools if given users were to be moved into the target license pool */
  licensePoolsUsersMovePreview: Array<LicensePool>;
  /**
   * Fetch the marketing intro cards row component.
   * This component displays intro copy on the left and a fixed row of cards on the right.
   */
  marketingIntroCardsRowV1?: Maybe<MarketingIntroCardsRowV1>;
  /**
   * Fetch the marketing split bulleted media component.
   * This component displays marketing copy with bullet points on the left and an image on the right.
   */
  marketingSplitBulletedMediaV1?: Maybe<MarketingSplitBulletedMediaV1>;
  /**
   * Fetch the marketing split cards carousel component.
   * This component displays marketing copy on the left and a carousel of cards on the right.
   * Returns all cards in a single request.
   */
  marketingSplitCardsCarouselV1?: Maybe<MarketingSplitCardsCarouselV1>;
  /**
   * Fetch the marketing split popular topics directory component.
   * This component displays a featured popular topic on the left and categorized topics directory on the right.
   */
  marketingSplitPopularTopicsDirectoryV1?: Maybe<MarketingSplitPopularTopicsDirectoryV1>;
  /**
   * Fetch the marketing tabs topics cards component.
   * This component displays a tabbed interface where topic selection controls course cards.
   */
  marketingTabsTopicsCardsV1?: Maybe<MarketingTabsTopicsCardsV1>;
  /** Query the current user */
  me: Me;
  /** This query is used to fetch more RecommendationContextSections from a RecommendationContext */
  moreRecommendationContextSections: MoreRecommendationContextSectionsResponse;
  /** This query is used to fetch more RecommendationItems from a RecommendationUnit */
  moreRecommendationItems: MoreRecommendationItemsResponse;
  /** Get the navigation list for a given name. */
  navList: Array<Maybe<NavListItem>>;
  /** Fetch occupation groups */
  occupationGroups: Array<Maybe<OccupationGroup>>;
  /** Search occupations */
  occupationSearch: OccupationPaged;
  /** Fetch occupations by ID */
  occupations: Array<Maybe<Occupation>>;
  /** Retrieves audit logs for a specific organization within a date range. */
  organizationAuditLogSearch: Array<OrganizationAuditLog>;
  /** Fetch an organization badge class by ID */
  organizationBadgeClass?: Maybe<OrganizationBadgeClass>;
  /** Fetch organization badge classes by IDs */
  organizationBadgeClasses: Array<Maybe<OrganizationBadgeClass>>;
  /** Query to get Organization Insights based on date range and buckets */
  organizationInsights?: Maybe<OrganizationInsights>;
  /** Retrieve a Organization Learning Goal by ID. */
  organizationLearningGoal?: Maybe<OrganizationLearningGoal>;
  /** Retrieve a set of organization learning goals by status. */
  organizationLearningGoalsByStatus?: Maybe<Array<Maybe<OrganizationLearningGoal>>>;
  /** Returns organization notification preferences */
  organizationNotificationPreferences: Array<OrganizationRoleBasedNotificationPreference>;
  /** Fetch settings for an organization by organization ID */
  organizationSettings: OrganizationSettings;
  /** Fetch specified settings for an organization by the setting names and organization ID, V1 */
  organizationSettingsByNamesAndOrganizationId: Array<OrganizationSetting>;
  /** Get the current licenses assigned to the User calling this Query in their org, filtered by type and if it is active or not */
  organizationUserLicenses?: Maybe<Array<OrganizationUserLicense>>;
  /** A query to check if payout exists with the given statuses and methods. */
  payoutExists?: Maybe<Scalars['Boolean']['output']>;
  /** Gets a list of all popular topics */
  popularTopicsByCategoryId: Array<Maybe<PopularTopic>>;
  /** Fetches a practice assignment by its ID */
  practiceAssignment?: Maybe<PracticeAssignment>;
  /** Fetches a practice test by its ID */
  practiceTest?: Maybe<PracticeTest>;
  /** Find the practice-test, its version history and the questions that were active between the dates specified in the filters, and all of their instructor relevant insights for given scope and date range */
  practiceTestsByIdAndChannel?: Maybe<InstructorInsightPracticeTest>;
  /** Get Pro learning paths by topic */
  proLearningPathsByTopic: Array<ProLearningPath>;
  /** Get query refinement suggestions by type. */
  queryRefinement?: Maybe<QueryRefinementResponse>;
  /** Fetches a quiz by its ID */
  quiz?: Maybe<Quiz>;
  /** Get quiz items by quiz ID and pagination */
  quizItemSearch?: Maybe<QuizItemSearchResponse>;
  /** Get the latest quiz attempt of an user by quiz ID */
  quizLatestAttemptByQuizId?: Maybe<QuizAttempt>;
  /**
   * When a page is being loaded initially, this query is made without a cursor. First slice of sections is returned
   * according to 'requestedSectionCount' parameter. Later, a new slice of sections can be fetched by
   * moreRecommendationContextSections query.
   */
  recommendations: RecommendationContextResponse;
  /** Search for autocomplete */
  searchAutocomplete: Array<Maybe<SearchAutocompleteSuggestion>>;
  /** Get search recommendation results for a query. */
  searchRecommendation?: Maybe<SearchRecommendationResponse>;
  /** Get skills framework by learning path id and optional versionId */
  skillsFrameworkByGeneratedLearningPath?: Maybe<SkillsFramework>;
  /** Get Skills Framework by id and type with optional versionId */
  skillsFrameworkByIdAndType?: Maybe<SkillsFramework>;
  /** Get reference id status for mapping content to skills framework */
  skillsFrameworkMapContentTask?: Maybe<SkillsFrameworkMapContentTask>;
  /** Get a Skills Preparation by its uniquely identifying parts */
  skillsPrep?: Maybe<SkillsPrep>;
  /** Get Skills Preparations by userId, a status filter can be used to restrict the results */
  skillsPrepsByUserId: Array<SkillsPrep>;
  /** Get Skills Preparations for the logged in user, a status filter can be used to restrict the results */
  skillsPrepsForLoggedInUser: Array<SkillsPrep>;
  /** Retrieve assessment trend data over time (daily breakdown) */
  skillsProficiencyAssessmentTrend?: Maybe<Array<AssessmentTrendDataPoint>>;
  /** Retrieve number of learners at each proficiency level */
  skillsProficiencyLevelCounts?: Maybe<ProficiencyLevelCountsChange>;
  /** Retrieve high-level skills proficiency metrics for an organization */
  skillsProficiencyMetrics?: Maybe<SkillsProficiencyMetrics>;
  /** Get current lecture consumption streak data for a request's user. */
  streakLectureConsumptionWeekly: StreakLectureConsumptionWeekly;
  /**
   * Engagement recap metrics for the authenticated subscriber.
   * Covers the user's current subscription period.
   */
  subscriberEngagementRecap?: Maybe<SubscriberEngagementRecap>;
  /** Retrieve all subscription features with their availability for the given subscriber (only available for applications with admin:application scope) */
  subscriptionFeaturesAllWithAvailabilityBySubscriber: Array<SubscriptionFeature>;
  /** Retrieve availability of the given subscription features for the user */
  subscriptionFeaturesAvailabilityByKeys: Array<SubscriptionFeatureAvailability>;
  /** Returns upgradable subscription plans for a given user within the same product family */
  subscriptionPlanUpgradesByProductFamily: Array<SubscriptionPlan>;
  /** Returns available subscription plans for a given user */
  subscriptionPlans: Array<SubscriptionPlan>;
  /** Returns a topic by ID */
  topic?: Maybe<Topic>;
  /** Returns a list of topic groups by ID */
  topicGroups: Array<TopicGroup>;
  /** Fetch topics user has expressed interest in */
  topicInterests: Array<Topic>;
  /** Search topics */
  topicSearch: Array<Topic>;
  /** Retrieve detailed  assessment breakdown for selected topics */
  topicToAssessmentsSummary?: Maybe<TopicToAssessmentsSummaryResponse>;
  /** Return a list of topics by ID */
  topics: Array<Topic>;
  /** The current user's checklists, optionally filtered by name */
  userChecklists: Array<UserChecklist>;
  /** Returns user notification preferences */
  userNotificationPreferences: Array<UserNotificationPreference>;
  /** Returns the details of current user occupation */
  userOccupationInfo: UserOccupationInfo;
};


/** Root query from which every query schema extends */
export type QueryApiClientArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryAssessmentArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryAssessmentAttemptsSummariesByAssessmentIdsArgs = {
  assessmentIds: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryAssessmentAttemptsSummariesByCollectionArgs = {
  collectionId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryAssessmentAttemptsSummaryArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryAssessmentAttemptsSummaryByCoursePrimaryTopicArgs = {
  courseId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryAssessmentAttemptsSummaryBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** Root query from which every query schema extends */
export type QueryAssessmentAttemptsSummaryForMarketplaceCourseArgs = {
  courseId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryAssessmentResultsByCourseArgs = {
  courseId: Scalars['ID']['input'];
  filters?: InputMaybe<AssessmentItemResultsFilters>;
};


/** Root query from which every query schema extends */
export type QueryAssessmentSearchArgs = {
  query: Scalars['String']['input'];
  triggerType?: SearchTriggerType;
};


/** Root query from which every query schema extends */
export type QueryAssessmentSummaryArgs = {
  input: AssessmentSummaryInput;
};


/** Root query from which every query schema extends */
export type QueryAssessmentVariantAttemptsLatestByCollectionArgs = {
  collectionId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryAssessmentsByCollectionArgs = {
  collectionId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryAssessmentsByCoursePrimaryTopicArgs = {
  courseId: Scalars['ID']['input'];
  maxResults?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query from which every query schema extends */
export type QueryAssessmentsRecommendedByCourseArgs = {
  courseId: Scalars['ID']['input'];
  maxResults?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query from which every query schema extends */
export type QueryAssetArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryBadgeAssertionArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryBadgeAssertionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryBadgeAssertionsByUserArgs = {
  page?: Scalars['NonNegativeInt']['input'];
  pageSize?: Scalars['MaxResultsPerPage']['input'];
  userId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryBadgeAssertionsForCurrentOrganizationArgs = {
  filters?: InputMaybe<BadgeAssertionsSearchFilters>;
  page?: Scalars['NonNegativeInt']['input'];
  pageSize?: Scalars['MaxResultsPerPage']['input'];
};


/** Root query from which every query schema extends */
export type QueryBadgeAssertionsImportedArgs = {
  page?: Scalars['NonNegativeInt']['input'];
  pageSize?: Scalars['MaxResultsPerPage']['input'];
};


/** Root query from which every query schema extends */
export type QueryBadgeClassArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryBadgeClassAdminSearchArgs = {
  filters?: InputMaybe<BadgeClassSearchFilters>;
  page?: Scalars['NonNegativeInt']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  size?: Scalars['MaxResultsPerPage']['input'];
};


/** Root query from which every query schema extends */
export type QueryBadgeClassEnrollmentsByBadgeClassIdArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryBadgeClassOrganizationSearchArgs = {
  filters?: InputMaybe<BadgeClassOrganizationSearchFilters>;
  page: Scalars['NonNegativeInt']['input'];
  pageSize?: Scalars['MaxResultsPerPage']['input'];
};


/** Root query from which every query schema extends */
export type QueryBadgeClassSearchArgs = {
  filters?: InputMaybe<BadgeClassSearchFilters>;
  page: Scalars['NonNegativeInt']['input'];
  pageSize?: Scalars['MaxResultsPerPage']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/** Root query from which every query schema extends */
export type QueryBadgeClassesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryBadgeClassesByLearningProductsArgs = {
  learningProducts: Array<LearningProductInput>;
};


/** Root query from which every query schema extends */
export type QueryBadgeClassesByTopicArgs = {
  topicId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryBadgeClassesByTopicsArgs = {
  topicIds: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryBundleArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryBundlesByBundleItemArgs = {
  bundleItem: BundleItemInput;
  pageInfo?: InputMaybe<CursorPaginatedInput>;
};


/** Root query from which every query schema extends */
export type QueryBundlesByTopicIdArgs = {
  pageInfo?: InputMaybe<CursorPaginatedInput>;
  topicId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryCareerAcceleratorArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryCareerAcceleratorBySlugArgs = {
  isInGooglePartnerCollectionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
};


/** Root query from which every query schema extends */
export type QueryCareerAcceleratorsArgs = {
  filters?: InputMaybe<CareerAcceleratorsFilters>;
  pageInfo?: InputMaybe<CursorPaginatedInput>;
};


/** Root query from which every query schema extends */
export type QueryCareerAcceleratorsByCourseIdsArgs = {
  courseIds: Array<Scalars['ID']['input']>;
  isInGooglePartnerCollectionOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query from which every query schema extends */
export type QueryCareerAcceleratorsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryCertificationVoucherExamBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** Root query from which every query schema extends */
export type QueryCertificationVoucherExamByTopicIdArgs = {
  topicId: Scalars['String']['input'];
};


/** Root query from which every query schema extends */
export type QueryCertificationVoucherExamsArgs = {
  excludedProviderTypes?: InputMaybe<Array<CertificationVoucherProviderType>>;
  pageInfo?: InputMaybe<CursorPaginatedInput>;
  providerTypes?: InputMaybe<Array<CertificationVoucherProviderType>>;
};


/** Root query from which every query schema extends */
export type QueryCertificationVoucherExamsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryCertificationVoucherPoolByTopicIdArgs = {
  topicId: Scalars['String']['input'];
};


/** Root query from which every query schema extends */
export type QueryCertificationVoucherPoolsArgs = {
  pageInfo?: InputMaybe<CursorPaginatedInput>;
};


/** Root query from which every query schema extends */
export type QueryCertificationVoucherPoolsByIdArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryCertificationVoucherPoolsBySlugArgs = {
  slugs: Array<Scalars['String']['input']>;
};


/** Root query from which every query schema extends */
export type QueryCodingExerciseArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryCodingExerciseTemplatesByLanguageArgs = {
  filters?: InputMaybe<CodingExerciseTemplateFilters>;
  language: CodingExerciseLanguageOption;
};


/** Root query from which every query schema extends */
export type QueryContentCollectionArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryCourseArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryCourseAiHighlightsByCourseIdArgs = {
  courseId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryCourseAssessmentItemResultsArgs = {
  courseId: Scalars['ID']['input'];
  filters?: InputMaybe<AssessmentItemResultsFilters>;
};


/** Root query from which every query schema extends */
export type QueryCourseByLandingUrlArgs = {
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  landingURL: Scalars['URL']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


/** Root query from which every query schema extends */
export type QueryCourseByVersionedIdentifierArgs = {
  versionedIdentifier: VersionedIdentifierInput;
};


/** Root query from which every query schema extends */
export type QueryCourseCatalogFullArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['MaxResultsPerPage']['input']>;
};


/** Root query from which every query schema extends */
export type QueryCourseCatalogUpdatedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['MaxResultsPerPage']['input']>;
  syncToken: Scalars['String']['input'];
};


/** Root query from which every query schema extends */
export type QueryCourseCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryCourseCopyRequestArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryCourseCopyRequestsByOriginalCourseIdArgs = {
  originalCourseId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryCourseSearchArgs = {
  context: CourseSearchContext;
  filters?: InputMaybe<CourseSearchFilters>;
  page?: Scalars['NonNegativeInt']['input'];
  pageSize?: Scalars['MaxResultsPerPage']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<CourseSearchSortType>;
};


/** Root query from which every query schema extends */
export type QueryCourseVariationAggregationArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryCourseVariationAggregationByCourseIdArgs = {
  courseId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryCoursesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryCoursesByLandingUrLsArgs = {
  landingURLs: Array<Scalars['URL']['input']>;
};


/** Root query from which every query schema extends */
export type QueryCoursesByVersionedIdentifiersArgs = {
  versionedIdentifiers: Array<VersionedIdentifierInput>;
};


/** Root query from which every query schema extends */
export type QueryCoursesCuratedByCategorySlugArgs = {
  slug: Scalars['String']['input'];
};


/** Root query from which every query schema extends */
export type QueryCoursesCuratedBySubcategorySlugArgs = {
  slug: Scalars['String']['input'];
};


/** Root query from which every query schema extends */
export type QueryCoursesRecommendedByAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
  maxResults?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query from which every query schema extends */
export type QueryDynamicWebContentArgs = {
  filters: DynamicWebContentFilters;
};


/** Root query from which every query schema extends */
export type QueryFeatureVariantAssignmentsByConfigurationContextCodeArgs = {
  configurationContextCode: Scalars['String']['input'];
  filters?: InputMaybe<FeatureVariantAssignmentFilters>;
};


/** Root query from which every query schema extends */
export type QueryFeatureVariantAssignmentsByFeatureCodesArgs = {
  featureCodes: Array<Scalars['String']['input']>;
  filters?: InputMaybe<FeatureVariantAssignmentFilters>;
};


/** Root query from which every query schema extends */
export type QueryFeaturedReviewsByTopicsArgs = {
  topicIds: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryInstructorContentOpportunityByCourseArgs = {
  courseId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryInstructorContentOpportunitySearchArgs = {
  filters?: InputMaybe<InstructorContentOpportunityFilters>;
  page?: Scalars['NonNegativeInt']['input'];
  pageSize?: Scalars['MaxResultsPerPage']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<InstructorContentOpportunitySortType>;
};


/** Root query from which every query schema extends */
export type QueryInstructorPayoutsByPageArgs = {
  page: Scalars['Int']['input'];
};


/** Root query from which every query schema extends */
export type QueryInstructorPreviewCurriculumByCourseIdArgs = {
  courseId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetAssetArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetCorrectSessionArgs = {
  context: InteractionWidgetContext;
  definition?: InputMaybe<InteractionWidgetEntityRef>;
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
  useLatestCompatibleAssets?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetDefaultDefinitionArgs = {
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
  useLatestCompatibleAssets?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetDefaultSessionArgs = {
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
  useLatestCompatibleAssets?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetDefinitionArgs = {
  definitionId: Scalars['ID']['input'];
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetDefinitionsArgs = {
  pageInfo?: InputMaybe<CursorPaginatedInput>;
  releaseId: Scalars['ID']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InteractionWidgetSource>;
  typeId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetReleaseArgs = {
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetReleaseComputeModelArgs = {
  context: InteractionWidgetContext;
  definition?: InputMaybe<InteractionWidgetEntityRef>;
  releaseId: Scalars['ID']['input'];
  session?: InputMaybe<InteractionWidgetEntityRef>;
  typeId: Scalars['ID']['input'];
  useLatestCompatibleAssets?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetReleasePublishedBundleArgs = {
  releaseId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
  useLatestCompatibleAssets?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetReleasesArgs = {
  pageInfo?: InputMaybe<CursorPaginatedInput>;
  typeId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetSessionArgs = {
  releaseId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  typeId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetSessionsArgs = {
  pageInfo?: InputMaybe<CursorPaginatedInput>;
  releaseId: Scalars['ID']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
  typeId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetTypeArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryInteractionWidgetTypesArgs = {
  pageInfo?: InputMaybe<CursorPaginatedInput>;
  source?: InputMaybe<InteractionWidgetSource>;
};


/** Root query from which every query schema extends */
export type QueryLabArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryLabSearchArgs = {
  filters?: InputMaybe<Array<SearchAggregationInputOption>>;
  query: Scalars['String']['input'];
  triggerType?: SearchTriggerType;
};


/** Root query from which every query schema extends */
export type QueryLabsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryLearningActivitySummaryArgs = {
  filters?: InputMaybe<LearningActivitySummaryFilters>;
};


/** Root query from which every query schema extends */
export type QueryLearningActivityTrendArgs = {
  filters?: InputMaybe<LearningActivityTrendFilters>;
};


/** Root query from which every query schema extends */
export type QueryLearningAssistantChatHistoryMessagesArgs = {
  before: Scalars['Timestamp']['input'];
  context?: InputMaybe<LearningAssistantChatContextInput>;
  name: LearningAssistantChatName;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['MaxResultsPerPage']['input']>;
};


/** Root query from which every query schema extends */
export type QueryLearningAssistantChatMessagesArgs = {
  chatId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['Timestamp']['input']>;
  size?: InputMaybe<Scalars['MaxResultsPerPage']['input']>;
};


/** Root query from which every query schema extends */
export type QueryLearningAssistantSuggestedPromptsArgs = {
  context?: InputMaybe<LearningAssistantChatContextInput>;
  name: LearningAssistantChatName;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSource: LearningAssistantSuggestedPromptPageSource;
  size?: InputMaybe<Scalars['MaxResultsPerPage']['input']>;
};


/** Root query from which every query schema extends */
export type QueryLearningAssistantUploadedPresignedUrlsArgs = {
  chatId: Scalars['ID']['input'];
  files: Array<LearningAssistantUploadedPresignedUrlInput>;
};


/** Root query from which every query schema extends */
export type QueryLearningObjectivesByIdsAndSkillsArgs = {
  ids: Array<Scalars['ID']['input']>;
  skillsFrameworkId: Scalars['ID']['input'];
  type: SkillsFrameworkGoalType;
};


/** Root query from which every query schema extends */
export type QueryLearningObjectivesBySkillsAndActivitiesArgs = {
  activities: Array<LearningObjectiveActivityInput>;
  skillsFrameworkId: Scalars['ID']['input'];
  type: SkillsFrameworkGoalType;
};


/** Root query from which every query schema extends */
export type QueryLearningPathArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryLearningPathCatalogFullArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['MaxResultsPerPage']['input']>;
};


/** Root query from which every query schema extends */
export type QueryLearningPathCatalogUpdatedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['MaxResultsPerPage']['input']>;
  syncToken: Scalars['String']['input'];
};


/** Root query from which every query schema extends */
export type QueryLearningPathSearchArgs = {
  filters?: InputMaybe<LearningPathSearchFilters>;
  query: Scalars['String']['input'];
  triggerType?: SearchTriggerType;
};


/** Root query from which every query schema extends */
export type QueryLearningProductAccessRequestsArgs = {
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  size?: InputMaybe<Scalars['MaxResultsPerPage']['input']>;
};


/** Root query from which every query schema extends */
export type QueryLearningProductsArgs = {
  filter?: InputMaybe<LearningProductsItemsFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['MaxResultsPerPage']['input']>;
};


/** Root query from which every query schema extends */
export type QueryLearningReminderArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryLearningRemindersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['MaxResultsPerPage']['input']>;
};


/** Root query from which every query schema extends */
export type QueryLearningTestimonialsArgs = {
  filters: LearningTestimonialFilters;
};


/** Root query from which every query schema extends */
export type QueryLectureArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryLectureSearchArgs = {
  query: Scalars['String']['input'];
  triggerType?: SearchTriggerType;
};


/** Root query from which every query schema extends */
export type QueryLectureSummariesForCourseArgs = {
  courseId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryLecturesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryLessonArgs = {
  id: LessonIdInput;
  localeInput?: LocaleInput;
};


/** Root query from which every query schema extends */
export type QueryLessonPublicArgs = {
  id: LessonIdInput;
};


/** Root query from which every query schema extends */
export type QueryLicensePoolsActiveUserCountsArgs = {
  filters?: InputMaybe<LicensePoolsActiveUserFilters>;
};


/** Root query from which every query schema extends */
export type QueryLicensePoolsByInviterArgs = {
  userId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryLicensePoolsUsersMovePreviewArgs = {
  targetPoolId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryMoreRecommendationContextSectionsArgs = {
  params: MoreRecommendationContextSectionsInput;
};


/** Root query from which every query schema extends */
export type QueryMoreRecommendationItemsArgs = {
  params: MoreRecommendationItemsInput;
};


/** Root query from which every query schema extends */
export type QueryNavListArgs = {
  name: NavListName;
};


/** Root query from which every query schema extends */
export type QueryOccupationGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Root query from which every query schema extends */
export type QueryOccupationSearchArgs = {
  filters?: InputMaybe<OccupationSearchFilters>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/** Root query from which every query schema extends */
export type QueryOccupationsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryOrganizationAuditLogSearchArgs = {
  filter: OrganizationAuditLogFilter;
};


/** Root query from which every query schema extends */
export type QueryOrganizationBadgeClassArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryOrganizationBadgeClassesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryOrganizationInsightsArgs = {
  organizationInsightsFilter?: InputMaybe<OrganizationInsightsFilterInput>;
};


/** Root query from which every query schema extends */
export type QueryOrganizationLearningGoalArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryOrganizationLearningGoalsByStatusArgs = {
  goalStatus?: InputMaybe<OrganizationLearningGoalStatus>;
};


/** Root query from which every query schema extends */
export type QueryOrganizationSettingsArgs = {
  organizationId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryOrganizationSettingsByNamesAndOrganizationIdArgs = {
  names: Array<OrganizationSettingName>;
  organizationId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryOrganizationUserLicensesArgs = {
  filters?: InputMaybe<OrganizationUserLicensesFilters>;
};


/** Root query from which every query schema extends */
export type QueryPayoutExistsArgs = {
  filter: PayoutExistsSearchFilterInput;
};


/** Root query from which every query schema extends */
export type QueryPopularTopicsByCategoryIdArgs = {
  categoryId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryPracticeAssignmentArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryPracticeTestArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryPracticeTestsByIdAndChannelArgs = {
  filters?: InputMaybe<PracticeTestInsightFilters>;
  id: Scalars['ID']['input'];
  scope: LearnerChannel;
};


/** Root query from which every query schema extends */
export type QueryProLearningPathsByTopicArgs = {
  topicId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryQueryRefinementArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
  triggerType?: QueryRefinementTriggerType;
  type: QueryRefinementType;
};


/** Root query from which every query schema extends */
export type QueryQuizArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryQuizItemSearchArgs = {
  page?: Scalars['NonNegativeInt']['input'];
  pageSize?: Scalars['MaxResultsPerPage']['input'];
  quizId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryQuizLatestAttemptByQuizIdArgs = {
  quizId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryRecommendationsArgs = {
  params: RecommendationContextInput;
};


/** Root query from which every query schema extends */
export type QuerySearchAutocompleteArgs = {
  filters?: InputMaybe<SearchAutocompleteRequestFilters>;
  limit?: Scalars['PositiveInt']['input'];
  metadata?: InputMaybe<SearchAutocompleteRequestMetadata>;
  query?: Scalars['String']['input'];
};


/** Root query from which every query schema extends */
export type QuerySearchRecommendationArgs = {
  isDebug?: InputMaybe<Scalars['Boolean']['input']>;
  query: Scalars['String']['input'];
  responseSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query from which every query schema extends */
export type QuerySkillsFrameworkByGeneratedLearningPathArgs = {
  id: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['String']['input']>;
};


/** Root query from which every query schema extends */
export type QuerySkillsFrameworkByIdAndTypeArgs = {
  id: Scalars['ID']['input'];
  type: SkillsFrameworkGoalType;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


/** Root query from which every query schema extends */
export type QuerySkillsFrameworkMapContentTaskArgs = {
  taskReferenceId: Scalars['String']['input'];
};


/** Root query from which every query schema extends */
export type QuerySkillsPrepArgs = {
  goalId: Scalars['ID']['input'];
  goalType: SkillsFrameworkGoalType;
  userId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QuerySkillsPrepsByUserIdArgs = {
  statusFilter: Array<SkillsPrepStatus>;
  userId: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QuerySkillsPrepsForLoggedInUserArgs = {
  statusFilter: Array<SkillsPrepStatus>;
};


/** Root query from which every query schema extends */
export type QuerySkillsProficiencyAssessmentTrendArgs = {
  filters?: InputMaybe<SkillsProficiencyInsightsFilterInput>;
};


/** Root query from which every query schema extends */
export type QuerySkillsProficiencyLevelCountsArgs = {
  filters?: InputMaybe<SkillsProficiencyInsightsFilterInput>;
};


/** Root query from which every query schema extends */
export type QuerySkillsProficiencyMetricsArgs = {
  filters?: InputMaybe<SkillsProficiencyInsightsFilterInput>;
};


/** Root query from which every query schema extends */
export type QuerySubscriptionFeaturesAllWithAvailabilityBySubscriberArgs = {
  subscriberId: Scalars['ID']['input'];
  subscriberType: SubscriberType;
};


/** Root query from which every query schema extends */
export type QuerySubscriptionFeaturesAvailabilityByKeysArgs = {
  keys: Array<SubscriptionFeatureKey>;
};


/** Root query from which every query schema extends */
export type QuerySubscriptionPlanUpgradesByProductFamilyArgs = {
  productFamily: SubscriptionPlanProductFamily;
};


/** Root query from which every query schema extends */
export type QuerySubscriptionPlansArgs = {
  filters?: InputMaybe<SubscriptionPlanFilters>;
};


/** Root query from which every query schema extends */
export type QueryTopicArgs = {
  id: Scalars['ID']['input'];
};


/** Root query from which every query schema extends */
export type QueryTopicGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Root query from which every query schema extends */
export type QueryTopicSearchArgs = {
  filters?: InputMaybe<TopicFilters>;
  limit: Scalars['PositiveInt']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/** Root query from which every query schema extends */
export type QueryTopicToAssessmentsSummaryArgs = {
  input: AssessmentSummaryInput;
};


/** Root query from which every query schema extends */
export type QueryTopicsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Root query from which every query schema extends */
export type QueryUserChecklistsArgs = {
  checklistNames?: InputMaybe<Array<UserChecklistName>>;
};

/** Represents a single query refinement suggestion. */
export type QueryRefinement = {
  __typename?: 'QueryRefinement';
  /** The suggestion text to display to the user. */
  suggestion: Scalars['String']['output'];
  /** Unique analytics tracking ID for this specific suggestion. */
  trackingId: Scalars['String']['output'];
};

/** List of query refinement suggestions and additional metadata about the response. */
export type QueryRefinementResponse = {
  __typename?: 'QueryRefinementResponse';
  /** Metadata for the query refinement response used by front end. */
  metadata: QueryRefinementResponseMetadata;
  /** List of query refinement suggestions for the requested type. */
  refinements: Array<Maybe<QueryRefinement>>;
};

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */
export type QueryRefinementResponseMetadata = {
  __typename?: 'QueryRefinementResponseMetadata';
  /** For the request, show experiment metadata results like bucketing info, experiment IDs of assigned feature variants. */
  experimentResults: Array<Maybe<FeatureVariantAssignment>>;
  /** Search analytics tracking id; for uniquely identifying this query and result set; for this request. */
  trackingId: Scalars['String']['output'];
};

/** Trigger types for query refinement source mapping. */
export enum QueryRefinementTriggerType {
  /** Represents source value 'sop' for original-query behavior. */
  SearchOriginalQuery = 'SEARCH_ORIGINAL_QUERY',
  /** Default trigger type for query refinement requests. */
  UserQuery = 'USER_QUERY'
}

/** Type of query refinement suggestion to request. */
export enum QueryRefinementType {
  /** User views most searched phrases for discovery. */
  MostSearched = 'MOST_SEARCHED',
  /** User clicks on a narrowing suggestion to refine their search. */
  NarrowingSuggestions = 'NARROWING_SUGGESTIONS',
  /** User clicks on a related searches suggestion. */
  RelatedSearches = 'RELATED_SEARCHES'
}

/** Possible question types for practice test questions. */
export enum QuestionType {
  /** Question Type is fill_in_the_blank */
  FillInTheBlank = 'FILL_IN_THE_BLANK',
  /** Question Type is multiple_choice */
  MultipleChoice = 'MULTIPLE_CHOICE',
  /** Question Type is multiple_selection */
  MultipleSelection = 'MULTIPLE_SELECTION'
}

/** Quiz with simple questions and multiple choice / multi select answers */
export type Quiz = CurriculumItem & {
  __typename?: 'Quiz';
  /** Course this quiz belongs to */
  course?: Maybe<Course>;
  /** The description of the quiz */
  description: Scalars['String']['output'];
  /** The Id of the quiz */
  id: Scalars['ID']['output'];
  /** Number of items in the quiz */
  itemCount: Scalars['Int']['output'];
  /** The title of the quiz */
  title: Scalars['String']['output'];
  /** Landing page to view this Quiz */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the quiz */
  versionedIdentifier: VersionedIdentifier;
};

/** An attempt of a quiz */
export type QuizAttempt = {
  __typename?: 'QuizAttempt';
  /** Completion time of the attempt */
  completionTime?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the attempt passed the passing score */
  hasMetPassingScore: Scalars['Boolean']['output'];
  /** ID of the attempt */
  id: Scalars['ID']['output'];
  /** Items completed in the attempt */
  itemResponses: Array<QuizItemResponse>;
  /** Start time of the attempt */
  startTime: Scalars['DateTime']['output'];
};

/** Represents quiz context for in-course chat */
export type QuizContextInput = {
  /** Multiple choice quiz context */
  multipleChoice?: InputMaybe<MultipleChoiceQuizContextInput>;
};

/** A quiz item */
export type QuizItem = {
  /** ID of the item */
  id: Scalars['ID']['output'];
  /** Related lectures */
  relatedLectures: Array<Lecture>;
};

/** An option for a quiz item */
export type QuizItemOption = {
  __typename?: 'QuizItemOption';
  /** Explanation of the option */
  explanation: Scalars['String']['output'];
  /** ID of the option */
  id: Scalars['ID']['output'];
  /** Text of the option */
  text: Scalars['String']['output'];
};

/** Response for a quiz item in an attempt */
export type QuizItemResponse = {
  __typename?: 'QuizItemResponse';
  /** The time taken to answer the item in seconds */
  durationInSeconds: Scalars['DurationInSeconds']['output'];
  /** Responses in order for fill in the blank items */
  filledAnswers?: Maybe<Array<Scalars['String']['output']>>;
  /** The quiz item this response belongs to */
  item: QuizItem;
  /** The response submitted for the item */
  selectedOptions: Array<QuizItemOption>;
  /** The status of the response */
  status: QuizItemResponseStatus;
};

/** Status of the response for a quiz item in an attempt */
export enum QuizItemResponseStatus {
  /** The item was answered correctly */
  Correct = 'CORRECT',
  /** The item was answered incorrectly */
  Incorrect = 'INCORRECT',
  /** The item was not answered */
  NotAnswered = 'NOT_ANSWERED',
  /** The item was skipped */
  Skipped = 'SKIPPED'
}

/** Input request to submit an answer for a quiz item */
export type QuizItemResponseSubmitInput = {
  /** ID of the attempt */
  attemptId: Scalars['ID']['input'];
  /** Duration taken to answer the item in seconds */
  durationInSeconds: Scalars['DurationInSeconds']['input'];
  /** User responses in order for fill in the blank items */
  filledAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID of the item */
  itemId: Scalars['ID']['input'];
  /** ID of the quiz */
  quizId: Scalars['ID']['input'];
  /** Response submitted for the item */
  selectedOptionIds: Array<Scalars['ID']['input']>;
};

/** Paginated response for quiz items in a quiz */
export type QuizItemSearchResponse = Paginated & {
  __typename?: 'QuizItemSearchResponse';
  /** List of quiz items */
  items: Array<QuizItem>;
  /** Current page number */
  page: Scalars['Int']['output'];
  /** Total number of pages */
  pageCount: Scalars['Int']['output'];
};

/**
 * This is a top level grouping comprising all recommendations queried by a context code (ID of this object).
 *
 * Usually, this corresponds to the entire page of the application. In that case, there would be just one recommendation
 * context on a single page. The biggest advantage of serving all recommendations in one response, is the ability to
 * run unit ranking and deduplication comprehensively for the entire recommendation context.
 *
 * Even though, it is common to see a single page of the application uses only one recommendation context, it is not an
 * obligation. The 'page' and 'context' concepts are decoupled. Having multiple contexts on a page might be acceptable
 * if the trade-offs about compromising comprehensive ranking and deduplication are evaluated.
 *
 * RecommendationContext doesn't directly contain a list of RecommendationItems. Instead, it has a list of sections.
 * The UI should follow this grouping while rendering the recommendations.
 */
export type RecommendationContext = TrackableRecommendation & {
  __typename?: 'RecommendationContext';
  /** Also known as 'Context Code' */
  id: Scalars['ID']['output'];
  /**
   * First slice of RecommendationContextSections available in this RecommendationContext. The field
   * 'sectionsCursor' is used to fetch a new slice of sections starting with the next section after this slice.
   */
  sections: Array<RecommendationContextSection>;
  /** Cursor to get more RecommendationContextSections from the RecommendationContext. Null, if there is no more. */
  sectionsCursor?: Maybe<Scalars['String']['output']>;
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation context is served.
   */
  trackingId: Scalars['String']['output'];
};

/** All information required to query a recommendation context */
export type RecommendationContextInput = {
  /** Also known as 'Context Code' */
  contextId: Scalars['ID']['input'];
  /** Can be used when the frontend application wants to ensure some items will not be recommended */
  excludedItems?: InputMaybe<Array<RecommendationItemInput>>;
  /** Requested number of items to fetch for each unit. The result might have less items. */
  requestedItemCountPerUnit?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Requested number of sections to fetch. The result might have less sections. */
  requestedSectionCount?: InputMaybe<Scalars['PositiveInt']['input']>;
  /**
   * In some cases, the client application might provide it's own set of recommendation source objects as a seed to
   * recommendations. For example, a category page adds the category object here while querying the RecommendationContext
   * for the 'category' context.
   */
  sourceObjects?: InputMaybe<Array<RecommendationSourceObjectInput>>;
};

/** Response returned when a RecommendationContext is queried */
export type RecommendationContextResponse = {
  __typename?: 'RecommendationContextResponse';
  /** The actual recommendation context object */
  recommendationContext: RecommendationContext;
};

/** RecommendationContext comprises multiple sections. Sections might be a RecommendationUnit or RecommendationUnitGroup. */
export type RecommendationContextSection = {
  /** ID of the actual section object (RecommendationUnit or RecommendationUnitGroup). */
  id: Scalars['ID']['output'];
  /** Title of the actual section object (RecommendationUnit or RecommendationUnitGroup). */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * A recommendation item comprises the actual entity (ex. course) to be recommended and some additional fields required
 * specifically by the recommendations domain.
 */
export type RecommendationItem = {
  /**
   * This ID is different from the ID of the underlying recommended object to provide uniqueness across item types.
   * For example, the ID of the course in a CourseRecommendation object might be 123 and there might be a
   * LectureRecommendation object with a lecture ID 123. To achieve uniqueness for the ID of the wrapper objects
   * CourseRecommendation and LectureRecommendation), this ID of the wrapper object is different from the ID of the
   * underlying object.
   */
  id: Scalars['ID']['output'];
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** Input version of RecommendationItem type to specify a recommendation item in queries */
export type RecommendationItemInput = {
  /** ID of the actual item. For example, the ID of a course */
  id: Scalars['ID']['input'];
  /** Type of the actual item. For example, COURSE */
  type: RecommendationItemType;
};

/** Currently supported RecommendationItem types */
export enum RecommendationItemType {
  /** The recommended object is a 'Assessment' */
  Assessment = 'ASSESSMENT',
  /** The recommended object is a 'Category' */
  Category = 'CATEGORY',
  /** The recommended object is a 'Coding Exercise' */
  CodingExercise = 'CODING_EXERCISE',
  /** The recommended object is a 'Course' */
  Course = 'COURSE',
  /** The recommended object is a 'Course Section' */
  CourseSection = 'COURSE_SECTION',
  /** The recommended object is a 'Instructor' */
  Instructor = 'INSTRUCTOR',
  /** The recommended object is a 'Lab' */
  Lab = 'LAB',
  /** The recommended object is a 'Label (aka. Topic)' */
  Label = 'LABEL',
  /** The recommended object is a 'Learning Path' */
  LearningPath = 'LEARNING_PATH',
  /** The recommended object is a 'Lecture' */
  Lecture = 'LECTURE',
  /** The recommended object is a 'Occupation' */
  Occupation = 'OCCUPATION',
  /** The recommended object is a 'SubCategory' */
  Subcategory = 'SUBCATEGORY'
}

/** A type to specify what objects were used as a source object (seed) for a recommendation unit */
export type RecommendationSourceObject = {
  __typename?: 'RecommendationSourceObject';
  /** Description of the actual item, if applicable. E.g. description of a course */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the actual item. For example, the ID of a course */
  id: Scalars['ID']['output'];
  /** Relative URL of the actual item, if applicable. It excludes the domain. E.g. /topic/web-development/ */
  relativeUrl?: Maybe<Scalars['String']['output']>;
  /** Title of the actual source object item, if applicable. E.g. title of a course */
  title?: Maybe<Scalars['String']['output']>;
  /** Type of the actual item. For example, COURSE */
  type: RecommendationSourceObjectType;
};

/** Input version of RecommendationSourceObject */
export type RecommendationSourceObjectInput = {
  /** ID of the actual item. For example, the ID of a course */
  id: Scalars['ID']['input'];
  /** Type of the actual item. For example, COURSE */
  type: RecommendationSourceObjectType;
};

/** Currently supported recommendation source (aka. seed) object types */
export enum RecommendationSourceObjectType {
  /** The type of recommendation source (aka. seed) object is 'Category' */
  Category = 'CATEGORY',
  /** The type of recommendation source (aka. seed) object is 'Collection' */
  Collection = 'COLLECTION',
  /** The type of recommendation source (aka. seed) object is 'Course' */
  Course = 'COURSE',
  /** The type of recommendation source (aka. seed) object is 'Instructor' */
  Instructor = 'INSTRUCTOR',
  /** The type of recommendation source (aka. seed) object is 'Label (aka. Topic)' */
  Label = 'LABEL',
  /** The type of recommendation source (aka. seed) object is 'Language' */
  Language = 'LANGUAGE',
  /** The type of recommendation source (aka. seed) object is 'Lecture' */
  Lecture = 'LECTURE',
  /** The type of recommendation source (aka. seed) object is 'Management Occupation' */
  ManagementOccupation = 'MANAGEMENT_OCCUPATION',
  /** The type of recommendation source (aka. seed) object is 'Occupation' */
  Occupation = 'OCCUPATION',
  /** The type of recommendation source (aka. seed) object is 'Occupation Group' */
  OccupationGroup = 'OCCUPATION_GROUP',
  /** The type of recommendation source (aka. seed) object is 'SubCategory' */
  Subcategory = 'SUBCATEGORY'
}

/**
 * Finest grained grouping of recommendations. Each recommendation unit corresponds to a specific algorithm,
 * source object (recommendation seed), and recommendation item type.
 */
export type RecommendationUnit = CustomizableRecommendationPresentation & RecommendationContextSection & TrackableRecommendation & {
  __typename?: 'RecommendationUnit';
  /**
   * ID of the RecommendationUnit object that will be unique among all units inside a recommendation context including
   * the member units of unit groups.
   *
   * In addition, this ID will be unique for all units in the initial 'recommendations' query response and the subsequent
   * 'moreRecommendationContextSections' queries.
   */
  id: Scalars['ID']['output'];
  /**
   * First slice of items available in this RecommendationUnit. The field
   * 'itemsCursor' is used to fetch a new slice of items starting with the next item after this slice.
   */
  items: Array<RecommendationItem>;
  /** Cursor to get more RecommendationItems from this RecommendationUnit. Null, if there is no more. */
  itemsCursor?: Maybe<Scalars['String']['output']>;
  /**
   * Some unit titles contain titles of source objects like "Newest courses in 'JavaScript'". If frontend needs to
   * insert source object links instead of just source object titles, this field can be used instead of the title field.
   * It will give "Newest courses in '{}'" instead of "Newest courses in 'JavaScript'".
   */
  rawTitle?: Maybe<Scalars['String']['output']>;
  /**
   * If the recommendation is seeded with some other objects such as viewed course, label affinity, or search query,
   * etc., they are listed here.
   *
   * Title and URLs of these source objects should be used to build a HTML title with links if the title field has
   * template placeholders ({}).
   */
  sourceObjects?: Maybe<Array<RecommendationSourceObject>>;
  /**
   * Localized title that is also interpolated with source object titles if necessary.
   * For example, "Newest courses in 'JavaScript'".
   */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation context is served.
   */
  trackingId: Scalars['String']['output'];
  /** Can optionally be entered on Tapen to give a hint to frontend about how it should be presented */
  viewType?: Maybe<Scalars['String']['output']>;
};

/** Group of units that should be presented together. */
export type RecommendationUnitGroup = CustomizableRecommendationPresentation & RecommendationContextSection & {
  __typename?: 'RecommendationUnitGroup';
  /**
   * ID of the RecommendationUnitGroup object that will be unique among all sections inside a recommendation context.
   *
   * In addition, this ID will be unique for all sections in the initial 'recommendations' query response and the
   * subsequent 'moreRecommendationContextSections' queries.
   */
  id: Scalars['ID']['output'];
  /** Localized title */
  title?: Maybe<Scalars['String']['output']>;
  /** Nested units in this unit group */
  units: Array<RecommendationUnit>;
  /** Can optionally be entered on Tapen to give a hint to frontend about how it should be presented */
  viewType?: Maybe<Scalars['String']['output']>;
};

/** Date range for the report generation */
export enum RelativeDateRange {
  /** Last 3 months */
  Last_3Months = 'LAST_3_MONTHS',
  /** Last 7 days */
  Last_7Days = 'LAST_7_DAYS',
  /** Last 30 days */
  Last_30Days = 'LAST_30_DAYS',
  /** Last year, whole months */
  LastYear = 'LAST_YEAR',
  /** Since activated */
  SinceActivated = 'SINCE_ACTIVATED'
}

/** Report job request */
export type ReportJob = {
  __typename?: 'ReportJob';
  /** Group IDs to include in the report, if not provided, all groups will be included */
  groups?: Maybe<Array<OrganizationUserGroup>>;
  /** The selected timeframe, relative to the current date */
  relativeDateRange?: Maybe<RelativeDateRange>;
  /** Subscription product types to filter users in the report by. If not provided, no subscription product type filtering will be applied */
  subscriptionProductTypes?: Maybe<Array<SubscriptionPlanProductType>>;
  /** Type of report job */
  type: ReportJobType;
};

/** Input type for report job */
export type ReportJobInput = {
  /** Group IDs to include in the report, if not provided, all groups will be included */
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The selected timeframe, relative to the current date */
  relativeDateRange?: InputMaybe<RelativeDateRange>;
  /** Subscription product types to filter users in the report by. If not provided, no subscription product type filtering will be applied */
  subscriptionProductTypes?: InputMaybe<Array<SubscriptionPlanProductType>>;
  /** Type of report job */
  type: ReportJobType;
};

/** Type of report job that can be scheduled or generated. */
export enum ReportJobType {
  /** Courses export report job request */
  CoursesExport = 'COURSES_EXPORT',
  /** Course activity report job request */
  CourseActivity = 'COURSE_ACTIVITY',
  /** Custom course export job request */
  CustomCourseExport = 'CUSTOM_COURSE_EXPORT',
  /** Public path export job request */
  PublicPathExport = 'PUBLIC_PATH_EXPORT',
  /** Ratings and reviews report job request */
  RatingsReviews = 'RATINGS_REVIEWS',
  /** Subscription course export job request */
  SubscriptionCourseExport = 'SUBSCRIPTION_COURSE_EXPORT',
  /** Udemy path export job request */
  UdemyPathExport = 'UDEMY_PATH_EXPORT',
  /** All active users export job request */
  UsersActive = 'USERS_ACTIVE',
  /** All users export job request */
  UsersAll = 'USERS_ALL',
  /** Deactivated users export job request */
  UsersDeactivated = 'USERS_DEACTIVATED',
  /** Group admins export job request */
  UsersGroupAdmin = 'USERS_GROUP_ADMIN',
  /** Pending group admin invitations export job request */
  UsersGroupAdminInvitations = 'USERS_GROUP_ADMIN_INVITATIONS',
  /** Pending invitations export job request */
  UsersInvitations = 'USERS_INVITATIONS',
  /** Users not in a group export job request */
  UsersNotInGroup = 'USERS_NOT_IN_GROUP',
  /** User account activity report job request for reporting activation/deactivation */
  UserAccountActivity = 'USER_ACCOUNT_ACTIVITY',
  /** User activity report job request */
  UserActivity = 'USER_ACTIVITY',
  /** User activity all users report job request */
  UserActivityAllUsers = 'USER_ACTIVITY_ALL_USERS',
  /** User activity all users v2 report job request */
  UserActivityAllUsersV2 = 'USER_ACTIVITY_ALL_USERS_V2',
  /** User activity trending report job request */
  UserActivityTrending = 'USER_ACTIVITY_TRENDING',
  /** User activity v2 report job request */
  UserActivityV2 = 'USER_ACTIVITY_V2',
  /** User adoption funnel export job request */
  UserAdoption = 'USER_ADOPTION',
  /** Users without enrollment export job request */
  UserAdoptionNotEnrolled = 'USER_ADOPTION_NOT_ENROLLED',
  /** Users without activity export job request */
  UserAdoptionNotWatched = 'USER_ADOPTION_NOT_WATCHED',
  /** User assessment activity report job request */
  UserAssessmentActivity = 'USER_ASSESSMENT_ACTIVITY',
  /** User assessment proficiency report job request */
  UserAssessmentProficiency = 'USER_ASSESSMENT_PROFICIENCY',
  /** User badge activity report job request */
  UserBadgeActivity = 'USER_BADGE_ACTIVITY',
  /** User course activity report job request */
  UserCourseActivity = 'USER_COURSE_ACTIVITY',
  /** User lab activity report job request */
  UserLabActivity = 'USER_LAB_ACTIVITY',
  /** User progress report job request */
  UserProgress = 'USER_PROGRESS',
  /** User role play activity report job request */
  UserRolePlayActivity = 'USER_ROLE_PLAY_ACTIVITY',
  /** User skills activity report job request */
  UserSkillsActivity = 'USER_SKILLS_ACTIVITY',
  /** User skills proficiency report job request */
  UserSkillsProficiency = 'USER_SKILLS_PROFICIENCY'
}

/** Defines assistant's response type */
export enum ResponseType {
  /** The response is audio */
  Audio = 'AUDIO',
  /** The response is text */
  Text = 'TEXT'
}

/** A review of a learning product */
export type Review = {
  __typename?: 'Review';
  /** The type of learning product being reviewed */
  learningProductType: LearningProductType;
  /** The review text */
  text: Scalars['String']['output'];
  /** The URL of the reviewed learning product */
  urlLearningProduct: Scalars['URL']['output'];
};

/** Role-play activity for students to practice soft skills */
export type RolePlay = CurriculumItem & {
  __typename?: 'RolePlay';
  /** Course this role-play belongs to */
  course?: Maybe<Course>;
  /** The Id of the role-play */
  id: Scalars['ID']['output'];
  /** The title of the role-play */
  title: Scalars['String']['output'];
  /** Landing page to view this RolePlay */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the role-play */
  versionedIdentifier: VersionedIdentifier;
};

/** Schedule configuration */
export type ScheduleConfig = {
  __typename?: 'ScheduleConfig';
  /** Day of the month to run the task, optional, 1-31 */
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  /** Day of the week to run the task, optional, 0-6 */
  dayOfWeek?: Maybe<DayOfWeek>;
  /** Frequency of the scheduled task */
  frequency: ScheduleFrequency;
  /** Hour of the day to run the task, optional, 0-23 */
  hour?: Maybe<Scalars['Int']['output']>;
  /** Timezone to run the task, defaults to UTC */
  timezone?: Maybe<Scalars['TimeZone']['output']>;
};

/** Input type for schedule configuration */
export type ScheduleConfigInput = {
  /** Day of the month to run the report, optional, 1-31 */
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Day of the week to run the report, optional, 0-6 */
  dayOfWeek?: InputMaybe<DayOfWeek>;
  /** Frequency of the report schedules */
  frequency: ScheduleFrequency;
  /** Hour of the day to run the report, optional, 0-23 */
  hour?: InputMaybe<Scalars['Int']['input']>;
  /** Timezone to run the report, defaults to UTC */
  timezone?: InputMaybe<Scalars['TimeZone']['input']>;
};

/** Frequency of a schedule */
export enum ScheduleFrequency {
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Weekly */
  Weekly = 'WEEKLY',
  /** Yearly */
  Yearly = 'YEARLY'
}

/** Recurring scheduled report */
export type ScheduledReportJob = {
  __typename?: 'ScheduledReportJob';
  /** ID of the recurring scheduled report */
  id: Scalars['ID']['output'];
  /** Report job configuration */
  job: ReportJob;
  /** Schedule configuration */
  scheduleConfig: ScheduleConfig;
};

/** Input types for creating/updating scheduled reports */
export type ScheduledReportJobInput = {
  /** Report job configuration */
  job: ReportJobInput;
  /** Schedule configuration */
  scheduleConfig: ScheduleConfigInput;
};

/** Response object for scheduled report creation */
export type ScheduledReportJobResponse = {
  __typename?: 'ScheduledReportJobResponse';
  /** The created report */
  scheduledReport?: Maybe<ScheduledReportJob>;
};

/** Identifies available search filter facets. */
export type SearchAggregation = {
  __typename?: 'SearchAggregation';
  /** Available values for this aggregation. */
  buckets: Array<SearchAggregationOption>;
  /** Key argument that can be passed to query to filter by this option. */
  key: Scalars['String']['output'];
  /** Label for this type/group of aggregation; e.g. 'Topic'. */
  label: Scalars['String']['output'];
};

/** Options for search aggregates */
export type SearchAggregationInputOption = {
  /** Key of search aggregation to apply */
  key: Scalars['String']['input'];
  /** Value of search aggregation to apply */
  value: Scalars['String']['input'];
};

/** One of the available options within a search facet type */
export type SearchAggregationOption = {
  __typename?: 'SearchAggregationOption';
  /** Number of results if this filter option were to be applied. */
  countWithFilterApplied: Scalars['Int']['output'];
  /** Whether this filter option is selected or not. */
  isSelected: Scalars['Boolean']['output'];
  /** Key that can be passed to the query to filter by this option. */
  key: Scalars['String']['output'];
  /** Human-readable label for this filter option. */
  label: Scalars['String']['output'];
  /** Value argument that can be passed to query to filter by this option. */
  value: Scalars['String']['output'];
};

/** A simple auto-complete item can be search log, course or instructor */
export type SearchAutocompleteItem = Course | CourseInstructor | SearchAutocompleteLogItem;

/** Search Log suggestion for autocomplete */
export type SearchAutocompleteLogItem = {
  __typename?: 'SearchAutocompleteLogItem';
  /** Machine-readable key for the section (e.g., 'popular', 'trending' etc.). Complements sectionLabel for programmatic handling */
  sectionKey?: Maybe<Scalars['String']['output']>;
  /** Human-readable label for the section (e.g., 'Popular on Udemy', 'Trending searches', 'Trending' etc.). Used for display purposes */
  sectionLabel?: Maybe<Scalars['String']['output']>;
  /** Phrase that will be shows as a suggestion */
  title: Scalars['String']['output'];
};

/** Info about the page or component that sends the request */
export type SearchAutocompleteOriginPageInput = {
  /** related entity id of the page if exists */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /** page/component key that sends the request */
  pageKey?: InputMaybe<Scalars['String']['input']>;
};

/** Search Autocomplete request filters */
export type SearchAutocompleteRequestFilters = {
  /** Indicates either free courses will be shown or not */
  freeCourseSuppression?: InputMaybe<Scalars['Boolean']['input']>;
  /** If flag is true then only courses solely consisting of practice tests will be shown */
  showPracticeTestCoursesOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Search Autocomplete request metadata */
export type SearchAutocompleteRequestMetadata = {
  /** origin of the page that sends the request */
  searchAutocompleteOriginPage?: InputMaybe<SearchAutocompleteOriginPageInput>;
};

/** A simple autocomplete item with the tracking metadata */
export type SearchAutocompleteSuggestion = {
  __typename?: 'SearchAutocompleteSuggestion';
  /** Search Autocomplete suggestion for autocomplete */
  item?: Maybe<SearchAutocompleteItem>;
  /** Search analytics tracking id; for uniquely identifying whole result set; for this request */
  resultTrackingId: Scalars['String']['output'];
  /** Search analytics tracking id; for uniquely identifying this item */
  trackingId: Scalars['String']['output'];
};

/** Represents a search suggestion for a search */
export type SearchQuerySuggestion = {
  __typename?: 'SearchQuerySuggestion';
  /** The suggested query based on the original search input. */
  query?: Maybe<Scalars['String']['output']>;
  /** The type of search query suggestion */
  type?: Maybe<SearchQuerySuggestionType>;
};

/** Possible suggestion types for the search query. */
export enum SearchQuerySuggestionType {
  /** 'Did you mean' suggestion for the search query. */
  DidYouMean = 'DID_YOU_MEAN',
  /** 'Rewrite' suggestion for the search query. */
  Rewrite = 'REWRITE'
}

/** Represents a single search recommendation item. */
export type SearchRecommendation = {
  __typename?: 'SearchRecommendation';
  /** The recommended course, resolved via CourseDataSource. */
  course: Course;
  /** Debug information for this recommendation item. Populated only when debug=true. */
  debug?: Maybe<SearchRecommendationDebug>;
  /** Unique analytics tracking id for this recommendation item. */
  trackingId: Scalars['String']['output'];
};

/** Debug fields for a single recommendation item. */
export type SearchRecommendationDebug = {
  __typename?: 'SearchRecommendationDebug';
  /** Model features used during ranking. */
  features: Scalars['JSON']['output'];
  /** Matched queries that contributed to this recommendation. */
  matchedQueries: Array<Scalars['String']['output']>;
  /** Model name used for ranking. */
  model: Scalars['String']['output'];
  /** ML model predictive score. */
  predictiveScore: Scalars['Float']['output'];
  /** Elasticsearch relevance score. */
  relevancyScore: Scalars['Float']['output'];
};

/** Response for search recommendation. */
export type SearchRecommendationResponse = {
  __typename?: 'SearchRecommendationResponse';
  /** Total recommendation count. */
  count: Scalars['Int']['output'];
  /** Metadata for the response used by front end. */
  metadata: SearchRecommendationResponseMetadata;
  /** List of recommendation items. */
  recommendations: Array<Maybe<SearchRecommendation>>;
  /** Display title for recommendation unit. */
  unitTitle: Scalars['String']['output'];
};

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */
export type SearchRecommendationResponseMetadata = {
  __typename?: 'SearchRecommendationResponseMetadata';
  /** For the request, show experiment metadata results like bucketing info and assigned variants. */
  experimentResults: Array<Maybe<FeatureVariantAssignment>>;
  /** Search analytics tracking id; uniquely identifies this request/result set. */
  trackingId: Scalars['String']['output'];
};

/** Trigger types for the lab, lecture, assessment and path search. */
export enum SearchTriggerType {
  /** Search triggered by the ChatGPT app */
  ChatgptApp = 'CHATGPT_APP',
  /** Search triggered by the MCP server */
  McpServer = 'MCP_SERVER',
  /** Search triggered by the Retool platform */
  Retool = 'RETOOL',
  /** User inputs query */
  UserQuery = 'USER_QUERY'
}

/** Security-related organization settings */
export type SecurityOrganizationSettings = {
  __typename?: 'SecurityOrganizationSettings';
  /** Whether MFA is enabled */
  isMfaEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** A skills framework is a collection of learning objectives that are organized into a hierarchy. */
export type SkillsFramework = LearningProduct & {
  __typename?: 'SkillsFramework';
  /** Entity tag for skills framework */
  entityTag: Scalars['Int']['output'];
  /** LearningPath generated from this skills framework */
  generatedLearningPath?: Maybe<OrganizationLearningPath>;
  /** Id to identify for skills framework */
  id: Scalars['ID']['output'];
  /** Child Learning objectives associated with this skills framework. */
  learningObjectives: Array<LearningObjective>;
  /** Name of skills framework */
  name: Scalars['String']['output'];
  /** Type for the skills framework */
  type: SkillsFrameworkGoalType;
  /** Version id of the skills framework */
  versionId: Scalars['String']['output'];
};

/** The goal for a skills framework which contains a set of learning objectives. */
export enum SkillsFrameworkGoalType {
  /** Blueprint is an assessment Udemy owns containing a list of learning objectives a user need to learn */
  Blueprint = 'BLUEPRINT',
  /** Small template that DL team generated */
  BottomUp = 'BOTTOM_UP',
  /** Open badge is not owned by Udemy containing a list of learning objectives a user need to learn. */
  OpenBadge = 'OPEN_BADGE',
  /** Generated via AI model */
  OrgUpskill = 'ORG_UPSKILL'
}

/** A SkillsFramework Id Input is used to identify a skills framework by id and type. */
export type SkillsFrameworkIdInput = {
  /** Id to identify for skills framework */
  id: Scalars['ID']['input'];
  /** Type for the skills framework */
  type: SkillsFrameworkGoalType;
};

/** To save a SkillsFramework we need the name and learning objectives associated with it */
export type SkillsFrameworkInput = {
  /** Child Learning objectives associated with this skills framework. */
  learningObjectives: Array<LearningObjectiveInput>;
  /** Name of skills framework */
  name: Scalars['String']['input'];
};

/** Response for mapping content to skills framework task reference id status */
export type SkillsFrameworkMapContentResponse = {
  __typename?: 'SkillsFrameworkMapContentResponse';
  /** Status of the mapping content to skills framework task */
  task: SkillsFrameworkMapContentTask;
};

/** Content mapping task id and current mapping task status */
export type SkillsFrameworkMapContentTask = {
  __typename?: 'SkillsFrameworkMapContentTask';
  /** Content mapping task id */
  id: Scalars['ID']['output'];
  /** Current status of mapping task */
  status: SkillsFrameworkMapContentTaskStatus;
};

/** Status of map content for a reference Id */
export enum SkillsFrameworkMapContentTaskStatus {
  /** Task failed */
  Failed = 'FAILED',
  /** Task is in progress */
  InProgress = 'IN_PROGRESS',
  /** Task was killed */
  Killed = 'KILLED',
  /** Task is completed successfully */
  Success = 'SUCCESS'
}

/** This is the response for updating a skills framework */
export type SkillsFrameworkUpdateResponse = {
  __typename?: 'SkillsFrameworkUpdateResponse';
  /** Saved skills framework */
  skillsFramework?: Maybe<SkillsFramework>;
};

/** A skills framework is a collection of learning objectives that are organized into a hierarchy. */
export type SkillsPrep = {
  __typename?: 'SkillsPrep';
  /** Activity the user completed towards the prep's skills framework */
  activity: SkillsPrepActivity;
  /** Timestamp when the skills preparation ended */
  endTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  /** The skills framework for the skills preparation */
  skillsFramework: SkillsFramework;
  /** Timestamp when the skills preparation started */
  startTimestamp: Scalars['Timestamp']['output'];
  /** Status of the skills preparation */
  status: SkillsPrepStatus;
  /** Whether an upgrade is available and the prep can be migrated to use the latest version of the skills framework */
  upgradeAvailable: Scalars['Boolean']['output'];
  /** Owner of the skills preparation */
  userId: Scalars['ID']['output'];
};

/** Holds a list events by skill node */
export type SkillsPrepActivity = {
  __typename?: 'SkillsPrepActivity';
  /** A list of events by skill node */
  eventsByNode: Array<SkillsPrepLearningEventsByNode>;
};

/** A skills preparation learning event */
export type SkillsPrepLearningEvent = {
  __typename?: 'SkillsPrepLearningEvent';
  /** Timestamp of the event */
  eventTimestamp: Scalars['Timestamp']['output'];
  /** The learning event type */
  eventType: SkillsPrepLearningEventType;
  /** The learning activity that was performed */
  learningObjectiveActivity: LearningObjectiveActivity;
  /** The model score mapping the activity to the learning objective */
  modelScore: Scalars['Float']['output'];
  /** The normalized score from 0.0 to 1.0 that the learner got for this event */
  normalizedScore?: Maybe<Scalars['Float']['output']>;
};

/** Type of a skills preparation learning event */
export enum SkillsPrepLearningEventType {
  /** Indicates that the activity was normally completed */
  Completed = 'COMPLETED',
  /** Indicates that the activity was completed with failure */
  Failed = 'FAILED'
}

/** A list of learning events corresponding to one skill node */
export type SkillsPrepLearningEventsByNode = {
  __typename?: 'SkillsPrepLearningEventsByNode';
  /** The learning events performed */
  learningEvents: Array<SkillsPrepLearningEvent>;
  /** The id of the node that the events were performed against */
  nodeId: Scalars['String']['output'];
};

/** Status for a user's skills preparation */
export enum SkillsPrepStatus {
  /** The user skills preparation is abandoned */
  Abandoned = 'ABANDONED',
  /** The user skills preparation is completed */
  Completed = 'COMPLETED',
  /** The user skills preparation is started */
  Started = 'STARTED'
}

/** The filter parameters for skills proficiency insights queries */
export type SkillsProficiencyInsightsFilterInput = {
  /** Optional list of assessment IDs to filter by specific assessments */
  assessmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Date range for filtering the assessment data. Optional to allow for "all time" timeframe. */
  dateFilter?: InputMaybe<DateFilter>;
  /** Optional list of group IDs to filter by specific user groups */
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Optional ID of the organization to filter data. If not provided, uses organization ID from JWT token.
   * Admin users can use this to query any organization.
   */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional list of subscription product types to filter data by. */
  subscriptionProductTypes?: InputMaybe<Array<SubscriptionPlanProductType>>;
  /** Optional list of topic IDs to filter by specific topics */
  topicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** High-level metrics for skills proficiency across an organization */
export type SkillsProficiencyMetrics = {
  __typename?: 'SkillsProficiencyMetrics';
  /** Number of distinct learners who have completed assessments */
  assessedLearnersCount: Scalars['NonNegativeInt']['output'];
  /** Total number of assessments taken/completed */
  assessmentsTakenCount: Scalars['NonNegativeInt']['output'];
  /** Number of learners who have improved their proficiency level by taking assessments */
  improvedLearnersCount: Scalars['NonNegativeInt']['output'];
  /** Number of re-assessments */
  reassessmentsTakenCount: Scalars['NonNegativeInt']['output'];
  /** Percentage of topic-level improvement */
  topicLevelImprovementPercentage?: Maybe<Scalars['Float']['output']>;
  /** Number of distinct skills/topics that have shown improvement */
  topicsImprovedCount: Scalars['NonNegativeInt']['output'];
};

/** Represents an Slide with its current time of a Video Mashup asset */
export type Slide = {
  __typename?: 'Slide';
  /** Offset time in which the slide is shown */
  slideOffsetInSeconds: Scalars['OffsetInSeconds']['output'];
  /** URL of the Video Mashup slide */
  url: Scalars['String']['output'];
};

/** Sort direction */
export enum SortDirection {
  /** Ascending sort direction */
  Ascending = 'ASCENDING',
  /** Descending sort direction */
  Descending = 'DESCENDING'
}

/** SSO-related organization settings */
export type SsoOrganizationSettings = {
  __typename?: 'SsoOrganizationSettings';
  /** The SSO provider label */
  providerLabel?: Maybe<Scalars['String']['output']>;
};

/** Details about a user's lecture minutes consumption streak, including what to achieve by what date */
export type StreakLectureConsumptionWeekly = {
  __typename?: 'StreakLectureConsumptionWeekly';
  /** Lecture consumption target the user needs to hit to continue streak, in minutes. */
  goalMinutesThisWeek?: Maybe<Scalars['Int']['output']>;
  /** Lecture consumption so far this week, in minutes. */
  minutesThisWeek?: Maybe<Scalars['Int']['output']>;
  /** Current status of the streak. */
  streakStatus: StreakStatus;
  /** Date to display to user for when the week ended. */
  weekEndTime: Scalars['DateTime']['output'];
  /** Date to display to user for when the week started. */
  weekStartTime: Scalars['DateTime']['output'];
  /** Serialized WeeklyStreak object. */
  weeklyStreak: WeeklyStreak;
};

/** Status of any type of streak */
export enum StreakStatus {
  /** The user's streak is ongoing and has not been broken, and they have completed their goals this week */
  ActiveCurrentPeriodAchieved = 'ACTIVE_CURRENT_PERIOD_ACHIEVED',
  /** The user's streak is ongoing and has not been broken, but they haven't completed their goals this week */
  ActiveCurrentPeriodUnachieved = 'ACTIVE_CURRENT_PERIOD_UNACHIEVED',
  /** The user's streak has expired, they will need to start a new streak from scratch */
  Dropped = 'DROPPED',
  /** The user has no history for this type of streak, they never have achieved this streak */
  ZeroHistory = 'ZERO_HISTORY'
}

/** SubCategory interface */
export type SubCategory = {
  /** ID of the subcategory */
  id: Scalars['ID']['output'];
  /** Name of the subcategory */
  name: Scalars['String']['output'];
};

/** A wrapper type to include the recommended SubCategory and some additional fields about its recommendation */
export type SubCategoryRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'SubCategoryRecommendation';
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /** Underlying object of the recommendation to get more information about it */
  subCategory?: Maybe<SubCategory>;
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** Subcategory navigation list item. */
export type SubcategoryNavListItem = NavListItem & {
  __typename?: 'SubcategoryNavListItem';
  /** List of child navigation items. */
  children: Array<Maybe<NavListItem>>;
  /** The subcategory this item represents. */
  subcategory: CourseSubCategory;
};

/** Subscription plan that the subscriber is subscribed to */
export type SubscribedPlan = {
  __typename?: 'SubscribedPlan';
  /** Content collections that are included in the subscription plan */
  contentCollections: Array<ContentCollection>;
  /** Description of the subscription plan */
  description?: Maybe<Scalars['String']['output']>;
  /** Id of the subscription plan */
  id: Scalars['ID']['output'];
  /** The types of learning products included in the subscription plan */
  learningProductTypes: Array<LearningProductType>;
  /** Type of the subscription product in the plan */
  productType: SubscriptionPlanProductType;
  /** Title of the subscription plan */
  title: Scalars['String']['output'];
  /** URL for the learn more page of the subscription plan */
  urlLearnMore: Scalars['URL']['output'];
};

/** Subscriber of the subscription */
export type Subscriber = Organization | User;

/** Aggregated engagement metrics for a subscriber within their subscription period. */
export type SubscriberEngagementRecap = {
  __typename?: 'SubscriberEngagementRecap';
  /** Personalized call-to-action for the engagement recap widget. */
  callToAction?: Maybe<SubscriberEngagementRecapCallToAction>;
  /** Number of certifications during the period. */
  certificationCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Number of courses completed (100% progress) during the period. Null when enrollment volume is too high to compute reliably. */
  coursesCompletedCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Number of courses enrolled in during the period. */
  coursesEnrolledCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Total distinct learning days (unique calendar days with activity) within the period. */
  learningDaysCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Longest weekly learning streak (weeks) within the period. */
  longestWeeklyStreak?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Total lecture minutes watched within the period. */
  minutesWatched?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Distinct topics explored from courses enrolled during the period. */
  topicsExplored?: Maybe<Array<Topic>>;
};

/** A personalized call-to-action shown alongside the engagement recap. */
export type SubscriberEngagementRecapCallToAction = {
  __typename?: 'SubscriberEngagementRecapCallToAction';
  /** Short description or subtitle for the CTA. */
  description: Scalars['String']['output'];
  /** Display title for the CTA. */
  title: Scalars['String']['output'];
  /** The CTA category, used by the client to select copy and routing. */
  type: SubscriberEngagementRecapCallToActionType;
  /** Deep link URL the CTA should navigate to. */
  url: Scalars['URL']['output'];
};

/** Priority-ordered call-to-action types for the engagement recap widget. */
export enum SubscriberEngagementRecapCallToActionType {
  /** Continue the most recently accessed course. */
  ContinueCourse = 'CONTINUE_COURSE',
  /** Personalized course recommendation. */
  RecommendedCourse = 'RECOMMENDED_COURSE',
  /** Active subscription with scheduled cancellation — prompt renewal. */
  RenewSubscription = 'RENEW_SUBSCRIPTION',
  /** User has never completed any assessment — invite them to try one. */
  TryAssessments = 'TRY_ASSESSMENTS'
}

/** Subscriber Type */
export enum SubscriberType {
  /** Organization */
  Organization = 'ORGANIZATION',
  /** User */
  User = 'USER'
}

/** Billing details of a subscription */
export type SubscriptionBilling = {
  __typename?: 'SubscriptionBilling';
  /** Total recurring amount for the subscription including tax */
  chargePrice: Money;
  /** End date of the current billing period */
  currentPeriodEndDate: Scalars['DateTime']['output'];
  /** Start date of the current billing period */
  currentPeriodStartDate: Scalars['DateTime']['output'];
  /** End date of the discount period */
  discountPeriodEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Total recurring amount for the discount period including tax */
  discountPrice?: Maybe<Money>;
  /** List price without the discount including tax */
  listPrice: Money;
  /** Payment method used for the subscription */
  paymentMethod: SubscriptionPaymentMethod;
  /** Type of payment method used for the subscription */
  paymentType: SubscriptionPaymentType;
  /** Tax amount for the subscription */
  taxPrice: Money;
};

/** Credit card used for the subscription */
export type SubscriptionCreditCard = {
  __typename?: 'SubscriptionCreditCard';
  /** Last 4 digits of the card number */
  last4Digits: Scalars['String']['output'];
  /** Card provider (visa, mc, amex, etc.) */
  provider: Scalars['String']['output'];
};

/** Subscription object that represents consumer and UB subscriptions */
export type SubscriptionEnrollment = {
  __typename?: 'SubscriptionEnrollment';
  /** Billing information for the subscription with recurring payment support */
  billing?: Maybe<SubscriptionBilling>;
  /** Date when the subscription was canceled */
  cancelDate?: Maybe<Scalars['DateTime']['output']>;
  /** Reference key to Recurring Billing System */
  checkoutReference?: Maybe<Scalars['String']['output']>;
  /** End date of the subscription */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Id of the subscription */
  id: Scalars['ID']['output'];
  /** Max number of licenses (seats) for the subscription */
  licenseCount: Scalars['Int']['output'];
  /** Renewal period of the subscription */
  renewalInterval: DateInterval;
  /** Start date of the subscription */
  startDate: Scalars['DateTime']['output'];
  /** Status of the subscription */
  status: SubscriptionStatus;
  /** Subscription plan that the subscriber is subscribed to */
  subscribedPlan: SubscribedPlan;
  /** User or Organization that has the subscription */
  subscriber: Subscriber;
  /** Trial period of the subscription */
  trialInterval?: Maybe<DateInterval>;
  /** Number of licenses (seats) in use */
  usedLicenseCount: Scalars['Int']['output'];
};

/** Response for subscription enrollment update mutations */
export type SubscriptionEnrollmentUpdateResponse = {
  __typename?: 'SubscriptionEnrollmentUpdateResponse';
  /** The subscription enrollment that was updated */
  subscriptionEnrollment?: Maybe<SubscriptionEnrollment>;
};

/** Subscription Feature */
export type SubscriptionFeature = {
  __typename?: 'SubscriptionFeature';
  /** Subscription feature description */
  description: Scalars['String']['output'];
  /** Subscription feature grouping category */
  groupingCategory?: Maybe<Scalars['String']['output']>;
  /** Whether subscription feature is available or not based on the override */
  isAvailable: Scalars['Boolean']['output'];
  /** Whether Subscription feature value is overridden or not */
  isOverridden: Scalars['Boolean']['output'];
  /** Subscription feature unique identifier */
  key: SubscriptionFeatureKey;
  /** Subscription feature name */
  name: Scalars['String']['output'];
};

/** Subscription Feature Availability */
export type SubscriptionFeatureAvailability = {
  __typename?: 'SubscriptionFeatureAvailability';
  /** Whether subscription feature is available or not */
  isAvailable: Scalars['Boolean']['output'];
  /** Subscription feature unique identifier */
  key: SubscriptionFeatureKey;
};

/** Subscription Feature Key */
export enum SubscriptionFeatureKey {
  /** Features related to AI Elevate Experience */
  AiElevateExperience = 'AI_ELEVATE_EXPERIENCE',
  /** Features related to AI Elevate Experience V2 */
  AiElevateExperienceV2 = 'AI_ELEVATE_EXPERIENCE_V2',
  /** AI Starter Paths */
  AiStarterPaths = 'AI_STARTER_PATHS',
  /** Altus */
  Altus = 'ALTUS',
  /** Assessments */
  Assessments = 'ASSESSMENTS',
  /** Category Navigation */
  CategoryNavigation = 'CATEGORY_NAVIGATION',
  /** Certificate Content */
  CertificateContent = 'CERTIFICATE_CONTENT',
  /** Commenting on instructor announcements */
  CommentingOnInstructorAnnouncements = 'COMMENTING_ON_INSTRUCTOR_ANNOUNCEMENTS',
  /** Content Discovery AI Assistant */
  ContentDiscoveryAiAssistant = 'CONTENT_DISCOVERY_AI_ASSISTANT',
  /** Course Recommendations during Learning Paths creation */
  CourseRecommendationsForLearningPathsCreation = 'COURSE_RECOMMENDATIONS_FOR_LEARNING_PATHS_CREATION',
  /** Create courses */
  CreateCourses = 'CREATE_COURSES',
  /** Customize Invitation Message */
  CustomizeInvitationMessage = 'CUSTOMIZE_INVITATION_MESSAGE',
  /** Custom Role Play */
  CustomRolePlay = 'CUSTOM_ROLE_PLAY',
  /** DEI features */
  Dei = 'DEI',
  /** Direct Messaging Feature */
  DirectMessaging = 'DIRECT_MESSAGING',
  /** DRM */
  Drm = 'DRM',
  /** Dynamic Lecture Articles */
  DynamicLectureArticles = 'DYNAMIC_LECTURE_ARTICLES',
  /** Groups Feature */
  Groups = 'GROUPS',
  /** Grow With Google */
  GrowWithGoogle = 'GROW_WITH_GOOGLE',
  /** Grow With Google UB */
  GrowWithGoogleUb = 'GROW_WITH_GOOGLE_UB',
  /** Hide Organization wide learning data */
  HideOrgWideLearnerData = 'HIDE_ORG_WIDE_LEARNER_DATA',
  /** Import courses */
  ImportCourses = 'IMPORT_COURSES',
  /** In course assignments */
  InCourseAssignments = 'IN_COURSE_ASSIGNMENTS',
  /** Labs Quota */
  LabsQuota = 'LABS_QUOTA',
  /** Learning streaks */
  LearningStreaks = 'LEARNING_STREAKS',
  /** Leaving reviews */
  LeavingReviews = 'LEAVING_REVIEWS',
  /** Manage Licenses */
  ManageLicenses = 'MANAGE_LICENSES',
  /** MCP Base */
  McpBase = 'MCP_BASE',
  /** MCP Premium */
  McpPremium = 'MCP_PREMIUM',
  /** MCP Server */
  McpServer = 'MCP_SERVER',
  /** Mobile app */
  MobileApp = 'MOBILE_APP',
  /** ORGANIZATION_BADGES */
  OrganizationBadges = 'ORGANIZATION_BADGES',
  /** ORGANIZATION_BADGES FOR LEARNERS */
  OrganizationBadgesForLearners = 'ORGANIZATION_BADGES_FOR_LEARNERS',
  /** Question and answer */
  QuestionAndAnswer = 'QUESTION_AND_ANSWER',
  /** Recommend */
  Recommend = 'RECOMMEND',
  /** Resources */
  Resources = 'RESOURCES',
  /** Role Play Enhanced */
  RolePlayEnhanced = 'ROLE_PLAY_ENHANCED',
  /** Role Play Unlimited */
  RolePlayUnlimited = 'ROLE_PLAY_UNLIMITED',
  /** SCIM Feature */
  Scim = 'SCIM',
  /** Showcase Paths */
  ShowcasePaths = 'SHOWCASE_PATHS',
  /** Skills benchmarking */
  SkillsBenchmarking = 'SKILLS_BENCHMARKING',
  /** Upload badges */
  UploadBadges = 'UPLOAD_BADGES',
  /** Video Player Display Ads */
  VideoPlayerDisplayAds = 'VIDEO_PLAYER_DISPLAY_ADS'
}

/** Subscription Feature Override */
export type SubscriptionFeatureOverride = {
  __typename?: 'SubscriptionFeatureOverride';
  /** The value to override the subscription feature */
  isAvailable: Scalars['Boolean']['output'];
  /** Subscription feature unique identifier */
  key: SubscriptionFeatureKey;
  /** ID of the Subscriber to whom the key is being overridden for */
  subscriberId: Scalars['ID']['output'];
  /** Type of the Subscriber to whom the key is being overridden for */
  subscriberType: SubscriberType;
};

/** Subscription Feature Override Input */
export type SubscriptionFeatureOverrideInput = {
  /** The value to override the subscription feature */
  isAvailable: Scalars['Boolean']['input'];
  /** Subscription feature unique identifier */
  key: SubscriptionFeatureKey;
  /** ID of the Subscriber to whom the key is being overridden for */
  subscriberId: Scalars['ID']['input'];
  /** Type of the Subscriber to whom the key is being overridden for */
  subscriberType: SubscriberType;
};

/** Response for the Subscription Feature Set Overrides mutations */
export type SubscriptionFeaturesSetOverrideResponse = {
  __typename?: 'SubscriptionFeaturesSetOverrideResponse';
  /** Subscription Feature Override that was created or modified */
  overrides: Array<SubscriptionFeatureOverride>;
};

/** Mobile in-app subscription (through iOS or Android) */
export type SubscriptionInAppPurchase = {
  __typename?: 'SubscriptionInAppPurchase';
  /** Mobile platform of the in-app subscription */
  platform: SubscriptionMobilePlatform;
};

/** Mobile platform that the subscription has been purchased */
export enum SubscriptionMobilePlatform {
  /** Google Android */
  Android = 'ANDROID',
  /** Apple iOS */
  Ios = 'IOS'
}

/** PayPal payment method for the subscription */
export type SubscriptionPayPalMethod = {
  __typename?: 'SubscriptionPayPalMethod';
  /** User's email address associated with PayPal account */
  email: Scalars['String']['output'];
};

/** Payment method of the subscription */
export type SubscriptionPaymentMethod = SubscriptionCreditCard | SubscriptionInAppPurchase | SubscriptionPayPalMethod | SubscriptionUpiMethod;

/** Payment type for subscription billing */
export enum SubscriptionPaymentType {
  /** Apple Pay payment */
  ApplePay = 'APPLE_PAY',
  /** Credit card payment */
  CreditCard = 'CREDIT_CARD',
  /** Google Pay payment */
  GooglePay = 'GOOGLE_PAY',
  /** Payment through a native mobile app */
  NativeApp = 'NATIVE_APP',
  /** PayPal payment over Stripe */
  PaypalOverStripe = 'PAYPAL_OVER_STRIPE',
  /** UPI payment */
  Upi = 'UPI'
}

/** A Subscription plan to access a catalog of Udemy content */
export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  /** List of content groups included in a given plan */
  contentCollections: Array<ContentCollection>;
  /** Temporary field indicating whether the subscription has a Google Gemini 90 day trial included */
  hasGoogleGemini90DayTrial?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the subscription plan: */
  id: Scalars['ID']['output'];
  /** Computed price options for given plan */
  priceOptions: Array<SubscriptionPlanPricingOptionItem>;
  /** Type of subscription plan being offered */
  productType: SubscriptionPlanProductType;
  /** Title of the subscription plan */
  title: Scalars['String']['output'];
  /** Express checkout url for given plan */
  urlExpressCheckout: Scalars['URL']['output'];
  /** Learn more url for a given plan */
  urlLearnMore: Scalars['URL']['output'];
  /** Terms and Conditions url for a given plan */
  urlTermsOfUse: Scalars['URL']['output'];
};


/** A Subscription plan to access a catalog of Udemy content */
export type SubscriptionPlanPriceOptionsArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  excludeTrialOffers?: Scalars['Boolean']['input'];
  includeBillingCycleUpgrade?: Scalars['Boolean']['input'];
  licenseCount?: InputMaybe<Scalars['Int']['input']>;
  marketingURL?: InputMaybe<Scalars['URL']['input']>;
};

/** Contains information about the discount metadata for a given subscription plan price option */
export type SubscriptionPlanDiscount = {
  __typename?: 'SubscriptionPlanDiscount';
  /** List of applied discounts on the plan price option data */
  appliedDiscounts: Array<SubscriptionPlanDiscountDetails>;
};

/** Details of the specific discount type */
export type SubscriptionPlanDiscountDataItem = SubscriptionPlanPriceDiscountData | SubscriptionPlanTrialDiscountData;

/** Contains information on the start and end perioid for the discount interval type can be month/year */
export type SubscriptionPlanDiscountDateIntervalType = {
  __typename?: 'SubscriptionPlanDiscountDateIntervalType';
  /** Total duration of the discount period */
  duration: Scalars['Int']['output'];
  /** End period of the discounted data */
  end: Scalars['Int']['output'];
  /** Start period of the discounted data */
  start: Scalars['Int']['output'];
  /** Interval type for the discounted period */
  type: DateIntervalType;
};

/** Discount details for applied discount */
export type SubscriptionPlanDiscountDetails = {
  __typename?: 'SubscriptionPlanDiscountDetails';
  /** Coupon code/campaign code for the discount applied */
  code: Scalars['String']['output'];
  /** Discount data for the specific discount type */
  data: SubscriptionPlanDiscountDataItem;
  /** Specific discount type for subscriptions ex: trial/price/seat discounts */
  discountType: SubscriptionPlanDiscountType;
  /** Flag for the applied code. tells if the applied discount can be removed on FE */
  isRemovable: Scalars['Boolean']['output'];
  /** Type of coupon code. will be either one of udemy/customer coupon */
  sourceType: DiscountSourceType;
};

/** enum definition for different discount types for subscription */
export enum SubscriptionPlanDiscountType {
  /** discount on the plan price monthly/yearly */
  PlanPriceDiscount = 'PLAN_PRICE_DISCOUNT',
  /** discount on the trial days */
  TrialDiscount = 'TRIAL_DISCOUNT'
}

/** Filers for subscription plans */
export type SubscriptionPlanFilters = {
  /** Filter by product type */
  productType?: InputMaybe<SubscriptionPlanProductType>;
};

/** Contains information about the license context for a given subscription plan price option */
export type SubscriptionPlanLicenseContext = {
  __typename?: 'SubscriptionPlanLicenseContext';
  /** Default license count to be offered for purchase for given subscription plan option */
  defaultLicenseCount: Scalars['Int']['output'];
  /** License count for the subscription plan option */
  licenseCount: Scalars['Int']['output'];
  /** Maximum license count for purchase for given subscription plan option */
  maximumLicenseCount: Scalars['Int']['output'];
  /** Minimum license count for purchase for given subscription plan option */
  minimumLicenseCount: Scalars['Int']['output'];
  /** The unit price of the subscription price plan option based on provided requested count from request */
  unitPrice: Money;
};

/** Price data for plan pricing options */
export type SubscriptionPlanPrice = {
  __typename?: 'SubscriptionPlanPrice';
  /** The annual savings amount for the subscription price plan when compared to monthly plans. calculated on pricing backend can be null */
  annualSavings?: Maybe<Scalars['Decimal']['output']>;
  /** Currency */
  currency?: Maybe<CurrencyCode>;
  /** Discount price for the pricing option */
  discount?: Maybe<Scalars['Decimal']['output']>;
  /** The annual savings amount on discounted annual price for the subscription price plan when compared to monthly plans. */
  discountAnnualSavings?: Maybe<Scalars['Decimal']['output']>;
  /** The monthly price for the discounted annual price option */
  discountMonthly?: Maybe<Scalars['Decimal']['output']>;
  /** List price for the pricing option */
  list: Scalars['Decimal']['output'];
  /** Monthly price for the annual pricing option, for monthly plan price option will be equal to list price. */
  monthly?: Maybe<Scalars['Decimal']['output']>;
};

/** Contains information on the plan price discount */
export type SubscriptionPlanPriceDiscountData = {
  __typename?: 'SubscriptionPlanPriceDiscountData';
  /** Contains information on the start and end period for discount */
  interval: SubscriptionPlanDiscountDateIntervalType;
  /** Discount type for the price can be percentage off/fixed price discount */
  type: SubscriptionPlanPriceDiscountType;
  /** Discount value applied on the actual price. */
  value: Scalars['Decimal']['output'];
};

/** Definition for different price discount types */
export enum SubscriptionPlanPriceDiscountType {
  /** fixed value discount on the price */
  Fixed = 'FIXED',
  /** percentage of on the price */
  Percentage = 'PERCENTAGE'
}

/** Union of possible plan pricing options */
export type SubscriptionPlanPricingOptionItem = AnnualSubscriptionPlanPricingOption | DailySubscriptionPlanPricingOption | MonthlySubscriptionPlanPricingOption | WeeklySubscriptionPlanPricingOption;

/** A subscription plan product family */
export enum SubscriptionPlanProductFamily {
  /** Consumer */
  Consumer = 'CONSUMER',
  /** Enterprise */
  Enterprise = 'ENTERPRISE',
  /** Team */
  Team = 'TEAM'
}

/** The type of subscription plan being offered */
export enum SubscriptionPlanProductType {
  /** Consumer subscription (previously Spadefish) */
  Consumersubscription = 'CONSUMERSUBSCRIPTION',
  /** Consumer subscription + Grow With Google content */
  ConsumersubscriptionPlusGrowWithGoogle = 'CONSUMERSUBSCRIPTION_PLUS_GROW_WITH_GOOGLE',
  /** Consumer subscription value plan */
  ConsumersubscriptionValuePlan = 'CONSUMERSUBSCRIPTION_VALUE_PLAN',
  /** Enterprise Plan */
  Enterprise = 'ENTERPRISE',
  /** Enterprise PRO Plan */
  Enterprisepro = 'ENTERPRISEPRO',
  /** Enterprise AI growth plan */
  EnterpriseAiGrowth = 'ENTERPRISE_AI_GROWTH',
  /** Enterprise AI readiness plan */
  EnterpriseAiReadiness = 'ENTERPRISE_AI_READINESS',
  /** Enterprise AI readiness plan (Spanish) */
  EnterpriseAiReadinessEs = 'ENTERPRISE_AI_READINESS_ES',
  /** Enterprise AI readiness plan (Japanese) */
  EnterpriseAiReadinessJp = 'ENTERPRISE_AI_READINESS_JP',
  /** Enterprise AI readiness plan (Portuguese) */
  EnterpriseAiReadinessPt = 'ENTERPRISE_AI_READINESS_PT',
  /**
   * Enterprise base plan.
   * This plan serves as a base for other plans and is not available for purchase directly.
   */
  EnterpriseBase = 'ENTERPRISE_BASE',
  /** Enterprise Federal plan */
  EnterpriseFederal = 'ENTERPRISE_FEDERAL',
  /** Enterprise Japan plan */
  EnterpriseJapan = 'ENTERPRISE_JAPAN',
  /** Enterprise MCP plan */
  EnterpriseMcp = 'ENTERPRISE_MCP',
  /** Enterprise Roleplay plan */
  EnterpriseRoleplay = 'ENTERPRISE_ROLEPLAY',
  /** Enterprise Sandbox plan */
  EnterpriseSandbox = 'ENTERPRISE_SANDBOX',
  /** Plan for Grow With Google content only */
  GrowWithGoogle = 'GROW_WITH_GOOGLE',
  /** Team Plan */
  Team = 'TEAM',
  /**
   * Udemy Pro (deprecated)
   * @deprecated This product type is deprecated.
   */
  Udemypro = 'UDEMYPRO'
}

/** contains information on the trial discount if available */
export type SubscriptionPlanTrialDiscountData = {
  __typename?: 'SubscriptionPlanTrialDiscountData';
  /** The total trial days offered as part of the discount */
  days: Scalars['Int']['output'];
};

/** Status of the subscription */
export enum SubscriptionStatus {
  /** Subscription is paid and active */
  Active = 'ACTIVE',
  /** Subscription has canceled but still usable until the end date */
  Canceled = 'CANCELED',
  /** Subscription has ended and not usable anymore */
  Expired = 'EXPIRED',
  /** Subscription has not started yet (only for UB subscriptions) */
  Future = 'FUTURE',
  /** Subscription is in free trial period */
  Trial = 'TRIAL'
}

/** Type representing details about the trial subscription offer available for a given user and plan */
export type SubscriptionTrial = {
  __typename?: 'SubscriptionTrial';
  /** The length of the trial available to a user for a subscription plan. */
  dateInterval: DateInterval;
};

/** UPI payment method for the subscription */
export type SubscriptionUpiMethod = {
  __typename?: 'SubscriptionUPIMethod';
  /** UPI payment method type like QR or Intent */
  type: Scalars['String']['output'];
};

/** Represents a badge awarded to a top-rated category topic. */
export type TopRatedCategoryTopicBadge = LearningProductBadge & {
  __typename?: 'TopRatedCategoryTopicBadge';
  /** The category associated with the badge. */
  category?: Maybe<Category>;
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
  /** The topic associated with the badge. */
  topic?: Maybe<Topic>;
};

/** Represents a badge awarded to a top-rated subcategory. */
export type TopRatedSubcategoryBadge = LearningProductBadge & {
  __typename?: 'TopRatedSubcategoryBadge';
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
  /** The subcategory associated with the badge. */
  subcategory?: Maybe<BadgeSubCategory>;
};

/** Represents a badge awarded to a top-rated subcategory topic. */
export type TopRatedSubcategoryTopicBadge = LearningProductBadge & {
  __typename?: 'TopRatedSubcategoryTopicBadge';
  /** The localized name of the badge. */
  name: Scalars['String']['output'];
  /** The subcategory associated with the badge. */
  subcategory?: Maybe<BadgeSubCategory>;
  /** The topic associated with the badge. */
  topic?: Maybe<Topic>;
};

/** Topic */
export type Topic = {
  __typename?: 'Topic';
  /** Topic groups this topic belongs to */
  groups: Array<TopicGroup>;
  /** ID of topic */
  id: Scalars['ID']['output'];
  /** Images associated with this topic. Null when no images are configured for the topic. */
  images: TopicImages;
  /** Title of topic (Python, Programming Languages) */
  name: Scalars['String']['output'];
  /** A collection of question and answer pairs with optional link for additional context */
  questionsAndAnswers: Array<TopicQuestionAndAnswer>;
  /** Statistics about this topic */
  stats: TopicStats;
  /** Web url of the topic page */
  url: Scalars['URL']['output'];
};

/** A topic descriptor that categorizes topics */
export type TopicDescriptor = {
  __typename?: 'TopicDescriptor';
  /** ID of the topic descriptor */
  id: Scalars['ID']['output'];
  /** Name of the topic descriptor */
  name: Scalars['String']['output'];
};

/** Topic Filters for searching topics. All filters are ANDed together. */
export type TopicFilters = {
  /** Include topics associated with these topic ids */
  associatedWithTopicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Exclude topic group IDs */
  excludeTopicGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Include topic group IDs */
  includeTopicGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Include topics related to occupation group IDs */
  occupationGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Include topics related to occupation IDs */
  occupationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Topic Group */
export type TopicGroup = {
  __typename?: 'TopicGroup';
  /** ID of topic group */
  id: Scalars['ID']['output'];
  /** Name of topic group */
  name: Scalars['String']['output'];
};

/** An image asset associated with a topic. */
export type TopicImage = {
  __typename?: 'TopicImage';
  /** An optional higher-density variant of the image, suitable for high-DPR displays. */
  highDensityUrl?: Maybe<Scalars['URL']['output']>;
  /** The default image URL. */
  url: Scalars['URL']['output'];
};

/**
 * A collection of images associated with a topic.
 * Currently populated only for certification topics
 */
export type TopicImages = {
  __typename?: 'TopicImages';
  /** Badge image, typically displayed at the top of the topic page. */
  badgeImage?: Maybe<TopicImage>;
  /** Hero image, typically displayed at the top of the topic page. */
  heroImage?: Maybe<TopicImage>;
};

/** Response for topic interest update mutations */
export type TopicInterestUpdateResponse = {
  __typename?: 'TopicInterestUpdateResponse';
  /** The topics that are assigned as interests to the user */
  topicInterests?: Maybe<Array<Topic>>;
};

/** Types of popularity for Topics */
export enum TopicPopularityTypes {
  /** Popular popularity type */
  Popular = 'POPULAR',
  /** Trending popularity type */
  Trending = 'TRENDING'
}

/** A question and answer pair with optional link for additional context */
export type TopicQuestionAndAnswer = {
  __typename?: 'TopicQuestionAndAnswer';
  /** The answer text */
  answer: Scalars['String']['output'];
  /** ID of the question and answer */
  id: Scalars['ID']['output'];
  /** Text to display for the link to additional information about the question and answer */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The question text */
  question: Scalars['String']['output'];
  /** The URL for additional information about the question and answer */
  urlReadMore?: Maybe<Scalars['URL']['output']>;
};

/** A wrapper type to include the recommended Topic (aka. Label) and some additional fields about its recommendation */
export type TopicRecommendation = RecommendationItem & TrackableRecommendation & {
  __typename?: 'TopicRecommendation';
  /**
   * This is the ID of this wrapper object. This ID is different from the ID of the underlying recommended object
   * to provide uniqueness across item types
   */
  id: Scalars['ID']['output'];
  /** Underlying object of the recommendation to get more information about it */
  topic?: Maybe<Topic>;
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation item is served.
   */
  trackingId: Scalars['String']['output'];
};

/** Stats related to a Topic */
export type TopicStats = {
  __typename?: 'TopicStats';
  /** Number of learners associated with this topic */
  learnerCount: Scalars['NonNegativeInt']['output'];
};

/** List of assessment metrics related to a topic */
export type TopicToAssessmentsSummary = {
  __typename?: 'TopicToAssessmentsSummary';
  /** List of assessment summaries for this topic */
  assessmentSummaries: Array<AssessmentSummary>;
  /** The topic associated with these assessments */
  topic: Topic;
};

/** Paginated list for topic-to-assessment summary list */
export type TopicToAssessmentsSummaryResponse = Paginated & {
  __typename?: 'TopicToAssessmentsSummaryResponse';
  /** The current page number, 0 based */
  page: Scalars['Int']['output'];
  /** The total amount of pages. Calculated as (total result count / page size) */
  pageCount: Scalars['Int']['output'];
  /** List of skill metrics for the current page */
  results: Array<TopicToAssessmentsSummary>;
};

/**
 * If backend generates a tracking ID for any part of the response, and if the tracking ID ıs needed in the frontend, the
 * object should implement this interface.
 */
export type TrackableRecommendation = {
  /**
   * Tracking ID generated in the backend. Useful to relate tracking events generated in the backend with the tracking
   * events generated in the frontend. The value will change each time a recommendation is served.
   */
  trackingId: Scalars['String']['output'];
};

/** A Udemy user */
export type User = {
  __typename?: 'User';
  /** Id of the user */
  id: Scalars['ID']['output'];
  /**
   * Personally identifiable information of the User
   * scopes required: udemy:application
   */
  profile: UserProfile;
};

/**
 * A checklist that guides new Personal Plan subscribers through key onboarding steps.
 * The checklist tracks which steps the user has completed and provides progress
 * information for steps that require multiple actions.
 */
export type UserChecklist = {
  __typename?: 'UserChecklist';
  /** The name of this checklist */
  name: UserChecklistName;
  /** The tasks in this checklist */
  tasks: Array<UserChecklistTask>;
};

/** The name of the onboarding checklist */
export enum UserChecklistName {
  /** Onboarding checklist for new Personal Plan subscribers */
  Onboarding = 'ONBOARDING'
}

/**
 * Tracks the user's position in a multi-page informational flow.
 * Present only on tasks that have a multi-page component.
 */
export type UserChecklistPageTracking = {
  __typename?: 'UserChecklistPageTracking';
  /** Zero-based index of the last page the user viewed */
  lastViewedPageNumber: Scalars['NonNegativeInt']['output'];
};

/**
 * A task within an onboarding checklist. Task-specific capabilities (page tracking,
 * incremental progress) are modeled as nullable fields — a null value means the task
 * does not have that capability.
 */
export type UserChecklistTask = {
  __typename?: 'UserChecklistTask';
  /** Which task this is */
  name: UserChecklistTaskName;
  /** Non-null only for tasks that track multi-page viewing (e.g. SEE_ONBOARDING_MODALS) */
  pageTracking?: Maybe<UserChecklistPageTracking>;
  /** Non-null only for tasks with incremental progress (e.g. COMPLETE_FIVE_ITEMS) */
  progress?: Maybe<UserChecklistTaskProgress>;
  /** Current completion status */
  status: UserChecklistTaskStatus;
};

/** Response returned after a checklist task mutation */
export type UserChecklistTaskMutationResponse = {
  __typename?: 'UserChecklistTaskMutationResponse';
  /** The full updated checklist after the mutation */
  userChecklist?: Maybe<UserChecklist>;
};

/** The name of a task within a checklist */
export enum UserChecklistTaskName {
  /** Complete five learning activities to start building a learning habit */
  CompleteFiveItems = 'COMPLETE_FIVE_ITEMS',
  /** Complete three specific learning items */
  CompleteThreeSpecificItems = 'COMPLETE_THREE_SPECIFIC_ITEMS',
  /** Download and log in to the Udemy mobile app */
  DownloadApp = 'DOWNLOAD_APP',
  /** Walk through the Personal Plan features and benefits in a multi-page modal */
  SeeOnboardingModals = 'SEE_ONBOARDING_MODALS',
  /** Set up learning interests and skill preferences to personalize recommendations */
  UpdateSkillsAndOccupationSurvey = 'UPDATE_SKILLS_AND_OCCUPATION_SURVEY'
}

/**
 * Tracks incremental progress toward completing a task that requires
 * multiple actions (e.g., completing 5 learning activities).
 * Present only on tasks with incremental progress.
 */
export type UserChecklistTaskProgress = {
  __typename?: 'UserChecklistTaskProgress';
  /** Actions completed so far */
  completedCount: Scalars['Int']['output'];
  /** Actions required to complete the task */
  requiredCount: Scalars['Int']['output'];
};

/** Completion status of a checklist task */
export enum UserChecklistTaskStatus {
  /** The task has been completed */
  Completed = 'COMPLETED',
  /** The task has not yet been completed */
  Incomplete = 'INCOMPLETE'
}

/** Represents the each notification preference of a user */
export type UserNotificationPreference = {
  __typename?: 'UserNotificationPreference';
  /** Preference value of particular notification type */
  isEnabled: Scalars['Boolean']['output'];
  /** Type of notification preference */
  notificationType: UserNotificationType;
};

/** Represents the users notification preference */
export type UserNotificationPreferenceInput = {
  /** Preference value of particular notification type */
  isEnabled: Scalars['Boolean']['input'];
  /** Type of notification preference */
  notificationType: UserNotificationType;
};

/** Input for update for notification preferences  */
export type UserNotificationPreferenceSetInput = {
  /** Source of the action to store audit information */
  source: Scalars['String']['input'];
  /** Set of users notification preferences containing preference value */
  userNotificationPreferences: Array<UserNotificationPreferenceInput>;
};

/** Response of update user notification preferences */
export type UserNotificationPreferencesUpdateResponse = {
  __typename?: 'UserNotificationPreferencesUpdateResponse';
  /** The updated notification preferences */
  userNotificationPreferences: Array<UserNotificationPreference>;
};

/** Type of notification preferences */
export enum UserNotificationType {
  /** Encapsulates all notifications */
  All = 'ALL',
  /** Notifications that inform about the state of asset */
  AssetReady = 'ASSET_READY',
  /** Notifications that announces an update about specific course */
  CourseAnnouncement = 'COURSE_ANNOUNCEMENT',
  /** Course related messages */
  CourseMessageNotification = 'COURSE_MESSAGE_NOTIFICATION',
  /** Notifications that contain promo for specific course */
  CoursePromotion = 'COURSE_PROMOTION',
  /** Notifications that contain recommendations */
  CourseRecommendations = 'COURSE_RECOMMENDATIONS',
  /** Daily digest informing notifications */
  DailyDiscussionsDigest = 'DAILY_DISCUSSIONS_DIGEST',
  /** Offerings for MX learners to upgrade to UB */
  EnterpriseUbOfferings = 'ENTERPRISE_UB_OFFERINGS',
  /** Notifications sent by instructors to learners */
  InstructorAnnouncement = 'INSTRUCTOR_ANNOUNCEMENT',
  /** Inspiration notifications */
  LearningInspiration = 'LEARNING_INSPIRATION',
  /** Learning statistics notifications */
  LearningStats = 'LEARNING_STATS',
  /** On-site message notifications */
  MessageNotification = 'MESSAGE_NOTIFICATION',
  /** Promo containing notifications */
  OffersPromotions = 'OFFERS_PROMOTIONS',
  /** Notifications that contains announcements */
  ProductAnnouncements = 'PRODUCT_ANNOUNCEMENTS',
  /** Represents notifications containing promotions */
  Promotional = 'PROMOTIONAL',
  /** Video upload status notification */
  VideoUploadError = 'VIDEO_UPLOAD_ERROR'
}

/** Shows details of the user's occupation */
export type UserOccupationInfo = {
  __typename?: 'UserOccupationInfo';
  /** User's canonical occupation, may be null if user provided raw occupation. */
  canonical?: Maybe<Occupation>;
  /** Occupation group of the occupation */
  group?: Maybe<OccupationGroup>;
  /** Shows if the user is manager */
  isManager?: Maybe<Scalars['Boolean']['output']>;
  /** User's raw input occupation */
  raw?: Maybe<Occupation>;
};

/** Mutation response for occupation info update */
export type UserOccupationInfoUpdateResponse = {
  __typename?: 'UserOccupationInfoUpdateResponse';
  /** The updated user occupation info if the mutation succeeded */
  userOccupationInfo?: Maybe<UserOccupationInfo>;
};

/** Represents the basic information of a user */
export type UserProfile = {
  __typename?: 'UserProfile';
  /** Country of the user as defined by ISO 3166-1 alpha-2 */
  country?: Maybe<Scalars['CountryCode']['output']>;
  /** Email of the user */
  email: Scalars['EmailAddress']['output'];
  /** User avatar in different sizes */
  images: UserProfileImages;
  /** User's locale as defined by ISO 639-1 language code and ISO 3166-1 country code */
  locale: Scalars['String']['output'];
  /** Name of the user */
  name: Scalars['String']['output'];
  /** User's profile slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Surname of the user */
  surname: Scalars['String']['output'];
  /** User's IANA time zone */
  timeZone?: Maybe<Scalars['String']['output']>;
};

/** Represents different sizes of the same image */
export type UserProfileImages = {
  __typename?: 'UserProfileImages';
  /** User profile image size 125h */
  height125: Scalars['URL']['output'];
  /** User profile image size 200h */
  height200: Scalars['URL']['output'];
  /** User profile image size 50x50 */
  px50x50: Scalars['URL']['output'];
  /** User profile image size 75x75 */
  px75x75: Scalars['URL']['output'];
  /** User profile image size 100x100 */
  px100x100: Scalars['URL']['output'];
};

/** Represents a user setting */
export type UserSetting = {
  __typename?: 'UserSetting';
  /** Name of the setting */
  name: UserSettingName;
  /** Value of the setting */
  value: UserSettingValue;
};

/** Object representing Boolean User Setting value */
export type UserSettingBooleanValue = {
  __typename?: 'UserSettingBooleanValue';
  /** Boolean value of the setting */
  value: Scalars['Boolean']['output'];
};

/** Filter for user settings */
export type UserSettingFilter = {
  /** Filter settings by name */
  names?: InputMaybe<Array<UserSettingName>>;
};

/** The setting names available for a user */
export enum UserSettingName {
  /** Onboarding checklist setting: completed skills and occupation survey */
  OnboardingChecklistCompletedSkillsAndOccupationSurvey = 'ONBOARDING_CHECKLIST_COMPLETED_SKILLS_AND_OCCUPATION_SURVEY',
  /** Onboarding checklist setting: downloaded mobile app */
  OnboardingChecklistDownloadedMobileApp = 'ONBOARDING_CHECKLIST_DOWNLOADED_MOBILE_APP',
  /** Onboarding checklist setting: seen onboarding modals */
  OnboardingChecklistSeenOnboardingModals = 'ONBOARDING_CHECKLIST_SEEN_ONBOARDING_MODALS'
}

/** Object representing String User Setting value */
export type UserSettingStringValue = {
  __typename?: 'UserSettingStringValue';
  /** String value of the setting */
  value: Scalars['String']['output'];
};

/** Union representing possible UserSetting Values */
export type UserSettingValue = UserSettingBooleanValue | UserSettingStringValue;

/** A versioned identifier type */
export type VersionedIdentifier = {
  __typename?: 'VersionedIdentifier';
  /** ID of the entity */
  id: Scalars['ID']['output'];
  /** Versioned of the entity, not set when not versioned */
  version?: Maybe<Scalars['String']['output']>;
};

/** A versioned identifier input */
export type VersionedIdentifierInput = {
  /** ID of the entity */
  id: Scalars['ID']['input'];
  /** Version of the entity, not set when not versioned */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Video lecture */
export type VideoLecture = CurriculumItem & Lecture & {
  __typename?: 'VideoLecture';
  /** AI-generated summary of the lecture content */
  aiSummary?: Maybe<Scalars['String']['output']>;
  /** Lecture's main learning asset */
  asset?: Maybe<Asset>;
  /** The Course this lecture belongs to */
  course?: Maybe<Course>;
  /** Instructor-authored description of the lecture, may contain HTML */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** Total duration of the lecture's content in seconds */
  durationInSeconds: Scalars['DurationInSeconds']['output'];
  /** Id of the video lecture */
  id: Scalars['ID']['output'];
  /** Images by their dimensions */
  images: LectureImages;
  /** If user has completed the lecture */
  isCompleted: Scalars['Boolean']['output'];
  /** Whether the lecture is downloadable */
  isDownloadable: Scalars['Boolean']['output'];
  /** Whether this lecture is used for promos and course previews. */
  isPreviewable: Scalars['Boolean']['output'];
  /** Last watched second by the user */
  lastWatchedSecond?: Maybe<Scalars['Int']['output']>;
  /** The lesson associated with this video lecture */
  lesson?: Maybe<Lesson>;
  /** Lecture's supplementary resources */
  resources?: Maybe<Array<Maybe<Asset>>>;
  /** Associated learning products for supplementary learning */
  supplementaryLearningProducts: Array<LearningProduct>;
  /** The URL of the lecture thumbnail */
  thumbnail?: Maybe<Scalars['URL']['output']>;
  /** Lecture title */
  title: Scalars['String']['output'];
  /** The URL to access the lecture on the auto-enroll page */
  urlAutoEnroll: Scalars['URL']['output'];
  /** Download URL for lecture */
  urlDownload?: Maybe<Scalars['URL']['output']>;
  /** Landing page to view this Lecture */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the lecture */
  versionedIdentifier: VersionedIdentifier;
};


/** Video lecture */
export type VideoLectureSupplementaryLearningProductsArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** Length of the video in course */
export enum VideoLength {
  /** Extra long */
  ExtraLong = 'EXTRA_LONG',
  /** Extra short */
  ExtraShort = 'EXTRA_SHORT',
  /** Long */
  Long = 'LONG',
  /** Medium */
  Medium = 'MEDIUM',
  /** Short */
  Short = 'SHORT'
}

/** Mashup lecture has both video and a presentation */
export type VideoMashupLecture = CurriculumItem & Lecture & {
  __typename?: 'VideoMashupLecture';
  /** Lecture's main learning asset */
  asset?: Maybe<Asset>;
  /** The Course this lecture belongs to */
  course?: Maybe<Course>;
  /** Instructor-authored description of the lecture, may contain HTML */
  description?: Maybe<Scalars['SafeHtml']['output']>;
  /** Total duration of the lecture's content in seconds */
  durationInSeconds: Scalars['DurationInSeconds']['output'];
  /** Id of the lecture */
  id: Scalars['ID']['output'];
  /** Images by their dimensions */
  images: LectureImages;
  /** If user has completed the lecture */
  isCompleted: Scalars['Boolean']['output'];
  /** Whether this lecture is used for promos and course previews. */
  isPreviewable: Scalars['Boolean']['output'];
  /** Lecture's supplementary resources */
  resources?: Maybe<Array<Maybe<Asset>>>;
  /** Associated learning products for supplementary learning */
  supplementaryLearningProducts: Array<LearningProduct>;
  /** The URL of the lecture thumbnail */
  thumbnail?: Maybe<Scalars['URL']['output']>;
  /** Lecture title */
  title: Scalars['String']['output'];
  /** The URL to access the lecture on the auto-enroll page */
  urlAutoEnroll: Scalars['URL']['output'];
  /** Download URL for lecture */
  urlDownload?: Maybe<Scalars['URL']['output']>;
  /** Landing page to view this Lecture */
  urlLanding: Scalars['URL']['output'];
  /** Versioned identifier of the lecture */
  versionedIdentifier: VersionedIdentifier;
};


/** Mashup lecture has both video and a presentation */
export type VideoMashupLectureSupplementaryLearningProductsArgs = {
  versionId?: InputMaybe<Scalars['String']['input']>;
};

/** Voucher pool product types */
export enum VoucherPoolProductType {
  /** Standard voucher offering/pricing option */
  Default = 'DEFAULT',
  /** Retake insurance offering/pricing option */
  RetakeInsurance = 'RETAKE_INSURANCE'
}

/** Contains metadata about any retention streak */
export type WeeklyStreak = {
  __typename?: 'WeeklyStreak';
  /** Have they achieved their goal this week? */
  achievedThisWeek: Scalars['Boolean']['output'];
  /** ID of the streak. */
  id: Scalars['ID']['output'];
  /** Start date of the first week of this streak chain. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Current number of weeks achieved. */
  streakLength: Scalars['Int']['output'];
  /** User who this streak belongs to. */
  userId: Scalars['ID']['output'];
};

/** Price option for computed price plan. Will be returned for weekly plans */
export type WeeklySubscriptionPlanPricingOption = {
  __typename?: 'WeeklySubscriptionPlanPricingOption';
  /** Contains information about the discount context for a given subscription plan price option */
  discount?: Maybe<SubscriptionPlanDiscount>;
  /** Field containing details about the discounted trial subscription offer for a given user. Null indicates no trial is available */
  discountTrial?: Maybe<SubscriptionTrial>;
  /** ID of the price option: */
  id: Scalars['ID']['output'];
  /** Contains information about the license context for a given subscription plan price option */
  licenseContext?: Maybe<SubscriptionPlanLicenseContext>;
  /** The list price of the subscription price plan based on provided requested count from request */
  listPrice: Money;
  /** Field showing the prices for the option. */
  price?: Maybe<SubscriptionPlanPrice>;
  /** Interval for renewing the subscription plan ie the length of the subscription plan */
  renewalInterval: DateInterval;
  /** Field containing details about the trial subscription offer for a given user. Null indicates no trial is available */
  trial?: Maybe<SubscriptionTrial>;
};

export type PreviewableAssetQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type PreviewableAssetQuery = { __typename?: 'Query', asset?: { __typename: 'AssetArticle' } | { __typename: 'AssetAudio' } | { __typename: 'AssetEbook' } | { __typename: 'AssetExternalLink' } | { __typename: 'AssetFile' } | { __typename: 'AssetIFrame' } | { __typename: 'AssetImportContent' } | { __typename: 'AssetPresentation' } | { __typename: 'AssetSourceCode' } | { __typename: 'AssetVideo', id: string, title: string, duration: any, status: AssetStatus, accessToken?: string | null, isDrmProtected: boolean, processingErrors?: Array<{ __typename?: 'ProcessingError', errorMessage: string, helpLink: string }> | null, mediaSources: Array<{ __typename?: 'AssetMediaSource', label: string, src: any, mediaType: MediaSourceType }>, downloads: Array<{ __typename?: 'AssetDownload', label: string, urlFile: any }>, captions?: Array<{ __typename?: 'AssetCaption', id: string, fileName: string, url: any, language: any, title: string, videoLabel: string, source: CaptionSource, status: AssetStatus }> | null, thumbnailTrack?: { __typename?: 'AssetThumbnailTrack', vttUrl: any, imgUrl: any } | null } | { __typename: 'AssetVideoMashup' } | null };

export type BadgeClassesByCourseIdQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type BadgeClassesByCourseIdQuery = { __typename?: 'Query', badgeClassesByLearningProducts?: Array<{ __typename?: 'OpenBadgeClass', id: string, name: string, topic?: { __typename?: 'Topic', id: string, name: string, url: any } | null } | { __typename?: 'OrganizationBadgeClass', id: string, name: string, topic?: { __typename?: 'Topic', id: string, name: string, url: any } | null }> | null };

export type CertificationBundleQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CertificationBundleQuery = { __typename?: 'Query', courses: Array<{ __typename?: 'Course', id: string, title: string, headline?: string | null, learningOutcomes: Array<string>, prerequisites: Array<string>, targetAudience: Array<string>, enrollable: boolean, isFree: boolean, locale: any, urlMobileNativeDeeplink: any, urlCourseLanding?: any | null, badges: Array<{ __typename?: 'BeginnerTopRatedCategoryTopicBadge', name: string } | { __typename?: 'BeginnerTopRatedSubcategoryBadge', name: string } | { __typename?: 'BeginnerTopRatedSubcategoryTopicBadge', name: string } | { __typename?: 'BestSellerCategoryTopicBadge', name: string } | { __typename?: 'BestSellerSubcategoryBadge', name: string } | { __typename?: 'BestSellerSubcategoryTopicBadge', name: string } | { __typename?: 'HotAndNewBadge', name: string } | { __typename?: 'NewBadge', name: string } | { __typename?: 'TopRatedCategoryTopicBadge', name: string } | { __typename?: 'TopRatedSubcategoryBadge', name: string } | { __typename?: 'TopRatedSubcategoryTopicBadge', name: string }>, images: { __typename?: 'CourseImages', px100x100?: string | null, px304x171?: string | null, px480x270?: string | null }, rating?: { __typename?: 'CourseRating', average?: any | null, count: number } | null, instructors: Array<{ __typename?: 'CourseInstructor', name: string }>, enrollments: { __typename?: 'CourseEnrollments', count?: number | null }, categories: Array<{ __typename?: 'CourseCategory', name: string, id: string }> } | null> };

export type ClpCourseQueryVariables = Exact<{
  landingURL: Scalars['URL']['input'];
}>;


export type ClpCourseQuery = { __typename?: 'Query', courseByLandingURL?: { __typename?: 'Course', description?: any | null, duration?: any | null, durationInSeconds?: any | null, durationVideoContent?: any | null, enrollable: boolean, hasCertificate: boolean, headline?: string | null, id: string, isFree: boolean, isPracticeTestCourse: boolean, isPublished: boolean, learningOutcomes: Array<string>, level?: DifficultyLevel | null, locale: any, prerequisites: Array<string>, targetAudience: Array<string>, title: string, updatedOn?: any | null, urlAutoEnroll?: any | null, urlCourseLanding?: any | null, urlCourseTaking?: any | null, urlMobileNativeDeeplink: any, xapiActivityId: string, accreditations?: Array<{ __typename?: 'CourseAccreditation', compliantSince?: any | null, creditCount: any, level?: string | null, subject?: string | null, type: CourseAccreditationType }> | null, badges: Array<{ __typename: 'BeginnerTopRatedCategoryTopicBadge', name: string } | { __typename: 'BeginnerTopRatedSubcategoryBadge', name: string } | { __typename: 'BeginnerTopRatedSubcategoryTopicBadge', name: string } | { __typename: 'BestSellerCategoryTopicBadge', name: string } | { __typename: 'BestSellerSubcategoryBadge', name: string } | { __typename: 'BestSellerSubcategoryTopicBadge', name: string } | { __typename: 'HotAndNewBadge', name: string } | { __typename: 'NewBadge', name: string } | { __typename: 'TopRatedCategoryTopicBadge', name: string } | { __typename: 'TopRatedSubcategoryBadge', name: string } | { __typename: 'TopRatedSubcategoryTopicBadge', name: string }>, captions?: Array<{ __typename: 'CourseCaptionDetails', automaticallyGenerated: boolean, locale: any, type: CaptionType }> | null, categories: Array<{ __typename?: 'CourseCategory', id: string, name: string, url: any, subcategories: Array<{ __typename?: 'CourseSubCategory', id: string, name: string, url: any }> }>, contentCollectionInfo?: { __typename?: 'CourseContentCollectionInfo', isInGooglePartnerCollection: boolean } | null, curriculum: { __typename?: 'Curriculum', contentCounts?: { __typename?: 'CourseCurriculumContentCounts', lecturesCount: number, quizzesCount: number, codingExercisesCount: number, practiceAssignmentsCount: number, practiceTestsCount: number, practiceTestQuestionsCount: number, rolePlaysCount: number, downloadableResourcesCount: number, inCourseLabsCount: number } | null, sections: Array<{ __typename: 'CourseSection', description?: string | null, id: string, title: string, items: Array<{ __typename: 'ArticleLecture', description?: any | null, durationInSeconds: any, id: string, title: string } | { __typename: 'AudioLecture', description?: any | null, durationInSeconds: any, id: string, title: string } | { __typename: 'CodingExercise', id: string, title: string } | { __typename: 'CourseSection', id: string, title: string } | { __typename: 'EBookLecture', description?: any | null, durationInSeconds: any, id: string, title: string } | { __typename: 'ExternalLecture', description?: any | null, id: string, title: string } | { __typename: 'FileLecture', description?: any | null, id: string, title: string } | { __typename: 'PracticeAssignment', id: string, title: string } | { __typename: 'PracticeTest', id: string, title: string } | { __typename: 'PresentationLecture', description?: any | null, durationInSeconds: any, id: string, title: string } | { __typename: 'Quiz', id: string, title: string } | { __typename: 'RolePlay', id: string, title: string } | { __typename: 'VideoLecture', description?: any | null, durationInSeconds: any, isPreviewable: boolean, aiSummary?: string | null, id: string, title: string, images: { __typename?: 'LectureImages', height100?: string | null } } | { __typename: 'VideoMashupLecture', description?: any | null, isPreviewable: boolean, durationInSeconds: any, id: string, title: string, images: { __typename?: 'LectureImages', height100?: string | null } }> }> }, enrollments: { __typename?: 'CourseEnrollments', count?: number | null, roundedCount: number }, images: { __typename?: 'CourseImages', height125?: string | null, height200?: string | null, px100x100?: string | null, px240x135?: string | null, px304x171?: string | null, px480x270?: string | null, px48x27?: string | null, px50x50?: string | null, px75x75?: string | null, px96x54?: string | null }, instructors: Array<{ __typename?: 'CourseInstructor', id: string, name: string, url?: any | null, images: { __typename?: 'InstructorImages', px50x50?: string | null } }>, owner?: { __typename?: 'CourseInstructor', id: string, name: string, isOptedIntoDeals?: boolean | null } | null, primaryTopic?: { __typename?: 'Topic', id: string, name: string, url: any } | null, promoVideo?: { __typename?: 'CoursePromoVideo', asset: { __typename: 'AssetArticle' } | { __typename: 'AssetAudio' } | { __typename: 'AssetEbook' } | { __typename: 'AssetExternalLink' } | { __typename: 'AssetFile' } | { __typename: 'AssetIFrame' } | { __typename: 'AssetImportContent' } | { __typename: 'AssetPresentation' } | { __typename: 'AssetSourceCode' } | { __typename: 'AssetVideo', id: string, title: string, duration: any, status: AssetStatus, accessToken?: string | null, isDrmProtected: boolean, processingErrors?: Array<{ __typename?: 'ProcessingError', errorMessage: string, helpLink: string }> | null, mediaSources: Array<{ __typename?: 'AssetMediaSource', label: string, src: any, mediaType: MediaSourceType }>, downloads: Array<{ __typename?: 'AssetDownload', label: string, urlFile: any }>, captions?: Array<{ __typename?: 'AssetCaption', id: string, fileName: string, url: any, language: any, title: string, videoLabel: string, source: CaptionSource, status: AssetStatus }> | null, thumbnailTrack?: { __typename?: 'AssetThumbnailTrack', vttUrl: any, imgUrl: any } | null } | { __typename: 'AssetVideoMashup' } } | null, rating?: { __typename?: 'CourseRating', average?: any | null, count: number } | null, topics?: Array<{ __typename?: 'Topic', id: string, name: string, url: any }> | null, versionedIdentifier: { __typename?: 'VersionedIdentifier', id: string, version?: string | null } } | null };

export type CourseEnrollmentByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CourseEnrollmentByIdQuery = { __typename?: 'Query', course?: { __typename?: 'Course', isEnrolled: boolean } | null };

export type CourseUrlByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CourseUrlByIdQuery = { __typename?: 'Query', course?: { __typename?: 'Course', urlCourseLanding?: any | null } | null };

export type CoursesByIdQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CoursesByIdQuery = { __typename?: 'Query', courses: Array<{ __typename?: 'Course', targetAudience: Array<string>, enrollable: boolean, hasCertificate: boolean, learningOutcomes: Array<string>, prerequisites: Array<string>, headline?: string | null, id: string, isFree: boolean, isPracticeTestCourse: boolean, isPublished: boolean, locale: any, title: string, updatedOn?: any | null, urlAutoEnroll?: any | null, urlCourseLanding?: any | null, urlCourseTaking?: any | null, urlMobileNativeDeeplink: any, xapiActivityId: string, badges: Array<{ __typename: 'BeginnerTopRatedCategoryTopicBadge', name: string } | { __typename: 'BeginnerTopRatedSubcategoryBadge', name: string } | { __typename: 'BeginnerTopRatedSubcategoryTopicBadge', name: string } | { __typename: 'BestSellerCategoryTopicBadge', name: string } | { __typename: 'BestSellerSubcategoryBadge', name: string } | { __typename: 'BestSellerSubcategoryTopicBadge', name: string } | { __typename: 'HotAndNewBadge', name: string } | { __typename: 'NewBadge', name: string } | { __typename: 'TopRatedCategoryTopicBadge', name: string } | { __typename: 'TopRatedSubcategoryBadge', name: string } | { __typename: 'TopRatedSubcategoryTopicBadge', name: string }>, enrollments: { __typename?: 'CourseEnrollments', count?: number | null, roundedCount: number }, curriculum: { __typename?: 'Curriculum', contentCounts?: { __typename?: 'CourseCurriculumContentCounts', lecturesCount: number, quizzesCount: number, codingExercisesCount: number, practiceAssignmentsCount: number, practiceTestsCount: number, practiceTestQuestionsCount: number, rolePlaysCount: number, downloadableResourcesCount: number, inCourseLabsCount: number } | null, sections: Array<{ __typename: 'CourseSection', description?: string | null, id: string, title: string, items: Array<{ __typename: 'ArticleLecture', description?: any | null, durationInSeconds: any, id: string, title: string } | { __typename: 'AudioLecture', description?: any | null, durationInSeconds: any, id: string, title: string } | { __typename: 'CodingExercise', id: string, title: string } | { __typename: 'CourseSection', id: string, title: string } | { __typename: 'EBookLecture', description?: any | null, durationInSeconds: any, id: string, title: string } | { __typename: 'ExternalLecture', description?: any | null, id: string, title: string } | { __typename: 'FileLecture', description?: any | null, id: string, title: string } | { __typename: 'PracticeAssignment', id: string, title: string } | { __typename: 'PracticeTest', id: string, title: string } | { __typename: 'PresentationLecture', description?: any | null, durationInSeconds: any, id: string, title: string } | { __typename: 'Quiz', id: string, title: string } | { __typename: 'RolePlay', id: string, title: string } | { __typename: 'VideoLecture', description?: any | null, durationInSeconds: any, isPreviewable: boolean, aiSummary?: string | null, id: string, title: string, images: { __typename?: 'LectureImages', height100?: string | null } } | { __typename: 'VideoMashupLecture', description?: any | null, isPreviewable: boolean, durationInSeconds: any, id: string, title: string, images: { __typename?: 'LectureImages', height100?: string | null } }> }> }, categories: Array<{ __typename?: 'CourseCategory', id: string, name: string, url: any, subcategories: Array<{ __typename?: 'CourseSubCategory', id: string, name: string, url: any }> }>, images: { __typename?: 'CourseImages', height125?: string | null, height200?: string | null, px100x100?: string | null, px240x135?: string | null, px304x171?: string | null, px480x270?: string | null, px48x27?: string | null, px50x50?: string | null, px75x75?: string | null, px96x54?: string | null }, instructors: Array<{ __typename?: 'CourseInstructor', id: string, name: string, url?: any | null, images: { __typename?: 'InstructorImages', px50x50?: string | null } }>, primaryTopic?: { __typename?: 'Topic', id: string, name: string, url: any } | null, rating?: { __typename?: 'CourseRating', average?: any | null, count: number } | null, topics?: Array<{ __typename?: 'Topic', id: string, name: string, url: any }> | null, versionedIdentifier: { __typename?: 'VersionedIdentifier', id: string, version?: string | null }, contentCollectionInfo?: { __typename?: 'CourseContentCollectionInfo', isInGooglePartnerCollection: boolean } | null } | null> };

export type CoursesSubscriptionAvailabilityQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CoursesSubscriptionAvailabilityQuery = { __typename?: 'Query', courses: Array<{ __typename?: 'Course', id: string, subscriptionInfo?: { __typename?: 'CourseSubscriptionInfo', availabilityStatus?: CourseSubscriptionAvailabilityStatus | null } | null } | null> };

type CurriculumItemDetails_ArticleLecture_Fragment = { __typename: 'ArticleLecture', description?: any | null, durationInSeconds: any, id: string, title: string };

type CurriculumItemDetails_AudioLecture_Fragment = { __typename: 'AudioLecture', description?: any | null, durationInSeconds: any, id: string, title: string };

type CurriculumItemDetails_CodingExercise_Fragment = { __typename: 'CodingExercise', id: string, title: string };

type CurriculumItemDetails_CourseSection_Fragment = { __typename: 'CourseSection', id: string, title: string };

type CurriculumItemDetails_EBookLecture_Fragment = { __typename: 'EBookLecture', description?: any | null, durationInSeconds: any, id: string, title: string };

type CurriculumItemDetails_ExternalLecture_Fragment = { __typename: 'ExternalLecture', description?: any | null, id: string, title: string };

type CurriculumItemDetails_FileLecture_Fragment = { __typename: 'FileLecture', description?: any | null, id: string, title: string };

type CurriculumItemDetails_PracticeAssignment_Fragment = { __typename: 'PracticeAssignment', id: string, title: string };

type CurriculumItemDetails_PracticeTest_Fragment = { __typename: 'PracticeTest', id: string, title: string };

type CurriculumItemDetails_PresentationLecture_Fragment = { __typename: 'PresentationLecture', description?: any | null, durationInSeconds: any, id: string, title: string };

type CurriculumItemDetails_Quiz_Fragment = { __typename: 'Quiz', id: string, title: string };

type CurriculumItemDetails_RolePlay_Fragment = { __typename: 'RolePlay', id: string, title: string };

type CurriculumItemDetails_VideoLecture_Fragment = { __typename: 'VideoLecture', description?: any | null, durationInSeconds: any, isPreviewable: boolean, aiSummary?: string | null, id: string, title: string, images: { __typename?: 'LectureImages', height100?: string | null } };

type CurriculumItemDetails_VideoMashupLecture_Fragment = { __typename: 'VideoMashupLecture', description?: any | null, isPreviewable: boolean, durationInSeconds: any, id: string, title: string, images: { __typename?: 'LectureImages', height100?: string | null } };

export type CurriculumItemDetailsFragment = CurriculumItemDetails_ArticleLecture_Fragment | CurriculumItemDetails_AudioLecture_Fragment | CurriculumItemDetails_CodingExercise_Fragment | CurriculumItemDetails_CourseSection_Fragment | CurriculumItemDetails_EBookLecture_Fragment | CurriculumItemDetails_ExternalLecture_Fragment | CurriculumItemDetails_FileLecture_Fragment | CurriculumItemDetails_PracticeAssignment_Fragment | CurriculumItemDetails_PracticeTest_Fragment | CurriculumItemDetails_PresentationLecture_Fragment | CurriculumItemDetails_Quiz_Fragment | CurriculumItemDetails_RolePlay_Fragment | CurriculumItemDetails_VideoLecture_Fragment | CurriculumItemDetails_VideoMashupLecture_Fragment;

export type AssetVideoDetailsFragment = { __typename?: 'AssetVideo', id: string, title: string, duration: any, status: AssetStatus, accessToken?: string | null, isDrmProtected: boolean, processingErrors?: Array<{ __typename?: 'ProcessingError', errorMessage: string, helpLink: string }> | null, mediaSources: Array<{ __typename?: 'AssetMediaSource', label: string, src: any, mediaType: MediaSourceType }>, downloads: Array<{ __typename?: 'AssetDownload', label: string, urlFile: any }>, captions?: Array<{ __typename?: 'AssetCaption', id: string, fileName: string, url: any, language: any, title: string, videoLabel: string, source: CaptionSource, status: AssetStatus }> | null, thumbnailTrack?: { __typename?: 'AssetThumbnailTrack', vttUrl: any, imgUrl: any } | null };

export type LectureAssetIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type LectureAssetIdsQuery = { __typename?: 'Query', lectures: Array<{ __typename: 'ArticleLecture', id: string, thumbnail?: any | null } | { __typename: 'AudioLecture', id: string, thumbnail?: any | null } | { __typename: 'EBookLecture', id: string, thumbnail?: any | null } | { __typename: 'ExternalLecture', id: string, thumbnail?: any | null } | { __typename: 'FileLecture', id: string, thumbnail?: any | null } | { __typename: 'PresentationLecture', id: string, thumbnail?: any | null } | { __typename: 'VideoLecture', id: string, thumbnail?: any | null, asset?: { __typename: 'AssetArticle' } | { __typename: 'AssetAudio' } | { __typename: 'AssetEbook' } | { __typename: 'AssetExternalLink' } | { __typename: 'AssetFile' } | { __typename: 'AssetIFrame' } | { __typename: 'AssetImportContent' } | { __typename: 'AssetPresentation' } | { __typename: 'AssetSourceCode' } | { __typename: 'AssetVideo', id: string, title: string, duration: any, status: AssetStatus, accessToken?: string | null, isDrmProtected: boolean, processingErrors?: Array<{ __typename?: 'ProcessingError', errorMessage: string, helpLink: string }> | null, mediaSources: Array<{ __typename?: 'AssetMediaSource', label: string, src: any, mediaType: MediaSourceType }>, downloads: Array<{ __typename?: 'AssetDownload', label: string, urlFile: any }>, captions?: Array<{ __typename?: 'AssetCaption', id: string, fileName: string, url: any, language: any, title: string, videoLabel: string, source: CaptionSource, status: AssetStatus }> | null, thumbnailTrack?: { __typename?: 'AssetThumbnailTrack', vttUrl: any, imgUrl: any } | null } | { __typename: 'AssetVideoMashup' } | null } | { __typename: 'VideoMashupLecture', id: string, thumbnail?: any | null, asset?: { __typename: 'AssetArticle' } | { __typename: 'AssetAudio' } | { __typename: 'AssetEbook' } | { __typename: 'AssetExternalLink' } | { __typename: 'AssetFile' } | { __typename: 'AssetIFrame' } | { __typename: 'AssetImportContent' } | { __typename: 'AssetPresentation' } | { __typename: 'AssetSourceCode' } | { __typename: 'AssetVideo', id: string, title: string, duration: any, status: AssetStatus, accessToken?: string | null, isDrmProtected: boolean, processingErrors?: Array<{ __typename?: 'ProcessingError', errorMessage: string, helpLink: string }> | null, mediaSources: Array<{ __typename?: 'AssetMediaSource', label: string, src: any, mediaType: MediaSourceType }>, downloads: Array<{ __typename?: 'AssetDownload', label: string, urlFile: any }>, captions?: Array<{ __typename?: 'AssetCaption', id: string, fileName: string, url: any, language: any, title: string, videoLabel: string, source: CaptionSource, status: AssetStatus }> | null, thumbnailTrack?: { __typename?: 'AssetThumbnailTrack', vttUrl: any, imgUrl: any } | null } | { __typename: 'AssetVideoMashup' } | null } | null> };

export type SubscriptionPlansNonCatalogQueryVariables = Exact<{
  filters?: InputMaybe<SubscriptionPlanFilters>;
}>;


export type SubscriptionPlansNonCatalogQuery = { __typename?: 'Query', subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, title: string, productType: SubscriptionPlanProductType, urlExpressCheckout: any, urlLearnMore: any, urlTermsOfUse: any, contentCollections: Array<{ __typename?: 'ContentCollection', stats?: { __typename?: 'ContentCollectionStats', numberOfCourses: number } | null }>, priceOptions: Array<{ __typename?: 'AnnualSubscriptionPlanPricingOption', id: string, listPrice: { __typename?: 'Money', amount?: any | null, currency?: CurrencyCode | null }, renewalInterval: { __typename?: 'DateInterval', type: DateIntervalType, count: number }, trial?: { __typename?: 'SubscriptionTrial', dateInterval: { __typename?: 'DateInterval', type: DateIntervalType, count: number } } | null } | { __typename?: 'DailySubscriptionPlanPricingOption' } | { __typename?: 'MonthlySubscriptionPlanPricingOption', id: string, listPrice: { __typename?: 'Money', amount?: any | null, currency?: CurrencyCode | null }, renewalInterval: { __typename?: 'DateInterval', type: DateIntervalType, count: number }, trial?: { __typename?: 'SubscriptionTrial', dateInterval: { __typename?: 'DateInterval', type: DateIntervalType, count: number } } | null } | { __typename?: 'WeeklySubscriptionPlanPricingOption' }> }> };


export const CurriculumItemDetailsFragmentDoc = `
    fragment CurriculumItemDetails on CurriculumItem {
  __typename
  id
  title
  ... on Lecture {
    description
  }
  ... on ArticleLecture {
    durationInSeconds
  }
  ... on AudioLecture {
    durationInSeconds
  }
  ... on EBookLecture {
    durationInSeconds
  }
  ... on PresentationLecture {
    durationInSeconds
  }
  ... on VideoLecture {
    durationInSeconds
    isPreviewable
    images {
      height100
    }
    aiSummary
  }
  ... on VideoMashupLecture {
    isPreviewable
    durationInSeconds
    images {
      height100
    }
  }
}
    `;
export const AssetVideoDetailsFragmentDoc = `
    fragment AssetVideoDetails on AssetVideo {
  id
  title
  duration
  status
  processingErrors {
    errorMessage
    helpLink
  }
  accessToken
  isDrmProtected
  mediaSources {
    label
    src
    mediaType
  }
  downloads {
    label
    urlFile
  }
  captions {
    id
    fileName
    url
    language
    title
    videoLabel
    source
    status
  }
  thumbnailTrack {
    vttUrl
    imgUrl
  }
}
    `;
export const PreviewableAssetDocument = `
    query PreviewableAsset($assetId: ID!) {
  asset(id: $assetId) {
    __typename
    ...AssetVideoDetails
  }
}
    ${AssetVideoDetailsFragmentDoc}`;

export const usePreviewableAssetQuery = <
      TData = PreviewableAssetQuery,
      TError = unknown
    >(
      variables: PreviewableAssetQueryVariables,
      options?: Omit<UseQueryOptions<PreviewableAssetQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PreviewableAssetQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PreviewableAssetQuery, TError, TData>(
      {
    queryKey: ['PreviewableAsset', variables],
    queryFn: fetcher<PreviewableAssetQuery, PreviewableAssetQueryVariables>(PreviewableAssetDocument, variables),
    ...options
  }
    )};

usePreviewableAssetQuery.getKey = (variables: PreviewableAssetQueryVariables) => ['PreviewableAsset', variables];


usePreviewableAssetQuery.fetcher = (variables: PreviewableAssetQueryVariables, options?: RequestInit['headers']) => fetcher<PreviewableAssetQuery, PreviewableAssetQueryVariables>(PreviewableAssetDocument, variables, options);

export const BadgeClassesByCourseIdDocument = `
    query badgeClassesByCourseId($courseId: ID!) {
  badgeClassesByLearningProducts(
    learningProducts: [{id: $courseId, type: COURSE}]
  ) {
    id
    name
    topic {
      id
      name
      url
    }
  }
}
    `;

export const useBadgeClassesByCourseIdQuery = <
      TData = BadgeClassesByCourseIdQuery,
      TError = unknown
    >(
      variables: BadgeClassesByCourseIdQueryVariables,
      options?: Omit<UseQueryOptions<BadgeClassesByCourseIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BadgeClassesByCourseIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BadgeClassesByCourseIdQuery, TError, TData>(
      {
    queryKey: ['badgeClassesByCourseId', variables],
    queryFn: fetcher<BadgeClassesByCourseIdQuery, BadgeClassesByCourseIdQueryVariables>(BadgeClassesByCourseIdDocument, variables),
    ...options
  }
    )};

useBadgeClassesByCourseIdQuery.getKey = (variables: BadgeClassesByCourseIdQueryVariables) => ['badgeClassesByCourseId', variables];


useBadgeClassesByCourseIdQuery.fetcher = (variables: BadgeClassesByCourseIdQueryVariables, options?: RequestInit['headers']) => fetcher<BadgeClassesByCourseIdQuery, BadgeClassesByCourseIdQueryVariables>(BadgeClassesByCourseIdDocument, variables, options);

export const CertificationBundleDocument = `
    query CertificationBundle($ids: [ID!]!) {
  courses(ids: $ids) {
    id
    title
    headline
    learningOutcomes
    prerequisites
    targetAudience
    enrollable
    isFree
    locale
    urlMobileNativeDeeplink
    badges {
      name
    }
    images {
      px100x100
      px304x171
      px480x270
    }
    urlCourseLanding
    rating {
      average
      count
    }
    instructors {
      name
    }
    enrollments {
      count
    }
    categories {
      name
      id
    }
  }
}
    `;

export const useCertificationBundleQuery = <
      TData = CertificationBundleQuery,
      TError = unknown
    >(
      variables: CertificationBundleQueryVariables,
      options?: Omit<UseQueryOptions<CertificationBundleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CertificationBundleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CertificationBundleQuery, TError, TData>(
      {
    queryKey: ['CertificationBundle', variables],
    queryFn: fetcher<CertificationBundleQuery, CertificationBundleQueryVariables>(CertificationBundleDocument, variables),
    ...options
  }
    )};

useCertificationBundleQuery.getKey = (variables: CertificationBundleQueryVariables) => ['CertificationBundle', variables];


useCertificationBundleQuery.fetcher = (variables: CertificationBundleQueryVariables, options?: RequestInit['headers']) => fetcher<CertificationBundleQuery, CertificationBundleQueryVariables>(CertificationBundleDocument, variables, options);

export const ClpCourseDocument = `
    query CLPCourse($landingURL: URL!) {
  courseByLandingURL(landingURL: $landingURL) {
    accreditations {
      compliantSince
      creditCount
      level
      subject
      type
    }
    badges {
      __typename
      name
    }
    captions {
      __typename
      automaticallyGenerated
      locale
      type
    }
    categories {
      id
      name
      subcategories {
        id
        name
        url
      }
      url
    }
    contentCollectionInfo {
      isInGooglePartnerCollection
    }
    curriculum {
      contentCounts {
        lecturesCount
        quizzesCount
        codingExercisesCount
        practiceAssignmentsCount
        practiceTestsCount
        practiceTestQuestionsCount
        rolePlaysCount
        downloadableResourcesCount
        inCourseLabsCount
      }
      sections {
        __typename
        description
        id
        items {
          ...CurriculumItemDetails
        }
        title
      }
    }
    description
    duration
    durationInSeconds
    durationVideoContent
    enrollable
    enrollments {
      count
      roundedCount
    }
    hasCertificate
    headline
    id
    images {
      height125
      height200
      px100x100
      px240x135
      px304x171
      px480x270
      px48x27
      px50x50
      px75x75
      px96x54
    }
    instructors {
      id
      images {
        px50x50
      }
      name
      url
    }
    owner {
      id
      name
      isOptedIntoDeals
    }
    isFree
    isPracticeTestCourse
    isPublished
    learningOutcomes
    level
    locale
    prerequisites
    primaryTopic {
      id
      name
      url
    }
    promoVideo {
      asset {
        __typename
        ...AssetVideoDetails
      }
    }
    rating {
      average
      count
    }
    targetAudience
    title
    topics {
      id
      name
      url
    }
    updatedOn
    urlAutoEnroll
    urlCourseLanding
    urlCourseTaking
    urlMobileNativeDeeplink
    versionedIdentifier {
      id
      version
    }
    xapiActivityId
    contentCollectionInfo {
      isInGooglePartnerCollection
    }
  }
}
    ${CurriculumItemDetailsFragmentDoc}
${AssetVideoDetailsFragmentDoc}`;

export const useClpCourseQuery = <
      TData = ClpCourseQuery,
      TError = unknown
    >(
      variables: ClpCourseQueryVariables,
      options?: Omit<UseQueryOptions<ClpCourseQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClpCourseQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClpCourseQuery, TError, TData>(
      {
    queryKey: ['CLPCourse', variables],
    queryFn: fetcher<ClpCourseQuery, ClpCourseQueryVariables>(ClpCourseDocument, variables),
    ...options
  }
    )};

useClpCourseQuery.getKey = (variables: ClpCourseQueryVariables) => ['CLPCourse', variables];


useClpCourseQuery.fetcher = (variables: ClpCourseQueryVariables, options?: RequestInit['headers']) => fetcher<ClpCourseQuery, ClpCourseQueryVariables>(ClpCourseDocument, variables, options);

export const CourseEnrollmentByIdDocument = `
    query CourseEnrollmentById($id: ID!) {
  course(id: $id) {
    isEnrolled
  }
}
    `;

export const useCourseEnrollmentByIdQuery = <
      TData = CourseEnrollmentByIdQuery,
      TError = unknown
    >(
      variables: CourseEnrollmentByIdQueryVariables,
      options?: Omit<UseQueryOptions<CourseEnrollmentByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CourseEnrollmentByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CourseEnrollmentByIdQuery, TError, TData>(
      {
    queryKey: ['CourseEnrollmentById', variables],
    queryFn: fetcher<CourseEnrollmentByIdQuery, CourseEnrollmentByIdQueryVariables>(CourseEnrollmentByIdDocument, variables),
    ...options
  }
    )};

useCourseEnrollmentByIdQuery.getKey = (variables: CourseEnrollmentByIdQueryVariables) => ['CourseEnrollmentById', variables];


useCourseEnrollmentByIdQuery.fetcher = (variables: CourseEnrollmentByIdQueryVariables, options?: RequestInit['headers']) => fetcher<CourseEnrollmentByIdQuery, CourseEnrollmentByIdQueryVariables>(CourseEnrollmentByIdDocument, variables, options);

export const CourseUrlByIdDocument = `
    query CourseUrlById($id: ID!) {
  course(id: $id) {
    urlCourseLanding
  }
}
    `;

export const useCourseUrlByIdQuery = <
      TData = CourseUrlByIdQuery,
      TError = unknown
    >(
      variables: CourseUrlByIdQueryVariables,
      options?: Omit<UseQueryOptions<CourseUrlByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CourseUrlByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CourseUrlByIdQuery, TError, TData>(
      {
    queryKey: ['CourseUrlById', variables],
    queryFn: fetcher<CourseUrlByIdQuery, CourseUrlByIdQueryVariables>(CourseUrlByIdDocument, variables),
    ...options
  }
    )};

useCourseUrlByIdQuery.getKey = (variables: CourseUrlByIdQueryVariables) => ['CourseUrlById', variables];


useCourseUrlByIdQuery.fetcher = (variables: CourseUrlByIdQueryVariables, options?: RequestInit['headers']) => fetcher<CourseUrlByIdQuery, CourseUrlByIdQueryVariables>(CourseUrlByIdDocument, variables, options);

export const CoursesByIdDocument = `
    query CoursesById($ids: [ID!]!) {
  courses(ids: $ids) {
    badges {
      __typename
      name
    }
    targetAudience
    enrollable
    hasCertificate
    learningOutcomes
    prerequisites
    enrollments {
      count
      roundedCount
    }
    curriculum {
      contentCounts {
        lecturesCount
        quizzesCount
        codingExercisesCount
        practiceAssignmentsCount
        practiceTestsCount
        practiceTestQuestionsCount
        rolePlaysCount
        downloadableResourcesCount
        inCourseLabsCount
      }
      sections {
        __typename
        description
        id
        items {
          ...CurriculumItemDetails
        }
        title
      }
    }
    categories {
      id
      name
      subcategories {
        id
        name
        url
      }
      url
    }
    headline
    id
    images {
      height125
      height200
      px100x100
      px240x135
      px304x171
      px480x270
      px48x27
      px50x50
      px75x75
      px96x54
    }
    instructors {
      id
      images {
        px50x50
      }
      name
      url
    }
    isFree
    isPracticeTestCourse
    isPublished
    locale
    primaryTopic {
      id
      name
      url
    }
    rating {
      average
      count
    }
    title
    topics {
      id
      name
      url
    }
    updatedOn
    urlAutoEnroll
    urlCourseLanding
    urlCourseTaking
    urlMobileNativeDeeplink
    versionedIdentifier {
      id
      version
    }
    xapiActivityId
    contentCollectionInfo {
      isInGooglePartnerCollection
    }
  }
}
    ${CurriculumItemDetailsFragmentDoc}`;

export const useCoursesByIdQuery = <
      TData = CoursesByIdQuery,
      TError = unknown
    >(
      variables: CoursesByIdQueryVariables,
      options?: Omit<UseQueryOptions<CoursesByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CoursesByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CoursesByIdQuery, TError, TData>(
      {
    queryKey: ['CoursesById', variables],
    queryFn: fetcher<CoursesByIdQuery, CoursesByIdQueryVariables>(CoursesByIdDocument, variables),
    ...options
  }
    )};

useCoursesByIdQuery.getKey = (variables: CoursesByIdQueryVariables) => ['CoursesById', variables];


useCoursesByIdQuery.fetcher = (variables: CoursesByIdQueryVariables, options?: RequestInit['headers']) => fetcher<CoursesByIdQuery, CoursesByIdQueryVariables>(CoursesByIdDocument, variables, options);

export const CoursesSubscriptionAvailabilityDocument = `
    query CoursesSubscriptionAvailability($ids: [ID!]!) {
  courses(ids: $ids) {
    id
    subscriptionInfo {
      availabilityStatus
    }
  }
}
    `;

export const useCoursesSubscriptionAvailabilityQuery = <
      TData = CoursesSubscriptionAvailabilityQuery,
      TError = unknown
    >(
      variables: CoursesSubscriptionAvailabilityQueryVariables,
      options?: Omit<UseQueryOptions<CoursesSubscriptionAvailabilityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CoursesSubscriptionAvailabilityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CoursesSubscriptionAvailabilityQuery, TError, TData>(
      {
    queryKey: ['CoursesSubscriptionAvailability', variables],
    queryFn: fetcher<CoursesSubscriptionAvailabilityQuery, CoursesSubscriptionAvailabilityQueryVariables>(CoursesSubscriptionAvailabilityDocument, variables),
    ...options
  }
    )};

useCoursesSubscriptionAvailabilityQuery.getKey = (variables: CoursesSubscriptionAvailabilityQueryVariables) => ['CoursesSubscriptionAvailability', variables];


useCoursesSubscriptionAvailabilityQuery.fetcher = (variables: CoursesSubscriptionAvailabilityQueryVariables, options?: RequestInit['headers']) => fetcher<CoursesSubscriptionAvailabilityQuery, CoursesSubscriptionAvailabilityQueryVariables>(CoursesSubscriptionAvailabilityDocument, variables, options);

export const LectureAssetIdsDocument = `
    query LectureAssetIds($ids: [ID!]!) {
  lectures(ids: $ids) {
    id
    __typename
    thumbnail
    ... on VideoLecture {
      asset {
        __typename
        ...AssetVideoDetails
      }
    }
    ... on VideoMashupLecture {
      asset {
        __typename
        ...AssetVideoDetails
      }
    }
  }
}
    ${AssetVideoDetailsFragmentDoc}`;

export const useLectureAssetIdsQuery = <
      TData = LectureAssetIdsQuery,
      TError = unknown
    >(
      variables: LectureAssetIdsQueryVariables,
      options?: Omit<UseQueryOptions<LectureAssetIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LectureAssetIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LectureAssetIdsQuery, TError, TData>(
      {
    queryKey: ['LectureAssetIds', variables],
    queryFn: fetcher<LectureAssetIdsQuery, LectureAssetIdsQueryVariables>(LectureAssetIdsDocument, variables),
    ...options
  }
    )};

useLectureAssetIdsQuery.getKey = (variables: LectureAssetIdsQueryVariables) => ['LectureAssetIds', variables];


useLectureAssetIdsQuery.fetcher = (variables: LectureAssetIdsQueryVariables, options?: RequestInit['headers']) => fetcher<LectureAssetIdsQuery, LectureAssetIdsQueryVariables>(LectureAssetIdsDocument, variables, options);

export const SubscriptionPlansNonCatalogDocument = `
    query SubscriptionPlansNonCatalog($filters: SubscriptionPlanFilters) {
  subscriptionPlans(filters: $filters) {
    id
    title
    productType
    urlExpressCheckout
    urlLearnMore
    urlTermsOfUse
    contentCollections {
      stats {
        numberOfCourses
      }
    }
    priceOptions {
      ... on MonthlySubscriptionPlanPricingOption {
        id
        listPrice {
          amount
          currency
        }
        renewalInterval {
          type
          count
        }
        trial {
          dateInterval {
            type
            count
          }
        }
      }
      ... on AnnualSubscriptionPlanPricingOption {
        id
        listPrice {
          amount
          currency
        }
        renewalInterval {
          type
          count
        }
        trial {
          dateInterval {
            type
            count
          }
        }
      }
    }
  }
}
    `;

export const useSubscriptionPlansNonCatalogQuery = <
      TData = SubscriptionPlansNonCatalogQuery,
      TError = unknown
    >(
      variables?: SubscriptionPlansNonCatalogQueryVariables,
      options?: Omit<UseQueryOptions<SubscriptionPlansNonCatalogQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SubscriptionPlansNonCatalogQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SubscriptionPlansNonCatalogQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SubscriptionPlansNonCatalog'] : ['SubscriptionPlansNonCatalog', variables],
    queryFn: fetcher<SubscriptionPlansNonCatalogQuery, SubscriptionPlansNonCatalogQueryVariables>(SubscriptionPlansNonCatalogDocument, variables),
    ...options
  }
    )};

useSubscriptionPlansNonCatalogQuery.getKey = (variables?: SubscriptionPlansNonCatalogQueryVariables) => variables === undefined ? ['SubscriptionPlansNonCatalog'] : ['SubscriptionPlansNonCatalog', variables];


useSubscriptionPlansNonCatalogQuery.fetcher = (variables?: SubscriptionPlansNonCatalogQueryVariables, options?: RequestInit['headers']) => fetcher<SubscriptionPlansNonCatalogQuery, SubscriptionPlansNonCatalogQueryVariables>(SubscriptionPlansNonCatalogDocument, variables, options);
